import { createStore } from "vuex";

export default createStore({
  state() {
    return {
      beginner: {
        unit1: [
          {
            id: 1,
            key: "n",
            text_uz: "manzil",
            text_en: "address",
            description: "What is your home adress?",
          },
          {
            id: 2,
            key: "n",
            text_uz: "alifbo",
            text_en: "alphabet",
            description: "The English alphabet has twenty-six letters",
          },
          {
            id: 4,
            key: "conj",
            text_uz: "va",
            text_en: "and",
            description: "Nice to meet you. And you",
          },
          {
            id: 6,
            key: "v",
            text_uz: "bo'lmoq",
            text_en: "be",
            description: "I want to be a doctor",
          },
          {
            id: 7,
            key: "n",
            text_uz: "ish yuzasidan",
            text_en: "business",
            description: "I am here on business",
          },
          {
            id: 8,
            key: "n",
            text_uz: "shahar",
            text_en: "city",
            description: "What city are you from",
          },
          {
            id: 9,
            key: "n",
            text_uz: "mamlakat,davlat",
            text_en: "country",
            description: "What country are you from",
          },
          {
            id: 10,
            key: "n",
            text_uz: "kun",
            text_en: "day",
            description: "Have a nice day",
          },
          {
            id: 11,
            key: "adj",
            text_uz: "yaxshi",
            text_en: "fine",
            description: "I am fine, thanks",
          },
          {
            id: 12,
            key: "n",
            text_uz: "ism",
            text_en: "first name",
            description: "My first name is Anna",
          },
          {
            id: 13,
            key: "prep",
            text_uz: "dan",
            text_en: "from",
            description: "I am from Uzbekistan",
          },
          {
            id: 14,
            key: "phr",
            text_uz: "hayrli tong",
            text_en: "good morning",
            description: "good morning. how are you",
          },
          {
            id: 15,
            key: "exclamation",
            text_uz: "hayr",
            text_en: "goodbye",
            description: "See you later, goodbye",
          },
          {
            id: 16,
            key: "adj",
            text_uz: "ajoyib",
            text_en: "great",
            description: "New York is a great city!",
          },
          {
            id: 17,
            key: "exclamation",
            text_uz: "salom",
            text_en: "hello",
            description: "Hello, I'm Alisa",
          },
          {
            id: 18,
            key: "adv",
            text_uz: "bu yerda",
            text_en: "here",
            description: "Are you here on business",
          },
          {
            id: 19,
            key: "exclamation",
            text_uz: "salom",
            text_en: "hi",
            description: "Hi, I'm Paul",
          },
          {
            id: 20,
            key: "n",
            text_uz: "ta'til",
            text_en: "holiday",
            description: "I'm here on holiday",
          },
          {
            id: 21,
            key: "n",
            text_uz: "mehmonxona",
            text_en: "hotel",
            description: "We are in a hotel in Granada",
          },
          {
            id: 22,
            key: "adv",
            text_uz: "qanday",
            text_en: "how",
            description: "How do you spell that ?",
          },
          {
            id: 23,
            key: "pron",
            text_uz: "men",
            text_en: "I",
            description: "I'm from Brazil",
          },
          {
            id: 24,
            key: "prep",
            text_uz: "..da,..dagi",
            text_en: "in",
            description: "We are from Chennai in India",
          },
          {
            id: 25,
            key: "v",
            text_uz: "tanishtirmoq",
            text_en: "introduce",
            description: "Henry, let me introduce you to Lena",
          },
          {
            id: 27,
            key: "n",
            text_uz: "familiya",
            text_en: "last name",
            description: "What is your last name",
          },
          {
            id: 28,
            key: "n",
            text_uz: "harf",
            text_en: "letter",
            description: "There are five letters in my last name",
          },
          {
            id: 29,
            key: "n",
            text_uz: "xarita",
            text_en: "map",
            description: "This is a map of the World",
          },
          {
            id: 30,
            key: "n",
            text_uz: "uchrashuv",
            text_en: "meeting",
            description: "What time is the meeting",
          },
          {
            id: 31,
            key: "n",
            text_uz: "ism",
            text_en: "name",
            description: "What is your name",
          },
          {
            id: 32,
            key: " ",
            text_uz: "emas",
            text_en: "no",
            description: "No I'm not. I'm Canadian",
          },
          {
            id: 33,
            key: "n",
            text_uz: "raqam",
            text_en: "number",
            description: "I think number 1 is China",
          },
          {
            id: 34,
            key: "prep",
            text_uz: "..da",
            text_en: "on",
            description: "Are you on holiday",
          },
          {
            id: 35,
            key: "adj",
            text_uz: "to'g'ri",
            text_en: "right",
            description: "That's right",
          },
          {
            id: 36,
            key: "n",
            text_uz: "telefon raqami",
            text_en: "phone number",
            description: "My mobile phone number is 0918-143-4267",
          },
          {
            id: 37,
            key: "v",
            text_uz: "talaffuz qilmoq",
            text_en: "spell",
            description: "How do you spell your name?",
          },
          {
            id: 38,
            key: "v",
            text_uz: "o'qimoq",
            text_en: "study",
            description: "I'm here to study",
          },
          {
            id: 39,
            key: "exclamation",
            text_uz: "rahmat",
            text_en: "thanks",
            description: "Have a nice day, thanks",
          },
          {
            id: 40,
            key: "det",
            text_uz: "bu, o'sha",
            text_en: "that",
            description: "How do you spell that ?",
          },
          {
            id: 41,
            key: "adv",
            text_uz: "..ham",
            text_en: "too",
            description: "Nice to meet you, Garry. You too",
          },
          {
            id: 42,
            key: " ",
            text_uz: "nima",
            text_en: "what",
            description: "What is your first name ?",
          },
          {
            id: 43,
            key: " ",
            text_uz: "qayerda",
            text_en: "where",
            description: "Where are you from",
          },
          {
            id: 44,
            key: " ",
            text_uz: "ha",
            text_en: "yes",
            description: "Are you from the UK ? Yes, I am",
          },
          {
            id: 45,
            key: "pron",
            text_uz: "siz",
            text_en: "you",
            description: "Hello. Are you Angela ?",
          },
          {
            id: 46,
            key: "det",
            text_uz: "sizning",
            text_en: "your",
            description: "What is your email address ?",
          },
        ],
        unit2: [
          {
            id: 2,
            key: "prep",
            text_uz: "haqida",
            text_en: "about",
            description: "Tell me about your family.",
          },
          {
            id: 3,
            key: "n",
            text_uz: "aeroport",
            text_en: "airport",
            description: "The offices are near Ciampino Airport.",
          },
          {
            id: 4,
            key: "n",
            text_uz: "olma",
            text_en: "apple",
            description: "'What are these?' 'They're apples from England.'",
          },
          {
            id: 5,
            key: "n",
            text_uz: "Argentina",
            text_en: "Argentina",
            description: "This is my friend Romina. She's from Argentina.",
          },
          {
            id: 6,
            key: "n",
            text_uz: "sumka",
            text_en: "bag",
            description: "What's in the bag?",
          },
          {
            id: 7,
            key: "n",
            text_uz: "kitob",
            text_en: "book",
            description: "There are thirty students and fifteen books.",
          },
          {
            id: 8,
            key: "n",
            text_uz: "bino",
            text_en: "building",
            description: "What's the name of that building over there?",
          },
          {
            id: 9,
            key: "n",
            text_uz: "avtobus",
            text_en: "bus",
            description: "What time's the next bus?",
          },
          {
            id: 10,
            key: "n",
            text_uz: "bosh oshpaz",
            text_en: "chef",
            description: "Pedro isn't a student. He's a chef in a restaurant.",
          },
          {
            id: 11,
            key: "n",
            text_uz: "sinf",
            text_en: "class",
            description: "The students in my class are really friendly.",
          },
          {
            id: 12,
            key: "n",
            text_uz: "kompaniya",
            text_en: "company",
            description: "ENI is an electricity company in Rome.",
          },
          {
            id: 13,
            key: "n",
            text_uz: "shifokor",
            text_en: "doctor",
            description: "He's a doctor at a hospital in Cancun.",
          },
          {
            id: 14,
            key: "n",
            text_uz: "elektron xat",
            text_en: "email",
            description: "Thanks for your email.",
          },
          {
            id: 15,
            key: "n",
            text_uz: "muhandis",
            text_en: "engineer",
            description: "I'm an engineer for a telecoms company.",
          },
          {
            id: 16,
            key: "adj",
            text_uz: "Inglizcha",
            text_en: "English",
            description: "We're in an English class together.",
          },
          {
            id: 17,
            key: "n",
            text_uz: "do'st",
            text_en: "friend",
            description: "This is my friend Pieter. ",
          },
          {
            id: 18,
            key: "n",
            text_uz: "bog'",
            text_en: "garden",
            description: "It's a small house, but it's got a garden.",
          },
          {
            id: 20,
            key: "n",
            text_uz: "yigit",
            text_en: "guy",
            description: "I'm with my friend Pedro in this photo. He's a nice guy.",
          },
          {
            id: 21,
            key: "n",
            text_uz: "shifoxona",
            text_en: "hospital",
            description: "They're nurses at a hospital in London.",
          },
          {
            id: 22,
            key: "adj",
            text_uz: "Italiyancha",
            text_en: "Italian",
            description: "She's a chef in an Italian restaurant.",
          },
          {
            id: 23,
            key: "n",
            text_uz: "Italiya",
            text_en: "Italy",
            description: "I'm Gio from Italy.",
          },
          {
            id: 24,
            key: "n",
            text_uz: "kasb, ish",
            text_en: "job",
            description: "'What's his job?' 'He's an engineer.'",
          },
          {
            id: 26,
            key: "n",
            text_uz: "kalit",
            text_en: "key",
            description: "Are these your keys?",
          },
          {
            id: 27,
            key: "n",
            text_uz: "til maktabi",
            text_en: "language school",
            description: "He is a teacher at a language school.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "kompyuter(noutbuk)",
            text_en: "laptop",
            description: "I've got an old laptop.",
          },
          {
            id: 29,
            key: "n",
            text_uz: "xat, maktub",
            text_en: "letter",
            description: "I write letters to my friends.",
          },
          {
            id: 30,
            key: "n",
            text_uz: "Meksika",
            text_en: "Mexico",
            description: "He's a teacher at a school in Mexico",
          },
          {
            id: 31,
            key: "adv",
            text_uz: "yaqinida",
            text_en: "near",
            description: "It's on Cromwell Road, near the Science Museum.",
          },
          {
            id: 32,
            key: "n",
            text_uz: "Muzey",
            text_en: "Museum",
            description: "The Palace Museum is in Beijing.",
          },
          {
            id: 33,
            key: "adv",
            text_uz: "keyingi, yon tarafdagi",
            text_en: "next to",
            description: "It's next to the City Hall.",
          },
          {
            id: 34,
            key: "adj",
            text_uz: "yaxshi",
            text_en: "nice",
            description: "Have a nice day.",
          },
          {
            id: 35,
            key: "n",
            text_uz: "bloknot(daftarcha)",
            text_en: "notepad",
            description: "It's a notepad.",
          },
          {
            id: 36,
            key: "n",
            text_uz: "hamshira",
            text_en: "nurse",
            description: "He's a nurse at Westmore Hospital.",
          },
          {
            id: 37,
            key: "n",
            text_uz: "narsa, buyum",
            text_en: "object",
            description: "This is an interesting object.",
          },
          {
            id: 38,
            key: "adv",
            text_uz: "soat (...da)",
            text_en: "o'clock",
            description: "Is the film at eight o'clock?",
          },
          {
            id: 39,
            key: "n",
            text_uz: "ofis, idora",
            text_en: "office",
            description: "Where are the eni offices?",
          },
          {
            id: 40,
            key: "n",
            text_uz: "ruchka",
            text_en: "pen",
            description: "This is a pen.",
          },
          {
            id: 41,
            key: "n",
            text_uz: "telefon",
            text_en: "phone",
            description: "It's a new phone.",
          },
          {
            id: 42,
            key: "n",
            text_uz: "rasm, surat",
            text_en: "photo",
            description: "In this photo I'm with Nevin.",
          },
          {
            id: 43,
            key: "n",
            text_uz: "restoran",
            text_en: "restaurant",
            description: "He's a chef in a Spanish restaurant.",
          },
          {
            id: 44,
            key: "n",
            text_uz: "daryo",
            text_en: "river",
            description: "London is on the River Thames.",
          },
          {
            id: 45,
            key: "n",
            text_uz: "yo'l",
            text_en: "road",
            description: "Madam e Tussauds is on Marylebone Road.",
          },
          {
            id: 46,
            key: "n",
            text_uz: "Ruminia",
            text_en: "Romania",
            description: "This is a photo of my house in Romania.",
          },
          {
            id: 47,
            key: "n",
            text_uz: "maktab",
            text_en: "school",
            description: "I'm a student at a language school in Vancouver.",
          },
          {
            id: 48,
            key: "n",
            text_uz: "sotuvchi",
            text_en: "shop assistant",
            description: "Kumiko's a shop assistant.",
          },
          {
            id: 49,
            key: "n",
            text_uz: "opa/ singil",
            text_en: "sister",
            description: "She's Tibor's sister.",
          },
          {
            id: 50,
            key: "n",
            text_uz: "maydon/skver",
            text_en: "Square",
            description: "The restaurant is on Church Square.",
          },
          {
            id: 51,
            key: "n",
            text_uz: "bekat",
            text_en: "station",
            description: "Madame Tussauds is near Baker Street Station.",
          },
          {
            id: 52,
            key: "n",
            text_uz: "ko'cha",
            text_en: "Street",
            description: "The Metropolitan Opera is on 65th Street.",
          },
          {
            id: 53,
            key: "n",
            text_uz: "talaba",
            text_en: "student",
            description: "My name is Tai. I'm a student in Hanoi.",
          },
          {
            id: 54,
            key: "n",
            text_uz: "planshet",
            text_en: "tablet",
            description: "It's a phone, not a tablet.",
          },
          {
            id: 55,
            key: "n",
            text_uz: "taksi haydovchisi",
            text_en: "taxi driver",
            description: "Yanni's a taxi driver.",
          },
          {
            id: 56,
            key: "n",
            text_uz: "o'qituvchi",
            text_en: "teacher",
            description: "She's a teacher at a language school.",
          },
          {
            id: 57,
            key: "n",
            text_uz: "Tayland",
            text_en: "Thailan",
            description: "They're in Thailand for a week.",
          },
          {
            id: 58,
            key: "adv",
            text_uz: "anavi yerda",
            text_en: "there",
            description: "He's there on business.",
          },
          {
            id: 59,
            key: "adv",
            text_uz: "bular",
            text_en: "These",
            description: "These are my friends, Jana and Milos.",
          },
          {
            id: 60,
            key: "pron",
            text_uz: "bu",
            text_en: "this",
            description: "What's this in English?",
          },
          {
            id: 61,
            key: "pron",
            text_uz: "anavilar",
            text_en: "those",
            description: "Where are those people from?",
          },
          {
            id: 62,
            key: "n",
            text_uz: "vaqt",
            text_en: "time",
            description: "What's the time?",
          },
          {
            id: 63,
            key: "n",
            text_uz: "poyezd",
            text_en: "train",
            description: "What time is the next train to the university?",
          },
          {
            id: 64,
            key: "n",
            text_uz: "soyabon",
            text_en: "umbrella",
            description: "That's an umbrella.",
          },
          {
            id: 65,
            key: "n",
            text_uz: "unversitet",
            text_en: "university",
            description: "Hannah and David are students at Columbia University. ",
          },
          {
            id: 66,
            key: "n",
            text_uz: "ofitsant",
            text_en: "waiter",
            description: "Thierry's a waiter.",
          },
          {
            id: 67,
            key: "n",
            text_uz: "hamyon",
            text_en: "wallet",
            description: "This is my wallet.",
          },
          {
            id: 68,
            key: "n",
            text_uz: "hafta",
            text_en: "week",
            description: "I'm in Italy for a week",
          },
          {
            id: 69,
            key: " ",
            text_uz: "kim",
            text_en: "Who",
            description: "'Who's that? ' 'It's my friend, Lynne.'",
          },
        ],
        unit3: [
          {
            id: 2,
            key: "n",
            text_uz: "rassom",
            text_en: "artist",
            description: "Emilie and Bruno are artists.",
          },
          {
            id: 3,
            key: "adj",
            text_uz: "yomon",
            text_en: "bad",
            description: "This apple is bad.",
          },
          {
            id: 4,
            key: "n",
            text_uz: "bank hisob raqami",
            text_en: "bank account",
            description: "30% of people in the world have got a bank account.",
          },
          {
            id: 5,
            key: "adj",
            text_uz: "chiroyli",
            text_en: "beautiful",
            description: "It's a beautiful city.",
          },
          {
            id: 6,
            key: "n",
            text_uz: "yotoqxona",
            text_en: "bedroom",
            description: "It's only got one bedroom.",
          },
          {
            id: 7,
            key: "n",
            text_uz: "chin do'st",
            text_en: " best friend",
            description: "Has your best friend got a pet?",
          },
          {
            id: 8,
            key: "n",
            text_uz: "velosiped",
            text_en: "bicycle",
            description: "Has yo ur neighbour got a bicycle?",
          },
          {
            id: 9,
            key: "adj",
            text_uz: "katta",
            text_en: "big",
            description: "Mr Thompson is a teacher at a big school.",
          },
          {
            id: 10,
            key: "n",
            text_uz: "o'g'il bola",
            text_en: "boy",
            description: "The boy is her son.",
          },
          {
            id: 11,
            key: "n",
            text_uz: "aka/uka",
            text_en: "brother",
            description: "Andy and Anna are brother and sister.",
          },
          {
            id: 12,
            key: "conj",
            text_uz: "ammo, lekin",
            text_en: "but",
            description: "It's a hard job, but she's happy.",
          },
          {
            id: 13,
            key: "adj",
            text_uz: "nomlangan",
            text_en: "called",
            description: "Amy's father is called Lee.",
          },
          {
            id: 14,
            key: "n",
            text_uz: "mashina, avtomobil",
            text_en: "car",
            description: "Have your parents got a car?",
          },
          {
            id: 15,
            key: "n",
            text_uz: "mushuk",
            text_en: "cat",
            description: "My mother's got nine cats.",
          },
          {
            id: 16,
            key: "n",
            text_uz: "markaz",
            text_en: "centre",
            description: "The hotel is nice and it's near the city centre.",
          },
          {
            id: 17,
            key: "adj",
            text_uz: "arzon",
            text_en: "cheap",
            description: "It's a good restaurant but it's not cheap.",
          },
          {
            id: 18,
            key: "n",
            text_uz: "bola",
            text_en: "child",
            description: "My aunt and uncle have got one child.",
          },
          {
            id: 19,
            key: "n pl",
            text_uz: "bolalar",
            text_en: "children",
            description: "They've got four children.",
          },
          {
            id: 20,
            key: "adj",
            text_uz: "aqlli",
            text_en: "clever",
            description: "She's a clever woman.",
          },
          {
            id: 21,
            key: "n",
            text_uz: "qahva",
            text_en: "coffee",
            description: "This coffee is hot.",
          },
          {
            id: 22,
            key: "adj",
            text_uz: "sovuq",
            text_en: "cold",
            description: "My room is very cold.",
          },
          {
            id: 23,
            key: "n",
            text_uz: "konferensiya, anjuman",
            text_en: "conference",
            description: "He's here for a conference, but I'm on holiday.",
          },
          {
            id: 24,
            key: "n",
            text_uz: "qiz farzand",
            text_en: "daughter",
            description: "Marichka and Mikolaj's daughter is ten.",
          },
          {
            id: 25,
            key: "n",
            text_uz: "it",
            text_en: "dog",
            description: "Sarah's got a friendly dog.",
          },
          {
            id: 26,
            key: "adj",
            text_uz: "qimmat",
            text_en: "expensive",
            description: "London is a great city but it's very expensive.",
          },
          {
            id: 27,
            key: "n",
            text_uz: "oila",
            text_en: "family",
            description: "Their family is poor, but they are happy.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "ota",
            text_en: "father",
            description: "His father is very young.",
          },
          {
            id: 29,
            key: "n",
            text_uz: "film, kino",
            text_en: "film",
            description: "It's a happy film .",
          },
          {
            id: 30,
            key: "n",
            text_uz: "kvartira, xonadon",
            text_en: "flat",
            description: "We've got a flat near Notre Dame de Paris.",
          },
          {
            id: 31,
            key: " ",
            text_uz: "men uchun",
            text_en: "for me",
            description: "So for me, the flat is like a hotel.",
          },
          {
            id: 33,
            key: "adj",
            text_uz: "do'stona",
            text_en: "friendly",
            description: "The people are very friendly.",
          },
          {
            id: 34,
            key: "adj",
            text_uz: "kulguli, qiziq, qiziqarli",
            text_en: "funny",
            description: "Will Ferrell is a funny man.",
          },
          {
            id: 35,
            key: "n",
            text_uz: "qiz bola",
            text_en: "girl",
            description: "The girl is their daughter.",
          },
          {
            id: 36,
            key: "adj",
            text_uz: "yaxshi",
            text_en: "good",
            description: "I've got a good job.",
          },
          {
            id: 37,
            key: "adj",
            text_uz: "buva",
            text_en: "grandfather",
            description: "David's grandfather is from the USA. ",
          },
          {
            id: 38,
            key: "n",
            text_uz: "buvi",
            text_en: "grandmother",
            description: "Where's your grandmother?",
          },
          {
            id: 39,
            key: "n",
            text_uz: "bobo-buvi",
            text_en: "grandparents",
            description: "Derek and Carol are Fergus, Olivia and Katie's grandparents.",
          },
          {
            id: 40,
            key: "adj",
            text_uz: "baxtli",
            text_en: "happy",
            description: "He's very happy in Australia.",
          },
          {
            id: 41,
            key: "adj",
            text_uz: "qiyin, qattiq",
            text_en: "hard",
            description: "Agnieszka is a doctor. She's got a hard job.",
          },
          {
            id: 42,
            key: "adj",
            text_uz: "issiq",
            text_en: "hot",
            description: "It's very hot, but that's OK.",
          },
          {
            id: 43,
            key: "n",
            text_uz: "uy",
            text_en: "house",
            description: "Filipa's house is in Warsaw.",
          },
          {
            id: 45,
            key: "adj",
            text_uz: "qiziqarli",
            text_en: "interesting",
            description: "I've got an interesting job.",
          },
          {
            id: 46,
            key: "adj",
            text_uz: "ajoyib",
            text_en: "lovely",
            description: "Amit and Syreeta are lovely people.",
          },
          {
            id: 47,
            key: "n",
            text_uz: "erkak",
            text_en: "man",
            description: "He isn't a rich man.",
          },
          {
            id: 48,
            key: "adj",
            text_uz: "oilali",
            text_en: "married",
            description: "Are you married?",
          },
          {
            id: 49,
            key: "n pl",
            text_uz: "erkaklar",
            text_en: "men",
            description: "We've got five neighbours - three men and two women.",
          },
          {
            id: 50,
            key: "v",
            text_uz: "xabar yubormoq",
            text_en: "Message",
            description: "Message me soon. Bye.",
          },
          {
            id: 51,
            key: "n",
            text_uz: "mobil telefon",
            text_en: "mobile phone",
            description: "70% of people in the world have got a mobile phone.",
          },
          {
            id: 52,
            key: "n",
            text_uz: "ona",
            text_en: "mother",
            description: "This is my mother.",
          },
          {
            id: 53,
            key: "n",
            text_uz: "sozanda",
            text_en: "musician",
            description: "He's a musician, too.",
          },
          {
            id: 54,
            key: "n",
            text_uz: "qo'shni",
            text_en: "neighbour",
            description: "My other neighbour, Cedric, is a teacher.",
          },
          {
            id: 55,
            key: "adj",
            text_uz: "yangi",
            text_en: "new",
            description: "It's a new phone.",
          },
          {
            id: 56,
            key: "n",
            text_uz: "Yangi Zelandiya",
            text_en: "New Zealand",
            description: "They're from New Zealand and they're lovely people.",
          },
          {
            id: 57,
            key: " ",
            text_uz: "albatta",
            text_en: "Of course",
            description: "'Can I sit here?' 'Of course.'",
          },
          {
            id: 58,
            key: "adj",
            text_uz: "eski, qari",
            text_en: "old",
            description: "I've got an old bicycle.",
          },
          {
            id: 61,
            key: "n",
            text_uz: "rasm",
            text_en: "painting",
            description: "They've got a lovely painting in their room.",
          },
          {
            id: 62,
            key: "n pl",
            text_uz: "ota-ona",
            text_en: "parents",
            description: "Amy's parents are in Taiwan.",
          },
          {
            id: 63,
            key: "n pl",
            text_uz: "odamlar",
            text_en: "people",
            description: "The people here are very nice.",
          },
          {
            id: 64,
            key: "n",
            text_uz: "shaxs",
            text_en: "person",
            description: "Sam is a lovely person.",
          },
          {
            id: 65,
            key: "n",
            text_uz: "uy hayvoni",
            text_en: "pet",
            description: "The children's pet is a dog called Benji.",
          },
          {
            id: 66,
            key: "n",
            text_uz: "joy",
            text_en: "place",
            description: "It's a nice place.",
          },
          {
            id: 67,
            key: " ",
            text_uz: "iltimos",
            text_en: "please",
            description: "'Coffee?' 'Yes, please.'",
          },
          {
            id: 68,
            key: "adj",
            text_uz: "kambag'al",
            text_en: "poor",
            description: "They are poor, but they are happy.",
          },
          {
            id: 69,
            key: "n",
            text_uz: "mulk",
            text_en: "possessions",
            description: "Have you got a lot of possessions?",
          },
          {
            id: 70,
            key: "n",
            text_uz: "loyiha",
            text_en: "project",
            description: "He's got a job on a big project in Vietnam.",
          },
          {
            id: 71,
            key: "adj",
            text_uz: "davlat",
            text_en: "country",
            description: "The USA is a rich country.",
          },
          {
            id: 72,
            key: "n",
            text_uz: "xona",
            text_en: "room",
            description: "We're in a hotel and our room is really big.",
          },
          {
            id: 73,
            key: "adj",
            text_uz: "xafa, xomush",
            text_en: "sad",
            description: "Why is the woman sad?",
          },
          {
            id: 74,
            key: "n",
            text_uz: "dengiz",
            text_en: "sea",
            description: "We're in a hotel near the sea.",
          },
          {
            id: 75,
            key: "n",
            text_uz: "o'rindiq",
            text_en: "seat",
            description: "Excuse me. That's my seat.",
          },
          {
            id: 76,
            key: "n",
            text_uz: "do'kon",
            text_en: "shop",
            description: "My village hasn't got a shop.",
          },
          {
            id: 77,
            key: "n",
            text_uz: "opa/singil",
            text_en: "sister",
            description: "His sister, Grace, is six.",
          },
          {
            id: 78,
            key: "adj",
            text_uz: "kichik",
            text_en: "small",
            description: "Her flat is nice, but it's small.",
          },
          {
            id: 79,
            key: "n",
            text_uz: "o'g'il farzand",
            text_en: "son",
            description: "This is Xavier and Carmen's son, Cristobal.",
          },
          {
            id: 80,
            key: "n",
            text_uz: "qo'shiq",
            text_en: "song",
            description: "What's your favourite song?",
          },
          {
            id: 81,
            key: "adj",
            text_uz: "kechirasiz",
            text_en: "sorry",
            description: "Sorry I'm late.",
          },
          {
            id: 82,
            key: "n",
            text_uz: "televizor",
            text_en: "TV",
            description: "20% of people in the world have got a TV.",
          },
          {
            id: 83,
            key: "n",
            text_uz: "hojatxona",
            text_en: "toilet",
            description: "Excuse me. Where is the toilet?",
          },
          {
            id: 84,
            key: "n",
            text_uz: "qishloq",
            text_en: "village",
            description: "This is my village.",
          },
          {
            id: 85,
            key: "n",
            text_uz: "xotin",
            text_en: "wife",
            description: "His wife's name is Yu.",
          },
          {
            id: 86,
            key: "n",
            text_uz: "ayol",
            text_en: "woman",
            description: "The woman next to the man is his wife.",
          },
          {
            id: 87,
            key: "n pl",
            text_uz: "ayollar",
            text_en: "women",
            description: "These women are Japanese Maiko.",
          },
          {
            id: 88,
            key: "n",
            text_uz: "dunyo",
            text_en: "world",
            description: "9% of people in the world have got a car.",
          },
          {
            id: 89,
            key: "adj",
            text_uz: "yosh",
            text_en: "young",
            description: "The young boy is her son.",
          },
        ],
        unit4: [
          {
            id: 1,
            key: "pron",
            text_uz: "ko'p",
            text_en: "a lot",
            description: "We watch a lot of films.",
          },
          {
            id: 2,
            key: "n",
            text_uz: "aktyor",
            text_en: "actor",
            description: "Matt Damon is a film actor and writer",
          },
          {
            id: 3,
            key: "n",
            text_uz: "san'at",
            text_en: "art",
            description: "Koko likes art.",
          },
          {
            id: 4,
            key: "phr",
            text_uz: "dam olish kunlarida",
            text_en: "at the weekend ",
            description: "Does she work at the weekend?",
          },
          {
            id: 5,
            key: "n",
            text_uz: "beyzbol",
            text_en: "baseball",
            description: "When he has time, Matt Damon watches baseball",
          },
          {
            id: 6,
            key: "n",
            text_uz: "basketbol",
            text_en: "basketball",
            description: "When he has time, he plays basketball",
          },
          {
            id: 7,
            key: "n",
            text_uz: "kitob do'koni",
            text_en: "bookshop",
            description: "I work in a bookshop",
          },
          {
            id: 8,
            key: "n",
            text_uz: "avtobus",
            text_en: "bus",
            description: "Pedro goes to work by bus",
          },
          {
            id: 9,
            key: "v",
            text_uz: "qo'ng'iroq qilmoq",
            text_en: "call",
            description: "Call me when you get to the hotel",
          },
          {
            id: 10,
            key: "n pl",
            text_uz: "karta o'yinlari",
            text_en: "card games",
            description: "He also plays card games",
          },
          {
            id: 12,
            key: "n",
            text_uz: "xayriya",
            text_en: "charity",
            description: "She works for a charity",
          },
          {
            id: 13,
            key: "phr",
            text_uz: "elektron xatlarni tekshirmoq",
            text_en: "check emails",
            description: "When do you check emails?",
          },
          {
            id: 14,
            key: "n pl",
            text_uz: "komikslar",
            text_en: "comics",
            description: "He likes Spider-Man comics!",
          },
          {
            id: 15,
            key: "n",
            text_uz: "xaridor",
            text_en: "customer",
            description: "I'm a waiter in a cafe and I serve customers",
          },
          {
            id: 16,
            key: "v",
            text_uz: "velosiped minmoq",
            text_en: "cycle",
            description: "Do you cycle to work?",
          },
          {
            id: 17,
            key: "n",
            text_uz: "Daniya",
            text_en: "Denmark",
            description: "in Denmark, 36% of people cycle to work, school or university",
          },
          {
            id: 18,
            key: "n",
            text_uz: "univermag/do'kon",
            text_en: "department store",
            description: "My brother works in a big department store",
          },
          {
            id: 19,
            key: "adj",
            text_uz: "har xil,turli",
            text_en: "different",
            description: "We are twins, but we have very different lives",
          },
          {
            id: 20,
            key: "n",
            text_uz: "dollar",
            text_en: "dollar",
            description: "It's ten dollars",
          },
          {
            id: 21,
            key: "v",
            text_uz: "mashina xaydamoq,mashinada bormoq",
            text_en: "drive",
            description: "We drive to work",
          },
          {
            id: 22,
            key: "adv",
            text_uz: "erta",
            text_en: "early",
            description: "Does she get up early?",
          },
          {
            id: 23,
            key: "n",
            text_uz: "elektronika do'koni",
            text_en: "electronics shop",
            description: "My best friend works in an electronics shop",
          },
          {
            id: 24,
            key: "n",
            text_uz: "yevro(pul birligi)",
            text_en: "euro",
            description: "it's six euros fifty cents",
          },
          {
            id: 25,
            key: "n",
            text_uz: "zavod,fabrika",
            text_en: "factory",
            description: "John works in a car factory",
          },
          {
            id: 26,
            key: "adj",
            text_uz: "sevimli",
            text_en: "favourite",
            description: "My favourite day is Saturday",
          },
          {
            id: 27,
            key: "n",
            text_uz: "parom(kema)",
            text_en: "ferry",
            description: "No one in our group goes to work by ferry",
          },
          {
            id: 28,
            key: "phr",
            text_uz: "ishni tamomlamoq",
            text_en: "finish work",
            description: "i finish work at 6 p.m",
          },
          {
            id: 29,
            key: "phr",
            text_uz: "kiyinmoq",
            text_en: "get dressed",
            description: "I have a shower, and then l get dressed",
          },
          {
            id: 30,
            key: "phr",
            text_uz: "uyga yetib olmoq,bormoq",
            text_en: "get home",
            description: "I get home at 5 a.m",
          },
          {
            id: 31,
            key: "phr v",
            text_uz: "o'rnidan turmoq",
            text_en: "get up",
            description: "What time do you get up?",
          },
          {
            id: 32,
            key: "v",
            text_uz: "bormoq",
            text_en: "go",
            description: "I go to work by train",
          },
          {
            id: 33,
            key: "phr",
            text_uz: "chet elga bormoq",
            text_en: "go abroad",
            description: "I go abroad a lot",
          },
          {
            id: 34,
            key: "phr v",
            text_uz: "sayrga chiqmoq",
            text_en: "go out",
            description: "On Saturdays we go out with friends",
          },
          {
            id: 35,
            key: "phr",
            text_uz: "uxlashga yotmoq",
            text_en: "go to bed",
            description: "After dinner l go to bed",
          },
          {
            id: 36,
            key: "phr",
            text_uz: "ishga bormoq",
            text_en: "go to work",
            description: "A lot of people in Vietnam go to work by motorbike",
          },
          {
            id: 37,
            key: "n",
            text_uz: "gitara",
            text_en: "guitar",
            description: "My sister plays the guitar",
          },
          {
            id: 38,
            key: "v",
            text_uz: "ega bo'lmoq",
            text_en: "have",
            description: "i don't have a car",
          },
          {
            id: 39,
            key: "phr",
            text_uz: "vanna qabul qilmoq",
            text_en: "have a bath",
            description: "I have a bath in the evening",
          },
          {
            id: 40,
            key: "phr",
            text_uz: "dush qabul qilmoq",
            text_en: "have a shower",
            description: "l get up at 5 a.m. and have a shower",
          },
          {
            id: 41,
            key: "phr",
            text_uz: "nonushta qilmoq",
            text_en: "have breakfast",
            description: "Does she have breakfast with her family?",
          },
          {
            id: 42,
            key: "phr",
            text_uz: "kechki ovqatni yemoq",
            text_en: "have dinner",
            description: "I have dinner at 7.30 p.m.",
          },
          {
            id: 43,
            key: "v",
            text_uz: "yordam bermoq",
            text_en: "help",
            description: "Can l help you?",
          },
          {
            id: 44,
            key: "phr",
            text_uz: "bo'sh vaqtimda",
            text_en: "in my free time",
            description: "in my free time, l go to the cinema",
          },
          {
            id: 45,
            key: "n",
            text_uz: "safar/sayohat",
            text_en: "journey",
            description: "I really like my journey to work.",
          },
          {
            id: 46,
            key: "n",
            text_uz: "Keniya",
            text_en: "Kenya",
            description: "She lives in Nairobi in Kenya",
          },
          {
            id: 47,
            key: "v",
            text_uz: "yoqtirmoq",
            text_en: "like",
            description: "Bryan and Anna like music",
          },
          {
            id: 48,
            key: "v",
            text_uz: "yashamoq",
            text_en: "live",
            description: "I don't live in Sydney.",
          },
          {
            id: 50,
            key: "n",
            text_uz: "mototsikl",
            text_en: "motorbike",
            description: "Hanoi has three million motorbikes",
          },
          {
            id: 51,
            key: "adj",
            text_uz: "ismli,atalgan,nomli",
            text_en: "named",
            description: "She has a daughter named Akinyi",
          },
          {
            id: 52,
            key: "v",
            text_uz: "kerak,zarur bo'lmoq",
            text_en: "need",
            description: "I need a notepad",
          },
          {
            id: 53,
            key: "adj",
            text_uz: "gazeta",
            text_en: "newspaper ",
            description: "He works for a newspaper",
          },
          {
            id: 54,
            key: "adv",
            text_uz: "anavi yerda",
            text_en: "over there",
            description: "They're over there near the window",
          },
          {
            id: 55,
            key: "n",
            text_uz: "xiyobon",
            text_en: "park",
            description: "London Zoo is in The Regent's Park",
          },
          {
            id: 57,
            key: "n",
            text_uz: "dorixona",
            text_en: "pharmacy",
            description: "I need to go to the pharmacy",
          },
          {
            id: 58,
            key: "v",
            text_uz: "o'ynamoq",
            text_en: "play",
            description: "He also plays badminton",
          },
          {
            id: 59,
            key: "n",
            text_uz: "funt(pul birligi)",
            text_en: "pound",
            description: "It's three pounds",
          },
          {
            id: 60,
            key: "n",
            text_uz: "jamoat transporti",
            text_en: "public transport",
            description: "In Sydney, 17% of people go to work on public transport",
          },
          {

            id: 61,
            key: "v",
            text_uz: "o'qimoq",
            text_en: "read",
            description: "I read books and watch TV",
          },
          {
            id: 62,
            key: "adj",
            text_uz: "bir xil",
            text_en: "same",
            description: "They have the same father but different mothers",
          },
          {
            id: 63,
            key: "adj",
            text_uz: "o'xshash",
            text_en: "similar",
            description: "Auma and her brother have different lives, but their jobs are similar",
          },
          {
            id: 64,
            key: "adv",
            text_uz: "ba'zan/bazida",
            text_en: "sometimes",
            description: "Sometimes he goes to other countries for his work",
          },
          {
            id: 65,
            key: "n",
            text_uz: "Janubiy Afrika",
            text_en: "South Africa",
            description: "We live in Johannesburg in South Africa",
          },
          {
            id: 66,
            key: "n",
            text_uz: "Janubiy Koreya",
            text_en: "South Korea",
            description: "I live with my parents in South Korea",
          },
          {
            id: 67,
            key: "phr",
            text_uz: "ishni boshlamoq",
            text_en: "start work",
            description: "I start work at 8 a.m.",
          },
          {
            id: 68,
            key: "v",
            text_uz: "o'qimoq/o'rganmoq",
            text_en: "study",
            description: "We study at Charles University",
          },
          {
            id: 69,
            key: "n",
            text_uz: "Shvetsariya",
            text_en: "Switzerland ",
            description: "A lot of people in Switzerland go to work by train",
          },
          {
            id: 70,
            key: "v",
            text_uz: "o'rgatmoq, dars bermoq",
            text_en: "teach",
            description: "They teach young people from poor families",
          },
          {
            id: 71,
            key: "n",
            text_uz: "tennis",
            text_en: "tennis",
            description: "At the weekend, Valentina plays tennis",
          },
          {
            id: 72,
            key: "n",
            text_uz: "matnli/yozuvli habar",
            text_en: "text massage",
            description: "I send a lot of text messages to my friends",
          },
          {
            id: 73,
            key: "n",
            text_uz: "chipta/bilet",
            text_en: "ticket",
            description: "You buy your ticket on the bus",
          },
          {
            id: 74,
            key: "adv",
            text_uz: "birga/birgalikda",
            text_en: "together",
            description: "We have dinner together",
          },
          {
            id: 75,
            key: "n",
            text_uz: "poyezd",
            text_en: "train",
            description: "My father goes to work by train",
          },
          {
            id: 76,
            key: "n",
            text_uz: "Vyetnam",
            text_en: "Vietnam",
            description: "My grandparents live in Vietnam",
          },
          {
            id: 77,
            key: "v",
            text_uz: "piyoda yurmoq, sayr qilmoq",
            text_en: "walk",
            description: "He doesn't walk to work",
          },
          {
            id: 78,
            key: "v",
            text_uz: "tomosha qilmoq",
            text_en: "watch",
            description: "I watch Tv at the weekend",
          },
          {
            id: 79,
            key: "v",
            text_uz: "ishlamoq",
            text_en: "work",
            description: "I don't work on Sundays",
          },
          {
            id: 80,
            key: "n",
            text_uz: "yozuvchi",
            text_en: "writer",
            description: "Ben Stiller is a film actor and writer",
          },
        ],
        unit5: [
          {
            id: 1,
            key: "phr",
            text_uz: "bir bo'lak,parcha",
            text_en: "a piece of",
            description: "They wear a piece of wood on their heads",
          },
          {
            id: 2,
            key: "n",
            text_uz: "voyaga yetgan",
            text_en: "adult",
            description: "The museum costs £5 for children and £10 for adults",
          },
          {
            id: 3,
            key: "adv",
            text_uz: "hamisha,doim",
            text_en: "always",
            description: "I always buy my own clothes",
          },
          {
            id: 4,
            key: "adj",
            text_uz: "ajoyib,qiziqarli",
            text_en: "amazing",
            description: "Jenny's clothes are always amazing",
          },
          {
            id: 5,
            key: "n",
            text_uz: "e'lon",
            text_en: "announcement",
            description: "This is anannouncement for passengers on flight FW1632",
          },
          {
            id: 6,
            key: "n",
            text_uz: "arxitekyura,qurilish",
            text_en: "architecture",
            description: "I love the architecture in Manchester",
          },
          {
            id: 7,
            key: "n",
            text_uz: "qo'l",
            text_en: "arm",
            description: "People have two arms and two legs",
          },
          {
            id: 8,
            key: "n",
            text_uz: "bank",
            text_en: "bank",
            description: "I always wear smart clothes in the week, because i work in a bank",
          },
          {
            id: 9,
            key: "phr",
            text_uz: "yalangoyoq",
            text_en: "bare feet",
            description: "Children walk with bare feet in the street",
          },
          {
            id: 10,
            key: "n",
            text_uz: "asosiy",
            text_en: "basic",
            description: "There are only four basic types of clothes",
          },
          {
            id: 11,
            key: "conj",
            text_uz: "chunki",
            text_en: "because",
            description: "I like people's clothes in London, because they are different",
          },
          {
            id: 12,
            key: "adj",
            text_uz: "qora",
            text_en: "black",
            description: "I really like old black and white films",
          },
          {
            id: 13,
            key: "adj",
            text_uz: "moviy,ko'k",
            text_en: "blue",
            description: "She has a red top and blue jeans",
          },
          {
            id: 14,
            key: "n",
            text_uz: "tana",
            text_en: "body",
            description: "Where on the body does a Tuareg man wear a 'tagelmust'?",
          },
          {
            id: 15,
            key: "n",
            text_uz: "Boliviya",
            text_en: "Bolivia",
            description: "The Chola women of Bolivia are famous for their style",
          },
          {
            id: 16,
            key: "n",
            text_uz: "bovler shlyapasi",
            text_en: "bowler hat",
            description: "They wear big skirts and bowler hats",
          },
          {
            id: 17,
            key: "adj",
            text_uz: "jigarrang",
            text_en: "brown",
            description: "They want to have brown skin",
          },
          {
            id: 18,
            key: "adj",
            text_uz: "band",
            text_en: "busy",
            description: "Hi, Hannah. Are you busy on Saturday?",
          },
          {
            id: 19,
            key: "v",
            text_uz: "sotib olmoq",
            text_en: "buy",
            description: "Where do i buy a ticket?",
          },
          {
            id: 20,
            key: "adj",
            text_uz: "oddiy kiyim",
            text_en: "casual",
            description: "I sometimes wear casual clothes",
          },
          {
            id: 21,
            key: "v",
            text_uz: "almashtirmoq",
            text_en: "change",
            description: "The Allianz Arena changes colour because different teams play there",
          },
          {
            id: 22,
            key: "v",
            text_uz: "kino",
            text_en: "cinema",
            description: "See you at the cinem a a t 6.15",
          },
          {
            id: 23,
            key: "v",
            text_uz: "yopmoq",
            text_en: "close",
            description: "When do the shops close on Saturday?",
          },
          {
            id: 24,
            key: "npl",
            text_uz: "kiyimlar",
            text_en: "clothes",
            description: "At the weekend l usually wear sports clothes",
          },
          {
            id: 25,
            key: "n",
            text_uz: "rang",
            text_en: "colour",
            description: "What's your favourite colour?",
          },
          {
            id: 26,
            key: "adj",
            text_uz: "rangbarang",
            text_en: "colourful",
            description: "Their clothes are always really colourful.",
          },
          {
            id: 27,
            key: "n",
            text_uz: "sharh,izoh",
            text_en: "comment",
            description: "I sometimes write comments on websites",
          },
          {
            id: 28,
            key: "n",
            text_uz: "dizayner",
            text_en: "designer",
            description: "Emma is a clothes designer, too",
          },
          {
            id: 29,
            key: "n",
            text_uz: "kiyim",
            text_en: "dress",
            description: "Her dresses are amazing!",
          },
          {
            id: 30,
            key: "v",
            text_uz: "yemoq",
            text_en: "eat",
            description: "When does your family eat dinner?",
          },
          {
            id: 31,
            key: "n",
            text_uz: "Yevropa",
            text_en: "Europe",
            description: "In northern Europe people put fake tan on their hands and faces",
          },
          {
            id: 32,
            key: "adv",
            text_uz: "har kuni",
            text_en: "every day",
            description: "It's open from ten to six every day",
          },
          {
            id: 33,
            key: "n",
            text_uz: "namuna,misol",
            text_en: "example",
            description: "Our neighbours, David and Erika, are a good example",
          },
          {
            id: 34,
            key: "adj",
            text_uz: "zavqli,hayajonli",
            text_en: "exciting",
            description: "Clothes shopping is exciting",
          },
          {
            id: 35,
            key: "n",
            text_uz: "chehra,yuz",
            text_en: "face",
            description: "She's got a really lovely face",
          },
          {
            id: 36,
            key: "phr",
            text_uz: "to'q rangli krem",
            text_en: "fake tan",
            description: "People use fake tan because they don't like white skin",
          },
          {
            id: 37,
            key: "adj",
            text_uz: "mashhur",
            text_en: "famous",
            description: "Mt.Angel is famous for its festival - the 'Oktoberfest'",
          },
          {
            id: 38,
            key: "n",
            text_uz: "rusm,moda",
            text_en: "fashion",
            description: "They love fashion, but they don't like new clothes",
          },
          {
            id: 39,
            key: "n",
            text_uz: "jihat",
            text_en: "feature",
            description: "The Allianz Arena has an interesting design feature - it changes colour",
          },
          {
            id: 40,
            key: "n",
            text_uz: "birinchi qavat",
            text_en: "first floor",
            description: "My office is on the first floor",
          },
          {
            id: 41,
            key: "n",
            text_uz: "qavat",
            text_en: "floor",
            description: "There's a restaurant on the top floor",
          },
          {
            id: 42,
            key: "n",
            text_uz: "gul",
            text_en: "flower",
            description: "They put white and red flowers on top of their heads",
          },
          {
            id: 43,
            key: "n",
            text_uz: "oyoq",
            text_en: "foot",
            description: "We wear shoes and socks on our feet",
          },
          {
            id: 44,
            key: "n",
            text_uz: "Fransiya",
            text_en: "France",
            description: "My friend has a house in France",
          },
          {
            id: 45,
            key: "phr",
            text_uz: "xarid qilmoq",
            text_en: "go shopping",
            description: "I sometimes go shopping with my wife",
          },
          {
            id: 46,
            key: "phr",
            text_uz: "yahshi sifatli",
            text_en: "good quality",
            description: "Expensive clothes are good quality",
          },
          {
            id: 47,
            key: "adj",
            text_uz: "yashil",
            text_en: "green",
            description: "I've got brown hair and green eyes",
          },
          {
            id: 48,
            key: "adj",
            text_uz: "kulrang",
            text_en: "grey",
            description: "I wear grey trousers to work",
          },
          {
            id: 49,
            key: "n",
            text_uz: "soch",
            text_en: "hair",
            description: "She's got really long hair",
          },
          {

            id: 50,
            key: "n",
            text_uz: "bosh",
            text_en: "head",
            description: "They've got very long hair and they put it up on their heads",
          },
          {
            id: 51,
            key: "n",
            text_uz: "qo'l",
            text_en: "hand",
            description: "Some people put fake tan on their hands",
          },
          {
            id: 52,
            key: "adj",
            text_uz: "muhim",
            text_en: "important",
            description: "Clothes are n't important to me",
          },
          {
            id: 53,
            key: "n",
            text_uz: "ish kunlarida",
            text_en: "in the week ",
            description: "I never wear casual clothes in the week",
          },
          {
            id: 54,
            key: "n",
            text_uz: "hind",
            text_en: "Indian",
            description: "Where do Indian women put henna?",
          },
          {
            id: 55,
            key: "n",
            text_uz: "ma'lumot",
            text_en: "information",
            description: "I have my travel information in an email",
          },
          {
            id: 56,
            key: "adj",
            text_uz: "qiziqarli",
            text_en: "interesting",
            description: "That building is really interesting",
          },
          {
            id: 57,
            key: "n",
            text_uz: "kurtka,pidjak",
            text_en: "jacket",
            description: "Has he got a red jacket?",
          },
          {
            id: 58,
            key: "n",
            text_uz: "djinsi shim",
            text_en: "jeans",
            description: "I like Ramon's jeans, but I don't like his hat",
          },
          {
            id: 59,
            key: "n",
            text_uz: "jemfer",
            text_en: "jumper",
            description: "I wear jumpers when it's cold",
          },
          {
            id: 60,
            key: "adj",
            text_uz: "kech",
            text_en: "late",
            description: "'I get up at 8 a.m .' 'That's late'",
          },
          {
            id: 61,
            key: "adj",
            text_uz: "charm",
            text_en: "leather",
            description: "David often wears cowboy shirts and leather jackets",
          },
          {
            id: 62,
            key: "v",
            text_uz: "jo'namoq",
            text_en: "leave",
            description: "The bus leaves a t 9.35",
          },
          {
            id: 63,
            key: "n",
            text_uz: "oyoq",
            text_en: "leg",
            description: "Women put it on their arms and legs",
          },
          {
            id: 64,
            key: "n",
            text_uz: "joylashuv, manzil",
            text_en: "location",
            description: "What's the location of the hotel?",
          },
          {
            id: 65,
            key: "adj",
            text_uz: "uzun",
            text_en: "long",
            description: "in Bolivia, some women wear really long skirts",
          },
          {
            id: 66,
            key: "n",
            text_uz: "tushlik",
            text_en: "lunch",
            description: "Do you want to meet fo r lunch?",
          },
          {
            id: 67,
            key: "n",
            text_uz: "jurnal",
            text_en: "magazine",
            description: "Fashion magazines often have young people in them ",
          },
          {
            id: 68,
            key: "phr",
            text_uz: "uchrashuv belgilamoq",
            text_en: "make arrangements",
            description: "I usually make arrangements with my friends by text message",
          },
          {
            id: 69,
            key: "n",
            text_uz: "peshin",
            text_en: "midday",
            description: "The restaurant is open from 12 midday to 12 at night",
          },
          {
            id: 70,
            key: "adj",
            text_uz: "zamonaviy",
            text_en: "modern",
            description: "Why do they like that modem building?",
          },
          {
            id: 71,
            key: "n",
            text_uz: "musiqa",
            text_en: "music",
            description: "what music does she like?",
          },
          {
            id: 72,
            key: "adv",
            text_uz: "hech qachon",
            text_en: "never",
            description: "They never wear the same clothes",
          },
          {
            id: 73,
            key: "adj",
            text_uz: "keyingisi",
            text_en: "next",
            description: "What time is the next metro?",
          },
          {
            id: 74,
            key: "n",
            text_uz: "xobbi",
            text_en: "hobby",
            description: "A new hobby gives us something to talk about with our friends and family",
          },
          {
            id: 75,
            key: "n",
            text_uz: "tun",
            text_en: "night",
            description: "The bar is open from 12 midday to 11 at night",
          },
          {
            id: 76,
            key: "adv",
            text_uz: "tez-tez",
            text_en: "often",
            description: "Matt often works at home",
          },
          {
            id: 77,
            key: "v",
            text_uz: "ochmoq",
            text_en: "open",
            description: "What time does them useum open?",
          },
          {
            id: 78,
            key: "n",
            text_uz: "ish vaqti",
            text_en: "opening times",
            description: "The opening timesof the shop are 9 a.m .in the week and 10 a.m . at weekends",
          },
          {
            id: 79,
            key: "adj",
            text_uz: "olov rang",
            text_en: "orange",
            description: "They want to have brown skin, but sometimes the colour is orange!",
          },
          {
            id: 80,
            key: "adv",
            text_uz: "tashqarida",
            text_en: "outside",
            description: "They don't wear it in the house but they wear it outside",
          },
          {
            id: 81,
            key: "adj",
            text_uz: "mashhur",
            text_en: "popular",
            description: "The cafe is a popular place to have food and drink",
          },
          {
            id: 82,
            key: "n",
            text_uz: "omma",
            text_en: "public",
            description: "Is it open to the public?",
          },
          {
            id: 83,
            key: "adv",
            text_uz: "haqiqattan",
            text_en: "really",
            description: "He's got really short hair",
          },
          {
            id: 84,
            key: "n",
            text_uz: "sabab",
            text_en: "reason",
            description: "What's the reason that you are late?",
          },
          {
            id: 85,
            key: "adj",
            text_uz: "qizil",
            text_en: "red",
            description: "Kuniko's got a beautiful red top",
          },
          {
            id: 86,
            key: "n",
            text_uz: "ro'mol",
            text_en: "shawl",
            description: "They wear a shawl around their body because it is sometimes very cold",
          },
          {
            id: 87,
            key: "n",
            text_uz: "ko'ylak(erkaklar)",
            text_en: "shirt",
            description: "He has a blue shirt",
          },
          {
            id: 88,
            key: "n",
            text_uz: "poyabzal",
            text_en: "shoes",
            description: "in New Zealand, children don't always wear shoes",
          },
          {
            id: 89,
            key: "n",
            text_uz: "teri",
            text_en: "skin",
            description: "People use fake tan because they don't like white skin",
          },
          {
            id: 90,
            key: "n",
            text_uz: "yubka",
            text_en: "skirt",
            description: "She has a really long skirt",
          },
          {
            id: 91,
            key: "adj",
            text_uz: "aqlli,jiddiy",
            text_en: "smart",
            description: "I never wear smart clothes at work",
          },
          {
            id: 92,
            key: "v",
            text_uz: "gapirmoq",
            text_en: "speak",
            description: "Do you speak English? ",
          },
          {
            id: 93,
            key: "n pl",
            text_uz: "sport",
            text_en: "sports",
            description: "My father sometimes wears sports clothes",
          },
          {
            id: 94,
            key: "n",
            text_uz: "stadion",
            text_en: "stadium",
            description: "The Allianz Arena is a football stadium in Munich",
          },
          {
            id: 95,
            key: "adj",
            text_uz: "g'alati",
            text_en: "strange",
            description: "It's really strange to see this",
          },
          {
            id: 96,
            key: "adj",
            text_uz: "kuchli",
            text_en: "strong",
            description: "The sun and wind are very strong in the Sahara",
          },
          {
            id: 97,
            key: "n",
            text_uz: "uslub",
            text_en: "style",
            description: "Their style is very traditional",
          },
          {
            id: 98,
            key: "n",
            text_uz: "quyosh",
            text_en: "sun",
            description: "The sun is strong in the Sahara",
          },
          {
            id: 99,
            key: "n",
            text_uz: "basseyn",
            text_en: "swimming pool",
            description: "There's a swimming pool and a park",
          },
          {
            id: 100,
            key: "n",
            text_uz: "jamoa",
            text_en: "team",
            description: "Different teams play football there",
          },
          {
            id: 101,
            key: "v",
            text_uz: "o'ylamoq",
            text_en: "think",
            description: "They think shoes are bad for their feet",
          },
          {
            id: 102,
            key: "n",
            text_uz: "tepa,ustki kiyim",
            text_en: "top",
            description: "Lucy's got a beautiful yellow top",
          },
          {
            id: 103,
            key: "n",
            text_uz: "shaharcha",
            text_en: "town",
            description: "What time is the next bus to the tow n centre?",
          },
          {
            id: 104,
            key: "adj",
            text_uz: "an'anaviy",
            text_en: "traditional",
            description: "On their bodies they wear a traditional dress called a kimono",
          },
          {
            id: 105,
            key: "n pl",
            text_uz: "krossovka",
            text_en: "trainers",
            description: "I wear trainers when l go running",
          },
          {
            id: 106,
            key: "v",
            text_uz: "sayohat qilmoq",
            text_en: "travel",
            description: "I travel by bus a lot",
          },
          {
            id: 107,
            key: "n pl",
            text_uz: "shim",
            text_en: "trousers",
            description: "A Sudanese woman doesn't wear trousers",
          },
          {
            id: 108,
            key: "n",
            text_uz: "futbolka",
            text_en: "T-shirt",
            description: "I usually wear a T-shirt on hot day",
          },
          {
            id: 109,
            key: "n",
            text_uz: "tur,xil",
            text_en: "type",
            description: "You probably think that there are many different types of clothes.",
          },
          {
            id: 110,
            key: "adj",
            text_uz: "noodatiy",
            text_en: "unusual",
            description: "This building is unusual - it changes colour",
          },
          {
            id: 111,
            key: "adj",
            text_uz: "foydali",
            text_en: "useful",
            description: "Why is English a useful language?",
          },
          {
            id: 102,
            key: "adv",
            text_uz: "odatda",
            text_en: "usually",
            description: "I usually go shopping at the weekend",
          },
          {
            id: 103,
            key: "v",
            text_uz: "kiymoq",
            text_en: "wear",
            description: "I often wear smart clothes at work",
          },
          {
            id: 104,
            key: "adj",
            text_uz: "oq",
            text_en: "white",
            description: "The Allianz Arena is white for the German national team ",
          },
          {
            id: 105,
            key: "",
            text_uz: "nima uchun",
            text_en: "why",
            description: "Why do you study English?",
          },
          {
            id: 106,
            key: "n",
            text_uz: "shamol",
            text_en: "wind",
            description: "The wind is very strong in the Arctic",
          },


        ],
        unit6: [
          {
            id: 1,
            key: "n",
            text_uz: "Foydalanish imkoniyati/ kirish huquqi",
            text_en: "access",
            description: "Guests have 24-hour access to the hotel.",
          },
          {
            id: 2,
            key: "n",
            text_uz: "konditsioner",
            text_en: "air conditioning",
            description: "There is air conditioning in every room.",
          },
          {
            id: 3,
            key: "det",
            text_uz: "hamma",
            text_en: "all",
            description: "All the flats have got lovely balconies.",
          },
          {
            id: 4,
            key: "det",
            text_uz: "boshqa, yana bir",
            text_en: "another",
            description: "You can have another room.",
          },
          {
            id: 5,
            key: "n",
            text_uz: "hudud, joy",
            text_en: "area",
            description: "There's one dining area fo r all the students in the flat.",
          },
          {
            id: 6,
            key: "v",
            text_uz: "yetib kelmoq",
            text_en: "arrive",
            description: "I arrive in Barcelona at four o'clock.",
          },
          {
            id: 7,
            key: "n",
            text_uz: "novvoyxona, pishiriqlar do'koni",
            text_en: "bakery",
            description: "There's an amazing bakery - my favourite shop in Lewisburg. ",
          },
          {
            id: 8,
            key: "n",
            text_uz: "balkon",
            text_en: "balcony",
            description: "Has each room got a balcony?",
          },
          {
            id: 9,
            key: "n",
            text_uz: "vanna",
            text_en: "bath",
            description: "Has our room got a bath?",
          },
          {
            id: 9,
            key: "n",
            text_uz: "hammom",
            text_en: "bathroom",
            description: "Each bathroom has got a shower and a toilet.",
          },
          {
            id: 10,
            key: "n",
            text_uz: "yotoq",
            text_en: "bed",
            description: "The other bedroom has got a European bed.",
          },
          {
            id: 11,
            key: "n",
            text_uz: "yotoqxona",
            text_en: "bedroom",
            description: "The bedrooms are very cold.",
          },
          {
            id: 12,
            key: "v",
            text_uz: "buyurtma bermoq",
            text_en: "book",
            description: "It looks great. Let's book it.",
          },
          {
            id: 13,
            key: "adj",
            text_uz: "singan",
            text_en: "broken",
            description: "The phone in my room is broken.",
          },
          {
            id: 14,
            key: "n",
            text_uz: "kafe",
            text_en: "cafe",
            description: "There's a cafe near the hotel.",
          },
          {
            id: 15,
            key: "n",
            text_uz: "mashina to'xtash joyi",
            text_en: "car park",
            description: "Is there a hotel car park?",
          },
          {
            id: 16,
            key: "n",
            text_uz: "stul, kursi",
            text_en: "chair",
            description: "There is a table and fo u r chairs on each balcony.",
          },
          {
            id: 17,
            key: "n",
            text_uz: "ro'yxatdan o'tish (mehmonxonada)",
            text_en: "check-in",
            description: "Check-in is after 2 p.m.",
          },
          {
            id: 18,
            key: "n",
            text_uz: "ro'yxatdsn chiqish (mehmonxonada)",
            text_en: "checkout",
            description: "Checkout is before 11 a.m.",
          },
          {
            id: 19,
            key: "adj",
            text_uz: "toza",
            text_en: "clean",
            description: "The room s in the hotel are clean.",
          },
          {
            id: 20,
            key: "n",
            text_uz: "kod",
            text_en: "code",
            description: "I don't know the code for the door.",
          },
          {
            id: 21,
            key: "n",
            text_uz: "shkaf",
            text_en: "cupboard",
            description: "There are to w e ls in the cupboard.",
          },
          {
            id: 22,
            key: "n",
            text_uz: "ovqatlanish xonasi",
            text_en: "dining room",
            description: "The fla t has g o t a sm all bathroom , a kitchen and a dining room ",
          },
          {
            id: 23,
            key: "adj",
            text_uz: "kir",
            text_en: "dirty",
            description: "The bathroom is very dirty.",
          },
          {
            id: 24,
            key: "n",
            text_uz: "ichimlik",
            text_en: "drink",
            description: "Are there any drinks in the fridge?",
          },
          {
            id: 25,
            key: "det",
            text_uz: "har bir",
            text_en: "each",
            description: "Has each fla t got a kitchen?",
          },
          {
            id: 26,
            key: "pl",
            text_uz: "qulayliklar",
            text_en: "facilities",
            description: "Mt. Angel doesn 't have a lot of facilities.",
          },
          {
            id: 27,
            key: "n",
            text_uz: "festival, bayram",
            text_en: "festival",
            description: "Mt. Angel has a fam ous festival.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "baliq ovi",
            text_en: "fishing",
            description: "There are lots of things to do - walking, sw im m ing and fishing. ",
          },
          {
            id: 29,
            key: "phr",
            text_uz: "soatlab",
            text_en: "for hours",
            description: "He can listen to the Beatles for hours.",
          },
          {
            id: 30,
            key: "n",
            text_uz: "o'rmon",
            text_en: "forest",
            description: "People walk in the forest and in the mountains.",
          },
          {
            id: 31,
            key: "phr",
            text_uz: "bepul mashina qo'yish joyi",
            text_en: "free parking",
            description: "The hotel has free parking, Wi-fi and a gym.",
          },
          {
            id: 32,
            key: "n",
            text_uz: "muzlatgich",
            text_en: "fridge",
            description: "There's a small kitchen with a fridge and microwave.",
          },
          {
            id: 33,
            key: "v",
            text_uz: "bermoq",
            text_en: "give",
            description: "Please give me the code.",
          },
          {
            id: 34,
            key: "n",
            text_uz: "golf maydoni",
            text_en: "golf course",
            description: "There's a golf course near the town.",
          },
          {
            id: 35,
            key: "",
            text_uz: "mehmon",
            text_en: "guest",
            description: "Is there free Wi-fi for guests?",
          },
          {
            id: 36,
            key: "n",
            text_uz: "Sport zali",
            text_en: "GYM",
            description: "It has alotof good facilities: tennis, mini-golf and a gym.",
          },
          {
            id: 37,
            key: "",
            text_uz: "oldindan buyurtmaga ega bo'lmoq",
            text_en: "have a reservation",
            description: "I have a reservation. The name is Davis.",
          },
          {
            id: 38,
            key: "phr",
            text_uz: "isitgich",
            text_en: "heater",
            description: "There's a heater in the room.",
          },
          {
            id: 39,
            key: "pl",
            text_uz: "qo'llanma",
            text_en: "instructions",
            description: "They can't understand the instructions.",
          },
          {
            id: 40,
            key: "n",
            text_uz: "internet",
            text_en: "internet",
            description: "Are you on the internet? ",
          },
          {
            id: 41,
            key: "n",
            text_uz: "dazmol",
            text_en: "iron",
            description: "Is there an iron in the room ?",
          },
          {
            id: 42,
            key: "n",
            text_uz: "dazmol doskasi",
            text_en: "ironing board",
            description: "Each room has an ironing board.",
          },
          {
            id: 43,
            key: "n",
            text_uz: "oshxona",
            text_en: "kitchen",
            description: "Each kitchen has got a big fridge.",
          },
          {
            id: 44,
            key: "n",
            text_uz: "lift",
            text_en: "lift",
            description: "There isn't a lift in this hotel.",
          },
          {
            id: 45,
            key: "phr",
            text_uz: "men kabi",
            text_en: "like me",
            description: "It's a great place for people like me.",
          },
          {
            id: 46,
            key: "n",
            text_uz: "havola",
            text_en: "link",
            description: "I'll send you the link to the flats.",
          },
          {
            id: 47,
            key: "n",
            text_uz: "mehmonxona",
            text_en: "living room",
            description: "There's a living room for all the flats.",
          },
          {
            id: 48,
            key: "adj",
            text_uz: "mahalliy",
            text_en: "local",
            description: "A bus goes to the local town, Nikiti.",
          },
          {
            id: 49,
            key: "v",
            text_uz: "sevmoq",
            text_en: "love",
            description: "I live in Lewisburg and l love the place.",
          },
          {
            id: 50,
            key: "adj",
            text_uz: "omadli",
            text_en: "lucky",
            description: "There are a lot of things to do - we're very lucky.",
          },
          {
            id: 51,
            key: "n",
            text_uz: "mikro to'lqinli pech",
            text_en: "microwave",
            description: "The fridge and the microwave are in the kitchen.",
          },
          {
            id: 52,
            key: "n",
            text_uz: "minibar",
            text_en: "mini-bar",
            description: "The mini-bar has got tea, coffee and water.",
          },
          {
            id: 53,
            key: "n",
            text_uz: "minut, daqiqa",
            text_en: "minute",
            description: "This flat in Hiroshima is twenty minutes from the city centre. ",
          },
          {
            id: 54,
            key: "n",
            text_uz: "tog'",
            text_en: "mountain",
            description: "There are m ountains near here.",
          },
          {
            id: 55,
            key: "adj",
            text_uz: "shovqinli",
            text_en: "noisy",
            description: "Our room is very noisy.",
          },
          {
            id: 56,
            key: "adj",
            text_uz: "shaxsiy",
            text_en: "own",
            description: "Have ail the flats got their own kitchen?",
          },
          {
            id: 57,
            key: "n",
            text_uz: "parol",
            text_en: "password",
            description: "The Wi-fi password is 'guest'.",
          },
          {
            id: 58,
            key: "n",
            text_uz: "pitsa",
            text_en: "pizza",
            description: "There's a great pizza restaurant on my street.",
          },
          {
            id: 59,
            key: "n",
            text_uz: "muammo",
            text_en: "problem",
            description: "One problem is that Lewisburg has a lot of visitors.",
          },
          {
            id: 60,
            key: "adj",
            text_uz: "tinch, osoyishta",
            text_en: "quiet",
            description: "She's got a quiet room in the hotel.",
          },
          {
            id: 61,
            key: "n",
            text_uz: "qabulxona",
            text_en: "reception",
            description: "There is free Wi-fi in reception.",
          },
          {
            id: 62,
            key: "n",
            text_uz: "qabulxona xodimi",
            text_en: "receptionist",
            description: "My sister works as a receptionist in a hotel.",
          },
          {
            id: 63,
            key: "pl",
            text_uz: "salqin ichimliklar",
            text_en: "refreshments",
            description: "I like refreshm ents in my room.",
          },
          {
            id: 64,
            key: "n",
            text_uz: "seyf",
            text_en: "safe",
            description: "The code for the safe is B50079.",
          },
          {
            id: 65,
            key: "v",
            text_uz: "jo'natmoq, yubormoq",
            text_en: "send",
            description: "I'll send someone to help.",
          },
          {
            id: 66,
            key: "n",
            text_uz: "dush",
            text_en: "shower",
            description: "The shower in my room is broken.",
          },
          {
            id: 67,
            key: "n",
            text_uz: "divan",
            text_en: "sofa",
            description: "The sofa is in the living room.",
          },
          {
            id: 68,
            key: "n",
            text_uz: "xodim, ishchi",
            text_en: "staff",
            description: "The staff are lovely.",
          },
          {
            id: 69,
            key: "n",
            text_uz: "supermarket",
            text_en: "supermarket",
            description: "There is a big supermarket in the town.",
          },
          {
            id: 70,
            key: "n",
            text_uz: "vklyuchatel",
            text_en: "switch",
            description: "The switch is near the door.",
          },
          {
            id: 71,
            key: "n",
            text_uz: "stol",
            text_en: "table",
            description: "The table is on the balcony.",
          },
          {
            id: 72,
            key: "n",
            text_uz: "choy",
            text_en: "tea",
            description: "The restaurant serves tea and coffee.",
          },
          {
            id: 73,
            key: "n",
            text_uz: "teatr",
            text_en: "theatre",
            description: "There's a Shakespeare play on at the theatre.",
          },
          {
            id: 74,
            key: "n",
            text_uz: "mavzu",
            text_en: "theme",
            description: "Each room has a car theme.",
          },
          {
            id: 75,
            key: "n",
            text_uz: "tualet, hojatxona",
            text_en: "toilet",
            description: "Each bathroom has got a toilet.",
          },
          {
            id: 76,
            key: "pl",
            text_uz: "sochiqlar",
            text_en: "towels",
            description: "There a ren't any towels in the bathroom.",
          },
          {
            id: 77,
            key: "n",
            text_uz: "daraxtdagi uy",
            text_en: "treehouse",
            description: "it looks like a big tree house.",
          },
          {
            id: 78,
            key: "n",
            text_uz: "urinib ko'rmoq",
            text_en: "try",
            description: "Try in the cupboard near the window.",
          },
          {
            id: 79,
            key: "n",
            text_uz: "televizor",
            text_en: "TV",
            description: "The TV is in the living room.",
          },
          {
            id: 80,
            key: "n",
            text_uz: "mehmon",
            text_en: "visitor",
            description: "Lewisburg has a lot of visitors.",
          },
          {
            id: 81,
            key: "n",
            text_uz: "suv",
            text_en: "water",
            description: "All the room s have cold and hot water.",
          },
          {
            id: 82,
            key: "n",
            text_uz: "vebsayt",
            text_en: "website",
            description: "There are some really nice flats on this website.",
          },
          {
            id: 83,
            key: "n",
            text_uz: "vay-fay",
            text_en: "Wi-fi",
            description: "Is there free Wi-fi in the hotel?",
          },
        ],
        unit7: [
          {
            id: 1,
            key: "n",
            text_uz: "(bir) shisha ",
            text_en: "a bottle of",
            description: "Can I have a bottle of water, please?",
          },
          {
            id: 2,
            key: "n",
            text_uz: "e'lon",
            text_en: "advert ",
            description: "Look at this job advert - it looks really interesting.",
          },
          {
            id: 3,
            key: "n",
            text_uz: "qobiliyat",
            text_en: "ability",
            description: "Koko has an unusual ability: she understands language.",
          },
          {
            id: 4,
            key: "n",
            text_uz: "Jazoyir",
            text_en: "Algeria",
            description: "My name is Khalid. I'm from Algeria.",
          },
          {
            id: 5,
            key: "n",
            text_uz: "hayvon",
            text_en: "animal",
            description: "She can't paint animals.",
          },
          {
            id: 6,
            key: "adv",
            text_uz: "yomon",
            text_en: "badly",
            description: "I like playing the guitar, but l play badly.",
          },
          {
            id: 7,
            key: "n",
            text_uz: "hulq - atvor",
            text_en: "behaviour",
            description: "The Dolphin Research Project studies dolphins' behaviour.",
          },
          {
            id: 8,
            key: "n",
            text_uz: "qush",
            text_en: "bird",
            description: "Murphy's an amazing bird.",
          },
          {
            id: 9,
            key: "adj",
            text_uz: "zerikkan",
            text_en: "bored",
            description: "I'm always bored at the weekend.",
          },
          {
            id: 10,
            key: "adj",
            text_uz: "zerikarli",
            text_en: "boring",
            description: "I don't like watching football - it's really boring.",
          },
          {
            id: 11,
            key: "n",
            text_uz: "quti, korobka",
            text_en: "box",
            description: "I can't open this box.",
          },
          {
            id: 12,
            key: "n pl",
            text_uz: "kompyuter ko'nikmalari",
            text_en: "computer skills",
            description: "It's very useful to have good computer skills.",
          },
          {
            id: 13,
            key: "v",
            text_uz: "aloga qilmoq,bog'lanmoq",
            text_en: "contact",
            description: "Please contact me, so we can speak English to each other.",
          },
          {
            id: 14,
            key: "v",
            text_uz: "pishirmoq",
            text_en: "cook",
            description: "My partner cooks delicious food.",
          },
          {
            id: 15,
            key: "v",
            text_uz: "narlanmoq, ...narx turmoq",
            text_en: "cost",
            description: "How much does it cost?",
          },
          {
            id: 16,
            key: "v",
            text_uz: "raqsga tushmoq",
            text_en: "dance",
            description: "I can't dance very well.",
          },
          {
            id: 17,
            key: "n",
            text_uz: "delfin",
            text_en: "dolphin",
            description: "Dolphins can understand about sixty words.",
          },
          {
            id: 18,
            key: "pron",
            text_uz: "bir-birini/-ga/-dan",
            text_en: "each other",
            description: "My friend and I speak Spanish to each other.",
          },
          {
            id: 19,
            key: "n",
            text_uz: "elektrik pianino",
            text_en: "electric piano",
            description: "Koko can play an electric piano.",
          },
          {
            id: 20,
            key: "adj",
            text_uz: "shijoatli",
            text_en: "enthusiastic",
            description: "We want enthusiastic English teachers for our summer school.",
          },
          {
            id: 21,
            key: " adj",
            text_uz: "tez",
            text_en: "fast",
            description: "I'm a fast learner.",
          },
          {
            id: 22,
            key: "adv",
            text_uz: "tezda",
            text_en: "fast",
            description: "She can type fast.",
          },
          {
            id: 23,
            key: "v",
            text_uz: "uchmoq",
            text_en: "fly",
            description: "Birds can fly.",
          },
          {
            id: 24,
            key: "n",
            text_uz: "xorijiy til",
            text_en: "foreign language",
            description: "I can speak three foreign languages.",
          },
          {
            id: 25,
            key: "phr",
            text_uz: "feysbukga kirmoq",
            text_en: "go on Facebook",
            description: "I sometimes go on Facebook at work.",
          },
          {
            id: 26,
            key: "phr",
            text_uz: "do'stlari bilan sayrga chiqmoq",
            text_en: "go out with friends",
            description: "At the weekend, I out with friends",
          },
          {
            id: 27,
            key: "phr",
            text_uz: "kinoga bormoq",
            text_en: "go to the cinema",
            description: "We go to the cinema every weekend.",
          },
          {
            id: 28,
            key: "phr",
            text_uz: "teatrga bormoq",
            text_en: "go to the theatre",
            description: "I never go to the theatre.",
          },
          {
            id: 29,
            key: "n",
            text_uz: "oltin baliq",
            text_en: "goldfish",
            description: "Comet the goldfish can play football and basketball.",
          },
          {
            id: 30,
            key: "n",
            text_uz: "gorilla",
            text_en: "gorilla",
            description: "Koko is a gorilla.",
          },
          {
            id: 31,
            key: "n",
            text_uz: "yo'lboshlovchi, gid",
            text_en: "guide",
            description: "My mother is a tour guide in Cambridge.",
          },
          {
            id: 32,
            key: "v",
            text_uz: "yomon ko'rmoa",
            text_en: "hate",
            description: "I hate playing tennis.",
          },
          {
            id: 33,
            key: "n",
            text_uz: "qiziqqan mashg'uloti",
            text_en: "hobby",
            description: "My hobbies are football and rock music.",
          },
          {
            id: 34,
            key: "n",
            text_uz: "qiziqish",
            text_en: "interest",
            description: "She is very interested in Koko.",
          },
          {
            id: 35,
            key: "adj",
            text_uz: "giziqqan",
            text_en: "interested in",
            description: "She is very interested in Koko.",
          },
          {
            id: 36,
            key: "v",
            text_uz: "bilmoq",
            text_en: "Know",
            description: "Do you know any clever animals?",
          },
          {
            id: 37,
            key: "n",
            text_uz: "Livan",
            text_en: "Lebanon",
            description: "Ziad Fazah, from Lebanon, can speak fifty eight languages.",
          },
          {
            id: 38,
            key: "v",
            text_uz: "musiqa tinglamoq",
            text_en: "listen to music",
            description: "I always listen to music in the car.",
          },
          {
            id: 39,
            key: "adj",
            text_uz: "adashgan, yo'qolib qolgan",
            text_en: "lost",
            description: "I'm lost. Can you tell me the way to the station?",
          },
          {
            id: 40,
            key: "phr",
            text_uz: "narsalar tayyorlamoq",
            text_en: "make things",
            description: "My sister often makes thinks to give as presents",
          },
          {
            id: 41,
            key: " pron",
            text_uz: "hech kim",
            text_en: "nobody",
            description: "Nobody in our group goes to work by ferry.",
          },
          {
            id: 42,
            key: "n",
            text_uz: "mo'yqalam",
            text_en: "paintbrush",
            description: "Koko can use a paintbrush.",
          },
          {
            id: 43,
            key: "n",
            text_uz: "to'ti",
            text_en: "parrot",
            description: "My neighbours have a parrot, Murphy.",
          },
          {
            id: 44,
            key: "n",
            text_uz: "surat",
            text_en: "picture",
            description: "Koko can paint a picture of a bird.",
          },
          {
            id: 45,
            key: "phr",
            text_uz: "sport o'yinlarini o'ynamoq",
            text_en: "play sport",
            description: "I often play sport in the evenings.",
          },
          {
            id: 46,
            key: "phr",
            text_uz: "video o'yinlari o'ynamoq",
            text_en: "play video games",
            description: "My son plays video games all weekend!",
          },
          {
            id: 47,
            key: "n",
            text_uz: "post, xabar, e'lon",
            text_en: "post",
            description: "I write a post on my blog every day.",
          },
          {
            id: 48,
            key: "v",
            text_uz: "yozib olmoq",
            text_en: "record",
            description: "When you learn a new word, record it in a notebook.",
          },
          {
            id: 49,
            key: "v",
            text_uz: "eslamoq",
            text_en: "remember",
            description: "She remembers people's faces.",
          },
          {
            id: 50,
            key: "n",
            text_uz: "tadqiqod",
            text_en: "research",
            description: "My friend works with gorillas on a research project.",
          },
          {
            id: 51,
            key: "v",
            text_uz: "minmoq",
            text_en: "ride",
            description: "She can ride a motorbike.",
          },
          {
            id: 52,
            key: "v",
            text_uz: "yugurmoq",
            text_en: "run",
            description: "I can't run fast.",
          },
          {
            id: 53,
            key: "n",
            text_uz: "o'rindiq, joy",
            text_en: "seat",
            description: "Excuse me. That's my seat.",
          },
          {
            id: 54,
            key: "phr",
            text_uz: "onlayn xarid qilmoq",
            text_en: "shop online",
            description: "I shop online for clothes because it's easy and cheap.",
          },
          {
            id: 55,
            key: "n",
            text_uz: "belgi",
            text_en: "sign",
            description: "She can use over 1,000 signs.",
          },
          {
            id: 56,
            key: "v",
            text_uz: "kuylamoq",
            text_en: "sing",
            description: "Murphy can sing and speak.",
          },
          {
            id: 57,
            key: "n",
            text_uz: "ko'nikma, mahorat",
            text_en: "skill",
            description: "It's important to learn new skills.",
          },
          {
            id: 58,
            key: "adv",
            text_uz: "sekin-asta",
            text_en: "slowly",
            description: "Can you speak slowly?",
          },
          {
            id: 59,
            key: "n",
            text_uz: "ijtimoiy tarmoq",
            text_en: "social media",
            description: "I use social media to talk to my friends and family.",
          },
          {
            id: 60,
            key: "n",
            text_uz: "ispancha",
            text_en: "Spanish",
            description: "I can't speak Spanish.",
          },
          {
            id: 61,
            key: " v",
            text_uz: "suzmog",
            text_en: "swim",
            description: "You can swim well.",
          },
          {
            id: 62,
            key: "n",
            text_uz: "suzuvchi",
            text_en: "swimmer",
            description: "Is Jack a good swimmer?",
          },
          {
            id: 63,
            key: "phr",
            text_uz: "suratga olmoq",
            text_en: "take photos",
            description: "What do you take photos of?",
          },
          {
            id: 64,
            key: "adj",
            text_uz: "chanqagan",
            text_en: "thirsty",
            description: "I'm really thirsty.",
          },
          {
            id: 65,
            key: "n",
            text_uz: "sayyoh",
            text_en: "tourist",
            description: "A lot of tourists visit Lewisburg.",
          },
          {
            id: 66,
            key: "n",
            text_uz: "tarjimon",
            text_en: "translator",
            description: "My wife Jane is a translator.",
          },
          {
            id: 67,
            key: "v",
            text_uz: "harf termoq",
            text_en: "type",
            description: "type very slowly.",
          },
          {
            id: 68,
            key: "n",
            text_uz: "mashinist",
            text_en: "typist",
            description: "I am a bad typist.",
          },
          {
            id: 69,
            key: "n",
            text_uz: "Urugvay",
            text_en: "Uruguay",
            description: "In Uruguay people never speak English",
          },
          {
            id: 70,
            key: "n",
            text_uz: "video",
            text_en: "video",
            description: "In one video, we watch Koko as she uses a paintbrush.",
          },
          {
            id: 71,
            key: "n",
            text_uz: "ko'ngilli",
            text_en: "volunteer",
            description: "I'm a volunteer on a research project in Zanzibar.",
          },
          {
            id: 72,
            key: "phr",
            text_uz: "sport oyinlari tomosha qilmoq",
            text_en: "watch sport",
            description: "I watch sport on TV with my friends.",
          },
          {
            id: 73,
            key: " adv",
            text_uz: "yaxshi",
            text_en: "well",
            description: "They can't use a computer well.",
          },
          {
            id: 74,
            key: "phr",
            text_uz: "bog'da ishlamoq",
            text_en: "work in the garden",
            description: "My grandfather always works in the garden on sunny days.",
          },
          {
            id: 75,
            key: "v",
            text_uz: "yozmoq",
            text_en: "write",
            description: "He writes amazing songs",
          },
        ],
        unit8: [
          {
            id: 1,
            key: "n",
            text_uz: "baxtsiz xodisa",
            text_en: "accident",
            description: "He died in a flying accident in 1869.",
          },
          {
            id: 2,
            key: "n",
            text_uz: "aktirisa",
            text_en: "actress",
            description: "Ingrid Bergman was an actress from Sweden.",
          },
          {
            id: 3,
            key: "n",
            text_uz: "sarguzasht",
            text_en: "adventure",
            description: "They both loved adventure.",
          },
          {
            id: 4,
            key: "n",
            text_uz: "maqola",
            text_en: "artecle",
            description: "This is an interesting article about people from history.",
          },
          {
            id: 5,
            key: "n",
            text_uz: "astronavt",
            text_en: "astronaut",
            description: "His dream was to be an astronaut",
          },
          {
            id: 6,
            key: "n",
            text_uz: "tavallud kun",
            text_en: "birthday",
            description: "When is your birthday?",
          },
          {
            id: 7,
            key: "n",
            text_uz: "xo`jayin, raxbar",
            text_en: "boss",
            description: "Bill Gates was the boss of Microsoft.",
          },
          {
            id: 8,
            key: "n",
            text_uz: "duradgor",
            text_en: "carpenter",
            description: "Wnek was a carpenter and had no school education.",
          },
          {
            id: 9,
            key: "n",
            text_uz: "asr",
            text_en: "century",
            description: "The Brothers Grimm lived in the 19th century.",
          },
          {
            id: 10,
            key: "n pl",
            text_uz: "(ertak,voqea)qahramonlar",
            text_en: "characters",
            description: "The characters were real children from different placesin England.",
          },
          {
            id: 11,
            key: "v",
            text_uz: "to`plamoq",
            text_en: "collect",
            description: "They were interested in tales and started to collect them .",
          },
          {
            id: 12,
            key: "v",
            text_uz: "o`lmoq, vafot etmoq",
            text_en: "die",
            description: "After their father died, life was very difficult.",
          },
          {
            id: 13,
            key: "n",
            text_uz: "xujjat",
            text_en: "document",
            description: "The films are important historical documents.",
          },
          {
            id: 14,
            key: "n",
            text_uz: "tush, orzu",
            text_en: "dream",
            description: "Her dream was to be married and have a family.",
          },
          {
            id: 15,
            key: "n",
            text_uz: "asos, fond",
            text_en: "foundation",
            description: "They use the Gates Foundation to help poor people.",
          },
          {
            id: 16,
            key: "n",
            text_uz: "planyor, glayder",
            text_en: "glider",
            description: "He wanted to make the world's firs t glider.",
          },
          {
            id: 17,
            key: "phr v",
            text_uz: "ulg`aymoq",
            text_en: "grow up",
            description: "We watch him as he grows up.",
          },
          {
            id: 18,
            key: "n",
            text_uz: "ot(hayvon)",
            text_en: "horse",
            description: "She and her father travelled around California on horses.",
          },
          {
            id: 19,
            key: "det",
            text_uz: "o`tgan(yili)",
            text_en: "last(year)",
            description: "We were on holiday in South Africa last year.",
          },
          {
            id: 20,
            key: "n",
            text_uz: "sardor, ledir",
            text_en: "leader",
            description: "He was a civil rights leader from the USA.",
          },
          {
            id: 21,
            key: "n",
            text_uz: "bazm",
            text_en: "party",
            description: "I can come to your party.",
          },
          {
            id: 22,
            key: "adj",
            text_uz: "haqiqiy",
            text_en: "real",
            description: "The characters were real children.",
          },
          {
            id: 23,
            key: "v",
            text_uz: "qaytmoq, qaytarmoq",
            text_en: "return",
            description: "When she returned to the USA, she talked to people about her travels.",
          },
          {
            id: 24,
            key: "n",
            text_uz: "olim",
            text_en: "scientist",
            description: "Marie Sktodowska-Curie was a scientist from Poland.",
          },
          {
            id: 25,
            key: "n",
            text_uz: "hikoyachi",
            text_en: "storyteller",
            description: "Hans Christian Andersen was a famous storyteller from Denmark.",
          },
          {
            id: 26,
            key: "n",
            text_uz: "ertak",
            text_en: "tale",
            description: "He wrote tales fo r children.",
          },
          {
            id: 27,
            key: "phr",
            text_uz: "tug`ilgan",
            text_en: "was/were born",
            description: "They were born in Hanau, Germany,",
          },
          {
            id: 28,
            key: "adv",
            text_uz: "kecha",
            text_en: "yesterday",
            description: "I listened to her for two hours yesterday.",
          },
          {
            id: 29,
            key: "-",
            text_uz: "birinchi",
            text_en: "first",
            description: " ",
          },
          {
            id: 30,
            key: "-",
            text_uz: "ikkinchi",
            text_en: "second",
            description: " ",
          },
          {
            id: 31,
            key: "-",
            text_uz: "uchinchi",
            text_en: "thrid",
            description: " ",
          },
          {
            id: 32,
            key: "-",
            text_uz: "to'rtinchi",
            text_en: "fourth",
            description: " ",
          },
          {
            id: 33,
            key: "-",
            text_uz: "beshinchi",
            text_en: "fifth",
            description: " ",
          },
          {
            id: 34,
            key: "-",
            text_uz: "oltinchi",
            text_en: "sixth ",
            description: " ",
          },
          {
            id: 35,
            key: "-",
            text_uz: "yettinchi",
            text_en: "seventh ",
            description: " ",
          },
          {
            id: 36,
            key: "-",
            text_uz: "sakkizinchi",
            text_en: "eighth",
            description: " ",
          },
          {
            id: 37,
            key: "-",
            text_uz: "to`qqizinchi",
            text_en: "ninth",
            description: " ",
          },
          {
            id: 38,
            key: "-",
            text_uz: "o`ninchi",
            text_en: "tenth",
            description: " ",
          },
          {
            id: 39,
            key: "-",
            text_uz: "o`n birinchi",
            text_en: "eleventh",
            description: " ",
          },
          {
            id: 40,
            key: "",
            text_uz: "o`n ikkinchi",
            text_en: "twelfth",
            description: " ",
          },
          {
            id: 41,
            key: "-",
            text_uz: "yigirmanchi",
            text_en: "twentieth",
            description: " ",
          },
          {
            id: 42,
            key: "-",
            text_uz: "yigirma birinchi",
            text_en: "twenty-first",
            description: " ",
          },
          {
            id: 43,
            key: "-",
            text_uz: "o`ttizinchi",
            text_en: "thirtieth",
            description: " ",
          },
          {
            id: 44,
            key: "-",
            text_uz: "o`ttiz birinchi",
            text_en: "thirtieth-first",
            description: " ",
          },
          {
            id: 45,
            key: "-",
            text_uz: "oylar",
            text_en: "months",
            description: " ",
          },
          {
            id: 46,
            key: "-",
            text_uz: "Yanvar",
            text_en: "January",
            description: " ",
          },
          {
            id: 47,
            key: "-",
            text_uz: "Fevral",
            text_en: "February",
            description: " ",
          },
          {
            id: 48,
            key: "-",
            text_uz: "Mart",
            text_en: "March",
            description: " ",
          },
          {
            id: 49,
            key: "-",
            text_uz: "Aprel",
            text_en: "April",
            description: " ",
          },
          {
            id: 50,
            key: "-",
            text_uz: "May",
            text_en: "May",
            description: " ",
          },
          {
            id: 51,
            key: "-",
            text_uz: "Iyun",
            text_en: "June",
            description: " ",
          },
          {
            id: 52,
            key: "-",
            text_uz: "Iyul",
            text_en: "July",
            description: " ",
          },
          {
            id: 53,
            key: "-",
            text_uz: "Avgust",
            text_en: "August",
            description: " ",
          },
          {
            id: 54,
            key: "-",
            text_uz: "Sentabr",
            text_en: "September",
            description: " ",
          },
          {
            id: 55,
            key: "-",
            text_uz: "Oktabr",
            text_en: "October",
            description: " ",
          },
          {
            id: 56,
            key: "-",
            text_uz: "Noyabr",
            text_en: "November",
            description: " ",
          },
          {
            id: 57,
            key: "-",
            text_uz: "Dekabr",
            text_en: "December",
            description: " ",
          },
        ],
        unit9: [
          {
            id: 1,
            key: "n",
            text_uz: "dan olish kuni",
            text_en: "a day off",
            description: "l didn't go to work yesterday - it was my dayoff.",
          },
          {
            id: 2,
            key: "adv",
            text_uz: "avval, oldin",
            text_en: "ago",
            description: "The train left an hour ago.",
          },
          {
            id: 3,
            key: "n",
            text_uz: "muhit",
            text_en: "atmosphere",
            description: "The atmosphere was great,",
          },
          {
            id: 4,
            key: "n",
            text_uz: "kuz",
            text_en: "autumn",
            description: "in autumn it isn't hot, but it is warm.",
          },
          {
            id: 5,
            key: "n",
            text_uz: "xisob",
            text_en: "bill",
            description: "A customer left a $3,000 tip on an $88 bill,",
          },
          {
            id: 6,
            key: "adj",
            text_uz: "bulutli",
            text_en: "cloud ",
            description: "in winter it is cloudy and often rainy",
          },
          {
            id: 7,
            key: "adj",
            text_uz: "sovuq",
            text_en: "cold",
            description: "Was it cold in New York today?",
          },
          {
            id: 8,
            key: "v",
            text_uz: "kelmoq",
            text_en: "come",
            description: "Deborah often came to England to visit Clive.",
          },
          {
            id: 9,
            key: "n",
            text_uz: "komik",
            text_en: "comidian",
            description: "We saw a comedian but he wasn't very funny.",
          },
          {
            id: 10,
            key: "n",
            text_uz: "narx",
            text_en: "cost",
            description: "Normally the tip is between 10 and 20% of the cost of the meal.",
          },
          {
            id: 11,
            key: "adj",
            text_uz: "qiyin",
            text_en: "difficult",
            description: "Life was very difficult for them .",
          },
          {
            id: 12,
            key: "n",
            text_uz: "oxiri, xotima",
            text_en: "ending",
            description: "The film has a really sad ending.",
          },
          {
            id: 13,
            key: "n",
            text_uz: "voqea",
            text_en: "event",
            description: "Lots of events happened in my life last year.",
          },
          {
            id: 14,
            key: "n",
            text_uz: "disert(shirinlik)",
            text_en: "dessert",
            description: "I`d like to have some dessert",
          },
          {
            id: 15,
            key: "n",
            text_uz: "baxona",
            text_en: "excuse",
            description: "What's your excuse for being late?",
          },
          {
            id: 16,
            key: "n",
            text_uz: "ichimlik",
            text_en: "drink",
            description: "Would you like a hot drink?",
          },
          {
            id: 17,
            key: "v",
            text_uz: "yiqilmoq",
            text_en: "fall",
            description: "I was in the kitchen and the fridge fell on me.",
          },
          {
            id: 18,
            key: "phr",
            text_uz: "sevib qolmoq",
            text_en: "fall in love",
            description: "They fell in love and married in 1984. ",
          },
          {
            id: 19,
            key: "v",
            text_uz: "unutmoq",
            text_en: "forget",
            description: "I forgot the time of my meeting with the team .",
          },
          {
            id: 20,
            key: "v",
            text_uz: "avtobusga chiqmoq",
            text_en: "get a bus",
            description: "Why did you get the bus today?",
          },
          {
            id: 21,
            key: "phr",
            text_uz: "tobi qochmoq, kasal bo`lmoq",
            text_en: "get ill",
            description: "He had a good holiday, but he got ill in Tangiers.",
          },
          {
            id: 22,
            key: "v",
            text_uz: "sodir bo`lmoq",
            text_en: "happen",
            description: "When did it happen?",
          },
          {
            id: 23,
            key: "phr",
            text_uz: "vaqtni yaxshi o`tkazmoq",
            text_en: "have a good time",
            description: "Did you have a good time?",
          },
          {
            id: 24,
            key: "n",
            text_uz: "bosh og`rig`i",
            text_en: "headache",
            description: "She had a really bad headache and felt sick.",
          },
          {
            id: 25,
            key: "adv",
            text_uz: "qo`rqinchli film",
            text_en: "horror film",
            description: "I watched a horror film and I couldn't sleep.",
          },
          {
            id: 26,
            key: "adj",
            text_uz: "issiq",
            text_en: "hot",
            description: "It's never very hot and it's never very cold.",
          },
          {
            id: 27,
            key: "adj",
            text_uz: "ulka",
            text_en: "huge",
            description: "A waiter got a huge tip - $7,000 - on a $50 bill.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "kasallik",
            text_en: "illness",
            description: "After his illness, he couldn't remember anything,",
          },
          {
            id: 29,
            key: "adv",
            text_uz: "rosti, aslida",
            text_en: "in fact",
            description: "in fact, one or two of the bands were terrible.",
          },
          {
            id: 30,
            key: "v",
            text_uz: "isinmoq",
            text_en: "keep(warm)",
            description: "Diaz gave him his wallet and his jacket to keep him warm .",
          },
          {
            id: 31,
            key: "n",
            text_uz: "pichoq",
            text_en: "knife",
            description: "He saw a boy with a knife.",
          },
          {
            id: 32,
            key: "v",
            text_uz: "yo`qotmoq",
            text_en: "lose",
            description: "He got very ill and lost his memory.",
          },
          {
            id: 33,
            key: "n",
            text_uz: "go'sht",
            text_en: "meat",
            description: "We need some meat for the barbecue.",
          },
          {
            id: 34,
            key: "n",
            text_uz: "uchrashmoq",
            text_en: "meet",
            description: "I met my husband, John, when l was five years old!",
          },
          {
            id: 35,
            key: "n",
            text_uz: "xotira",
            text_en: "memory",
            description: "Bob had an amazing memory.",
          },
          {
            id: 36,
            key: "n",
            text_uz: "millioner",
            text_en: "millionaire",
            description: "People think that it is a group of internet millionaires from California.",
          },
          {
            id: 37,
            key: "v",
            text_uz: "o`tkazib yubormoq(poyezdni)",
            text_en: "miss(the trian)",
            description: "I was late for work because l missed the train.",
          },
          {
            id: 38,
            key: "n",
            text_uz: "xato",
            text_en: "mistake",
            description: "The waiter thought it was a mistake.",
          },
          {
            id: 39,
            key: "adj",
            text_uz: "yomg`irli",
            text_en: "rainy",
            description: "It was cold and rainy so we went to the cinema.",
          },
          {
            id: 40,
            key: "v",
            text_uz: "anglab yetmoq",
            text_en: "realize",
            description: "He realized his mistake later.",
          },
          {
            id: 41,
            key: "n",
            text_uz: "chek, kvitansiya",
            text_en: "receipt",
            description: "Mr Kinney wants to find the credit card receipt.",
          },
          {
            id: 42,
            key: "n",
            text_uz: "nafaqa",
            text_en: "retirement",
            description: "He needs some money for his retirem ent.",
          },
          {
            id: 43,
            key: "v",
            text_uz: "ko`rmoq",
            text_en: "see",
            description: "We saw a lot of different things at the festival.",
          },
          {
            id: 44,
            key: "v",
            text_uz: "sotmoq",
            text_en: "sell",
            description: "Deborah sold their flat in London and moved back to the USA.",
          },
        ],
        unit10: [
          {
            id: 1,
            key: "phr",
            text_uz: "bir poyali",
            text_en: "a cup of",
            description: "I`d like a cup of tea, please.",
          },
          {
            id: 2,
            key: "phr",
            text_uz: "tur/hil",
            text_en: "a kind of",
            description: "Sachertorte is a kind of chocolate cake.",
          },
          {
            id: 3,
            key: "n",
            text_uz: "olma sharbati",
            text_en: "apple juice",
            description: "Apple juice is my favourite kind of juice.",
          },
          {
            id: 4,
            key: "n",
            text_uz: "pechenye",
            text_en: "biscuit",
            description: "Would you like a biscuit?",
          },
          {
            id: 5,
            key: "n",
            text_uz: "gamburger",
            text_en: "burger",
            description: "A burger and chips, please.",
          },
          {
            id: 6,
            key: "phr",
            text_uz: "uy sotib olmoq",
            text_en: "buy a house",
            description: "I`m probably not going to buy a house.",
          },
          {
            id: 7,
            key: "n",
            text_uz: "tort(shirinlik)",
            text_en: "cake",
            description: "Try the popular Tres Leches cake, made with three kinds of milk.",
          },
          {
            id: 8,
            key: "n",
            text_uz: "imkoniyat",
            text_en: "chance",
            description: "Next year, she has a chance to go to Europe.",
          },
          {
            id: 9,
            key: "phr",
            text_uz: "kasbini(ishini) o`zgartirmoq",
            text_en: "change jobs",
            description: "Are you goingto change jobs next year?",
          },
          {
            id: 10,
            key: "n",
            text_uz: "chips(qovurilgan kartoshka)",
            text_en: "chips",
            description: "Fish and chips is a traditional British dinner.",
          },
          {
            id: 11,
            key: "n",
            text_uz: "qahva",
            text_en: "coffee",
            description: "Coffee is very cheap in Cuba and it`s very good.",
          },
          {
            id: 12,
            key: "n",
            text_uz: "kruassan(Fransiya non mahsuloti)",
            text_en: "crolssant",
            description: "I sometimes hava a chocolate crolssant for breakfast.",
          },
          {
            id: 13,
            key: "n",
            text_uz: "kapkeyk",
            text_en: "copcake",
            description: "Try a colorful cupcake with your coffee.",
          },
          {
            id: 14,
            key: "n",
            text_uz: "disert(shirinlik)",
            text_en: "dessert",
            description: "I`d like to have some dessert",
          },
          {
            id: 15,
            key: "n",
            text_uz: "shirin teshik kulcha",
            text_en: "doughnut",
            description: "Would you like a doughnut or a biscuit?",
          },
          {
            id: 16,
            key: "n",
            text_uz: "ichimlik",
            text_en: "drink",
            description: "Would you like a hot drink?",
          },
          {
            id: 17,
            key: "-",
            text_uz: "mobaynida",
            text_en: "during",
            description: "They can`t pay for the hotels or food druing the tour.",
          },
          {
            id: 18,
            key: "n",
            text_uz: "atrof muhit",
            text_en: "environment",
            description: "We`re going to study the environment in Alaska.",
          },
          {
            id: 19,
            key: "n",
            text_uz: "nachinka",
            text_en: "filling",
            description: "Moi-ji is a kind of rice cake with a sweet filling.",
          },
          {
            id: 20,
            key: "phr",
            text_uz: "maktabni tugatmoq",
            text_en: "finish school",
            description: "When did you finish school?",
          },
          {
            id: 21,
            key: "n",
            text_uz: "parvoz,reys",
            text_en: "flight",
            description: "My flight to Vienna is at 12.15",
          },
          {
            id: 22,
            key: "n",
            text_uz: "ovqat",
            text_en: "food",
            description: "There was interesting dfood from all over the world.",
          },
          {
            id: 23,
            key: "phr",
            text_uz: "farzandli bo`lmoq",
            text_en: "have a baby",
            description: "Is shi going to hava a baby",
          },
          {
            id: 24,
            key: "n",
            text_uz: "hot-dog",
            text_en: "hot dog",
            description: "A large hot dog, please.",
          },
          {
            id: 25,
            key: "adv",
            text_uz: "uch kundan so`ng",
            text_en: "in three days",
            description: "Shi`s going to visit her frinds in Spain in three days.",
          },
          {
            id: 26,
            key: "adj",
            text_uz: "xalqaro",
            text_en: "international",
            description: "Every year there is an international Coffe Expo there.",
          },
          {
            id: 27,
            key: "n",
            text_uz: "taklifnoma",
            text_en: "invitation",
            description: "Thank you very much for the invitation.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "orol",
            text_en: "island",
            description: "We`re going to live in a small house on another island.",
          },
          {
            id: 29,
            key: "v",
            text_uz: "qo`shilmoq",
            text_en: "join",
            description: "M y friend and l are going to join a group there.",
          },
          {
            id: 30,
            key: "phr",
            text_uz: "yangi til o`rganmoq",
            text_en: "learn a new language",
            description: "I'm going to learn a new language next year.",
          },
          {
            id: 31,
            key: "n",
            text_uz: "taomnoma",
            text_en: "menu",
            description: "Would you like to see the menu?",
          },
          {
            id: 32,
            key: "n",
            text_uz: "sut",
            text_en: "milk",
            description: "Would you like m ilk with your coffee?",
          },
          {
            id: 33,
            key: "n",
            text_uz: "chet elga ko`chib ketmoq",
            text_en: "move abroad",
            description: "We're going to move abroad.",
          },
          {
            id: 34,
            key: "adj",
            text_uz: "keyingi oy, kelasi oy",
            text_en: "next (month) ",
            description: "I'm going to be a volunteer in Bolivia next month.",
          },
          {
            id: 35,
            key: "n",
            text_uz: "apelsin sharbati",
            text_en: "orange juice ",
            description: "Some people have  orange juice for breakfast.",
          },
          {
            id: 36,
            key: "n",
            text_uz: "buyurtma",
            text_en: "order",
            description: "Can I take your order?",
          },
          {
            id: 37,
            key: "n",
            text_uz: "buyurtma bermoq",
            text_en: "order",
            description: "Would you like to order?",
          },
          {
            id: 38,
            key: "n",
            text_uz: "tashkilot",
            text_en: "organization",
            description: "I'm going to walk 150 kilometres to help an international organization for dogs.",
          },
          {
            id: 39,
            key: "adv",
            text_uz: "ehtimol",
            text_en: "probably",
            description: "My father is probably going to change jobs.",
          },
          {
            id: 40,
            key: "n",
            text_uz: "guruch",
            text_en: "rice",
            description: "Japanese food has got a lot of rice in it.",
          },
          {
            id: 41,
            key: "n",
            text_uz: "salat",
            text_en: "salad",
            description: "A small salad, please.",
          },
          {
            id: 42,
            key: "n",
            text_uz: "sendvich",
            text_en: "sandwich",
            description: "A croque monsieur is a kind of sandwich.",
          },
          {
            id: 43,
            key: "v",
            text_uz: "kuylamoq",
            text_en: "sing",
            description: "The children are going to sing for us tomorrow .",
          },
          {
            id: 44,
            key: "n",
            text_uz: "tamaddi",
            text_en: "snack",
            description: "It's very popular with coffee as a snack.",
          },
          {
            id: 45,
            key: "adj",
            text_uz: "maxsus",
            text_en: "special",
            description: "There are some very special cakes to try.",
          },
          {
            id: 46,
            key: "n",
            text_uz: "shirin",
            text_en: "sweet",
            description: "I love sweet food, and l always order adessert.",
          },
          {
            id: 47,
            key: "n",
            text_uz: "choy",
            text_en: "tea",
            description: "A cup of tea and a piece of chocolate cake,please.",
          },
          {
            id: 48,
            key: "adv",
            text_uz: "indinga",
            text_en: "the day after tomorrow",
            description: "The day after tomorrow my parents and my brother are going to visit me.",
          },
          {
            id: 49,
            key: "adv",
            text_uz: "bugun kechqurun",
            text_en: "this evening",
            description: "I'm not going to have pizza for dinner this evening.",
          },
          {
            id: 50,
            key: "adv",
            text_uz: "bugun",
            text_en: "today",
            description: "You aren't going to buy a new skirt today.",
          },
          {
            id: 51,
            key: "adv",
            text_uz: "ertaga",
            text_en: "tomorrow",
            description: "Rafael is going to clean the kitchen tomorrow .",
          },
          {
            id: 52,
            key: "n",
            text_uz: "tur, sayohat",
            text_en: "tour",
            description: "I'm going to do a tour of London next week.",
          },
          {
            id: 53,
            key: "n",
            text_uz: "suv",
            text_en: "water",
            description: "I'd like some water, please.",
          },
          {
            id: 54,
            key: "phr",
            text_uz: "xohlamoq, istamoq",
            text_en: "would like",
            description: "Would you like something to eat?",
          },
        ],
      },
      elemntary: {
        unit1: [
          {
            id: 1,
            key: "adj",
            text_uz: "amerikalik",
            text_en: "american ",
            description: "My boss isn't American. They're Arabic",
          },
          {
            id: 2,
            key: "adj",
            text_uz: "Arab millatiga mansub",
            text_en: "Arabic ",
            description: "They're Arabic",
          },
          {
            id: 3,
            key: "n",
            text_uz: "rassom",
            text_en: "artist ",
            description: "She's an artist.",
          },
          {
            id: 4,
            key: "n",
            text_uz: "xola , amma",
            text_en: "aunt ",
            description: "Is she your aunt?",
          },
          {
            id: 5,
            key: "n",
            text_uz: "boshliq , xo'jayin",
            text_en: "boss ",
            description: "My boss isn't American, she's Turkish. ",
          },
          {
            id: 6,
            key: "adj",
            text_uz: "Britaniyalik",
            text_en: "British ",
            description: ". I'm from London. I'm British.",
          },
          {
            id: 7,
            key: "n",
            text_uz: "aka , uka",
            text_en: "brother ",
            description: "My brother is a doctor.",
          },
          {
            id: 8,
            key: "n",
            text_uz: "qayn-oga , pochcha",
            text_en: "brother-in-law ",
            description: "My brother-in-law is a doctor.",
          },
          {
            id: 9,
            key: "n",
            text_uz: "biznes boshqaruvi",
            text_en: "business management ",
            description: "He studied business management at university.",
          },
          {
            id: 10,
            key: "n",
            text_uz: "avto-mexanik",
            text_en: "car mechanic",
            description: "I'm a car mechanic.",
          },
          {
            id: 11,
            key: "n",
            text_uz: "bola",
            text_en: "child ",
            description: "They have one child.",
          },
          {
            id: 12,
            key: "n",
            text_uz: "iste`molchi",
            text_en: "children",
            description: "How old are your children?",
          },
          {
            id: 13,
            key: "adj",
            text_uz: "xitoylik",
            text_en: "Chinese ",
            description: "My neighbours are Chinese.",
          },
          {
            id: 14,
            key: "v",
            text_uz: "muloqot qilmoq",
            text_en: "communicate ",
            description: "I'm good at communicating with people.",
          },
          {
            id: 15,
            key: "n",
            text_uz: "mamlakat",
            text_en: "country ",
            description: "Which country are you from?",
          },
          {
            id: 16,
            key: "n",
            text_uz: "amakivachcha , tog'avachcha",
            text_en: "cousin ",
            description: "Anna is my cousin.",
          },
          {
            id: 17,
            key: "n",
            text_uz: "qiz farzand",
            text_en: "daughter",
            description: "Their daughter is married.",
          },
          {
            id: 18,
            key: "v",
            text_uz: "dizayner",
            text_en: "designer ",
            description: "She's Australian and she's a designer. ",
          },
          {
            id: 19,
            key: "adj",
            text_uz: "BAA fuqarosi",
            text_en: "Emirati ",
            description: "They're from Dubai.They're Emirati.  ",
          },
          {
            id: 20,
            key: "n",
            text_uz: "familiyasi , sharifi",
            text_en: "family name ",
            description: "His family name's Ramirez.",
          },
          {
            id: 21,
            key: "n",
            text_uz: "ota , dada",
            text_en: "father ",
            description: "Her father's name is Hasan.",
          },
          {
            id: 22,
            key: "adj",
            text_uz: "ravon",
            text_en: "fluent ",
            description: "She's fluent in Portuguese.",
          },
          {
            id: 23,
            key: "adj",
            text_uz: "fransuz",
            text_en: "French ",
            description: "My wife's mother is French.",
          },
          {
            id: 24,
            key: "adj",
            text_uz: "irsiy",
            text_en: "genetic ",
            description: "The village doctor says it isn't genetic; he thinks it's something in the water or the food.",
          },
          {
            id: 25,
            key: "n",
            text_uz: "nevara qiz",
            text_en: "granddaughter ",
            description: "Her granddaughter is at university.",
          },
          {
            id: 26,
            key: "n",
            text_uz: "bobo",
            text_en: "grandfather ",
            description: "How old is your grandfather?",
          },
          {
            id: 27,
            key: "n",
            text_uz: "buvi , momo",
            text_en: "grandmother ",
            description: "My grandmother is Spanish.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "o'g'il nevara",
            text_en: "grandson ",
            description: "They have one grandson.",
          },
          {
            id: 29,
            key: "adj",
            text_uz: "grek",
            text_en: "greek",
            description: "Are your neighbours Greek?",
          },
          {
            id: 30,
            key: "adj",
            text_uz: "vengriyalik",
            text_en: "Hungarian ",
            description: "Are you Hungarian?",
          },
          {
            id: 31,
            key: "n",
            text_uz: "er",
            text_en: "husband ",
            description: "My husband is Italian.",
          },
          {
            id: 32,
            key: "v",
            text_uz: "tanishtirmoq",
            text_en: "Introduce ",
            description: "Let me introduce you to the other students.",
          },
          {
            id: 33,
            key: "adj",
            text_uz: "italiyalik",
            text_en: "Italian",
            description: "They're Italian.",
          },
          {
            id: 34,
            key: "adj",
            text_uz: "yaponiyalik",
            text_en: "Japanese ",
            description: "My neighbours are Japanese.",
          },
          {
            id: 35,
            key: "adj",
            text_uz: "livanlik",
            text_en: "Lebanese",
            description: "Are they Lebanese?",
          },
          {
            id: 36,
            key: "adj",
            text_uz: "turmush qurgan",
            text_en: "married ",
            description: "In some countries, wives can have their husband's last names after they're married.",
          },
          {
            id: 37,
            key: "adj",
            text_uz: "meksikalik",
            text_en: "Mexican",
            description: "I'm from Mexico. I'm Mexican.",
          },
          {
            id: 38,
            key: "n",
            text_uz: "ona",
            text_en: "mother",
            description: "She is the mother of six children.",
          },
          {
            id: 39,
            key: "n",
            text_uz: "millat",
            text_en: "nationality",
            description: "What's your nationality?",
          },
          {
            id: 40,
            key: "n",
            text_uz: "qo'shni",
            text_en: "neighbour",
            description: "The neighbours are a family from Iraq.",
          },
          {
            id: 41,
            key: "n",
            text_uz: "jiyan (o'g'il bola )",
            text_en: "nephew",
            description: "My nephew's name is José.",
          },
          {
            id: 42,
            key: "n",
            text_uz: "jiyan ( qiz bola )",
            text_en: "niece ",
            description: "What's your niece's name? ",
          },
          {
            id: 43,
            key: "adj",
            text_uz: "nigeriyalik",
            text_en: "Nigerian",
            description: "I'm from Nigeria. I'm Nigerian.",
          },
          {
            id: 44,
            key: "adj",
            text_uz: "pokistonlik",
            text_en: "Pakistani ",
            description: "His father's from Pakistan. He's Pakistani.",
          },
          {
            id: 45,
            key: "adj",
            text_uz: "polshalik",
            text_en: "Polish",
            description: "There's a Polish supermarket next to our house.",
          },
          {
            id: 46,
            key: "adj",
            text_uz: "portugaliyalik",
            text_en: "Portuguese",
            description: "Is José Portuguese?",
          },
          {
            id: 47,
            key: "n",
            text_uz: "restoran",
            text_en: "restaurant",
            description: "I work in a restaurant. ",
          },
          {
            id: 48,
            key: "adj",
            text_uz: "rus",
            text_en: "Russian ",
            description: ". My neighbour is Russian.",
          },
          {
            id: 49,
            key: "n",
            text_uz: "saksofon",
            text_en: "saxophone",
            description: "I play the saxophone. ",
          },
          {
            id: 50,
            key: "adj",
            text_uz: "turmush qurmagan , bo'ydoq",
            text_en: "single",
            description: "Is Sylvie single?",
          },
          {
            id: 51,
            key: "n",
            text_uz: "opa , singil",
            text_en: "sister",
            description: "How old is your sister? ",
          },
          {
            id: 52,
            key: "n",
            text_uz: "o'g'il",
            text_en: "son",
            description: "I'm his son.",
          },
          {
            id: 53,
            key: "adj",
            text_uz: "ispaniyalik",
            text_en: "Spanish",
            description: "Is Martha Spanish?",
          },
          {
            id: 54,
            key: "n",
            text_uz: "o'gay ota",
            text_en: "stepfather",
            description: "Didier is my stepfather.",
          },
          {
            id: 55,
            key: "n",
            text_uz: "supermarket",
            text_en: "supermarket",
            description: "My Saturday job is at a Chinese supermarket called Jing Jing Foods.",
          },
          {
            id: 56,
            key: "adj",
            text_uz: "turk , turkiyalik",
            text_en: "Turkish ",
            description: "She isn't American, she's Turkish.",
          },
          {
            id: 57,
            key: "n",
            text_uz: "egizak",
            text_en: "twin",
            description: "Four of their sons are twins.",
          },
          {
            id: 58,
            key: "n",
            text_uz: "amaki , tog'a",
            text_en: "uncle",
            description: "My uncle's a teacher.",
          },
          {
            id: 59,
            key: "adj",
            text_uz: "ishsiz",
            text_en: "unemployed ",
            description: "I'm unemployed at the moment.",
          },
          {
            id: 60,
            key: "n",
            text_uz: "Urdu",
            text_en: "Urdu ",
            description: "They speak Urdu.",
          },
          {
            id: 61,
            key: "adj",
            text_uz: "vyetnamlik",
            text_en: "Vietnamese",
            description: "She's Vietnamese.",
          },
          {
            id: 62,
            key: "n",
            text_uz: "xotin",
            text_en: "wife",
            description: "His wife is Rashida.",
          },
        ],
        unit2: [
          {

            id: 1,
            key: "v",
            text_uz: "rozi bo'lmoq",
            text_en: "agree (with) ",
            description: "I usually agree with my friends.",
          },
          {
            id: 2,
            key: "adv",
            text_uz: "yolg'iz",
            text_en: "alone",
            description: "Melanie often works there alone.",
          },
          {
            id: 3,
            key: "v",
            text_uz: "so'ramoq",
            text_en: "ask (for) ",
            description: "Do students often ask for a discount? Is it cheaper for students?",
          },
          {
            id: 4,
            key: "n",
            text_uz: "astronavt , samogir",
            text_en: "astronaut",
            description: "All astronauts in Europe learn their job at the European Astronaut Centre in Cologne in Germany.",
          },
          {
            id: 5,
            key: "n",
            text_uz: "sohil",
            text_en: "beach",
            description: "In the summer, I get up early and go to the beach. I swim there and lie on the sand.",
          },
          {
            id: 6,
            key: "n",
            text_uz: "biologik soat",
            text_en: "body clock ",
            description: "There is no perfect time to sleep because very one's bodyclock is different.",
          },
          {
            id: 7,
            key: "n",
            text_uz: "tanaffus",
            text_en: "break",
            description: "She stops for a break in the morning at quarter past eleven. She doesn't work during her break, she takes a walk in the garden.",
          },
          {
            id: 8,
            key: "n",
            text_uz: "nonushta",
            text_en: "breakfast",
            description: "I usually have eggs and cheese for breakfast.",
          },
          {
            id: 9,
            key: "n",
            text_uz: "oshxona",
            text_en: "canteen",
            description: "She has breakfast in the canteen at eight o'clock.",
          },
          {
            id: 10,
            key: "n",
            text_uz: "yorma",
            text_en: "cereal",
            description: "I eat cereal for breakfast every morning. It is really good with milk.",
          },
          {
            id: 11,
            key: "n",
            text_uz: "dars",
            text_en: "class",
            description: "Our English classes start again at half past seven.",
          },
          {
            id: 12,
            key: "adj",
            text_uz: "xavfli",
            text_en: "dangerous ",
            description: "Male seals are big and sometimes dangerous. They may attack humans.",
          },
          {
            id: 13,
            key: "adj",
            text_uz: "kir , iflos",
            text_en: "dirty",
            description: "It's dirty in the city. You can see trash in the streets.",
          },
          {
            id: 14,
            key: "n",
            text_uz: "chegirma",
            text_en: "discount",
            description: "Do students often ask for a discount? Is it cheaper for students?",
          },
          {
            id: 15,
            key: "n",
            text_uz: "mutaxassis",
            text_en: "expert",
            description: "Sleep expert Dr Michael Howell says the best sleep is six hours at night and two hours in the afternoon.",
          },
          {
            id: 16,
            key: "n",
            text_uz: "ko'rish qobiliyati , nigoh",
            text_en: "eyesight",
            description: "-Do you need perfect eyesight to be an astronaut? Yes, you need to be able to see perfectly.",
          },
          {
            id: 17,
            key: "phr",
            text_uz: "o'zini yaxshi his qilmoq",
            text_en: "feel well",
            description: "Most astronauts don't feel well when they first go into space. They feel a little sick.",
          },
          {
            id: 18,
            key: "adj",
            text_uz: "tekin",
            text_en: "free",
            description: "Tea and coffee are free at work. We do not pay for them.",
          },
          {
            id: 19,
            key: "n",
            text_uz: "bo'sh vaqt",
            text_en: "free time",
            description: "He works very hard and he hardly ever has free time.",
          },
          {
            id: 20,
            key: "n",
            text_uz: "toza havo",
            text_en: "fresh air",
            description: "I prefer to live in the country because of the fresh air.",
          },
          {
            id: 21,
            key: "phr v",
            text_uz: "o'rnidan turmoq",
            text_en: "get up",
            description: "I get up at about seven o'clock and wash my face.",
          },
          {
            id: 22,
            key: "v",
            text_uz: "bormoq",
            text_en: "go",
            description: "I go to work at eight o'clock.",
          },
          {
            id: 23,
            key: "phr",
            text_uz: "klubga bormoq",
            text_en: "go clubbing",
            description: "We go clubbing every weekend and dance there.",
          },
          {
            id: 24,
            key: "phr",
            text_uz: "yarim soat o'tdi",
            text_en: "half past",
            description: "Classes finish at half past six in the evening.",
          },
          {
            id: 25,
            key: "phr",
            text_uz: "kechgi ovqatni yemoq",
            text_en: "have dinner",
            description: "We usually have dinner at 7p.m.",
          },
          {
            id: 26,
            key: "phr",
            text_uz: "tushlik qilmoq",
            text_en: "have lunch",
            description: "I always have lunch at 12.30.",
          },
          {
            id: 27,
            key: "adj",
            text_uz: "och ( qorin )",
            text_en: "hungry",
            description: "I am always hungry during the day. I want to eat sweets and fruits.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "g'oya",
            text_en: "idea",
            description: "Me and my brother think differently. We sometimes have different ideas.",
          },
          {
            id: 29,
            key: "n",
            text_uz: "sayohat",
            text_en: "journey",
            description: "How was your journey to Turkey?",
          },
          {
            id: 30,
            key: "n",
            text_uz: "laboratoriya",
            text_en: "lab",
            description: "He works in the lab every afternoon. He tests chemical formulas there.",
          },
          {
            id: 31,
            key: "adj",
            text_uz: "kech",
            text_en: "late",
            description: "My sister never waits for people who are late. She wants them to be on time.",
          },
          {
            id: 32,
            key: "v",
            text_uz: "tinglamoq",
            text_en: "listen",
            description: "Sam listens to pop and classical music.",
          },
          {
            id: 33,
            key: "n",
            text_uz: "majlis",
            text_en: "meeting",
            description: "I'd like to talk to you before the meeting in the office tomorrow.",
          },
          {
            id: 34,
            key: "adj",
            text_uz: "shovqinli",
            text_en: "noisy",
            description: "City life is sometimes noisy. Village life is quiet.",
          },
          {
            id: 35,
            key: "prep",
            text_uz: "tashqarida",
            text_en: "outside",
            description: "I often have lunch outside a café or a restaurant.",
          },
          {
            id: 36,
            key: "v",
            text_uz: "to'lamoq",
            text_en: "pay",
            description: "How much do you pay for tea and coffee at work?",
          },
          {
            id: 37,
            key: "n",
            text_uz: "pingvin",
            text_en: "penguin",
            description: "Melanie Szabo studies penguins. She loves those black and yellow animals.",
          },
          {
            id: 38,
            key: "adj",
            text_uz: "mukammal",
            text_en: "perfect",
            description: "His English is perfect. He can speak in English with anyone.",
          },
          {
            id: 39,
            key: "n",
            text_uz: "fizika",
            text_en: "Physics",
            description: "In the mornings, we study things like physics. Our teacher teaches us about electricity and light.",
          },
          {
            id: 40,
            key: "n",
            text_uz: "reja",
            text_en: "plan",
            description: "- Are you free tonight? Let's go to cinema. Thanks, but I'm afraid I have plans for tonight.",
          },
          {
            id: 41,
            key: "n",
            text_uz: "professor",
            text_en: "professor",
            description: "Melanie Szabo is a professor. She teaches Zoology at university.",
          },
          {
            id: 42,
            key: "n",
            text_uz: "jamoat transporti",
            text_en: "public transport",
            description: "-What time does public transport stop? -We can't use public transport after 11:00 p.m in Tashkent.",
          },
          {
            id: 43,
            key: "phr",
            text_uz: "chorak o'tdi",
            text_en: "quarter past",
            description: "He stops for a break in the morning at quarter past ten (10:15).",
          },
          {
            id: 44,
            key: "phr",
            text_uz: "chorak kam",
            text_en: "quarter to",
            description: "She goes to morning classes at quarter to nine (8:45).",
          },
          {
            id: 45,
            key: "v",
            text_uz: "o'qimoq",
            text_en: "read",
            description: "In my free time I like to listen to music or read a book.",
          },
          {
            id: 46,
            key: "n",
            text_uz: "javob",
            text_en: "reply",
            description: "-Do we have a reply from them? -No, they did not answer.",
          },
          {
            id: 47,
            key: "v",
            text_uz: "ko'tarilmoq",
            text_en: "rise",
            description: "The sun rises at about half past five in the morning.",
          },
          {
            id: 48,
            key: "n",
            text_uz: "sandvich , buterbrod",
            text_en: "sandwich",
            description: "We buy sandwiches at lunchtime.",
          },
          {
            id: 49,
            key: "adj",
            text_uz: "ilmiy",
            text_en: "scientific",
            description: "Bird Island is an important scientific research centre.",
          },
          {
            id: 50,
            key: "n",
            text_uz: "olim",
            text_en: "scientist",
            description: "Every year lots of scientists visit the island. They study the animals and plants there.",
          },
          {
            id: 51,
            key: "n",
            text_uz: "dengiz mushugi",
            text_en: "seal",
            description: "Sven Olafsson studies seals. Seals are interesting sea animals.",
          },
          {
            id: 52,
            key: "n",
            text_uz: "do'kon",
            text_en: "shop",
            description: "The shops open at half past eight in the morning. Customers usually buy bread and milk in the morning.",
          },
          {
            id: 53,
            key: "n",
            text_uz: "dush",
            text_en: "shower",
            description: "I sometimes have a shower in the morning.",
          },
          {
            id: 54,
            key: "n",
            text_uz: "kasallik",
            text_en: "sickness",
            description: "They often have space sickness. They feel ill at the beginning of their journey.",
          },
          {
            id: 55,
            key: "n",
            text_uz: "uxlash uchun maxsus qopcha",
            text_en: "sleeping bag",
            description: "They don't sleep in a bed - they sleep in special sleeping bags.",
          },
          {
            id: 56,
            key: "n",
            text_uz: "sho'rva",
            text_en: "soup",
            description: "They do very good Korean soup there. They cook it with Korean recipe.",
          },
          {
            id: 57,
            key: "n",
            text_uz: "samo , fazo",
            text_en: "space",
            description: "Some astronauts stay in space for over a year at a time. They come back to Earth after one year.",
          },
          {
            id: 58,
            key: "n",
            text_uz: "fazogir kiyimi , skafandr",
            text_en: "spacesuit",
            description: "Astronauts only need a spacesuit when they go on a spacewalk. They wear spacesuit to protect themselves.",
          },
          {
            id: 59,
            key: "v",
            text_uz: "boshlamoq",
            text_en: "start",
            description: "School starts at eight o'clock in the morning. It finishes at 2 p.m. in the afternoon.",
          },
          {
            id: 60,
            key: "v",
            text_uz: "to'xtamoq",
            text_en: "stop",
            description: "Public transport usually stops at 11 o'clock at night. You can't use public transport until 5 o'clock in the morning.",
          },
          {
            id: 61,
            key: "n",
            text_uz: "talabalik (o'quvchilik) guvohnomasi",
            text_en: "student card",
            description: "They need to show their student card to get discount.",
          },
          {
            id: 62,
            key: "v",
            text_uz: "(haqida) o`ylamoq",
            text_en: "think (about)",
            description: "When he's alone, he thinks about his friends and family.",
          },
          {
            id: 63,
            key: "adj",
            text_uz: "charchagan",
            text_en: "tired",
            description: "Many of us feel tired during the day. So, we take a rest after lunch.",
          },
          {
            id: 64,
            key: "n",
            text_uz: "unvon",
            text_en: "title",
            description: "Titles and names can tell us a lot about people.",
          },
          {
            id: 65,
            key: "n",
            text_uz: "qizdirilgan non",
            text_en: "toast",
            description: "They usually have toast for breakfast. They eat it with butter.",
          },
          {
            id: 66,
            key: "n",
            text_uz: "ish o`rganuvchi",
            text_en: "trainee",
            description: "Sanaa Diya is a trainee astronaut at the European Astronaut Centre in Cologne. She is training to fly to the Moon.",
          },
          {
            id: 67,
            key: "n",
            text_uz: "vulqon",
            text_en: "volcano",
            description: "Here drive sata volcano at 7 o'clock.",
          },
          {
            id: 68,
            key: "v",
            text_uz: "kutmoq",
            text_en: "wait",
            description: "-Do people often wait for buses and trains in your city? -Yes, they usually wait for 5-6 minutes.",
          },
          {
            id: 69,
            key: "phry",
            text_uz: "uyg`onmoq",
            text_en: "wake up",
            description: "I try to wake up early, but it's difficult. So,1 sleep until 7 a.m.",
          },
          {
            id: 70,
            key: "n",
            text_uz: "devor",
            text_en: "wall",
            description: "The sleeping bags are on the walls. There are some paintings on the walls.",
          },
          {
            id: 71,
            key: "phr",
            text_uz: "kino tomosha qilmoq",
            text_en: "watch a film",
            description: "We don't often watch a film in the evening. We do not have a TV.",
          },
          {
            id: 72,
            key: "phr",
            text_uz: "televizor ko`rmoq",
            text_en: "watch TV",
            description: "In the evening I usually watch TV. I like watching football at the weekend.",
          },
          {
            id: 73,
            key: "v",
            text_uz: "ishlamoq",
            text_en: "work",
            description: "Steve never works alone.",
          },
          {
            id: 74,
            key: "n",
            text_uz: "zoologiya",
            text_en: "zoology",
            description: "She is a professor of zoology. She studies animals and teaches about them at university.",
          },

        ],
        unit3: [
          {

            id: 1,
            key: "n",
            text_uz: "manzil",
            text_en: "address",
            description: "Write down your address and phone number.",
          },
          {
            id: 2,
            key: "n",
            text_uz: "ma`mur",
            text_en: "administrator",
            description: "Just tell the administrator before you leave.",
          },
          {
            id: 3,
            key: "adv",
            text_uz: "yana",
            text_en: "again",
            description: "Say that again, please.",
          },
          {
            id: 4,
            key: "n",
            text_uz: "aviakompaniya",
            text_en: "airline",
            description: "My brother flies planes for a Japanese airline.",
          },
          {
            id: 5,
            key: "n",
            text_uz: "javob",
            text_en: "answer",
            description: "What's the answer to this question?",
          },
          {
            id: 6,
            key: "n",
            text_uz: "muallif",
            text_en: "author",
            description: "His brother's an author.He's writing a book at the moment.",
          },
          {
            id: 7,
            key: "n",
            text_uz: "novvoy",
            text_en: "baker",
            description: "His father's a baker.",
          },
          {
            id: 8,
            key: "n",
            text_uz: "boshlang'ich bosqich o'quvchisi",
            text_en: "beginner",
            description: "It's difficult for a beginner to understand very much in a new language.",
          },
          {
            id: 9,
            key: "n",
            text_uz: "quruvchi",
            text_en: "builder",
            description: "My brother's a builder.",
          },
          {
            id: 10,
            key: "n",
            text_uz: "avtobus haydovchisi",
            text_en: "bus driver",
            description: "My brother drives buses in the city. He's a bus driver.",
          },
          {
            id: 11,
            key: "n",
            text_uz: "tadbirkor",
            text_en: "businessman",
            description: "He has his own company. He's a businessman.",
          },
          {
            id: 12,
            key: "n",
            text_uz: "tadbirkor ayol",
            text_en: "businesswoman",
            description: "She has her own company. She's a businesswoman.",
          },
          {
            id: 13,
            key: "adj",
            text_uz: "tinch , bosiq",
            text_en: "calm",
            description: "He's a very calm person.",
          },
          {
            id: 14,
            key: "n",
            text_uz: "bosh oshpaz",
            text_en: "chef",
            description: "Daniela cooks food in a restaurant. She's a chef,",
          },
          {
            id: 15,
            key: "n",
            text_uz: "farrosh",
            text_en: "cleaner",
            description: "My cousin cleans offices and people's houses. She's a cleaner.",
          },
          {
            id: 16,
            key: "adj",
            text_uz: "aqilli",
            text_en: "clever",
            description: "Your daughter's very clever.",
          },
          {
            id: 17,
            key: "n",
            text_uz: "hamkasp",
            text_en: "colleague",
            description: "He really enjoys his job because his colleagues are also his friends.",
          },
          {
            id: 18,
            key: "n",
            text_uz: "kompaniya",
            text_en: "company",
            description: "He works for a company in the city.",
          },
          {
            id: 19,
            key: "n",
            text_uz: "raqqos",
            text_en: "dancer",
            description: "How many of them failed the test?",
          },
          {
            id: 20,
            key: "n",
            text_uz: "tish shifokori",
            text_en: "dentist",
            description: "Sameeha cleans and fixes people's teeth. She's a dentist.",
          },
          {
            id: 21,
            key: "n",
            text_uz: "haydovchi",
            text_en: "driver",
            description: "My brother's a really bad driver.",
          },
          {
            id: 22,
            key: "v",
            text_uz: "pul ishlab topmoq",
            text_en: "earn",
            description: "He is a full time international business speaker",
          },
          {
            id: 23,
            key: "n",
            text_uz: "zavod",
            text_en: "factory",
            description: "My father works in a factory.",
          },
          {
            id: 24,
            key: "n",
            text_uz: "fermer",
            text_en: "farmer",
            description: "My uncle's a farmer.",
          },
          {
            id: 25,
            key: "v",
            text_uz: "tuzatmoq",
            text_en: "fix",
            description: "My son fixes a lot of different machines. He's a mechanic. ",
          },
          {
            id: 26,
            key: "n",
            text_uz: "o`rmon",
            text_en: "forest",
            description: "I work in a big forest.",
          },
          {
            id: 27,
            key: "v",
            text_uz: "unutmoq",
            text_en: "forget ",
            description: "Don't forget we're going to the cinema tomorrow.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "sartarosh",
            text_en: "hairdresser",
            description: "He washes hair, cuts it and dries it. He's a hairdresser.",
          },
          {
            id: 29,
            key: "adj",
            text_uz: "muhim",
            text_en: "important",
            description: "Which things do you think are most important in a job?",
          },
          {
            id: 30,
            key: "phr",
            text_uz: "ichkarida",
            text_en: "inside ",
            description: "Do you work inside?",
          },
          {
            id: 31,
            key: "n",
            text_uz: "internet",
            text_en: "Internet",
            description: "I used the internet to book my holiday.",
          },
          {
            id: 32,
            key: "n",
            text_uz: "jurnalist",
            text_en: "journalist",
            description: "Ekaterina writes for the newspaper. She's a journalist.",
          },
          {
            id: 33,
            key: "adv",
            text_uz: "keyinroq",
            text_en: "later",
            description: "I'll see you later.",
          },
          {
            id: 34,
            key: "adj",
            text_uz: "yolg`iz",
            text_en: "lonely",
            description: "Some people think mechanics, cleaners, farmers and artists have a lonely life.",
          },
          {
            id: 35,
            key: "n",
            text_uz: "kuzatuvchi",
            text_en: "lookout",
            description: "I am a fire lookout.",
          },
          {
            id: 36,
            key: "adj",
            text_uz: "omadli",
            text_en: "lucky",
            description: "And who are these lucky people? ",
          },
          {
            id: 37,
            key: "n",
            text_uz: "jurnal",
            text_en: "magazine",
            description: "My mother is a journalist and she works for a fashion magazine.",
          },
          {
            id: 38,
            key: "n",
            text_uz: "ish boshqaruvchi",
            text_en: "manager",
            description: "She works in an office. She's a manager.",
          },
          {
            id: 39,
            key: "n",
            text_uz: "pul",
            text_en: "money",
            description: "She makes a lot of money.",
          },
          {
            id: 40,
            key: "n",
            text_uz: "mp3 pleyer",
            text_en: "Mp3 player ",
            description: ". It's an MP3 player. `",
          },
          {
            id: 41,
            key: "n",
            text_uz: "ehtiroz",
            text_en: "musician",
            description: "My cousin sings and plays the guitar in a band. She's a musician.",
          },
          {
            id: 42,
            key: "n",
            text_uz: "hamshira",
            text_en: "nurse",
            description: "She works in a hospital and helps sick people. She's a nurse.",
          },
          {
            id: 43,
            key: "n",
            text_uz: "idora xodimi",
            text_en: "office worker ",
            description: "They say that office workers are happy because they usually work as part of a team.",
          },
          {
            id: 44,
            key: "n",
            text_uz: "musavvir",
            text_en: "painter",
            description: "My uncle is a painter.",
          },
          {
            id: 45,
            key: "adv",
            text_uz: "yarim stavkada",
            text_en: "part-time ",
            description: "My grandmother works part-time as a cleaner.",
          },
          {
            id: 46,
            key: "n",
            text_uz: "foto suratchi",
            text_en: "photographer",
            description: "Manu takes pictures with his camera. He's a photographer.",
          },
          {
            id: 47,
            key: "n",
            text_uz: "pianino",
            text_en: "piano",
            description: "I play the piano at a cinema in town. ",
          },
          {
            id: 48,
            key: "v",
            text_uz: "uchuvchi",
            text_en: " pilot ",
            description: "My brother flies planes. He's a pilot.",
          },
          {
            id: 49,
            key: "n",
            text_uz: "ish joyi",
            text_en: "place of work ",
            description: "I think your place of work is very important.",
          },
          {
            id: 50,
            key: "n",
            text_uz: "militsiya zobiti",
            text_en: "police officer ",
            description: "Serena catches criminals and makes people feel safe. She's a police officer.",
          },
          {
            id: 51,
            key: "adj",
            text_uz: "nafaqaga chiqqan",
            text_en: "retired ",
            description: "My parents are both retired.",
          },
          {
            id: 52,
            key: "n",
            text_uz: "ish haqi maosh",
            text_en: "salary ",
            description: "His salary is really good. He earns a lot of money. ",
          },
          {
            id: 53,
            key: "adj",
            text_uz: "ovozsiz",
            text_en: "silent",
            description: "At my cinema, they have a lot of old, silent movies, so they need someone to play music.",
          },
          {
            id: 54,
            key: "n",
            text_uz: "qo`shiqchi",
            text_en: "singer",
            description: "She's a singer in a band.",
          },
          {
            id: 55,
            key: "n",
            text_uz: "talaba , o`quvchi",
            text_en: "student",
            description: "She studies at university. She's a student.",
          },
          {
            id: 56,
            key: "n",
            text_uz: "ilmiy isbotlangan",
            text_en: "scientifically proven",
            description: "The results have been scientifically proven",
          },
          {
            id: 57,
            key: "n",
            text_uz: "o`qituvchi",
            text_en: "teacher",
            description: "My sister's a teacher.",
          },
          {
            id: 58,
            key: "n",
            text_uz: "chipta",
            text_en: "ticket",
            description: "I work in a cinema in town, but I don't sell tickets. ",
          },
          {
            id: 59,
            key: "n",
            text_uz: "minora",
            text_en: "tower",
            description: "I work in a very high tower so I can see very far.",
          },
          {
            id: 60,
            key: "n",
            text_uz: "kalta yengli",
            text_en: "uniform",
            description: "She hates the uniform that police officers wear.",
          },
          {
            id: 61,
            key: "v",
            text_uz: "noodatiy",
            text_en: "unusual",
            description: "Do you have an unusual job?",
          },
          {
            id: 62,
            key: "adj",
            text_uz: "yaxshi maoshli",
            text_en: "well-paid ",
            description: "He's very well-paid.",
          },
          {
            id: 63,
            key: "n",
            text_uz: "g`olib",
            text_en: "winner",
            description: "You win. You're the winner.",
          },
          {
            id: 64,
            key: "phr",
            text_uz: "mustaqil ishlamoq",
            text_en: "work freelance",
            description: "I don't have a boss because I work freelance.",
          },
          {
            id: 65,
            key: "phr",
            text_uz: "uzoq vaqt ishlamoq",
            text_en: "work long hours",
            description: "Do you work long hours?",
          },
          {
            id: 66,
            key: "n",
            text_uz: "yozuvchi",
            text_en: "writer",
            description: "My cousin is a famous writer.",
          }

        ],
        unit4: [
          {


            id: 1,
            key: "prep",
            text_uz: "tepasida",
            text_en: "above",
            description: "My bed is above the kitchen.",
          },
          {
            id: 2,
            key: "n",
            text_uz: "aeraport",
            text_en: "airport",
            description: "The roads to Coober Pedy are good and there's an airport.",
          },
          {
            id: 3,
            key: "n",
            text_uz: "kreslo",
            text_en: "armchair",
            description: "There's an armchair in the living room,",
          },
          {
            id: 4,
            key: "n",
            text_uz: "bank",
            text_en: "bank",
            description: "Where's the bank?",
          },
          {
            id: 5,
            key: "adj",
            text_uz: "hammom",
            text_en: "bathroom",
            description: "There's a small bathroom in my flat.",
          },
          {
            id: 6,
            key: "n",
            text_uz: "krovat",
            text_en: "bed",
            description: "There's a small table next to my bed.",
          },
          {
            id: 7,
            key: "n",
            text_uz: "yotoqxona",
            text_en: "bedroom",
            description: "In my house, there are three bedrooms.",
          },
          {
            id: 8,
            key: "prep",
            text_uz: "orqasida",
            text_en: "behind",
            description: "The East River is behind the building.",
          },
          {
            id: 9,
            key: "prep",
            text_uz: "orasida",
            text_en: "between",
            description: "My flat's on the fourth floor of a building between Delancey Street and Grand Street.",
          },
          {
            id: 10,
            key: "adj",
            text_uz: "katta",
            text_en: "big",
            description: "I need a big desk to work on.",
          },
          {
            id: 11,
            key: "n",
            text_uz: "buyurtma berish formasi",
            text_en: "booking form",
            description: "Bring the booking form with you.",
          },
          {
            id: 12,
            key: "n",
            text_uz: "kitob do`koni",
            text_en: "bookshop",
            description: "There's a bookshop opposite my flat.",
          },
          {
            id: 13,
            key: "n",
            text_uz: "bino",
            text_en: "building",
            description: "It's a modern building.",
          },
          {
            id: 14,
            key: "n",
            text_uz: "oromgoh",
            text_en: "campsite",
            description: "There are four or five hotels and there's also a campsite.",
          },
          {
            id: 15,
            key: "phr v",
            text_uz: "poytaxt",
            text_en: "capital",
            description: "Coober Pedy is the opal capital of the world.",
          },
          {
            id: 16,
            key: "n",
            text_uz: "gilam",
            text_en: "carpet",
            description: "There's a red carpet on the floor.",
          },
          {
            id: 17,
            key: "adj",
            text_uz: "arzon",
            text_en: "cheap",
            description: " My flat's in a cheap part of town.",
          },
          {
            id: 18,
            key: "adj",
            text_uz: "tarixiy",
            text_en: "historic",
            description: "It`s a mixture of historic buildings and natural beauty",
          },
          {
            id: 19,
            key: "n",
            text_uz: "dorixona ",
            text_en: "chemist's",
            description: "Is there a chemist near here?",
          },
          {
            id: 20,
            key: "n",
            text_uz: "kinoteatr",
            text_en: "cinema",
            description: "There's a cinema near the hotel.",
          },
          {
            id: 21,
            key: "adj",
            text_uz: "toza",
            text_en: "clean",
            description: "I like to keep them very clean.",
          },
          {
            id: 22,
            key: "n",
            text_uz: "gaz plitasi",
            text_en: "cooker",
            description: "In the kitchen there's a cooker.",
          },
          {
            id: 23,
            key: "n",
            text_uz: "tamaddi xona",
            text_en: "dining room",
            description: "There's a dining room next to the kitchen.",
          },
          {
            id: 24,
            key: "n",
            text_uz: "idish yuvish mashinasi",
            text_en: "dishwasher",
            description: "The dishwasher is under the sink.",
          },
          {
            id: 25,
            key: "adj",
            text_uz: "oson",
            text_en: "easy",
            description: "It's easy to find a flat in my town.",
          },
          {
            id: 26,
            key: "adj",
            text_uz: "qimmat",
            text_en: "expensive",
            description: "My computer is new and expensive.",
          },
          {
            id: 27,
            key: "adj",
            text_uz: "ajoyib",
            text_en: "fantastic",
            description: "The food is fantastic.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "xonadon",
            text_en: "flat",
            description: "I live in a flat.",
          },
          {
            id: 29,
            key: "n",
            text_uz: "sovutgich",
            text_en: "fridge",
            description: "The fridge is next to the sink.",
          },
          {
            id: 30,
            key: "n",
            text_uz: "mebel",
            text_en: "furniture",
            description: " My furniture is mostly old.",
          },
          {
            id: 31,
            key: "n",
            text_uz: "garaj",
            text_en: "garage",
            description: "There's a garage opposite my flat.",
          },
          {
            id: 32,
            key: "n",
            text_uz: "sartaroshxona",
            text_en: "hairdresser's",
            description: "In the hotel, there is a swimming pool, a hairdresser's and ninety-five bedrooms.",
          },
          {
            id: 33,
            key: "n",
            text_uz: "kasalxona",
            text_en: "hospital",
            description: "She works in a hospital.",
          },
          {
            id: 34,
            key: "n",
            text_uz: "xonadosh , hamxona",
            text_en: "housemate",
            description: "My housemates are very messy.",
          },
          {
            id: 35,
            key: "prep",
            text_uz: "old tomonida",
            text_en: "In front of",
            description: "It's on the floor in front of the window.",
          },
          {
            id: 36,
            key: "npl",
            text_uz: "ko'rsatmalar",
            text_en: "instructions",
            description: "Here are the instructions.",
          },
          {
            id: 37,
            key: "n",
            text_uz: "oshxona",
            text_en: "kitchen",
            description: "There is a fridge and a microwave in the kitchen",
          },
          {
            id: 38,
            key: "n",
            text_uz: "kir yuvish shahobchasi",
            text_en: "launderette",
            description: "I go to the launderette to wash my clothes.",
          },
          {
            id: 39,
            key: "adj",
            text_uz: "dangasa",
            text_en: "lazy",
            description: "They are very lazy.",
          },
          {
            id: 40,
            key: "n",
            text_uz: "kutubxona",
            text_en: "library",
            description: "Excuse me, where's the library?",
          },
          {
            id: 41,
            key: "adj",
            text_uz: "yorug`",
            text_en: "light",
            description: "There are lots of windows, so it's very light.",
          },
          {
            id: 42,
            key: "n",
            text_uz: "mehmonxona",
            text_en: "living room",
            description: "In my flat, there is a living room.",
          },
          {
            id: 43,
            key: "n",
            text_uz: "bozor",
            text_en: "market",
            description: " It's behind the market.",
          },
          {
            id: 44,
            key: "adj",
            text_uz: "tartibsiz",
            text_en: "messy",
            description: "I'm a messy worker.",
          },
          {
            id: 45,
            key: "n",
            text_uz: "kon",
            text_en: "mine",
            description: "A lot of the people in Coober Pedy work in the opal mines.",
          },
          {
            id: 46,
            key: "n",
            text_uz: " muzey",
            text_en: "museum",
            description: "There's a museum about the history of the town.",
          },
          {
            id: 47,
            key: "prep",
            text_uz: "yon tomonida",
            text_en: "next to ",
            description: "It's next to a restaurant.",
          },
          {
            id: 48,
            key: "adj",
            text_uz: "eski",
            text_en: "old",
            description: "I live in an old town.",
          },
          {
            id: 49,
            key: "adj",
            text_uz: "eskicha",
            text_en: "old-fashioned",
            description: "My house is very old-fashioned",
          },
          {
            id: 50,
            key: "n",
            text_uz: "ustida",
            text_en: "on",
            description: "My bed is on a shelf.",

          },
          {
            id: 51,
            key: "n",
            text_uz: "opal ",
            text_en: "opal",
            description: "Near Coober Pedy, there are opals under the ground.",
          },
          {
            id: 52,
            key: "prep",
            text_uz: "qarshisida , ro'parasida ",
            text_en: "opposite ",
            description: "The building is opposite a 24-hour garage.",
          },
          {
            id: 53,
            key: "adj",
            text_uz: "tartibli ",
            text_en: "organized ",
            description: "I work from home, so I keep everything tidy and organized.",
          },
          {
            id: 54,
            key: "n",
            text_uz: "saroy",
            text_en: "palace",
            description: " It's next to the palace.",
          },
          {
            id: 55,
            key: "n",
            text_uz: "pasport",
            text_en: "passport",
            description: "You usually need your passport to travel from here. ",
          },
          {
            id: 56,
            key: "n ",
            text_uz: "pochta idorasi",
            text_en: "post office",
            description: "Where's the post office?",
          },
          {
            id: 57,
            key: "n",
            text_uz: "vokzal",
            text_en: "railway station",
            description: "You can take the train from the railway station.",
          },
          {
            id: 58,
            key: "n",
            text_uz: "sharf",
            text_en: "scarf",
            description: "Put on your scarf too. It is cold outside.",
          },
          {
            id: 59,
            key: "n",
            text_uz: "javon",
            text_en: "shelf",
            description: "My bed is on a shelf above the kitchen.",
          },
          {
            id: 60,
            key: "n",
            text_uz: "rakovina",
            text_en: "sink",
            description: "In the kitchen, there's a sink.",
          },
          {
            id: 61,
            key: "n",
            text_uz: "bir xonadan tashkil topgan xonadon",
            text_en: "studio flat",
            description: "I live in a studio flat.",
          },
          {
            id: 62,
            key: "n",
            text_uz: "suzish havzasi",
            text_en: "swimming pool",
            description: "There's an underground swimming pool.",
          },
          {
            id: 63,
            key: "n",
            text_uz: "stol",
            text_en: "table",
            description: "There's a table next to the armchair.",
          },
          {
            id: 64,
            key: "n",
            text_uz: "ibodatxona",
            text_en: "temple",
            description: " Please don't take photographs inside the temple.",
          },
          {
            id: 65,
            key: "adj",
            text_uz: "juda yomon , ayanchli",
            text_en: "terrible",
            description: "It's a terrible restaurant.",
          },
          {
            id: 66,
            key: "n",
            text_uz: "teatr",
            text_en: "theatre",
            description: "Is there a theatre in Coober Pedy?",
          },
          {
            id: 67,
            key: "adj",
            text_uz: "orasta",
            text_en: "tidy",
            description: "Are you a tidy person?",
          },
          {
            id: 68,
            key: "n",
            text_uz: "hojatxona",
            text_en: "toilet",
            description: "There's a toilet next to the bedroom.",
          },
          {
            id: 69,
            key: "n",
            text_uz: "sayohat , tur , ekskursiya",
            text_en: "tour",
            description: "These are the instructions for tomorrow's tour.",
          },
          {
            id: 70,
            key: "n",
            text_uz: "sayyoh",
            text_en: "tourist",
            description: "There aren't any tourists there.",
          },
          {
            id: 71,
            key: "n",
            text_uz: "sayyohlik axborot markazi",
            text_en: "tourist information centre",
            description: "There's a big tourist information centre.",
          },
          {
            id: 72,
            key: "n",
            text_uz: "shahar (cha)",
            text_en: "town",
            description: "There are some nice restaurants in the town centre.",
          },
          {
            id: 73,
            key: "v",
            text_uz: "sayohat qilmoq",
            text_en: "travel",
            description: "You need a passport to travel there.",
          },
          {
            id: 74,
            key: "adj",
            text_uz: "xunuk",
            text_en: "ugly",
            description: "It's an ugly building.",
          },
          {
            id: 75,
            key: "prep",
            text_uz: "ostida",
            text_en: "under",
            description: "The toilet and shower are under the shelf.",
          },
          {
            id: 76,
            key: "adj",
            text_uz: "yer osti",
            text_en: "underground",
            description: "Are there any underground buildings. we can visit?",
          },
          {
            id: 77,
            key: "v",
            text_uz: "tashrif buyurmoq",
            text_en: "visit",
            description: "So can people visit the place? ",
          },
          {
            id: 78,
            key: "n",
            text_uz: "kir yuvish mashinasi",
            text_en: "washing machine",
            description: "There isn't a washing machine in my flat.",
          },
          {
            id: 79,
            key: "n",
            text_uz: "oyna , deraza",
            text_en: "window",
            description: "There's a table under the window.",
          },
        ],
        unit5: [
          {
            id: 1,
            key: "n",
            text_uz: "nonvoyxona",
            text_en: "baker's ",
            description: "I buy bread from the baker's.",
          },
          {
            id: 2,
            key: "adj",
            text_uz: "zerikarli",
            text_en: "boring",
            description: "I don't like shopping. It's boring.",
          },
          {
            id: 3,
            key: "n",
            text_uz: "go'sht do'koni",
            text_en: "butcher's",
            description: "I buy meat from the butcher's.",
          },
          {
            id: 4,
            key: "n",
            text_uz: "tugma",
            text_en: "button",
            description: "I choose a pair, press a button and the mirror shows me wearing them.",
          },
          {
            id: 5,
            key: "adj",
            text_uz: "ehtiyotkor",
            text_en: "careful",
            description: " Be careful!",
          },
          {
            id: 6,
            key: "adv",
            text_uz: "ehtiyotkorlik bilan",
            text_en: "carefully",
            description: "I try to spend my money carefully.",
          },
          {
            id: 7,
            key: "n",
            text_uz: "naqd pul",
            text_en: "cash",
            description: "I pay for things with cash.",
          },
          {
            id: 8,
            key: "n",
            text_uz: "kiyim almashtirish xonasi",
            text_en: "changing room",
            description: "The changing rooms are on the right.",
          },
          {
            id: 9,
            key: "adj",
            text_uz: "tiniq",
            text_en: "clear",
            description: "The water is very clear.",
          },
          {
            id: 10,
            key: "adv",
            text_uz: "aniq (holda)",
            text_en: "clearly",
            description: "Last year, Nigerians bought an astonishing 21,5 million mobile phones",
          },
          {
            id: 11,
            key: "n",
            text_uz: "palto",
            text_en: "coat",
            description: "She's wearing a coat and has a big scarf round her neck.",
          },
          {
            id: 12,
            key: "adj",
            text_uz: "to`g`ri",
            text_en: "correct",
            description: "I got all the answers correct.",
          },
          {
            id: 13,
            key: "adv",
            text_uz: "to`g`ri (holda)",
            text_en: "correctly",
            description: "Maria answers every question correctly.",
          },
          {
            id: 14,
            key: "adv",
            text_uz: "xavli tarzda",
            text_en: "dangerously",
            description: "You're driving dangerously.",
          },
          {
            id: 15,
            key: "npl",
            text_uz: "maxsus tikilgan oyoq kiyim(lar)",
            text_en: "designer shoes",
            description: "She is also wearing designer shoes.",
          },
          {
            id: 16,
            key: "adj",
            text_uz: "xafa, xafsalasi pir bo`lgan",
            text_en: "disappointed",
            description: "I'm very disappointed with this product.",
          },
          {
            id: 17,
            key: "n",
            text_uz: "ko'ylak (ayollar)",
            text_en: "dress",
            description: "She is wearing a blue dress."
          },
          {
            id: 18,
            key: "npl",
            text_uz: "qo'lqop",
            text_en: "gloves",
            description: "She has a hat on her head and gloves on her hands.",
          },
          {
            id: 19,
            key: "adj",
            text_uz: "yaxshi",
            text_en: "good",
            description: "He's very good at languages.",
          },
          {
            id: 20,
            key: "adj",
            text_uz: "katta, buyuk",
            text_en: "great",
            description: "It's great value.",
          },
          {
            id: 21,
            key: "v",
            text_uz: "shlyapa",
            text_en: "hat",
            description: "She is wearing a hat.",
          },
          {
            id: 22,
            key: "adj",
            text_uz: "og`ir",
            text_en: "heavy",
            description: "It's big and very heavy.",
          },
          {
            id: 23,
            key: "prep",
            text_uz: "qaytarma qalpoqli kiyim, tolstovka",
            text_en: "hoodie",
            description: "She is wearing a hoodie.",
          },
          {
            id: 24,
            key: "n",
            text_uz: "ma`lumot",
            text_en: "information",
            description: "Customers can't ask for information like they could in the past.",
          },
          {
            id: 25,
            key: "n",
            text_uz: "kurtka , pidjak",
            text_en: "jacket",
            description: "I am wearing a blue jacket today.",
          },
          {
            id: 26,
            key: "npl",
            text_uz: "jinsi shim",
            text_en: "jeans",
            description: " Leila is wearing jeans.",
          },
          {
            id: 27,
            key: "n",
            text_uz: "zargarlik buyumlari",
            text_en: "jewellery",
            description: "She is wearing gold jewellery.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "go`sht",
            text_en: "meat",
            description: "Where do you buy meat from?",
          },
          {
            id: 29,
            key: "n",
            text_uz: "matbuot do`koni",
            text_en: "newsagent's",
            description: "I buy magazines and newspapers from the newsagent's.",
          },
          {
            id: 30,
            key: "adv",
            text_uz: "internetda ,onlayn",
            text_en: "online",
            description: "I do a lot of my shopping online.",
          },
          {
            id: 31,
            key: "adj",
            text_uz: "qoniqarsiz ,nochor ,zaif",
            text_en: "poor",
            description: "It's very poor value.",
          },
          {
            id: 32,
            key: "n",
            text_uz: "tabriknoma",
            text_en: "postcard",
            description: " The first vending machines were in London in the 1880s and they sold postcards.",
          },
          {
            id: 33,
            key: "adj",
            text_uz: "jim , sokin",
            text_en: "quiet",
            description: "She's very quiet.",
          },
          {
            id: 34,
            key: "adv",
            text_uz: "past ovozda",
            text_en: "quietly",
            description: "Why are you talking so quietly?"
          },
          {
            id: 35,
            key: "n",
            text_uz: "yomg'ir suvi",
            text_en: "rain water",
            description: "Can you buy a bottle of rainwater for $11 these days?",
          },
          {
            id: 36,
            key: "phr v",
            text_uz: "o`qish ko'zoynaki",
            text_en: "reading glasses",
            description: "She is wearing her reading glasses.",
          },
          {
            id: 37,
            key: "n",
            text_uz: "kvitansiya",
            text_en: "receipt",
            description: "Would you like a receipt?",
          },
          {
            id: 38,
            key: "v",
            text_uz: "tavsiya qilmoq",
            text_en: "recommend",
            description: "I recommend it to everyone.",
          },
          {
            id: 39,
            key: "v",
            text_uz: "dam olmoq",
            text_en: "relax",
            description: "Leila and Mike are relaxing at home.",
          },
          {
            id: 40,
            key: "v",
            text_uz: "qaytarib bermoq",
            text_en: "return",
            description: "When I buy something I don't like, I return it to the shop.",
          },
          {
            id: 41,
            key: "npl",
            text_uz: "arzonlashtirilgan mollar sotuvi",
            text_en: "sales",
            description: "I stand outside and wait for the shops to open on the first day of the sales.",
          },
          {
            id: 42,
            key: "adj",
            text_uz: "jiddiy",
            text_en: "serious",
            description: "It can make you look serious and important.",
          },
          {
            id: 43,
            key: "n",
            text_uz: "savdo markazi",
            text_en: "shopping centre",
            description: "I buy things from a shopping centre. I prefer them to small shops.",
          },
          {
            id: 44,
            key: "npl",
            text_uz: "shortik",
            text_en: "shorts",
            description: "Mike is wearing shorts.",
          },
          {
            id: 45,
            key: "adj",
            text_uz: "oddiy",
            text_en: "simple",
            description: "I enjoy a simple life.",
          },
          {
            id: 46,
            key: "n",
            text_uz: "yubka",
            text_en: "skirt",
            description: "Anita is wearing a skirt and top.",
          },
          {
            id: 47,
            key: "adj",
            text_uz: "sekin",
            text_en: "slow",
            description: "Why is this train so slow?",
          },
          {
            id: 48,
            key: "adv",
            text_uz: "sekinlik bilan",
            text_en: "slowly",
            description: "The train is moving very slowly.",
          },
          {
            id: 49,
            key: "npl",
            text_uz: "paypoq",
            text_en: "socks",
            description: "He is wearing socks.",
          },
          {
            id: 50,
            key: "v",
            text_uz: "sarflamoq",
            text_en: "spend",
            description: "I spend a lot of money at the weekends.",
          },
          {
            id: 51,
            key: "n",
            text_uz: "kastyum-shim",
            text_en: "suit",
            description: "Paul is wearing a suit.",
          },
          {
            id: 52,
            key: "adj",
            text_uz: "kuchli",
            text_en: "strong",
            description: "You are probably a strong person and you always try hard at everything you do.",
          },
          {
            id: 53,
            key: "n",
            text_uz: "bo`yinbog`",
            text_en: "tie",
            description: "I am wearing a tie.",
          },
          {
            id: 54,
            key: "npl",
            text_uz: "krossovki",
            text_en: "trainers",
            description: "He is wearing trainers.",
          },
          {
            id: 55,
            key: "npl",
            text_uz: "shim",
            text_en: "trousers",
            description: "The trousers are the same colour as the jacket.",
          },
          {
            id: 56,
            key: "n",
            text_uz: "futbolka",
            text_en: "T-shirt",
            description: "Mike is wearing shorts and a T-shirt.",
          },
          {
            id: 57,
            key: "n",
            text_uz: "soyabon",
            text_en: "umbrella",
            description: "She's carrying an umbrella.",
          },
          {
            id: 58,
            key: "n",
            text_uz: "qiymat, qadr",
            text_en: "value",
            description: "It's great value.",
          },
          {
            id: 59,
            key: "n",
            text_uz: "savdo mashinasi",
            text_en: "vending machine",
            description: "Can you buy eggs from a vending machine?",
          },
          {
            id: 60,
            key: "adj",
            text_uz: "kompyuter yoki internetda yaratilgan",
            text_en: "virtual",
            description: "I'm here today to try the 'virtual mirror'.",
          },
          {
            id: 61,
            key: "n",
            text_uz: "to`y",
            text_en: "wedding",
            description: "She is at a wedding.",
          },
          {
            id: 62,
            key: "adv",
            text_uz: "yaxshi (tarzda)",
            text_en: "well",
            description: "She writes well.",
          },
          {
            id: 63,
            key: "phr v",
            text_uz: "arzigulik",
            text_en: "worth",
            description: "It's definitely not worth the money.",
          }
        ],
        unit6: [
          {
            id: 1,
            key: "phr",
            text_uz: "ozgina, biroz",
            text_en: "a bit",
            description: "As you get closer, you notice something a bit unusual.",
          },
          {
            id: 2,
            key: "v",
            text_uz: "ishonmoq",
            text_en: "believe",
            description: "They decided to make metal snakes and use them as money. They believed their snake money helped them to stay safe.",
          },
          {
            id: 3,
            key: "n",
            text_uz: "bobsley sport turi (chanada maxsus tramplinda tushish)",
            text_en: "bobsleigh",
            description: "People were surprised to see a bobsleigh team from Jamaica.",
          },
          {
            id: 4,
            key: "v",
            text_uz: "qo`ng`iroq qilmoq, chaqirmoq",
            text_en: "call",
            description: "His boss called the owner of the bag.",
          },
          {
            id: 5,
            key: "v",
            text_uz: "o`zgarmoq, o`zgartirmoq",
            text_en: "chance",
            description: "That all changed in the 1990s. ",
          },
          {
            id: 6,
            key: "n",
            text_uz: "sinf xonasi, o`quv xonasi",
            text_en: "classroom",
            description: "The classroom is cold today.",
          },
          {
            id: 7,
            key: "v",
            text_uz: "to`plamoq",
            text_en: "collect",
            description: "The owner was very happy when he collected his lost money.",
          },
          {
            id: 8,
            key: "v",
            text_uz: "nusxa ko`chirmoq",
            text_en: "copy",
            description: "She copied him.",
          },
          {
            id: 9,
            key: "v",
            text_uz: "qaror qilmoq",
            text_en: "decide",
            description: "Bernardo Paz decided to use the space for something very different.",
          },
          {
            id: 10,
            key: "n",
            text_uz: "modelyer moda dizayneri",
            text_en: "fashion designer",
            description: " She decided to become a fashion designer.",
          },
          {
            id: 11,
            key: "v",
            text_uz: "tugatmoq",
            text_en: "finish",
            description: "He finished work at 2 a.m.",
          },
          {
            id: 12,
            key: "n",
            text_uz: "asoschi",
            text_en: "faunder",
            description: "He was the founder of Sony.",
          },
          {
            id: 13,
            key: "n",
            text_uz: "konkida uchuchi",
            text_en: "Ice skater",
            description: "When she was younger she was a very good ice skater.",
          },
          {
            id: 14,
            key: "adj",
            text_uz: "qiziqarli",
            text_en: "interesting",
            description: "The sculptures were very interesting.",
          },
          {
            id: 15,
            key: "n",
            text_uz: "yorliq belgi",
            text_en: "label",
            description: "She has her own fashion label.",
          },
          {
            id: 16,
            key: "v",
            text_uz: "yoqtirmoq",
            text_en: "like",
            description: "The Ancient Egyptians liked wearing their money on their fingers as rings.",
          },
          {
            id: 17,
            key: "v",
            text_uz: "yashamoq",
            text_en: "live",
            description: "The Lobi people of Ancient Ghana in Africa lived as farmers.",
          },
          {
            id: 18,
            key: "v",
            text_uz: "qaramoq",
            text_en: "look at",
            description: "When he looked between the seats, he noticed a bag. ",
          },
          {
            id: 19,
            key: "v",
            text_uz: "sevmoq",
            text_en: "love",
            description: "They loved it.",
          },
          {
            id: 20,
            key: "n",
            text_uz: "zamonaviy san`at",
            text_en: "modern art",
            description: "Modern art is boring.",
          },
          {
            id: 21,
            key: "v",
            text_uz: "ko`chmoq",
            text_en: "move",
            description: "When was the last time you moved house?",
          },
          {
            id: 22,
            key: "adj",
            text_uz: "itoatsiz, betartib",
            text_en: "naughty",
            description: "My son was very naughty.",
          },
          {
            id: 23,
            key: "v",
            text_uz: "payqamoq, sezib qolmoq",
            text_en: "notice",
            description: "He noticed a bag between the seats.",
          },
          {
            id: 24,
            key: "v",
            text_uz: "ochmoq",
            text_en: "open",
            description: "She opened the window.",
          },
          {
            id: 25,
            key: "v",
            text_uz: "o`ynamoq",
            text_en: "play",
            description: " played football when I was a child.",
          },
          {
            id: 26,
            key: "adj",
            text_uz: "taniqli, mashhur",
            text_en: "popular",
            description: "They were very popular with the people watching because they tried so hard.",
          },
          {
            id: 27,
            key: "v",
            text_uz: "pochta orqali jo`natmoq",
            text_en: "post",
            description: "When was the last time you posted a letter?",
          },
          {
            id: 28,
            key: "v",
            text_uz: "tayyorlamoq",
            text_en: "prepare",
            description: "When was the last time you prepared a meal?",
          },
          {
            id: 29,
            key: "n",
            text_uz: "mahsulot",
            text_en: "product",
            description: "Their first product was an electric rice cooker.",
          },
          {
            id: 30,
            key: "adv",
            text_uz: "ancha, yetarlicha",
            text_en: "quite",
            description: "It is quite far from the usual tourist spots of Brazil.",
          },
          {
            id: 31,
            key: "adv",
            text_uz: "haqiqattan ham, juda ",
            text_en: "really",
            description: "It is really important for the local area.",
          },
          {
            id: 32,
            key: "v",
            text_uz: "qabul qilmoq, olmoq",
            text_en: "receive",
            description: "When was the last time you received an email?",
          },
          {
            id: 33,
            key: "v",
            text_uz: "qaytmoq, qaytarmoq",
            text_en: "return",
            description: "He returned the money to his boss.",
          },
          {
            id: 34,
            key: "n",
            text_uz: "haykal",
            text_en: "sculpture",
            description: "I thought the sculptures in the park were a bit boring.",
          },
          {
            id: 35,
            key: "v",
            text_uz: "baqirmoq",
            text_en: "shout ",
            description: "When was the last time you shouted at someone? ",
          },
          {
            id: 36,
            key: "v",
            text_uz: "boshlamoq",
            text_en: "start",
            description: "He started to clean his cab.",
          },
          {
            id: 37,
            key: "v",
            text_uz: "o`qimoq tahsil, olmpq",
            text_en: "study",
            description: "He studied for his exams yesterday.",
          },
          {
            id: 38,
            key: "adj",
            text_uz: "muvaffaqiyatli",
            text_en: "successful",
            description: "Today, she is very successful.",
          },
          {
            id: 39,
            key: "v",
            text_uz: "gapirmoq, suhbat qurmoq",
            text_en: "talk",
            description: "They talked a lot about the football match.",
          },
          {
            id: 40,
            key: "v",
            text_uz: "minnatdorlik bildirmoq",
            text_en: "thank",
            description: "He thanked Adam and gave him $2,000.",
          },
          {
            id: 41,
            key: "v",
            text_uz: "foydalanmoq, ishlatmoq",
            text_en: "use",
            description: "In the end, I used my ordinary shoes.",
          },
          {
            id: 42,
            key: "adj",
            text_uz: "juda",
            text_en: "very",
            description: "Bernardo Paz decided to use the space for something very different.",
          },
          {
            id: 43,
            key: "v",
            text_uz: "xoxlamoq",
            text_en: "want",
            description: "We wanted to change our places.",
          },
          {
            id: 44,
            key: "adv",
            text_uz: "tomosha qilmoq",
            text_en: "watch",
            description: "Would you like to watch this movie?",
          }
        ],
        unit7: [
          {
            id: 1,
            key: "n",
            text_uz: "ilova",
            text_en: "app",
            description: "I watched a programme about apps",
          },
          {
            id: 2,
            key: "n",
            text_uz: "yengil atletika",
            text_en: "athletics",
            description: "When we was a yping boy.Usaint Bolt did athletics all the time",
          },
          {
            id: 3,
            key: "v",
            text_uz: "man etmoq",
            text_en: "ban",
            description: "He banned smoking in public places",
          },
          {
            id: 4,
            key: "n",
            text_uz: "basketvol",
            text_en: "basketball",
            description: "I play basketball with my friends",
          },
          {
            id: 5,
            key: "v",
            text_uz: "qarzga olmoq",
            text_en: "borrow",
            description: "I forgot my pen, so I browwed one from my classmate.",
          },
          {
            id: 6,
            key: "v",
            text_uz: "keltirmoq, olib kelmoq",
            text_en: "bring",
            description: "Can you bring me my glasses?",
          },
          {
            id: 7,
            key: "n",
            text_uz: "chelak",
            text_en: "bucket",
            description: "He put his hand in a bucket of ice",
          },
          {
            id: 8,
            key: "v",
            text_uz: "kelmoq",
            text_en: "come",
            description: "Why don't you come to my house for dinner tomorrow?",
          },
          {
            id: 9,
            key: "v",
            text_uz: "bajarmoq, qilmoq",
            text_en: "do",
            description: "Do an hour of exercise each day",
          },
          {
            id: 10,
            key: "v",
            text_uz: "velosiped haydamoq",
            text_en: "cycle",
            description: "I usually cycle to work",
          },
          {
            id: 11,
            key: "v",
            text_uz: "ichmoq",
            text_en: "drink",
            description: "Drink eight glasses of water a day",
          },
          {
            id: 12,
            key: "v",
            text_uz: "yemoq, tanovvul qilmoq",
            text_en: "eat",
            description: "Eat lots of fruit and vegetables",
          },
          {
            id: 13,
            key: "adj",
            text_uz: "sog'lom tetik",
            text_en: "fit",
            description: "I cycle every day to keep fit",
          },
          {
            id: 14,
            key: "n",
            text_uz: "futbol",
            text_en: "football",
            description: "They're playing football in the park",
          },
          {
            id: 15,
            key: "n",
            text_uz: "qurilma",
            text_en: "gadget",
            description: "The programme was about apps and gadgets that check our health and daily exercise",
          },
          {
            id: 16,
            key: "phr",
            text_uz: "baliq oviga bormoq",
            text_en: "go fishing",
            description: "I like to go fishing with my uncle",
          },
          {
            id: 17,
            key: "n",
            text_uz: "gimnastika zali",
            text_en: "gym",
            description: "How often do you go to the gym?",
          },
          {
            id: 18,
            key: "n",
            text_uz: "odat",
            text_en: "habit",
            description: "Bloomberg tried to change their habits",
          },
          {
            id: 19,
            key: "adj",
            text_uz: "sog'lom",
            text_en: "health",
            description: "Michael Bloomberg wanted the people of New York to be healthy",
          },
          {
            id: 20,
            key: "n",
            text_uz: "qahramon",
            text_en: "hero",
            description: "They want to be like their heroes",
          },
          {
            id: 21,
            key: "v",
            text_uz: "yengil yugurish",
            text_en: "jog",
            description: "I jog every morning",
          },
          {
            id: 22,
            key: "n",
            text_uz: "dzyudo",
            text_en: "judo",
            description: "We do judo every Wednesday after work",
          },
          {
            id: 23,
            key: "v",
            text_uz: "o'rganmoq",
            text_en: "learn",
            description: "I do sport to learn something new",
          },
          {
            id: 24,
            key: "v",
            text_uz: "qarzga bermoq",
            text_en: "lend",
            description: "Can you lend me 10 pound",
          },
          {
            id: 25,
            key: "n",
            text_uz: "ko'tarmoq",
            text_en: "lift",
            description: "He told them he always took the stairs, not the lift",
          },
          {
            id: 26,
            key: "n",
            text_uz: "chaqmoq",
            text_en: "lightning",
            description: "Lightning didn't hit him, but there was lightning in the sky",
          },
          {
            id: 27,
            key: "adj",
            text_uz: "mahalliy",
            text_en: "local",
            description: "He played for his local team",
          },
          {
            id: 28,
            key: "v",
            text_uz: "yo'qotmoq",
            text_en: "lose",
            description: "I go swimming to lose weight",
          },
          {
            id: 29,
            key: "n",
            text_uz: "marafon",
            text_en: "marathon",
            description: "He ran the Toronto marathon and became the first person aged 100 years old to finish a marathon",
          },
          {
            id: 30,
            key: "n",
            text_uz: "shahar",
            text_en: "mayor",
            description: "In 2002, New York City chose a new mayor",
          },
          {
            id: 31,
            key: "n",
            text_uz: "fikr",
            text_en: "opinion",
            description: "What's your opinion, Jan",
          },
          {
            id: 32,
            key: "n",
            text_uz: "qog'oz qisqichi",
            text_en: "paperclip",
            description: "The first group took more paperclips",
          },
          {
            id: 33,
            key: "adj",
            text_uz: "jismoniy",
            text_en: "physical",
            description: "Do physical jobs around the house",
          },
          {
            id: 34,
            key: "n",
            text_uz: "rivojlanish",
            text_en: "progress",
            description: "They met again to talk about their progress",
          },
          {
            id: 35,
            key: "v",
            text_uz: "kamaymoq, qisqartirmoq",
            text_en: "reduce",
            description: "He also tried to reduce the size of sweet drinks",
          },
          {
            id: 36,
            key: "n",
            text_uz: "izlanish",
            text_en: "research",
            description: "New research shows that video gamers don't live in the real",
          },
          {
            id: 37,
            key: "v",
            text_uz: "minmoq, velosiped haydamoq",
            text_en: "ride",
            description: "He likes riding a bicycle in Spring",
          },
          {
            id: 38,
            key: "n",
            text_uz: "kundalik ish",
            text_en: "rountain",
            description: "New gadgets and technology can help us change our rountine and get more healthy",
          },
          {
            id: 39,
            key: "v",
            text_uz: "yugurmoq",
            text_en: "run",
            description: "Fauja didn't run marathons when he was young",
          },
          {
            id: 40,
            key: "v",
            text_uz: "uxlamoq",
            text_en: "sleep",
            description: "Sleep seven to eight hours a night",
          },
          {
            id: 41,
            key: "n",
            text_uz: "studiya",
            text_en: "studio",
            description: "Jan Hamilton and Sara White, two local parents, are in the studio with me to discuss this",
          },
          {
            id: 42,
            key: "n",
            text_uz: "subtitr",
            text_en: "subtitle",
            description: "How often do you watch films in English with out reading the subtitles?",
          },
          {
            id: 43,
            key: "v",
            text_uz: "suzmoq",
            text_en: "swim",
            description: "I swim every Saturday morning",
          },
          {
            id: 44,
            key: "v",
            text_uz: "olmoq",
            text_en: "take",
            description: "Take the stairs, not the lift ",
          },
          {
            id: 45,
            key: "n",
            text_uz: "tennis",
            text_en: "tennis",
            description: "People play tennis in my local park",
          },
          {
            id: 46,
            key: "n",
            text_uz: "momaqaldiroq",
            text_en: "thunderstorm",
            description: "There was a thunderstorm during the 100m World Championship final in 2013",
          },
          {
            id: 47,
            key: "adj",
            text_uz: "shavqatsiz",
            text_en: "violent",
            description: "Some video games aren't OK for children because they're very violent",
          },
          {
            id: 48,
            key: "v",
            text_uz: "piyoda yurmoq",
            text_en: "walk",
            description: "I walk to work",
          },
          {
            id: 49,
            key: "v",
            text_uz: "g'alaba qozonmoq",
            text_en: "win",
            description: "She always wins when she plays tennis",
          },
          {
            id: 50,
            key: "n",
            text_uz: "yoga",
            text_en: "yoga",
            description: "I do yoga every Thursday morning",
          }
        ],
        unit8: [
          {
            id: 1,
            key: "adj",
            text_en: "air-conditioned",
            text_uz: "havo sovutgichli",
            description: "Air-conditioned taxis are a comfortable way to travel.",
          },
          {
            id: 2,
            key: "adj",
            text_en: "amazing ",
            text_uz: "ajablanarli, g'aroyib",
            description: "India is amazing!",
          },
          {
            id: 3,
            key: "n",
            text_en: "apartment ",
            text_uz: "kvartira",
            description: "Do you prefer to stay in a hotel or rent an apartment?",
          },
          {
            id: 4,
            key: "n",
            text_en: "art gallery",
            text_uz: "san'at galereyasi",
            description: "I enjoy visiting all the art galleries and museums.",
          },
          {
            id: 5,
            key: "n",
            text_en: "bike",
            text_uz: "velosiped",
            description: "I go to work by bike. It's great exercise.",
          },
          {
            id: 6,
            key: "n",
            text_en: "bus",
            text_uz: "avtobus",
            description: "I get the bus to work.",
          },
          {
            id: 7,
            key: "n",
            text_en: "car ",
            text_uz: "yengil mashina",
            description: "I go to work by car and it takes about an hour.",
          },
          {
            id: 8,
            key: "n",
            text_en: "city break",
            text_uz: "shahar ta'tili",
            description: "I prefer going on a city break.",
          },
          {
            id: 9,
            key: "adj",
            text_en: "colourful",
            text_uz: "rangli",
            description: "Everywhere is really colourful and interesting",
          },
          {
            id: 10,
            key: "n",
            text_en: "countryside",
            text_uz: "qishloq",
            description: "Do you like staying in the countryside?",
          },
          {
            id: 11,
            key: "n",
            text_en: "culture ",
            text_uz: "madaniyat",
            description: "For me, holidays are about culture.  Indian railways have about a million employees.",
          },
          {
            id: 12,
            key: "n",
            text_en: "dinner ",
            text_uz: "tushlik",
            description: "Who do you usually have dinner with?",
          },
          {
            id: 13,
            key: "n",
            text_en: "employee ",
            text_uz: "ishchi",
            description: "Indian railways have about a million employees.",
          },
          {
            id: 14,
            key: "n",
            text_en: "environment",
            text_uz: "atrof-muhit",
            description: "Cyclos are a fun way to get around and they're good for the environment.",
          },
          {
            id: 15,
            key: "v",
            text_en: "get ",
            text_uz: "olmoq/qabul qilmoq",
            description: "How often do you get a taxi to go somewhere?",
          },
          {
            id: 16,
            key: "phrv",
            text_en: "get around",
            text_uz: "aylanmoq, xarakatlanmoq",
            description: "How do you usually get around town?",
          },
          {
            id: 17,
            key: "n",
            text_en: "group ",
            text_uz: "guruh",
            description: "I like going on holiday with a group of friends.",
          },
          {
            id: 18,
            key: "n",
            text_en: "guest house ",
            text_uz: "Mexmonxona(arzon turdagi)",
            description: "We usually stay in a guest house.",
          },
          {
            id: 19,
            key: "n",
            text_en: "guide ",
            text_uz: "yo'l boshlovchi",
            description: "Sometimes I go on a tour with a guide, because it's a great way to Tearn about a place.",
          },
          {
            id: 20,
            key: "n",
            text_en: "helmet",
            text_uz: "dubulg'a, kaska",
            description: "Your driver has to give you a helmet and you have to wear it.",
          },
          {
            id: 21,
            key: "v",
            text_en: "hold ",
            text_uz: "ushlamoq, ushlab turmoq",
            description: "You should hold the driver so you don't fall off!",
          },
          {
            id: 22,
            key: "v",
            text_en: "lie ",
            text_uz: "yotmoq",
            description: "Do you like lying on the beach?",
          },
          {
            id: 23,
            key: "n",
            text_en: "map ",
            text_uz: "xarita",
            description: "Do you usually take a map or do you get lost?",
          },
          {
            id: 24,
            key: "v",
            text_en: "miss ",
            text_uz: "o'tkazib yubormoq,ulgurmay qolmoq",
            description: "Did you miss your bus?",
          },
          {
            id: 1,
            key: "n",
            text_en: "mountain ",
            text_uz: "tog'",
            description: "We prefer to stay in the mountains",
          },
          {
            id: 25,
            key: "n",
            text_en: "passenger",
            text_uz: "yo'lovchi",
            description: "25 million passengers travel on 11,000 trains every day in India. ",
          },
          {
            id: 26,
            key: "n",
            text_en: "platform ",
            text_uz: "platforma, minbar",
            description: "Which platform does it leave from? ",
          },
          {
            id: 27,
            key: "n",
            text_en: "queue ",
            text_uz: "navbat",
            description: "You have to stand in a queue",
          },
          {
            id: 28,
            key: "n",
            text_en: "railway",
            text_uz: "temir yo'l",
            description: "What can you tell me about Indian railways?",
          },
          {
            id: 29,
            key: "n",
            text_en: "rainforest ",
            text_uz: "tropik o'rmon",
            description: "The ruins are in the middle of a rainforest and they're really beautiful. ",
          },
          {
            id: 30,
            key: "v",
            text_en: "rent ",
            text_uz: "ijaraga olmoq",
            description: "I normally rent an apartment by the sea",
          },
          {
            id: 31,
            key: "n",
            text_en: "return ",
            text_uz: "borib qaytish chiptasi ",
            description: "Would you like a single or return? ",
          },
          {
            id: 32,
            key: "npl",
            text_en: "ruins",
            text_uz: "xarobalar ",
            description: "My favourite thing was the ruins of a Mayan city in Tikal.",
          },
          {
            id: 33,
            key: "n",
            text_en: "seat belt ",
            text_uz: "xavfsizlik kamari",
            description: "You don't have to wear a seat belt for the whole journey on a plane.",
          },
          {
            id: 34,
            key: "n",
            text_en: "sightseeing ",
            text_uz: "diqqatga sazovor joylar ",
            description: "We don't go sightseeing.",
          },
          {
            id: 35,
            key: "n",
            text_en: "single",
            text_uz: "bir tomonlama chipta ",
            description: "Just a single, please.",
          },
          {
            id: 36,
            key: "n",
            text_en: "sunrise ",
            text_uz: "quyosh chiqishi",
            description: "I climbed to the top of a temple at sunrise.",
          },
          {
            id: 37,
            key: "n",
            text_en: "taxi ",
            text_uz: "taksi",
            description: "Sometimes I miss my train, so I have to get a taxi.",
          },
          {
            id: 38,
            key: "n",
            text_en: "text message ",
            text_uz: "matnli xabar",
            description: "How many text messages do you get?",
          },
          {
            id: 39,
            key: "n",
            text_en: "tip ",
            text_uz: "choychaqa, choy puli",
            description: "You don't have to leave a tip in restaurants.",
          },
          {
            id: 40,
            key: "n",
            text_en: "tradition ",
            text_uz: "urf-odat",
            description: "I don't know why they do it, it's just a tradition.",
          },
          {
            id: 41,
            key: "n",
            text_en: "train ",
            text_uz: "poyezd",
            description: "Sometimes I get up late and I miss my train.",
          },
          {
            id: 42,
            key: "v",
            text_en: "trek",
            text_uz: "piyoda safarga chiqish",
            description: "We like to trek in the mountains.",
          },
          {
            id: 43,
            key: "n",
            text_en: "street life ",
            text_uz: "shahar hayoti",
            description: "We think it's the best way to see the street life of the city.",
          }
        ],
        unit9: [
          {
            id: 1,
            key: "v",
            text_en: "bake ",
            text_uz: "pechda pishirmoq",
            description: "Do you bake your own bread?",

          },
          {

            id: 2,
            key: "n",
            text_en: "beef",
            text_uz: "mol go'shti ",
            description: "I'd like some beef, please. ",

          },
          {

            id: 3,
            key: "v",
            text_en: "boil",
            text_uz: "qaynatmoq ",
            description: "I always boil my vegetables",

          },
          {

            id: 4,
            key: "n",
            text_en: "bowl",
            text_uz: "tog'ora,kosa",
            description: "Put all the ingredients into a bowl. ",

          },
          {

            id: 5,
            key: "n",
            text_en: "bread ",
            text_uz: "non",
            description: "Not many people bake their own bread these days.",

          },
          {

            id: 6,
            key: "n",
            text_en: "castle ",
            text_uz: "qasr",
            description: "Can you see the castle from here? ",

          },
          {

            id: 7,
            key: "n",
            text_en: "chicken ",
            text_uz: "tovuq (tovuqli ovqat)",
            description: "Could I have the grilled chicken?",

          },
          {

            id: 8,
            key: "v",
            text_en: "chop ",
            text_uz: "to'g'ramoq, chopmoq",
            description: "Can you chop the onions with this knife, please?",

          },
          {

            id: 9,
            key: "n",
            text_en: "cube",
            text_uz: "go'sht bo'lagi",
            description: "Can I have some beef cubes? ",

          },
          {

            id: 10,
            key: "adj",
            text_en: "delicious ",
            text_uz: "mazali",
            description: "That looks delicious, but what is it? ",

          },
          {

            id: 11,
            key: "n",
            text_en: "food processor",
            text_uz: "oshxona kombayni",
            description: "Put everything in the food processor for one minute to make the soup",

          },
          {

            id: 12,
            key: "n",
            text_en: "fork",
            text_uz: "sanchqi",
            description: "There are knives and forks on the table",

          },
          {

            id: 13,
            key: "n",
            text_en: "fruit",
            text_uz: "meva",
            description: "We both had fruit and yoghurt for breakfast this morning.",

          },
          {

            id: 14,
            key: "v",
            text_en: "fry",
            text_uz: "qovurmoq",
            description: "For breakfast, I often fry bacon, eggs and mushrooms",

          },
          {

            id: 15,
            key: "n",
            text_en: "frying pan ",
            text_uz: " tova",
            description: "I have one frying pan and two saucepans.",

          },
          {

            id: 16,
            key: "n",
            text_en: "honey",
            text_uz: "asal",
            description: "I have honey and yoghurt for breakfast.",

          },
          {

            id: 17,
            key: "n",
            text_en: "ingredient",
            text_uz: "mahsulot",
            description: "Have you bought the ingredients for the meal?",

          },
          {

            id: 18,
            key: "n",
            text_en: "Jam ",
            text_uz: "murabbo",
            description: "Do you have any jam?",

          },
          {

            id: 19,
            key: "",
            text_en: "kettle",
            text_uz: "chovgun",
            description: "You boil water in a kettle to make tea.",

          },
          {

            id: 20,
            key: "n",
            text_en: "knife",
            text_uz: "pichoq",
            description: "You need a sharp knife to chop the onions.",

          },
          {

            id: 21,
            key: "n",
            text_en: "lemon ",
            text_uz: "limon",
            description: "There are only 17 calories in a lemon. ",

          },
          {

            id: 22,
            key: "n",
            text_en: "lemonade",
            text_uz: "limonad",
            description: "Can I have a bottle of lemonade?",

          },
          {

            id: 23,
            key: "n",
            text_en: "main course ",
            text_uz: "asosiy ovqat",
            description: "Could I have the grilled chicken for the main course?",

          },
          {

            id: 24,
            key: "n",
            text_en: "microwave",
            text_uz: "mikro to'lqinli pech",
            description: "The most important thing in my kitchen is the microwave.",

          },
          {

            id: 25,
            key: "v",
            text_en: "mix ",
            text_uz: "aralashtirmoq",
            description: "Mix all the ingredients together",

          },
          {

            id: 26,
            key: "n",
            text_en: "noodles ",
            text_uz: "ugra",
            description: "It comes with some noodles.",

          },
          {

            id: 27,
            key: "n",
            text_en: "olive ",
            text_uz: "zaytun",
            description: "I'd like some olives instead, please. ",

          },
          {

            id: 28,
            key: "n",
            text_en: "oven ",
            text_uz: "pech",
            description: "The oven is very hot.",

          },
          {

            id: 29,
            key: "n",
            text_en: "pasta ",
            text_uz: "makaron",
            description: "We can have pasta any day. ",

          },
          {

            id: 30,
            key: "n",
            text_en: "pear ",
            text_uz: "nok",
            description: "I'd like a pear.",

          },
          {

            id: 31,
            key: "n",
            text_en: "plate ",
            text_uz: "likopcha, tarelka",
            description: "I have a beautiful old set of plates and bowls for when people come for dinner.",

          },
          {

            id: 32,
            key: "v",
            text_en: "prepare ",
            text_uz: "tayyorlamoq",
            description: "The average American family today spends just 27 minutes a day preparing meals.",

          },
          {

            id: 33,
            key: "adj",
            text_en: "ready-made ",
            text_uz: "tayyor",
            description: "A lot of people buy ready-made meals.",

          },
          {

            id: 34,
            key: "n",
            text_en: "rice ",
            text_uz: "guruch",
            description: "We have some rice.",

          },
          {

            id: 35,
            key: "v",
            text_en: "roast ",
            text_uz: "olovda pishirmoq",
            description: "To roast meat, you need a very hot oven",

          },
          {

            id: 36,
            key: "adj",
            text_en: "rooftop ",
            text_uz: "tom usti",
            description: "There are wonderful views of the city from the rooftop restaurant.",

          },
          {

            id: 37,
            key: "n",
            text_en: "salad ",
            text_uz: "salat",
            description: "Can I have some salad with that as well, please?",

          },
          {

            id: 38,
            key: "n",
            text_en: "saucepen",
            text_uz: "kastryulya",
            description: "I've got three saucepen in my kitchen",

          },
          {

            id: 39,
            key: "n",
            text_en: "secret",
            text_uz: "sir",
            description: "What is the secret to good health?",

          },
          {

            id: 40,
            key: "n",
            text_en: "spoon",
            text_uz: "qoshiq",
            description: "Mix the water and flour together in a bowl with a spoon",

          },
          {

            id: 41,
            key: "n",
            text_en: "mushroom",
            text_uz: "qo'zoqorin",
            description: "Mix all the ingredients together. Do you have any mushrooms?",

          },
          {

            id: 42,
            key: "n",
            text_en: "starter",
            text_uz: "gazak, birinchi ovqat",
            description: "",

          },
          {

            id: 43,
            key: "adj",
            text_en: "sweet ",
            text_uz: "shirin",
            description: "",

          },
          {

            id: 44,
            key: "n",
            text_en: "survey",
            text_uz: "kuzatuv",
            description: "",

          },
          {

            id: 45,
            key: "n",
            text_en: "sweetcorn ",
            text_uz: "shirin johori",
            description: "",

          },
          {

            id: 46,
            key: "n",
            text_en: "take away food",
            text_uz: "o'zi bilan olib ketiladigan ovqat",
            description: "",

          },
          {

            id: 47,
            key: "adj",
            text_en: "unhealthy ",
            text_uz: "sog'liqqa zararli",
            description: "",

          },
          {

            id: 48,
            key: "n",
            text_en: "vegetable ",
            text_uz: "sabzavot",
            description: "",

          },
          {

            id: 49,
            key: "n",
            text_en: "view",
            text_uz: "manzara, ko'rinish",
            description: "",

          },
          {

            id: 50,
            key: "adj",
            text_en: "wonderful",
            text_uz: "ajoyib",
            description: "",

          },
          {

            id: 51,
            key: "n",
            text_en: "yoghurt",
            text_uz: "qatiq",
            description: "",

          },

        ],
        unit10: [
          {

            id: 1,
            key: "n",
            text_en: "accent ",
            text_uz: "talaffuz, ohang",
            description: "She's got a really strong accent. ",

          },
          {

            id: 2,
            key: "v",
            text_en: "blow ",
            text_uz: "esmoq",
            description: "The wind is blowing really hard",

          },
          {

            id: 3,
            key: "adj",
            text_en: "busy",
            text_uz: "gavjum",
            description: ". The busiest airport of the three is Beijing, then Dubai and then Los Angeles.",

          },
          {

            id: 4,
            key: "n",
            text_en: "camp ",
            text_uz: "lager, oromgoh",
            description: "You are going to walk 10 km from the main camp.",

          },
          {

            id: 5,
            key: "n",
            text_en: "climate ",
            text_uz: "iqlim",
            description: "Siberia has a very cold climate",

          },
          {

            id: 6,
            key: "adj",
            text_en: "close ",
            text_uz: "yaqin",
            description: "He's a close friend of mine.",

          },
          {

            id: 7,
            key: "adj",
            text_en: "cloudy ",
            text_uz: "bulutli",
            description: "It's going to be cloudy this afternoon",

          },
          {

            id: 8,
            key: "n",
            text_en: "coast ",
            text_uz: "sohil, qirg'oq",
            description: "There are some beautiful beaches near the west coast of Thailand. ",

          },
          {

            id: 9,
            key: "n",
            text_en: "compass ",
            text_uz: "kompas",
            description: "I think a map and compass are the most useful things.",

          },
          {

            id: 10,
            key: "adj",
            text_en: "crazy ",
            text_uz: "telba; aqldan ozgan",
            description: "People do some crazy things! ",

          },
          {

            id: 11,
            key: "adj",
            text_en: "deep ",
            text_uz: "chuqur",
            description: "Lake Baikal is more than 600 metres deep.",

          },
          {

            id: 12,
            key: "n",
            text_en: "desert ",
            text_uz: "chơi",
            description: "It's a cold desert because it's so far north and it sometimes snows there",

          },
          {

            id: 13,
            key: "adj",
            text_en: "dry ",
            text_uz: "quruq",
            description: " It's dry this morning.",

          },
          {

            id: 14,
            key: "n",
            text_en: "east ",
            text_uz: "sharq",
            description: "The east of the country is quite cold",

          },
          {

            id: 15,
            key: "n",
            text_en: "equipment",
            text_uz: "jihoz, uskuna",
            description: "The runners have to carry their food and equipment.",

          },
          {

            id: 16,
            key: "n",
            text_en: "first-aid kit ",
            text_uz: "birinchi yordam anjomlari",
            description: "What happens if we need the first-aid kit?",

          },
          {

            id: 17,
            key: "adj",
            text_en: "foggy ",
            text_uz: "tumanli",
            description: "It's cold and foggy.",

          },
          {

            id: 18,
            key: "v",
            text_en: "freeze ",
            text_uz: "muzlab qolmoq",
            description: "It's so cold. We're going to freeze if we go outside.",

          },
          {

            id: 19,
            key: "adj",
            text_en: "freezing ",
            text_uz: "qahraton sovuq",
            description: "It's freezing here today.",

          },
          {

            id: 20,
            key: "n",
            text_en: "hard worker",
            text_uz: "mehnatkash",
            description: "He's a really hard worker.",

          },
          {

            id: 21,
            key: "adj",
            text_en: "high ",
            text_uz: "baland",
            description: "Did you have a high score in your last test?",

          },
          {

            id: 22,
            key: "adj",
            text_en: "hot",
            text_uz: "issiq",
            description: "It's the hottest time of the year.",

          },
          {

            id: 23,
            key: "adj",
            text_en: "icy",
            text_uz: "muzlagan",
            description: "The roads are very icy.",

          },
          {

            id: 24,
            key: "n",
            text_en: "island ",
            text_uz: "orol",
            description: "The Andaman Sea has some very beautiful tropical islands and white sandy beaches near the west coast of Thailand.",

          },
          {

            id: 25,
            key: "n",
            text_en: "jungle ",
            text_uz: "chakalakzor",
            description: "The Amazon jungle is the biggest area of rainforest in the world",

          },
          {

            id: 26,
            key: "n",
            text_en: "lake ",
            text_uz: "ko'l",
            description: "It's the biggest and deepest lake in the world.",

          },
          {

            id: 27,
            key: "adj",
            text_en: "large",
            text_uz: "katta, yirik",
            description: "Mount Kilimanjaro is one of the largest volcanoes in the world.",

          },
          {

            id: 28,
            key: "n",
            text_en: "lighter ",
            text_uz: "zajigalka, yoritgich",
            description: "I think a lighter is more important than a stove.",

          },
          {

            id: 29,
            key: "adj",
            text_en: "low ",
            text_uz: "kam, past",
            description: "Which jobs usually have the lowest salaries?",

          },
          {

            id: 30,
            key: "adj",
            text_en: "mild ",
            text_uz: "yumshoq, mayin",
            description: "",

          },
          {

            id: 31,
            key: "n",
            text_en: "north ",
            text_uz: "shimol",
            description: "They have mild weather on the island. There are more mountains in the north.",

          },
          {

            id: 32,
            key: "n",
            text_en: "oasis ",
            text_uz: "voha",
            description: "Al Hasa is the largest oasis in Saudi Arabia.",

          },
          {

            id: 33,
            key: "n",
            text_en: "rain ",
            text_uz: "yomg'ir",
            description: "It's cloudy this morning but dry, so we don't expect any rain.",

          },
          {

            id: 34,
            key: "adj",
            text_en: "rainy ",
            text_uz: "yomg'irli",
            description: "It's cloudy and rainy here today.",

          },
          {

            id: 35,
            key: "n",
            text_en: "river ",
            text_uz: "daryo",
            description: "Which river is the longest in the world? ",

          },
          {

            id: 36,
            key: "adj",
            text_en: "sandy ",
            text_uz: "qumli",
            description: "There are lots of beautiful sandy beaches on the coast.",

          },
          {

            id: 37,
            key: "n",
            text_en: "score ",
            text_uz: "natija, baho",
            description: "He got a low score in the test.",

          },
          {

            id: 38,
            key: "n",
            text_en: "snow ",
            text_uz: "qor",
            description: "There was a lot of snow last night",

          },
          {

            id: 39,
            key: "v",
            text_en: "shine ",
            text_uz: "nur sochmoq, yoritmoq",
            description: "The sun is going to shine all afternoon",

          },
          {

            id: 40,
            key: "n",
            text_en: "sleeper ",
            text_uz: "uyquchi",
            description: "He's a light sleeper. ",

          },
          {

            id: 41,
            key: "adj",
            text_en: "snowy ",
            text_uz: "qorli",
            description: "It's cold and snowy here this morning",

          },
          {

            id: 42,
            key: "n",
            text_en: "south ",
            text_uz: "janub",
            description: "The best beaches are in the south",

          },
          {

            id: 43,
            key: "n",
            text_en: "storm ",
            text_uz: "to'fon; dovul",
            description: "There was a big storm.",

          },
          {

            id: 44,
            key: "n",
            text_en: "stove ",
            text_uz: "oshxona plitasi",
            description: "I think we should take one stove instead of three.",

          },
          {

            id: 45,
            key: "adj",
            text_en: "sunny ",
            text_uz: "quyoshli",
            description: "By the afternoon, it's going to be warm and sunny but not really hot",

          },
          {

            id: 46,
            key: "n",
            text_en: "survival ",
            text_uz: "tirik qolish",
            description: "The survival camp is in the rainforest next to the river.",

          },
          {

            id: 47,
            key: "v",
            text_en: "survive ",
            text_uz: "tirik qolmoq",
            description: "You need to survive for three days and two nights and find your way back to the main camp.",

          },
          {

            id: 48,
            key: "n",
            text_en: "tent ",
            text_uz: "chodir, palatka ",
            description: "You can take a tent and a sleeping bag.",

          },
          {

            id: 49,
            key: "n",
            text_en: "temperature",
            text_uz: "harorat",
            description: "By the afternoon, it's going to be warm and sunny but not really hot, with temperatures of around 20 degrees Celsius.",

          },
          {

            id: 50,
            key: "n",
            text_en: "thunder ",
            text_uz: "momoqaldiroq, chaqmoq ",
            description: "There was a big storm last night with very loud thunder.",

          },
          {

            id: 51,
            key: "n",
            text_en: "torch ",
            text_uz: "fonar, mash'al",
            description: "I'm going to take a torch to see in the dark.",

          },
          {

            id: 52,
            key: "n",
            text_en: "traffic ",
            text_uz: "yo'l-transport harakati",
            description: "Is there usually heavy traffic on the way to this class?",

          },
          {

            id: 53,
            key: "adj",
            text_en: "tropical ",
            text_uz: "tropik",
            description: "There are some beautiful tropical islands there.",

          },
          {

            id: 54,
            key: "adj",
            text_en: "warm ",
            text_uz: "iliq",
            description: "It's going to be warm this afternoon",

          },
          {

            id: 55,
            key: "n",
            text_en: "waterfall ",
            text_uz: "sharshara",
            description: "It's a very big waterfall on the Zambezi River."
          },
          {

            id: 56,
            key: "n",
            text_en: "weather",
            text_uz: "ob-havo",
            description: "The forecast is for mild weather tomorrow.",

          },
          {

            id: 57,
            key: "n",
            text_en: "weather forecast",
            text_uz: "ob-havo ma'lumoti",
            description: "Did you hear the weather forecast this morning?",

          },
          {

            id: 58,
            key: "n",
            text_en: "west ",
            text_uz: "g'arb",
            description: "We're going to the countryside in thewest.",

          },
          {

            id: 59,
            key: "adj",
            text_en: "wet ",
            text_uz: "nam",
            description: "It's going to be wet this afternoon.",

          },
          {

            id: 60,
            key: "adj",
            text_en: "windy ",
            text_uz: "shamolli",
            description: " It was really windy.",

          },
          {

            id: 61,
            key: "n",
            text_en: "worker ",
            text_uz: "ishchi",
            description: "Martha's a hard worker. She works very long hours",

          },
        ],
        unit11: [
          {

            id: 1,
            key: "adj",
            text_en: "annually ",
            text_uz: "har yili",
            description: "It's better to visit your dentist every six months than to go annually. ",

          },
          {

            id: 2,
            key: "v",
            text_en: "award ",
            text_uz: "mukofotlamoq",
            description: "The writers believe it is wrong to award the prize to one person",

          },
          {

            id: 3,
            key: "adj",
            text_en: "awful ",
            text_uz: "juda yomon",
            description: "It's really awful.I failed my driving test",

          },
          {

            id: 4,
            key: "v",
            text_en: "bark ",
            text_uz: "vovullamoq",
            description: "My neighbour's dog barks very loudly",

          },
          {

            id: 5,
            key: "n",
            text_en: "brilliant ",
            text_uz: "juda zo'r, aqlli ",
            description: "He was a brilliant scientist. ",

          },
          {

            id: 6,
            key: "v",
            text_en: "celebrate ",
            text_uz: "nishonlamoq",
            description: "People are telling us how they're going to celebrate the day",

          },
          {

            id: 7,
            key: "n",
            text_en: "charity ",
            text_uz: "xayriya",
            description: "Give the money to charity",

          },
          {

            id: 8,
            key: "n",
            text_en: "coach ",
            text_uz: "murabbiy",
            description: "The coach helps them with their game.",

          },
          {

            id: 9,
            key: "adj",
            text_en: "common ",
            text_uz: "oddiy, odatiy",
            description: "In the past, it was common for a really brilliant scientist like Isaac Newton to work alone.",

          },
          {

            id: 10,
            key: "n",
            text_en: "community",
            text_uz: "jamoat, mahalla",
            description: "Now it's your turn in your community",

          },
          {

            id: 11,
            key: "adv",
            text_en: "constantly",
            text_uz: "uzluksiz, doimiy",
            description: "My phone at work rings constantly",

          },
          {

            id: 12,
            key: "adj",
            text_en: "crucial ",
            text_uz: "muhim, asosiy",
            description: "She is a crucial member of the team",

          },
          {

            id: 13,
            key: "adj",
            text_en: "delighted ",
            text_uz: "xursand",
            description: "I was really delighted to get the job",

          },
          {

            id: 14,
            key: "n",
            text_en: "dietician ",
            text_uz: "diyetolog",
            description: ". The dietician tells them what to eat and drink.",

          },
          {

            id: 15,
            key: "adj",
            text_en: "elderly ",
            text_uz: "qari, keksa",
            description: "Visit an elderly neighbour.",

          },
          {

            id: 16,
            key: "adj",
            text_en: "excellent ",
            text_uz: "a'lo; zo'r",
            description: "Yes, she's really excellent! She always wins.",

          },
          {

            id: 17,
            key: "v",
            text_en: "fail ",
            text_uz: "yiqilmoq, uddalay olmaslik",
            description: "I failed my driving test!",

          },
          {

            id: 18,
            key: "v",
            text_en: "focus ",
            text_uz: "diqqatni qaratmoq",
            description: "Perhaps it's time to stop focusing only on the individual.",

          },
          {

            id: 19,
            key: "v",
            text_en: "help ",
            text_uz: "yordam bermoq",
            description: "Help a neighbour with difficult jobs",

          },
          {

            id: 20,
            key: "adj",
            text_en: "homeless ",
            text_uz: "uysiz, boshpanasiz",
            description: "Make sandwiches for homeless people.",

          },
          {

            id: 21,
            key: "adj",
            text_en: "huge",
            text_uz: "ulkan",
            description: "We should remember that there is often a huge team of many more people working hard to make everything possible.",

          },
          {

            id: 22,
            key: "v",
            text_en: "improve ",
            text_uz: "yaxshilamoq",
            description: "Nelson Mandela worked all his life to change and improve South Africa.",

          },
          {

            id: 23,
            key: "n",
            text_en: "individual ",
            text_uz: "individual, har bir shaxs",
            description: "There's usually a team that is working with the individual.",

          },
          {

            id: 24,
            key: "phrv",
            text_en: "look after ",
            text_uz: "g'amxo'rlik qilmoq",
            description: "Look after a neighbour's pet",

          },
          {

            id: 25,
            key: "adj",
            text_en: "lovely ",
            text_uz: "ajoyib",
            description: "The weather was really lovely on our holiday.",

          },
          {

            id: 26,
            key: "adj",
            text_en: "massive",
            text_uz: "juda katta",
            description: "They live in a massive house with ten bedrooms.",

          },
          {

            id: 27,
            key: "n",
            text_en: "member ",
            text_uz: "a'zo",
            description: "Only a maximum of three people can win the Nobel Prize at one time. We are looking for new members. Organize a sports event.",

          },
          {

            id: 28,
            key: "v",
            text_en: "organize ",
            text_uz: "tashkillashtirmoq",
            description: "Organize a sports event.",

          },
          {

            id: 29,
            key: "v",
            text_en: "paint ",
            text_uz: "bo'yamoq",
            description: "Paint the classrooms.",

          },
          {

            id: 30,
            key: "v",
            text_en: "plant ",
            text_uz: "ekmoq",
            description: "Plant a tree.",

          },
          {

            id: 31,
            key: "v",
            text_en: "repair",
            text_uz: "tuzatmoq",
            description: "Repair some broken furniture.",

          },
          {

            id: 32,
            key: "n",
            text_en: "player ",
            text_uz: "o'yinchi",
            description: "In sport, for example, there is usually a team of people helping the player of individual sports.",

          },
          {

            id: 33,
            key: "n",
            text_en: "resident ",
            text_uz: "yashovchi",
            description: "What are the residents like in your neighborhood?",

          },
          {

            id: 34,
            key: "adj",
            text_en: "scared ",
            text_uz: "qo'rqqan",
            description: "My sister is always really scared when she sees a spider.",

          },
          {

            id: 35,
            key: "n",
            text_en: "soil ",
            text_uz: "tuproq, yer",
            description: "You need to plant these flowers in good soil.",

          },
          {

            id: 36,
            key: "n",
            text_en: "tax ",
            text_uz: "soliq",
            description: "I think rich people and companies should pay more tax to government.",

          },
          {

            id: 37,
            key: "v",
            text_en: "teach",
            text_uz: "o'qitmoq, o'rgatmoq",
            description: "Teach someone a language",

          },
          {

            id: 38,
            key: "n",
            text_en: "team",
            text_uz: "jamoa",
            description: "These days, scientists usually work in teams",

          },
          {

            id: 39,
            key: "adj",
            text_en: "tiny",
            text_uz: "mayda",
            description: "My car is really tiny",

          },
          {

            id: 40,
            key: "adj",
            text_en: "worried",
            text_uz: "xavotirlangan",
            description: "Are you worried about the local area?",

          },
        ],
        unit12: [
          {

            id: 1,
            key: "n",
            text_en: "acrobat ",
            text_uz: "akrobat",
            description: "The acrobats were doing some amazing things.",

          },
          {

            id: 2,
            key: "n",
            text_en: "action film",
            text_uz: "jangari film",
            description: "I don't like action films because they're really boring.",

          },
          {

            id: 3,
            key: "n",
            text_en: "album ",
            text_uz: "albom",
            description: "She's had a few successful albums",

          },
          {

            id: 4,
            key: "n",
            text_en: "animation ",
            text_uz: "multfilm",
            description: "Shrek and Finding Nemo are two of my favourite animations",

          },
          {

            id: 5,
            key: "v",
            text_en: "ate ",
            text_uz: "ovqat istemol qilgan",
            description: "I ate everything that was on my plate.",

          },
          {

            id: 6,
            key: "adj",
            text_en: "autistic",
            text_uz: "autistik",
            description: "Stephen Wiltshire is autistic and could not speak until he was five.",

          },
          {

            id: 7,
            key: "n",
            text_en: "band ",
            text_uz: "guruh",
            description: "I've always wanted to play in a band",

          },
          {

            id: 8,
            key: "v",
            text_en: "began",
            text_uz: "boshladi",
            description: "He began learning the piano two years later.",

          },
          {

            id: 9,
            key: "v",
            text_en: "begun",
            text_uz: "boshlagan",
            description: "I think they've already begun.",

          },
          {

            id: 10,
            key: "phr",
            text_en: "black and white",
            text_uz: "oq-qora",
            description: "The film The Artist is black and white.",

          },
          {

            id: 11,
            key: "adj",
            text_en: "blind ",
            text_uz: "ko'r, ojiz",
            description: "Nobuyuki Tsujii was born blind.",

          },
          {

            id: 12,
            key: "v",
            text_en: "bought ",
            text_uz: "sotib olgan",
            description: "I bought Nicki a present from the new shop in town.",

          },
          {

            id: 13,
            key: "v",
            text_en: "broke ",
            text_uz: "sindirgan",
            description: "It wasn't me! He broke it.",

          },
          {

            id: 14,
            key: "v",
            text_en: "broken",
            text_uz: "sindirgan",
            description: "She has broken her arm.",

          },
          {

            id: 15,
            key: "n",
            text_en: "circus ",
            text_uz: "sirk",
            description: "Have you ever been to a circus? ",

          },
          {

            id: 16,
            key: "v",
            text_en: "clap",
            text_uz: "qarsak chalmoq",
            description: "When it finished, people stood up and clapped.",

          },
          {

            id: 17,
            key: "n",
            text_en: "collection ",
            text_uz: "to'plam",
            description: "Since I was a child, I've had a big music collection.",

          },
          {

            id: 18,
            key: "n",
            text_en: "comedy ",
            text_uz: "komediya",
            description: "Everybody likes comedies.",

          },
          {

            id: 19,
            key: "n",
            text_en: "concert ",
            text_uz: "konsert",
            description: "He gave his first big concert in Tokyo when he was 12 years old.",

          },
          {

            id: 20,
            key: "adj",
            text_en: "deaf ",
            text_uz: "kar",
            description: "She is deaf, but this hasn't stopped her dream of dancing.",

          },
          {

            id: 21,
            key: "n",
            text_en: "drama ",
            text_uz: "drama",
            description: "My favourite film is Titanic. It's a drama, but also a love story",

          },
          {

            id: 22,
            key: "v",
            text_en: "drank",
            text_uz: "ichgan",
            description: "I drank the water slowly.",

          },
          {

            id: 23,
            key: "v",
            text_en: "driven ",
            text_uz: "haydagan",
            description: "We've driven over 250 kilometres today.",

          },
          {

            id: 24,
            key: "v",
            text_en: "drove ",
            text_uz: "haydagan",
            description: "Paul drove them home after the concert.",

          },
          {

            id: 25,
            key: "n",
            text_en: "drum ",
            text_uz: "baraban",
            description: "The teacher asked the class to 'feel' the sound of a drum through their feet. ",

          },
          {

            id: 26,
            key: "v",
            text_en: "drunk",
            text_uz: "ichgan",
            description: "They've drunk all the orange juice.",

          },
          {

            id: 27,
            key: "v",
            text_en: "eaten ",
            text_uz: "yegan, ovqat iste'mol qilgan",
            description: "I've eaten too much!",

          },
          {

            id: 28,
            key: "n",
            text_en: "experience",
            text_uz: "tajriba",
            description: "This is a new experience for me.",

          },
          {

            id: 29,
            key: "adj",
            text_en: "favourite ",
            text_uz: "sevimli",
            description: "My favourite film is Titanic.",

          },
          {

            id: 30,
            key: "n",
            text_en: "future ",
            text_uz: "kelajak",
            description: "It's a science-fiction film and it's set in the future.",

          },
          {

            id: 31,
            key: "n",
            text_en: "gallery ",
            text_uz: "galereya",
            description: "He has his own art gallery in London. ",

          },
          {

            id: 32,
            key: "v",
            text_en: "gave ",
            text_uz: "berdi",
            description: "I gave it to you yesterday.",

          },
          {

            id: 33,
            key: "v",
            text_en: "given ",
            text_uz: "bergan",
            description: "Have you given him the front door key?",

          },
          {

            id: 34,
            key: "v",
            text_en: "gone ",
            text_uz: "ketgan",
            description: "She's already gone. I'm afraid.",

          },
          {

            id: 35,
            key: "v",
            text_en: "grew",
            text_uz: "o'sgan, katta bolgan",
            description: "The tree grew too big, so we had to cut it down.",

          },
          {

            id: 36,
            key: "v",
            text_en: "grown ",
            text_uz: "o'sgan, katta bo'lgan",
            description: "The children have grown so much!",

          },
          {

            id: 37,
            key: "phrv",
            text_en: "Hang on ",
            text_uz: "kutib turmoq",
            description: "Hang on a minute, I'll just get her. ",

          },
          {

            id: 38,
            key: "v",
            text_en: "heard ",
            text_uz: "eshitdi",
            description: "I've never heard of her.",

          },
          {

            id: 39,
            key: "n",
            text_en: "helicopter",
            text_uz: "vertolyot",
            description: "He spent just 20 minutes in a helicopter in the sky above the city",

          },
          {

            id: 40,
            key: "n",
            text_en: "horror film ",
            text_uz: "dahshatli film",
            description: "I don't like horror films because they're scary.",

          },
          {

            id: 41,
            key: "n",
            text_en: "illness ",
            text_uz: "kasallik",
            description: "Tai Lihua couldn't hear from the age of two after an illness.",

          },
          {

            id: 42,
            key: "n",
            text_en: "independence",
            text_uz: "mustaqillik",
            description: "When India celebrated 50 years of independence, she sang her own song and three million people watched her live.",

          },
          {

            id: 43,
            key: "n",
            text_en: "instrument",
            text_uz: "uskuna, asbob",
            description: "I've always wanted to play a musical instrument.",

          },
          {

            id: 44,
            key: "n",
            text_en: "lesson ",
            text_uz: "dars",
            description: "I had dance lessons at school, but I wasn't very good.",

          },
          {

            id: 45,
            key: "n",
            text_en: "love story ",
            text_uz: "sevgi hikoyasi",
            description: "It's a drama, but also a love story. ",

          },
          {

            id: 46,
            key: "v",
            text_en: "met ",
            text_uz: "ko'rishgan",
            description: "I've never met a famous person.",

          },
          {

            id: 47,
            key: "n",
            text_en: "musical ",
            text_uz: "musiqiy",
            description: "I usually go to two or three music festivals a year.",

          },
          {

            id: 48,
            key: "n",
            text_en: "music festival",
            text_uz: "musiqiy festival",
            description: "I've been to see all the big musicals- they're fantastic",

          },
          {

            id: 49,
            key: "n",
            text_en: "opera ",
            text_uz: "opera ",
            description: "I sometimes go to the opera with my cousin",

          },
          {

            id: 50,
            key: "n",
            text_en: "play ",
            text_uz: "o'yin",
            description: "I love going to the theatre to see a play.",

          },
          {

            id: 51,
            key: "n",
            text_en: "painting lesson",
            text_uz: "rasm darsi",
            description: "I've had lots of drawing and painting lessons.",

          },
          {

            id: 52,
            key: "v",
            text_en: "prefer ",
            text_uz: "afzal ko'rmoq",
            description: "I prefer comedies.",

          },
          {

            id: 53,
            key: "n",
            text_en: "prize ",
            text_uz: "mukofot",
            description: "He won many prizes.",

          },
          {

            id: 54,
            key: "v",
            text_en: "ran ",
            text_uz: "yugurgan",
            description: "She ran a marathon.",

          },
          {

            id: 55,
            key: "n",
            text_en: "romantic film",
            text_uz: "romantic film",
            description: "I prefer romantic films.",

          },
          {

            id: 56,
            key: "v",
            text_en: "saw ",
            text_uz: "ko'rgan",
            description: "I saw him outside the cinema yesterday afternoon.",

          },
          {

            id: 57,
            key: "adj",
            text_en: "scary",
            text_uz: "qo'rqinchli",
            description: "Sometimes you don't want to look because they're scary.",

          },
          {

            id: 58,
            key: "n",
            text_en: "science fiction film ",
            text_uz: "ilmiy fantastik film",
            description: "Avatar is a science fiction film.",

          },
          {

            id: 59,
            key: "v",
            text_en: "seen",
            text_uz: "ko'rgan",
            description: "I've already seen that film.",

          },
          {

            id: 60,
            key: "v",
            text_en: "set",
            text_uz: "tasvirga olingan",
            description: "It's set in the future.",

          },
          {

            id: 61,
            key: "v",
            text_en: "spoke ",
            text_uz: "gapirdi",
            description: "She spoke in a really quiet voice.",

          },
          {

            id: 62,
            key: "adv",
            text_en: "spoken ",
            text_uz: "gapirgan",
            description: "I've spoken to them about the noise",

          },
          {

            id: 63,
            key: "v",
            text_en: "star ",
            text_uz: "bosh rolni bermoq",
            description: "It stars Kate Winslet and Leonardo Di Caprio",

          },
          {

            id: 64,
            key: "n",
            text_en: "surprise ",
            text_uz: "kutilmagan sovg'a,",
            description: "It was the surprise success of 2012.",

          },
          {

            id: 65,
            key: "v",
            text_en: "went ",
            text_uz: "bordi",
            description: "He went there last week.",

          },
          {

            id: 66,
            key: "phrv",
            text_en: "woke up ",
            text_uz: "uyg'ondi",
            description: "My 18 th birthday was on a Saturday and I was really excited when I woke up.",

          },
          {

            id: 67,
            key: "v",
            text_en: "woken ",
            text_uz: "uyg'ongan",
            description: "Have you ever woken up feeling hungry in the middle of the night?",

          },
          {

            id: 68,
            key: "v",
            text_en: "written ",
            text_uz: "yozgan",
            description: "I've never written a comment on a website.",

          },
          {

            id: 69,
            key: "v",
            text_en: "wrote ",
            text_uz: "yozdi",
            description: "I wrote a lot of emails yesterday.",

          },
          {
            id: 70,
            key: "n",
            text_en: "stage",
            text_uz: "sahna",
            description: "We sat very close to the stage.",
          }
        ],
      },
      preIntermediate: {
        unit1: [
          {
            id: 1,
            key: "n",
            text_uz: "aerobika",
            text_en: "aerobics",
            description: "She does aerobics once or twice a week.",
          },
          {
            id: 2,
            key: "n",
            text_uz: "blog",
            text_en: "blog",
            description: "Would you like to write a blog about your daily life?",
          },
          {
            id: 3,
            key: "adj",
            text_uz: "band",
            text_en: "busy",
            description: "My life is too busy.",
          },
          {
            id: 4,
            key: "n",
            text_uz: "tabiatga sayr",
            text_en: "camping",
            description: "We usually go camping in the summer.",
          },
          {
            id: 5,
            key: "n",
            text_uz: "qarta",
            text_en: "cards",
            description: " Marta and Felix often play cards together.",
          },
          {
            id: 6,
            key: "v",
            text_uz: "onlayn yozishmoq va suhbatlashmoq",
            text_en: "chat",
            description: "I like to chat with friends online.",
          },
          {
            id: 7,
            key: "n",
            text_uz: "shaxmat",
            text_en: "chess",
            description: "Mehmet plays chess once or twice",
          },
          {
            id: 8,
            key: "adj",
            text_uz: "bulutli",
            text_en: "cloudy",
            description: "It's very cloudy today.",
          },
          {
            id: 9,
            key: "n",
            text_uz: "qahva",
            text_en: "coffee",
            description: "We hardly ever go out for a coffee.",
          },
          {
            id: 10,
            key: "n",
            text_uz: "kompyuter o'yini",
            text_en: "computer game",
            description: "He nearly always plays computer games ales plays computer",
          },
          {
            id: 11,
            key: "adj",
            text_uz: "nam",
            text_en: "damp",
            description: "Wear your raincoat. It's another damp day today.",
          },
          {
            id: 12,
            key: "n",
            text_uz: "tush, orzu",
            text_en: "dream",
            description: "Do you ever have a dream about flying?",
          },
          {
            id: 13,
            key: "adj",
            text_uz: "erta",
            text_en: "early ",
            description: "I'm going to have an early night.",
          },
          {
            id: 14,
            key: "adj",
            text_uz: "teng",
            text_en: "equal",
            description: "You should try to have an equal balance of all three.",
          },
          {
            id: 15,
            key: "n",
            text_uz: " mashq",
            text_en: "exercise",
            description: "You should do some exercise.",
          },
          {
            id: 16,
            key: "n",
            text_uz: "oila",
            text_en: "family",
            description: "Do you spend a lot of time with your family?",
          },
          {
            id: 17,
            key: "n",
            text_uz: "kino",
            text_en: "film",
            description: "Have you ever made a film and posted it on YouTube?",
          },
          {
            id: 18,
            key: "v",
            text_uz: "suratga olish",
            text_en: "film",
            description:
              "One of them stands next to the painting as the other one films her.",
          },
          {
            id: 19,
            key: "n",
            text_uz: "xursandchilik",
            text_en: "fun",
            description: "I like to have fun.",
          },
          {
            id: 20,
            key: "n",
            text_uz: "golf",
            text_en: "golf",
            description: "Do you play golf?",
          },
          {
            id: 21,
            key: "n",
            text_uz: "sport zal",
            text_en: "gym",
            description: "I sometimes go to the gym after work.",
          },
          {
            id: 22,
            key: "n",
            text_uz: "uy ishi (dars)",
            text_en: "homework",
            description: "Make sure you do your homework before supper.",
          },
          {
            Id: 23,
            key: "adj",
            text_uz: "issiq",
            text_en: "hot",
            description: "I love this hot weather.",
          },
          {
            id: 24,
            key: "n",
            text_uz: "uy yumushlari",
            text_en: "housework",
            description: "I'm going to do the housework after lunch.",
          },
          {
            id: 25,
            key: "adj",
            text_uz: "nam",
            text_en: "humid",
            description: "I hate this humid weather",
          },
          {
            id: 26,
            key: "adv",
            text_uz: "ichkarida",
            text_en: "indoors",
            description: "We sometimes play cards indoors",
          },
          {
            id: 27,
            key: "adv",
            text_uz: "kech",
            text_en: "late",
            description: "I try not to go to bed late during the week.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "karate",
            text_en: "karate",
            description: "He does karate most days.",
          },
          {
            id: 29,
            key: "n",
            text_uz: "uyg'ongandan keyin yotish",
            text_en: "lie-in",
            description: "Sunday going to have a lie-in on sunday?",
          },
          {
            id: 30,
            key: "adj",
            text_uz: "yengil (bu yerda: bir oz)",
            text_en: "light",
            description: "There is going to be some light snow this evening.",
          },
          {
            id: 31,
            key: "n",
            text_uz: "chaqmoq",
            text_en: "lightning",
            description: "Did you see the lightning last night?",
          },
          {
            id: 32,
            key: "n",
            text_uz: "nigoh",
            text_en: "look",
            description: "We'll have a look at it back at the hotel.",
          },
          {
            id: 33,
            key: "per",
            text_uz: "ro'yxat tuzmoq",
            text_en: "make a list",
            description: "I always start the day by making a to-do list.",
          },
          {
            id: 34,
            key: "phr",
            text_uz: "rejalar tuzmoq",
            text_en: "make plans",
            description: "She is making plans for her future.",
          },
          {
            id: 35,
            key: "n",
            text_uz: "ovqat",
            text_en: "meal",
            description: "We sometimes go out for a meal.",
          },
          {
            id: 36,
            key: "adv",
            text_uz: "ko'chada, tashqarida",
            text_en: "outdoors",
            description: "They are always playing outdoors.",
          },
          {
            id: 37,
            key: "adj",
            text_uz: "yoqimsiz",
            text_en: "nasty",
            description:
              "The water's too warm and there are sea snakes and other nasty animals.",
          },
          {
            id: 38,
            key: "n",
            text_uz: "davr",
            text_en: "period",
            description: "There are going to be some short periods of rain later.",
          },
          {
            id: 39,
            key: "n",
            text_uz: "rasm, surat",
            text_en: "photograph",
            description: "I always look serious if someone takes a photograph of me.",
          },
          {
            id: 40,
            key: "adj",
            text_uz: "yoqimli",
            text_en: "pleasant",
            description: "The weather is very pleasant.",
          },
          {
            id: 41,
            key: "n",
            text_uz: "zavq, mamnuniyat",
            text_en: "pleasure",
            description: "Can you say 'no' to immediate pleasures?",
          },
          {
            id: 42,
            key: "v",
            text_uz: "joylamoq",
            text_en: "post",
            description: "We'll post that on Facebook later.",
          },
          {
            id: 43,
            key: "n",
            text_uz: "va'da",
            text_en: "promise",
            description: "When I make a promise, I never change my mind.",
          },
          {
            id: 44,
            key: "n",
            text_uz: "ruhshunos ",
            text_en: "psychologist ",
            description: "Professor Philip Zimbardo is a psychologist. ",
          },
          {
            id: 45,
            key: "n",
            text_uz: "qayd ",
            text_en: "record ",
            description: "I always make a record of everything spend in a day. ",
          },
          {
            id: 46,
            key: "v",
            text_uz: " yozmoq (qayd etmoq)",
            text_en: "record ",
            description: " We can record the speech and post it on YouTube later.",
          },
          {
            id: 47,
            key: "n",
            text_uz: " munosabat",
            text_en: "relationship ",
            description: "They have a very good relationship with their parents.",
          },
          {
            id: 48,
            key: "n",
            text_uz: "qarindosh ",
            text_en: "relative ",
            description: " I love spending time with relatives.",
          },
          {
            id: 49,
            key: "n",
            text_uz: " yugurish",
            text_en: " running",
            description: "Do you ever go running? ",
          },
          {
            id: 50,
            key: "n",
            text_uz: "sharhlovchi ",
            text_en: " reviewer",
            description:
              " Here to tell us about the new book by Haruki Murakami is this week's reviewer, Maria Georgiou.",
          },
          {
            id: 51,
            key: "n",
            text_uz: " xarid",
            text_en: "shopping ",
            description: "I'm going to do the shopping this afternoon ",
          },
          {
            id: 52,
            key: "n",
            text_uz: "qor yog'ishi",
            text_en: "snowfall",
            description: "In the late autumn we get our first snowfalls.",
          },
          {
            id: 53,
            key: "v",
            text_uz: "vaqt o'tkazmoq",
            text_en: "spend time",
            description: "You should try and spend more time with relatives.",
          },
          {
            id: 54,
            key: "v",
            text_uz: "qolmoq (uyda)",
            text_en: "stay in",
            description: "I'm going to stay in tonight.",
          },
          {
            id: 55,
            key: "n",
            text_uz: "suzish",
            text_en: "swimming",
            description: "We never go swimming.",
          },
          {
            id: 56,
            key: "n",
            text_uz: "matn",
            text_en: "text",
            description: "Do you use special language when you write a text?",
          },
          {
            id: 57,
            key: "n",
            text_uz: "vaqt",
            text_en: "time",
            description: "Do you spend time with family during your holidays?",
          },
          {
            id: 58,
            key: "n",
            text_uz: "qilinadigan ishlar ro'yxati",
            text_en: "to-do list",
            description: "There's so much to do. You should make a to- do list.",
          },
          {
            id: 59,
            key: "n",
            text_uz: "sayohat",
            text_en: "trip",
            description: "Let's go on a trip some where.",
          },
          {
            id: 60,
            key: "adj",
            text_uz: "noqulay",
            text_en: "uncomfortable",
            description: "This hot weather is uncomfortable.",
          },
          {
            id: 61,
            key: "n",
            text_uz: "yurish",
            text_en: "walk",
            description: "She rarely goes for a walk.",
          },
          {
            id: 62,
            key: "n",
            text_uz: "ish",
            text_en: "work",
            description: "I must do some work this afternoon.",
          },
        ],
        unit2: [
          {
            id: 1,
            key: "n",
            text_uz: "me'mor",
            text_en: "architect",
            description:
              "Jim Thompson was an American architect who moved to Bangkok after the Second World War.",
          },
          {
            id: 2,
            key: "v",
            text_uz: "to'smoq",
            text_en: "block",
            description:
              "They block my way and don't move even when I say politely, Excuse me...",
          },
          {
            id: 3,
            key: "n",
            text_uz: "kafe",
            text_en: "café",
            description: "There's a pavement café in the city centre",
          },
          {
            id: 4,
            key: "n",
            text_uz: "sham, shag'am",
            text_en: "candle",
            description: "I love the candles in your bedroom",
          },
          {
            id: 5,
            key: "n",
            text_uz: "video kuzatuv kamerasi",
            text_en: "CCTV camera",
            description: "CCTV cameras check their speed",
          },
          {
            id: 6,
            key: "n",
            text_uz: "mato",
            text_en: "cloth",
            description: "Please clean the kitchen with this cloth.",
          },
          {
            id: 7,
            key: "n",
            text_uz: "tortmali javon",
            text_en: "chest of drawers",
            description: "I'm surprised there isn't a chest of drawers in the bedroom.",
          },
          {
            id: 8,
            key: "v",
            text_uz: "yig'moq",
            text_en: "collect",
            description: "They are developing a new way to collect rubbish.",
          },
          {
            id: 9,
            key: "adj",
            text_uz: "gavjum",
            text_en: "crowded",
            description: "The streets are crowded in the summer",
          },
          {
            id: 10,
            key: "v",
            text_uz: "buzmoq, vayron qilmoq",
            text_en: "destroy",
            description: "The new building work is going to destroy the old town.",
          },
          {
            id: 11,
            key: "adj",
            text_uz: "zerikarli",
            text_en: "dull",
            description: "It's quite dull in winter.",
          },
          {
            id: 12,
            key: "n",
            text_uz: "parko'rpa",
            text_en: "duvet",
            description: "The blue duvet on her bed is lovely.",
          },
          {
            id: 13,
            key: "n",
            text_uz: "xokandoz va cho'tka",
            text_en: "dustpan and brush",
            description: "He's cleaning the floor with a dustpan and brush.",
          },
          {
            id: 14,
            key: "n",
            text_uz: "yo'lning yuqoriroq tezlikda harakatlanish qismi",
            text_en: "fast lane",
            description: "In a pedestrian fast lane, the maximum speed is 3 mph.",
          },
          {
            id: 15,
            key: "v",
            text_uz: "jarimaga tortmoq",
            text_en: "fine",
            description: "Police officers fine people not following the rules.",
          },
          {
            id: 16,
            key: "n",
            text_uz: "gul rastasi",
            text_en: "flower stall",
            description: "There's a flower stall in the town centre.",
          },
          {
            id: 17,
            key: "n",
            text_uz: "uy almashib turish (vaqtincha)",
            text_en: "house swap",
            description:
              "They are doing a house swap with a family in the United States.",
          },
          {
            id: 18,
            key: "n",
            text_uz: "uy ro'zg'or buyumlari",
            text_en: "household possessions",
            description:
              "Huang Qingjun takes photos of people outside their homes with their household possessions.",
          },
          {
            id: 19,
            key: "n",
            text_uz: "uyga garab turish (vaqtinchalik)",
            text_en: "house-sit",
            description: "Felix is house-sitting for a friend.",
          },
          {
            id: 20,
            key: "n",
            text_uz: "sanoat",
            text_en: "industry",
            description: "He is famous for rebuilding the Thai silk industry.",
          },
          {
            id: 21,
            key: "adj",
            text_uz: "jonli, jo'shqin",
            text_en: "lively",
            description: "The nightlife is lively.",
          },
          {
            id: 22,
            key: "n",
            text_uz: "manzil",
            text_en: "location ",
            description: "He visited one location where a couple had to move house.",
          },
          {
            id: 23,
            key: "n",
            text_uz: "bozor",
            text_en: "market place",
            description: "I really like the market place in your town.",
          },
          {
            id: 24,
            key: "n",
            text_uz: "labirint",
            text_en: "maze",
            description: "This city's like a maze.",
          },
          {
            id: 25,
            key: "n",
            text_uz: "mikro to'lqinli pech",
            text_en: "microwave oven",
            description: "I'm disappointed there's only a microwave oven in the kitchen.",
          },
          {
            id: 26,
            key: "n",
            text_uz: "tosh oyna",
            text_en: "mirror",
            description: "Did you see the mirror on the bedroom wall?",
          },
          {
            id: 27,
            key: "adj",
            text_uz: "tor",
            text_en: "narrow ",
            description: "Many Italian towns have small or narrow streets.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "boshqaruv",
            text_en: "navigation",
            description:
              "Dustcart is a friendly-looking robot with maps and GPS navigation.",
          },
          {
            id: 29,
            key: "phr",
            text_uz: "ish yuzasidan",
            text_en: "on business",
            description: "There are so many people who come here on business.",
          },
          {
            id: 30,
            key: "phr",
            text_uz: "ta'tilda",
            text_en: "on holiday",
            description: "I really don't understand why they come here on holiday.",
          },
          {
            id: 31,
            key: "phr",
            text_uz: "jamoat transportida",
            text_en: "on public transport",
            description: "can you get to work or university on public transport?",
          },
          {
            id: 32,
            key: "phr",
            text_uz: "internetda",
            text_en: "on the internet",
            description: "You just look it up on the internet.",
          },
          {
            id: 33,
            key: "phr",
            text_uz: "yo'lda",
            text_en: "on the way",
            description: "I was on the way to the city centre.",
          },
          {
            id: 34,
            key: "phr",
            text_uz: "o'z vaqtida",
            text_en: "on time",
            description: "Nobody's ever on time for anything",
          },
          {
            id: 35,
            key: "phr",
            text_uz: "televizorda",
            text_en: "on TV",
            description: "Do you prefer watching films on TV or at the cinema?",
          },
          {
            id: 36,
            key: "n",
            text_uz: "tova",
            text_en: "pan",
            description: "Use this pan to cook the pasta in.",
          },
          {
            id: 37,
            key: "n",
            text_uz: "to'xtash joyi",
            text_en: "parking space",
            description: "It's difficult to find a parking space.",
          },
          {
            id: 38,
            key: "n",
            text_uz: "ko'cha rassomi",
            text_en: "pavement artist",
            description:
              "In the summer you can see pavement artists on some of the streets.",
          },
          {
            id: 39,
            key: "n",
            text_uz: "piyodalar hududi",
            text_en: "pedestrian area",
            description: "The pedestrian area is good for shopping.",
          },
          {
            id: 40,
            key: "n",
            text_uz: "o'yin maydoni",
            text_en: "play area",
            description: "There's a play area for the children.",
          },
          {
            id: 41,
            key: "n",
            text_uz: "loyiha",
            text_en: "project",
            description: "He began this project in 2006.",
          },
          {
            id: 42,
            key: "n",
            text_uz: "nashriyotchi",
            text_en: "publisher",
            description: "I'm the writer, publisher and the salesman.",
          },
          {
            id: 43,
            key: "n",
            text_uz: "g'azab",
            text_en: "rage",
            description: "He was so angry. I had never seen him in such a rage before.",
          },
          {
            id: 44,
            key: "v",
            text_uz: "qayta ishlash",
            text_en: "recycle",
            description: "These days, we recycle more and more of our rubbish.",
          },
          {
            id: 45,
            key: "n",
            text_uz: "robot",
            text_en: "robot",
            description: "Dustcart is a street-cleaning robot.",
          },
          {
            id: 46,
            key: "n",
            text_uz: "chiqindi",
            text_en: "rubbish",
            description: "There's a huge problem with rubbish in the city centre.",
          },
          {
            id: 47,
            key: "n",
            text_uz: "gilamcha",
            text_en: "rug",
            description: "I don't like the white rugs in the sitting room.",
          },
          {
            id: 48,
            key: "adj",
            text_uz: "xavfsiz",
            text_en: "safe",
            description: "The city centre is safe at night.",
          },
          {
            id: 49,
            key: "n",
            text_uz: "sun'iy yo'ldosh antennasi",
            text_en: "satellite dish",
            description: "The photo shows a satellite dish on the house.",
          },
          {
            id: 50,
            key: "n",
            text_uz: "choyshab",
            text_en: "sheet",
            description: "All the beds have got clean sheets.",
          },
          {
            id: 51,
            key: "n",
            text_uz: "do'kon ekrani",
            text_en: "shop display",
            description:
              "The people in front of me were walking slowly and taking photos of the shop displays",
          },
          {
            id: 52,
            key: "n",
            text_uz: "xaridor",
            text_en: "shopper",
            description: "There are so many shoppers on the streets.",
          },
          {
            id: 53,
            key: "n",
            text_uz: "yechim",
            text_en: "solution",
            description: "One solution to the problem is a pedestrian fast lane.",
          },
          {
            id: 54,
            key: "n",
            text_uz: "suviner sotuvchisi",
            text_en: "souvenir seller",
            description: "There are lots of souvenir sellers in summer.",
          },
          {
            id: 55,
            key: "n",
            text_uz: "do'koncha",
            text_en: "stall",
            description: "The market has all kinds of stalls.",
          },
          {
            id: 56,
            key: "n",
            text_uz: "haykal",
            text_en: "statue",
            description: "It's famous for its statue of a lion.",
          },
          {
            id: 57,
            key: "adj",
            text_uz: "g'alati",
            text_en: "strange",
            description: "Some people think that it's a strange idea.",
          },
          {
            id: 58,
            key: "n",
            text_uz: "ko'cha tozalovchi",
            text_en: "street cleaner",
            description: "The street cleaners keep our city looking nice.",
          },
          {
            id: 59,
            key: "n",
            text_uz: "ko'cha ijrochilari",
            text_en: "street performer",
            description: "You can see street performers every weekend in our city.",
          },
          {
            id: 60,
            key: "n",
            text_uz: "talabalar turar joyi",
            text_en: "student accommodation",
            description: "Petra is staying in student accommodation this term.",
          },
          {
            id: 61,
            key: "n",
            text_uz: "jo'mrak",
            text_en: "tap",
            description: "I can't work the taps in the bathroom.",
          },
          {
            id: 62,
            key: "n",
            text_uz: "sochiq",
            text_en: "towel",
            description: "The towels in the bathroom are lovely.",
          },
          {
            id: 63,
            key: "n",
            text_uz: "imorat",
            text_en: "tower block",
            description: "There are plans to build some tower blocks in the city centre",
          },
          {
            id: 64,
            key: "n",
            text_uz: "yuk mashinasi",
            text_en: "truck",
            description:
              "Rubbish trucks don't find it easy to get around the narrow streets.",
          },
          {
            id: 65,
            key: "n",
            text_uz: "shkaf",
            text_en: "wardrobe",
            description: "I'm surprised there isn't a wardrobe for our clothes.",
          },
        ],
        unit3: [
          {
            id: 1,
            key: "n",
            text_uz: "yutuq",
            text_en: "achievement",
            description:
              "Hello and welcome to Making History the programme where we look back at human achievements that have changed history.",
          },
          {
            id: 2,
            key: "adv",
            text_uz: "g'azab bilan",
            text_en: "angrily",
            description: "I look at them angrily.",
          },
          {
            id: 3,
            key: "adj",
            text_uz: "jahldor",
            text_en: "angry",
            description: "I get angry when people drop rubbish in the street.",
          },
          {
            id: 4,
            key: "adj",
            text_uz: "havotirli",
            text_en: "anxious",
            description: "I think she's feeling anxious.",
          },
          {
            id: 5,
            key: "v",
            text_uz: "chetlab o'tmoq",
            text_en: "avoid",
            description: "I try to avoid eye contact.",
          },
          {
            id: 6,
            key: "adv",
            text_uz: "orqaga, chalqancha",
            text_en: "backwards",
            description: "Scuba divers always dive backwards out of a boat.",
          },
          {
            id: 7,
            key: "n",
            text_uz: "havo shari",
            text_en: "balloon",
            description: "A large balloon took him up into space.",
          },
          {
            id: 8,
            key: "n",
            text_uz: "xulq",
            text_en: "behaviour",
            description:
              "If you watch what people do in lifts, you'll see some very interesting behaviour.",
          },
          {
            id: 9,
            key: "v",
            text_uz: "bezovta qilmoq",
            text_en: "bother",
            description: "It doesn't bother me if they listen to loud music.",
          },
          {
            id: 10,
            key: "adj",
            text_uz: "xotirjam",
            text_en: "calmly",
            description: "He calmly pushed the alarm button and waited for an answer.",
          },
          {
            id: 11,
            key: "n",
            text_uz: "kapsula",
            text_en: "capsule",
            description: "He came slowly out of the capsule.",
          },
          {
            id: 12,
            key: "v",
            text_uz: "oshib tushmoq, tirmashib chiqmoq",
            text_en: "climb",
            description:
              "I haven't got my key. I know - l'll climb in through that open window.",
          },
          {
            id: 13,
            key: "adj",
            text_uz: "chalkashgan, boshi qotgan",
            text_en: "confused",
            description: "I feel very confused. I don't know what to do!",
          },
          {
            id: 14,
            key: "n",
            text_uz: "oshpaz",
            text_en: "cook",
            description: "She's a good cook.",
          },
          {
            id: 15,
            key: "v",
            text_uz: "sho'ng'imoq",
            text_en: "dive",
            description: "Watch him dive into the swimming pool.",
          },
          {
            id: 16,
            key: "v",
            text_uz: "tushirib yubormoq",
            text_en: "drop",
            description:
              "If you drop your phone into liquid , put it in a bowl of uncooked rice to dry it out.",
          },
          {
            id: 17,
            key: "adv",
            text_uz: "osonlik bilan",
            text_en: "easily",
            description: "I can easily start a conversation with a stranger.",
          },
          {
            id: 18,
            key: "n",
            text_uz: "xo'rranda",
            text_en: "eater",
            description: "She's a slow eater.",
          },
          {
            id: 19,
            key: "adj",
            text_uz: "xijolat bo'lgan",
            text_en: "embarrassed",
            description: "I feel so embarrassed about it.",
          },
          {
            id: 20,
            key: "adj",
            text_uz: "hayajonlangan, hursand",
            text_en: "excited",
            description: "I feel so excited about journey tomorrow.",
          },
          {
            id: 21,
            key: "adj",
            text_uz: "toliqqan",
            text_en: "exhausted",
            description: "I feel exhausted most days.",
          },
          {
            id: 22,
            key: "n",
            text_uz: "ko'z bilan aloqa",
            text_en: "eye contact",
            description: "She's very shy and never makes eye contact.",
          },
          {
            id: 23,
            key: "v",
            text_uz: "yiqilmoq, tushib ketmoq",
            text_en: "fall",
            description: "Watch out! I think that tree is going to fall.",
          },
          {
            id: 24,
            key: "adv",
            text_uz: "ravon",
            text_en: "fluently",
            description: "I would like to speak two languages fluently.",
          },
          {
            id: 25,
            key: "adv",
            text_uz: "oldinga",
            text_en: "forwards",
            description: "She was running too fast and fell forwards.",
          },
          {
            id: 26,
            key: "adj",
            text_uz: "qo'rqqan, sarosimada",
            text_en: "frightened",
            description: "The building was empty. Now he was frightened.",
          },
          {
            id: 27,
            key: "adj",
            text_uz: "aybdor",
            text_en: "guilty",
            description: "I think he's feeling guilty about not going to the party.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "quloqchin",
            text_en: "headphones",
            description: "Put your headphones on to listen to your music.",
          },
          {
            id: 29,
            key: "phr",
            text_uz: "yaxshi kayfiyatda",
            text_en: "in a good mood",
            description: "She's in a good mood.",
          },
          {
            id: 30,
            key: "n",
            text_uz: "aloqa vositasi",
            text_en: "intercom",
            description: "A voice on the intercom asked, 'Is someone in there?'",
          },
          {
            id: 31,
            key: "prep",
            text_uz: "ichiga",
            text_en: "into ",
            description: "They ran into the garden.",
          },
          {
            id: 32,
            key: "v",
            text_uz: "sakramoq",
            text_en: "jump",
            description: "Everybody shouted and jumped up and down.",
          },
          {
            id: 33,
            key: "adv",
            text_uz: "baland ovozda",
            text_en: "loudly",
            description: "Thate it when people speak loudly on their mobile phones..",
          },
          {
            id: 34,
            key: "adj",
            text_uz: "asabiy",
            text_en: "nervous",
            description: "I feel nervous about the exam.",
          },
          {
            id: 35,
            key: "adv",
            text_uz: "muloyim",
            text_en: "nicely",
            description: "I ask them nicely to turn it down.",
          },
          {
            id: 36,
            key: "n",
            text_uz: "qo'rginchli tush",
            text_en: "nightmare",
            description: "I had a terrible nightmare last night.",
          },
          {
            id: 37,
            key: "prep",
            text_uz: "ichidan",
            text_en: "out of",
            description: "He came out of the capsule.",
          },
          {
            id: 38,
            key: "prep",
            text_uz: "ustidan, uzra",
            text_en: "over ",
            description: "He slowly walked over to the capsule.",
          },
          {
            id: 39,
            key: "v",
            text_uz: "parashutdan sakramoq",
            text_en: "parachute",
            description: "He parachuted down towards the desert.",
          },
          {
            id: 40,
            key: "adj",
            text_uz: "mamnun",
            text_en: "pleased",
            description: "She's really pleased the party was a success.",
          },
          {
            id: 41,
            key: "adv",
            text_uz: "xushmuomalalik bilan",
            text_en: "politely",
            description: "I smile politely.",
          },
          {
            id: 42,
            key: "v",
            text_uz: "sug'urib olmoq",
            text_en: "pull out",
            description: "Then he pulled the button out, so that the alarm",
          },
          {
            id: 43,
            key: "adv",
            text_uz: "tezda",
            text_en: "quickly",
            description: "He quickly moved to another seat.",
          },
          {
            id: 44,
            key: "n",
            text_uz: "kitobxon",
            text_en: "reader",
            description: "He's a slow reader.",
          },
          {
            id: 45,
            key: "n",
            text_uz: "qutqaruv guruhi",
            text_en: "rescue team",
            description:
              "A rescue team arrived a short time later to take her to hospital.",
          },
          {
            id: 46,
            key: "prep",
            text_uz: "aylanma harakat bilan",
            text_en: "round and round",
            description: "He suddenly began to turn round and round.",
          },
          {
            id: 47,
            key: "n",
            text_uz: "yuguruvchi",
            text_en: "runner",
            description: "She's a really fast runner.",
          },
          {
            id: 48,
            key: "n",
            text_uz: "parashut bilan sakrash",
            text_en: "skydiving",
            description:
              "The rest of his skydiving team saw this on their computer screens and were worried he was in terrible trouble.",
          },
          {
            id: 49,
            key: "adv",
            text_uz: "klassik uslubda",
            text_en: "smartly",
            description: "In my job I need to dress smartly.",
          },
          {
            id: 50,
            key: "n",
            text_uz: "snoubord uchish",
            text_en: "snowboarding",
            description: "A group of us went snowboarding in Switzerland.",
          },
          {
            id: 51,
            key: "n",
            text_uz: "notanish, begona",
            text_en: "stranger",
            description:
              "When train, what do astanger on a bus or train , what do you do?",
          },
          {
            id: 52,
            key: "n",
            text_uz: "naycha",
            text_en: "straw",
            description:
              "It was one of those little cartons of juice that comes with a little straw.",
          },
          {
            id: 53,
            key: "adj",
            text_uz: "havotirlangan",
            text_en: "stressed",
            description: "He's feeling stressed about the new project.",
          },
          {
            id: 54,
            key: "v",
            text_uz: "ko'tarilmoq",
            text_en: "take off",
            description: "Come and watch the plane take off.",
          },
          {
            id: 55,
            key: "prep",
            text_uz: "orqali, orasidan",
            text_en: "through",
            description: "She walked through the open door.",
          },
          {
            id: 56,
            key: "prep",
            text_uz: "tomonga",
            text_en: "towards",
            description: "Look! Martha is walking towards us.",
          },
          {
            id: 57,
            key: "n",
            text_uz: "svetofor",
            text_en: "traffic lights",
            description:
              "Come on traffic lights, turn green. I'm going to be so late for my meeting!",
          },
          {
            id: 58,
            key: "n",
            text_uz: "sayohatchi",
            text_en: "traveller",
            description: "I'm a regular traveller.",
          },
          {
            id: 59,
            key: "n",
            text_uz: "mashinist",
            text_en: "typist",
            description: "She's a quick typist.",
          },
          {
            id: 60,
            key: "n",
            text_uz: "video kamera",
            text_en: "video camera",
            description:
              "He hit the walls several times and shouted at the video camera.",
          },
          {
            id: 61,
            key: "n",
            text_uz: "piyoda, yo'lovchi",
            text_en: "walker",
            description: "He's a fast walker.",
          },
        ],
        unit4: [
          {
            id: 1,
            key: "adv",
            text_uz: "taxminan",
            text_en: "about",
            description: "I think she's about thirty-five",
          },
          {
            id: 2,
            key: "v",
            text_uz: "yetib kelmoq",
            text_en: "arrive",
            description: "she arrived home very late",
          },
          {
            id: 3,
            key: "v",
            text_uz: "hujum qilmoq",
            text_en: "attact",
            description: "As he was leaving a concert, two men attacked him.",
          },
          {
            id: 4,
            key: "v",
            text_uz: "bo'lmoq",
            text_en: "become",
            description: "He became anxious the more he thought about it.",
          },
          {
            id: 5,
            key: "v",
            text_uz: "blog yozmoq",
            text_en: "blog",
            description: "She blogs about daily life with two young children.",
          },
          {
            id: 6,
            key: "v",
            text_uz: "bokschi",
            text_en: "boxer",
            description: "He decided to become the manager of a boxer from Brazil. ",
          },
          {
            id: 7,
            key: "v",
            text_uz: "xarid qilmoq",
            text_en: "buy",
            description: "I want to buy a new T-shirt.",
          },
          {
            id: 8,
            key: "n",
            text_uz: "qiyinchilik, sinov",
            text_en: "challenge",
            description: "He did the challenges for a few.",
          },
          {
            id: 9,
            key: "phr",
            text_uz: "kasbni o'zgartirmoq",
            text_en: "change career",
            description: "I want to change career.",
          },
          {
            id: 10,
            key: "v",
            text_uz: "tanlamoq",
            text_en: "choose",
            description: "I need to choose a career, but I don't know what to do.",
          },
          {
            id: 11,
            key: "v",
            text_uz: "konsert zali",
            text_en: "concert hall",
            description: "He has played in many of the world's greatest concert halls.",
          },
          {
            id: 12,
            key: "n",
            text_uz: "dirijor",
            text_en: "conductor",
            description:
              "HJoão Carlos Martins is a famous Brazilian classical pianist and conductor.",
          },
          {
            id: 14,
            key: "phr",
            text_uz: "bilan ishlash (...ga mas'ul bo'lmoq)",
            text_en: "deal with",
            description: "I need to deal with these emails.",
          },
          {
            id: 15,
            key: "phr",
            text_uz: "bank operatsiyalarini,onlayn bajarmoq ",
            text_en: "do online banking",
            description: "How often do you do online banking?.",
          },
          {
            id: 16,
            key: "v",
            text_uz: "yuklab olmoq",
            text_en: "download",
            description: "You can download this app for free.",
          },
          {
            id: 17,
            key: "adj",
            text_uz: "unashtirilgan",
            text_en: "engaged",
            description: "When did you get engaged?",
          },
          {
            id: 19,
            key: "phr",
            text_uz: "turmush qurmoq",
            text_en: "get married",
            description: "We're getting married this year.",
          },
          {
            id: 20,
            key: "phr",
            text_uz: "internetdan foydalangan",
            text_en: "go online",
            description: "Why don't you go online to book the hotel?",
          },
          {
            id: 21,
            key: "phr",
            text_uz: "o'qishga kirmoq",
            text_en: "go to",
            description: "She wants to go to university We want to have children.",
          },
          {
            id: 22,
            key: "v",
            text_uz: "farzand ko'rmoq",
            text_en: "have  a baby/children",
            description: "We want to have children",
          },
          {
            id: 23,
            key: "n",
            text_uz: "25 yosh bilan 29 yosh o'rtasida",
            text_en: "in (your) late twenties",
            description: "I think he's in his late twenties.",
          },
          {
            id: 24,
            key: "n",
            text_uz: "oltmish yoshlarda",
            text_en: "in (your) sixties",
            description: "A lot of people retire in their sixties..",
          },
          {
            id: 25,
            key: "n",
            text_uz: "suzishni o'rganmoq",
            text_en: "learn to swim",
            description: "I want to learn to swim.",
          },
          {
            id: 26,
            key: "v",
            text_uz: "uyni tark etmoq,maktabni tamomlamoq",
            text_en: "leave home/school",
            description: "She decided to leave home I leave school this year.",
          },
          {
            id: 27,
            key: "phr",
            text_uz: "bilan yashamoq ",
            text_en: "live with",
            description: "Do you live with your partner?",
          },
          {
            id: 28,
            key: "phr",
            text_uz: "tizimga kirish/chiqish",
            text_en: "log on/out",
            description: "Make sure you log out when you have finished .",
          },
          {
            id: 29,
            key: "phr",
            text_uz: "o'rtasida",
            text_en: "mid",
            description: "She's in her mid-twenties. ",
          },
          {
            id: 30,
            key: "prep",
            text_uz: "o'rta yoshli",
            text_en: "middle-aged",
            description: "They're a middle-aged couple, with grownup children. .",
          },
          {
            id: 31,
            key: "n",
            text_uz: "lahza",
            text_en: "moment",
            description: "It was the most amazing moment of his life.",
          },
          {
            id: 32,
            key: "phr",
            text_uz: "ko'chmoq",
            text_en: "move house or flat",
            description: "Martha moved house last week..",
          },
          {
            id: 33,
            key: "v",
            text_uz: "erishmoq, olmoq",
            text_en: "obtain",
            description: "Where did you obtain that from? ",
          },
          {
            id: 34,
            key: "phr",
            text_uz: "imtihondan o'tmoq",
            text_en: "pass your exams/driving test",
            description: "Did you pass all your exams?",
          },
          {
            id: 35,
            key: "v",
            text_uz: "Ijro etmoq",
            text_en: "perform",
            description:
              "He learned to play the piano when he was a child and as a teenager he performed in concerts around the world.",
          },
          {
            id: 37,
            key: "n",
            text_uz: "pianinachi",
            text_en: "pianist",
            description: "He wanted to follow his dream of being a pianist.",
          },
          {
            id: 38,
            key: "n",
            text_uz: "sovg'a",
            text_en: "present",
            description: "I received a present today.",
          },
          {
            id: 39,
            key: "v",
            text_uz: "nafaqaga chiqmoq",
            text_en: "retire",
            description: "He's going to retire from teaching next year.",
          },
          {
            id: 40,
            key: "v",
            text_uz: "surunkali pay cho'zilish",
            text_en: "repetitive strain injury (RSI)",
            description:
              "He performed in concerts for another seven years, but then he had to give up because of Repetitive Strain Injury (RSI).",
          },
          {
            id: 41,
            key: "n",
            text_uz: "sharh",
            text_en: "review",
            description: "The hotel gets some great reviews.",
          },
          {
            id: 42,
            key: "n",
            text_uz: "dengiz bo'yi",
            text_en: "seafront",
            description: "The restaurant is on the seafront.",
          },
          {
            id: 43,
            key: "v",
            text_uz: "bo'lishmoq",
            text_en: "share",
            description: "I share a small flat with friends.",
          },
          {
            id: 44,
            key: "v",
            text_uz: "onlayn xarid qilmoq",
            text_en: "shop online",
            description: "I like to shop online.",
          },
          {
            id: 45,
            key: "n",
            text_uz: "ijtimoiy tarmoqlar",
            text_en: "social media",
            description: "I use social media all the time, especially Facebook.",
          },
          {
            id: 46,
            key: "v",
            text_uz: "boshlamoq",
            text_en: "take up",
            description: "I want to take up a new hobby.",
          },
          {
            id: 47,
            key: "n",
            text_uz: "suhbat",
            text_en: "talk",
            description:
              "Matt gave an online talk about how the challenges changed his life.",
          },
          {
            id: 48,
            key: "n",
            text_uz: "O'spirin",
            text_en: "teenager",
            description: "This TV programme is for teenagers and young adults.",
          },
          {
            id: 49,
            key: "v",
            text_uz: "sayohat qilmoq",
            text_en: "travel",
            description: "We're going to travel by taxi to the airport.",
          },
          {
            id: 50,
            key: "v",
            text_uz: "tvitterda izoh qoldirmoq",
            text_en: "tweet",
            description: "He tweeted that he was going to meet a famous musician.",
          },
          {
            id: 51,
            key: "v",
            text_uz: "yangilamoq",
            text_en: "update",
            description: "Did you update your Facebook page?",
          },
          {
            id: 52,
            key: "n",
            text_uz: "vegetarianlar uchun pazandalik kitobi",
            text_en: "vegetarian cook book",
            description: "We're going to get a vegetarian cookbook to help us.",
          },
          {
            id: 53,
            key: "v",
            text_uz: "harakat",
            text_en: "use",
            description: "A few years later, he lost the use of his left hand.",
          },
        ],
        unit5: [
          {
            id: 1,
            key: "n",
            text_uz: "maslahat",
            text_en: "advice",
            description:
              "It also included advice for teachers about how to teach music and mathematics.",
          },
          {
            id: 2,
            key: "v",
            text_uz: "qurbi yetmoq; imkoniyatga ega bo'lmoq",
            text_en: "afford",
            description: "What would you like to buy, but can't afford right now?",
          },
          {
            id: 3,
            key: "n",
            text_uz: "qoldiq",
            text_en: "balance",
            description:
              "I check my balance regularly so I know how much money there is in my bank account.",
          },
          {
            id: 4,
            key: "n",
            text_uz: "bank hisob raqami",
            text_en: "bank account",
            description: "Do you know how much money is in your bank account ?",
          },
          {
            id: 5,
            key: "n",
            text_uz: "foydali tomoni",
            text_en: "benefit",
            description:
              "Do you think living in a cashless society offers enough benefits?",
          },
          {
            id: 6,
            key: "n",
            text_uz: "to'lovnoma",
            text_en: "bill",
            description: "Ask the waiter for the bill.",
          },
          {
            id: 7,
            key: "n",
            text_uz: "qarzga olmoq",
            text_en: "borrow",
            description: "Have you ever borrowed a large amount of money? ",
          },
          {
            id: 8,
            key: "n",
            text_uz: "yangi, zamonaviy",
            text_en: "brand new",
            description: "It's brand new. only got it a few weeks ago.",
          },
          {
            id: 9,
            key: "adj",
            text_uz: "yorqin",
            text_en: "bright",
            description: "It's a lovely bright colour.",
          },
          {
            id: 10,
            key: "n",
            text_uz: "xaridor",
            text_en: "buyer",
            description: "We'll get a buyer for it.",
          },
          {
            id: 11,
            key: "n",
            text_uz: "mayda pul",
            text_en: "change",
            description: "I've got some change and lots of receipts in my wallet.",
          },
          {
            id: 12,
            key: "n",
            text_uz: "tanga",
            text_en: "coin",
            description: "We can give some coins to the street performers.",
          },
          {
            id: 13,
            key: "n",
            text_uz: "to'plam",
            text_en: "collection",
            description: "As a result, our book collection went from 300 down to six.",
          },
          {
            id: 14,
            key: "adj",
            text_uz: "qulaylik",
            text_en: "comfort",
            description: "I prefer to watch films in the comfort of my own home.",
          },
          {
            id: 15,
            key: "v",
            text_uz: "yupatmoq",
            text_en: "comfort",
            description: "She went to the nursery to comfort the baby.",
          },
          {
            id: 16,
            key: "adj",
            text_uz: "qulay",
            text_en: "comfortable",
            description: "It's very comfortable to ride.",
          },
          {
            id: 17,
            key: "v",
            text_uz: "hisoblamoq",
            text_en: "compute",
            description: "We need to compute the size and weight of each object.",
          },
          {
            id: 18,
            key: "n",
            text_uz: "holat, ahvol",
            text_en: "condition",
            description: "It's not in very good condition.",
          },
          {
            id: 19,
            key: "n",
            text_uz: "kridit karta",
            text_en: "credit card",
            description: " Can I pay for this by credit card, please?",
          },
          {
            id: 20,
            key: "n",
            text_uz: "jinoyat",
            text_en: "crimen",
            description:
              "Things have improved, for instance there isn't as much crime in Sweden.",
          },
          {
            id: 21,
            key: "adj",
            text_uz: "to'q",
            text_en: "dark",
            description: "It's got a dark blue stone.",
          },
          {
            id: 22,
            key: "n",
            text_uz: "qarz",
            text_en: "debt",
            description: "I don't like being in debt.",
          },
          {
            id: 23,
            key: "n",
            text_uz: "qaror qabul qilmoq",
            text_en: "decide",
            description: "She has to decide by next Monday.",
          },
          {
            id: 24,
            key: "n",
            text_uz: "rivojlanayotgan dunyo",
            text_en: "developing world",
            description:
              "Many countries in the developing world are using mobile phones to do online banking.",
          },
          {
            id: 25,
            key: "n",
            text_uz: "raqam",
            text_en: "digit",
            description: "How many digits are there in your account number?",
          },
          {
            id: 26,
            key: "n",
            text_uz: "raqamli",
            text_en: "digital",
            description:
              "Modern digital technology has helped. We gave away our CDs and now keep our music on the computer.",
          },
          {
            id: 27,
            key: "n",
            text_uz: "Ko'ngilni qoldirish",
            text_en: "disappointment",
            description: "Have you bought anything recently which was a disappointment?",
          },
          {
            id: 28,
            key: "n",
            text_uz: "iqtisodiyot",
            text_en: "economy",
            description: "I think life is better since the decrease in the cash economy.",
          },
          {
            id: 29,
            key: "v",
            text_uz: "bahra olmoq, zavqlanmoq",
            text_en: "enjoy",
            description: "Did you enjoy your holiday?",
          },
          {
            id: 30,
            key: "adj",
            text_uz: "zavqli",
            text_en: "enjoyable",
            description: "Some people think our life isn't enjoyable any more.",
          },
          {
            id: 31,
            key: "v",
            text_uz: "jihozlamoq",
            text_en: "equip",
            description: "This course will equip you with the skills you need.",
          },
          {
            id: 32,
            key: "adj",
            text_uz: "muhim",
            text_en: "essential",
            description: "It's essential you save some money.",
          },
          {
            id: 33,
            key: "adj",
            text_uz: "bashang",
            text_en: "fashionable",
            description: "It is quite fashionable.",
          },
          {
            id: 34,
            key: "n",
            text_uz: "to'lov",
            text_en: "fee",
            description:
              "In Kenya, people can use credit on their mobile phones to pay for things like their children's school fees.",
          },
          {
            id: 35,
            key: "n",
            text_uz: "og'ir",
            text_en: "heavy",
            description: "This box is really heavy.",
          },
          {
            id: 36,
            key: "n",
            text_uz: "katta",
            text_en: "large",
            description: "This is difficult to carry - it's quite large.",
          },
          {
            id: 37,
            key: "n",
            text_uz: "qarz bermoq",
            text_en: "lent",
            description: "Have you lent money to someone in the last month?",
          },
          {
            id: 38,
            key: "n",
            text_uz: "charm",
            text_en: "leather",
            description: "This seat's made of leather.",
          },
          {
            id: 39,
            key: "n",
            text_uz: "metal",
            text_en: "metal",
            description: "It's made of metal.",
          },
          {
            id: 40,
            key: "n",
            text_uz: "chivin",
            text_en: "mosquito",
            description: "It's a very bad time of year for mosquitoes.",
          },
          {
            id: 41,
            key: "adj",
            text_uz: "oddiylikni xush ko'ruvchi",
            text_en: "minimalist",
            description:
              "Our flat was full of stuff, so we went minimalist: we sold or gave away the things which we hardly ever use.",
          },
          {
            id: 42,
            key: "n",
            text_uz: "qog'oz pul, banknota",
            text_en: "note",
            description: "I've got one or two notes in my wallet.",
          },
          {
            id: 43,
            key: "v",
            text_uz: "qarz bo'lmoq",
            text_en: "owe",
            description: "She owes me £20!",
          },
          {
            id: 44,
            key: "adj",
            text_uz: "rangsiz, xira",
            text_en: "pale",
            description: "It's a kind of pale grey colour.",
          },
          {
            id: 45,
            key: "v",
            text_uz: "pulni qaytarmoq",
            text_en: "pay back",
            description: "I'll pay you back the money tomorrow.",
          },
          {
            id: 46,
            key: "adj",
            text_uz: "shaxsiy",
            text_en: "personal",
            description: "It contains personal things.",
          },
          {
            id: 47,
            key: "adj",
            text_uz: "plastik",
            text_en: "plastic",
            description: "It's got a plastic cover.",
          },
          {
            id: 48,
            key: "v",
            text_uz: "egalik qilmoq",
            text_en: "possess",
            description: "I don't possess a single CD or DVD",
          },
          {
            id: 49,
            key: "v",
            text_uz: "mol-mulk",
            text_en: "possessions",
            description: "Do you think possessions can make you feel happy?",
          },
          {
            id: 50,
            key: "n",
            text_uz: "hamyon",
            text_en: "purse",
            description: "I think I've got some money in my purse.",
          },
          {
            id: 52,
            key: "n",
            text_uz: "pul qaytarilishi",
            text_en: "refund",
            description: "I'd like to return the wallet and get a refund.",
          },
          {
            id: 52,
            key: "n",
            text_uz: "ijara",
            text_en: "rent",
            description: "How much is the rent for your flat?",
          },
          {
            id: 53,
            key: "n",
            text_uz: "hasharotga qarshi vosita",
            text_en: "repellent",
            description: "I always pack a mosquito-repellent plug.",
          },
          {
            id: 54,
            key: "n",
            text_uz: "inqilob",
            text_en: "revolution",
            description: "Kenya has led a revolution in mobile banking.",
          },
          {
            id: 55,
            key: "v",
            text_uz: "pul yig'moq",
            text_en: "save up ",
            description: "I'm saving up for a new car.",
          },
          {
            id: 56,
            key: "v",
            text_uz: "skuter",
            text_en: "scooter",
            description:
              "Riding my scooter is great fun and the feel of the cool wind is wonderful.",
          },
          {
            id: 57,
            key: "adj",
            text_uz: "yorqin, porloq",
            text_en: "shiny",
            description: "It's so bright and shiny.",
          },
          {
            id: 58,
            key: "adj",
            text_uz: "maxsus, qadrli",
            text_en: "special",
            description: "Somebody special gave it to me.",
          },
          {
            id: 59,
            key: "n",
            text_uz: "statistika, hisobot",
            text_en: "statistics",
            description: "Statistics show that the number of bank robberies has dropped.",
          },
          {
            id: 60,
            key: "v",
            text_uz: "ta'kidlamoq",
            text_en: "stress",
            description:
              "I must stress how important it is to be careful with your money.",
          },
          {
            id: 61,
            key: "n",
            text_uz: "stress",
            text_en: "stress",
            description: "He's under a lot of stress at the moment at work.",
          },
          {
            id: 62,
            key: "v",
            text_uz: "betoqat",
            text_en: "stressful",
            description: "Sometimes having too many things can be stressful.",
          },
          {
            id: 63,
            key: "adj",
            text_uz: "mos",
            text_en: "suitable",
            description: "It isn't suitable for work",
          },
          {
            id: 64,
            key: "adj",
            text_uz: "ingichka",
            text_en: "thin",
            description: "It's very thin and light, so it's easy to carry.",
          },
          {
            id: 65,
            key: "v",
            text_uz: "vaqt kapsulasi",
            text_en: "time capsule",
            description: "A time capsule is a special container with objects inside.",
          },
          {
            id: 66,
            key: "v",
            text_uz: "o'tkazmoq",
            text_en: "transfer",
            description: "Mobile phones are perfect for transferring money.",
          },
          {
            id: 67,
            key: "adj",
            text_uz: "foydali",
            text_en: "useful",
            description: "It's so useful that I can't imagine life without it.",
          },
          {
            id: 68,
            key: "adj",
            text_uz: "qardli",
            text_en: "valuable",
            description: "This watch isn't very valuable.",
          },
          {
            id: 69,
            key: "n",
            text_uz: "hamyon",
            text_en: "wallet",
            description: "It's so useful that I can't imagine life without it.",
          },
        ],
        unit6: [
          {
            id: 1,
            key: "v",
            text_uz: "asrab olmoq",
            text_en: "adopt",
            description: "They have decided to adopt a child.",
          },
          {
            id: 2,
            key: "phr",
            text_uz: "yomon xulq",
            text_en: "bad manners ",
            description:
              "I've heard that in other countries it's bad manners to talk when another person is speaking.",
          },
          {
            id: 3,
            key: "adj ",
            text_uz: "xaridorgir",
            text_en: " best-selling",
            description: "Susan Cain is the author of the best- selling book Quiet",
          },
          {
            id: 4,
            key: "n ",
            text_uz: "xususiyatlari",
            text_en: "  characteristic",
            description: "What do you think are the main characteristics of introverts?",
          },
          {
            id: 5,
            key: "adj ",
            text_uz: "o'ziga ishongan",
            text_en: "  confident",
            description: "She's confident about her exams.",
          },
          {
            id: 6,
            key: "n ",
            text_uz: "juftlik ",
            text_en: " couple",
            description: "Nicole and Paul make a lovely couple.",
          },
          {
            id: 7,
            key: "adj ",
            text_uz: "ijodkor ",
            text_en: " creative",
            description: "He's quite creative and often has new ideas.",
          },
          {
            id: 8,
            key: "adj ",
            text_uz: "insofsiz, adolatsiz ",
            text_en: " dishonest",
            description: "It was dishonest of him to say that.",
          },
          {
            id: 9,
            key: "adj ",
            text_uz: "tartibsiz ",
            text_en: " disorganized",
            description: "His manager is a bit disorganized. His office is a mess",
          },
          {
            id: 10,
            key: "n ",
            text_uz: " muloqotga kirishuvchan ",
            text_en: " extrovert",
            description: "She's an extrovert and confident in a large group of people.",
          },
          {
            id: 11,
            key: "adj ",
            text_uz: " halol, adolatli ",
            text_en: " fair",
            description: "Do you think it was fair of her to say that?",
          },
          {
            id: 12,
            key: "n ",
            text_uz: " qaynota ",
            text_en: " father-in-law",
            description: "My father-in-law enjoys gardening",
          },
          {
            id: 13,
            key: "n ",
            text_uz: " xonadosh ",
            text_en: " flatmate",
            description: "My flatmate is quite lazy. He never does the washing up.",
          },
          {
            id: 14,
            key: "adj ",
            text_uz: " do'stona ",
            text_en: " friendly",
            description: "He's a very friendly person.",
          },
          {
            id: 15,
            key: "phr ",
            text_uz: "ajrashmoq  ",
            text_en: " get divorced",
            description: "You get divorced only if your marriage goes wrong",
          },
          {
            id: 16,
            key: "adj ",
            text_uz: "mehnatkash  ",
            text_en: " hard-working",
            description: "She's a very hard-working person and works long hours.",
          },
          {
            id: 17,
            key: "adj ",
            text_uz: "rostgo'y  ",
            text_en: " honest",
            description: "Mia's an honest person - she always tells the truth.",
          },
          {
            id: 18,
            key: "adj ",
            text_uz: "besabr",
            text_en: "impatient",
            description: "She's a bit impatient. She doesn't like waiting for things.",
          },
          {
            id: 19,
            key: "adj ",
            text_uz: "qo'pol, odobsiz",
            text_en: "impolite",
            description: "I think it's a bit impolite to say that.",
          },
          {
            id: 20,
            key: "adj ",
            text_uz: "imkonsiz",
            text_en: "impossible",
            description: "It was impossible to sleep because it was so hot..",
          },
          {
            id: 21,
            key: "n ",
            text_uz: "kamgap",
            text_en: "introvert",
            description:
              "I'm an introvert. I find it easier to express myself in writing than speaking.",
          },
          {
            id: 22,
            key: "n ",
            text_uz: "qaynona",
            text_en: "mother-in-law",
            description: "Your mother-in-law is your husband or wife's mother",
          },
          {
            id: 23,
            key: "adj ",
            text_uz: "muhim, zarur",
            text_en: "necessary",
            description: "Was it necessary to speak to me like that?",
          },
          {
            id: 24,
            key: "adj ",
            text_uz: "sabrli",
            text_en: "patient",
            description: "I'm patient and don't mind if things take a long time.",
          },
          {
            id: 25,
            key: "adj ",
            text_uz: "mumkin",
            text_en: "possible",
            description: "It's possible she will arrive shortly?",
          },
          {
            id: 26,
            key: "adj ",
            text_uz: "aloqador",
            text_en: "related",
            description:
              "Did you know that Pascal and Isabelle are related to each other? They are in a romantic relationship.",
          },
          {
            id: 27,
            key: "adj ",
            text_uz: "ishqiy",
            text_en: "romantic",
            description: "They are in a romantic relationship.",
          },
          {
            id: 28,
            key: "v",
            text_uz: "ajrashmoq",
            text_en: "separate",
            description: "My parents separated when I was eight.",
          },
          {
            id: 29,
            key: "adj",
            text_uz: "tortinchoq, uyatchang",
            text_en: "shy",
            description:
              "He's quite a shy person and is often nervous about speaking to people.",
          },
          {
            id: 30,
            key: "v",
            text_uz: "chappillab yemoq",
            text_en: "slurp",
            description: "It sounds like a competition to see who can slurp the loudest.",
          },
          {
            id: 31,
            key: "adj",
            text_uz: "aqlli",
            text_en: "smart",
            description: "He's really smart. He knows everything about computers.",
          },
          {
            id: 32,
            key: "adj",
            text_uz: "ahmoq",
            text_en: "stupid",
            description: "I think he was really stupid to leave his job.",
          },
          {
            id: 33,
            key: "n",
            text_uz: "egizaklar",
            text_en: "twins",
            description: "My sister gave birth to twins yesterday. A boy and a girl!",
          },
          {
            id: 34,
            key: "adj",
            text_uz: "adolatsiz, nohaq",
            text_en: "unfair",
            description:
              "I think it's unfair that not everyone was invited to the party.",
          },
          {
            id: 35,
            key: "adj",
            text_uz: "xush ko'rmaydigan",
            text_en: "unfriendly",
            description: "I think she's a bit unfriendly.",
          },
          {
            id: 36,
            key: "adj",
            text_uz: "bemehr",
            text_en: "unkind",
            description: "It was a bit unkind of him to do that.",
          },
          {
            id: 37,
            key: "adj",
            text_uz: "keraksiz",
            text_en: "unnecessary",
            description: "That's a bit unnecessary. There was n need to say that.",
          },
          {
            id: 38,
            key: "adj",
            text_uz: "yoqimsiz",
            text_en: "unpleasant",
            description: "I find the smell of peanut butter a bit unpleasant.",
          },
          {
            id: 39,
            key: "adj",
            text_uz: "odamovi",
            text_en: "unsociable",
            description: "He hates going out and is quite unsociable.",
          },
          {
            id: 40,
            key: "adj",
            text_uz: "tartibsiz",
            text_en: "untidy",
            description: "The children are so untidy. Look at their bedroom!",
          },
          {
            id: 41,
            key: "adj",
            text_uz: "odatiy",
            text_en: "usual",
            description: "The journey to university took longer than usual.",
          },
          {
            id: 42,
            key: "n",
            text_uz: "ish joyi",
            text_en: "workplace",
            description:
              "In the USA especially, many schools, universities and workplaces are less interested in introverts than in extroverts.",
          },
        ],
        unit7: [
          {
            id: 1,
            key: "n",
            text_uz: "turar joy",
            text_en: "accommodation",
            description: "What type of holiday accommodation do you prefer?",
          },
          {
            id: 2,
            key: "n",
            text_uz: "afzalliklari",
            text_en: "advantages",
            description:
              "As well as speed, Maglaev has a number of advantages over other                               transport system",
          },
          {
            id: 3,
            key: "adj",
            text_uz: "hayratlangan",
            text_en: "amazed",
            description:
              "I was amazed when my dog turned up at my house after six months away",
          },
          {
            id: 4,
            key: "adj",
            text_uz: "hafa",
            text_en: "annoyed",
            description: "Martha's annoyed because you didn't invite her",
          },
          {
            id: 5,
            key: "adj",
            text_uz: "yoqimsiz",
            text_en: "annoying",
            description: "That noise is so annoying. I can concentrate",
          },
          {
            id: 6,
            key: "v",
            text_uz: "topshirmoq",
            text_en: "apply",
            description: "Do I need to apply for a visa befofe I travel",
          },
          {
            id: 7,
            key: "adj",
            text_uz: "oddiy",
            text_en: "basic",
            description: "It's basic but you everything you need",
          },
          {
            id: 8,
            key: "phr",
            text_uz: "oldindan buyurtma bermoq",
            text_en: "book in advance",
            description: "Train fares are much cheaper if you book in advance",
          },
          {
            id: 9,
            key: "phr",
            text_uz: "parvozni bron qilmoq",
            text_en: "book your flight",
            description: "Have you booked your flight toSpain yet",
          },
          {
            id: 10,
            key: "adj",
            text_uz: "zerikkan",
            text_en: "bored",
            description:
              "The lessons are always the same, so the students get rather bored",
          },
          {
            id: 11,
            key: "n",
            text_uz: "oylik atbus chiptasi",
            text_en: "bus pass",
            description: "I have a bus pass",
          },
          {
            id: 12,
            key: "n",
            text_uz: "kod",
            text_en: "code",
            description: "Will I need a code?",
          },
          {
            id: 13,
            key: "adj",
            text_uz: "chalkash",
            text_en: "confusing",
            description: "Her directions to the town were a bit confusing",
          },
          {
            id: 14,
            key: "adj",
            text_uz: "qulay",
            text_en: "convenient",
            description: "The bus is the most convenient form of transport for me",
          },
          {
            id: 15,
            key: "n",
            text_uz: "pul birligi",
            text_en: "currency",
            description: "Did you get the foreign currency for our trip",
          },
          {
            id: 16,
            key: "n",
            text_uz: "velosiped yo'lagi",
            text_en: "cycle lane",
            description: "The main roads have special cycle lanes",
          },
          {
            id: 17,
            key: "n",
            text_uz: "rivojlanish",
            text_en: "development",
            description: "The technology is still in development",
          },
          {
            id: 18,
            key: "n",
            text_uz: "dizel",
            text_en: "diesel",
            description: "Diesel engines are greener these days",
          },
          {
            id: 19,
            key: "adj",
            text_uz: "samarali",
            text_en: "efficient",
            description: "The bus service is efficient",
          },
          {
            id: 20,
            key: "adj",
            text_uz: "hijolatli",
            text_en: "embarrassing",
            description: "That was the most embarrassing moment of my life",
          },
          {
            id: 21,
            key: "adj",
            text_uz: "qiziqarli",
            text_en: "exciting",
            description: "It was a really exciting film",
          },
          {
            id: 22,
            key: "n",
            text_uz: "yo'l haqi",
            text_en: "fare",
            description: "Bus fares are expensive",
          },
          {
            id: 23,
            key: "adj",
            text_uz: "maftun bo'lgan",
            text_en: "fascinated",
            description: "I was fascinated to hear my uncle's stories",
          },
          {
            id: 24,
            key: "adj",
            text_uz: "ajoyib,maftunkor",
            text_en: "fascinating",
            description: "I watched a fascinating programme last night",
          },
          {
            id: 25,
            key: "v",
            text_uz: "suzmoq,qalqimoq",
            text_en: "float",
            description: "The train floats in the air above the tracks",
          },
          {
            id: 26,
            key: "adj",
            text_uz: "xorijiy",
            text_en: "foreign",
            description: "How much foreign currency are you talking on holiday?",
          },
          {
            id: 27,
            key: "adj",
            text_uz: "qo'rqinchli",
            text_en: "frightening",
            description: "My whole body is in pain.It's frightening",
          },
          {
            id: 28,
            key: "n",
            text_uz: "yoqilg'i",
            text_en: "fuel",
            description: "They use less fuel than other vehicles",
          },
          {
            id: 29,
            key: "adj",
            text_uz: "atrof muhitga havfsizligi",
            text_en: "greener",
            description: "Buses are greener than in the past",
          },
          {
            id: 30,
            key: "n",
            text_uz: "qo'llanma",
            text_en: "guidebook",
            description: "Do you usually take a guidebook on holiday?",
          },
          {
            id: 31,
            key: "adj",
            text_uz: "yuqori tezlikka ega",
            text_en: "high-speed",
            description:
              "Right nowb there is only one high-speed Maglaev system in the world",
          },
          {
            id: 32,
            key: "v",
            text_uz: "yollamoq",
            text_en: "hire",
            description: "How much will it cost to hire a car for a week?",
          },
          {
            id: 33,
            key: "n",
            text_uz: "mehmonxona",
            text_en: "hostel",
            description:
              "All the hostels were full so someone suggested staying in this cafe",
          },
          {
            id: 34,
            key: "phr",
            text_uz: "oldindan",
            text_en: "in advance",
            description: "Do you book your holidays far in advance",
          },
          {
            id: 35,
            key: "n",
            text_uz: "sug'urta",
            text_en: "insurance",
            description: "We need to buy our travel insurance before we go on holiday",
          },
          {
            id: 36,
            key: "adj",
            text_uz: "ishiga puxta bo'lmagan",
            text_en: "last minute",
            description: "I'm a last-person and never book my holidays in advance",
          },
          {
            id: 37,
            key: "n",
            text_uz: "yo'nalish,temir yo'l",
            text_en: "line",
            description: "In 2045, the line will extend to Osaka",
          },
          {
            id: 38,
            key: "n",
            text_uz: "yuk",
            text_en: "luggage",
            description: "Where can we leave our luggage?",
          },
          {
            id: 39,
            key: "n",
            text_uz: "asosiy yo'l",
            text_en: "main road",
            description: "The main roads are very busy in our town",
          },
          {
            id: 40,
            key: "n",
            text_uz: "benzin",
            text_en: "petrol",
            description: "Does your car run on petrol?",
          },
          {
            id: 41,
            key: "n",
            text_uz: "rejalashtiruvchi",
            text_en: "planner",
            description: "Transport planners are looking at the problems",
          },
          {
            id: 42,
            key: "n",
            text_uz: "ifloslanish",
            text_en: "pollution",
            description: "Buses are quieter and create less pollution these days",
          },
          {
            id: 43,
            key: "v",
            text_uz: "bashorat qilmoq",
            text_en: "predict",
            description:
              "They predict that the Tokyo to Osaka line will cost 51 billion                                dollars",
          },
          {
            id: 44,
            key: "n",
            text_uz: "haqiqat",
            text_en: "reality",
            description: "Their dreams are now a reality",
          },
          {
            id: 45,
            key: "n",
            text_uz: "ro'yhatdan o'tish shakli",
            text_en: "registration form",
            description: "Could you fill in the registration form, please?",
          },
          {
            id: 46,
            key: "adj",
            text_uz: "muntazam",
            text_en: "regular",
            description: "There's a regular bus service between the two towns",
          },
          {
            id: 47,
            key: "adj",
            text_uz: "rohatlangan",
            text_en: "relaxed",
            description: "The atmosphere in my company is relaxed",
          },
          {
            id: 48,
            key: "adj",
            text_uz: "rohatbaxsh",
            text_en: "relaxing",
            description: "It was very relaxing to lie next to the swimming pool",
          },
          {
            id: 49,
            key: "adj",
            text_uz: "ishonchli",
            text_en: "reliable",
            description: "The trains are very reliable-they usually leave on time",
          },
          {
            id: 50,
            key: "adj",
            text_uz: "uzoq,olis",
            text_en: "remote",
            description: "Yakutsk is remote-it's six time zones from Moscow",
          },
          {
            id: 51,
            key: "v",
            text_uz: "almashtirmoq",
            text_en: "replace",
            description:
              "Maglaev technology probably won't replace other forms of transport in the near future",
          },
          {
            id: 52,
            key: "adj",
            text_uz: "o'ziga o'zi xizmat ko'rsatish",
            text_en: "self-catering",
            description: "I prefer self-catering holidays",
          },
          {
            id: 53,
            key: "n",
            text_uz: "esdalik",
            text_en: "souvenir",
            description: "I always buy souvenirs when I'm on holiday",
          },
          {
            id: 54,
            key: "adj",
            text_uz: "hayratlangan",
            text_en: "surprised",
            description: "I was surprised when she told us she was engaged to be married",
          },
          {
            id: 55,
            key: "adj",
            text_uz: "hayratlanarli",
            text_en: "surprising",
            description: "It wasn't surprising thhat we lose the match",
          },
          {
            id: 56,
            key: "n",
            text_uz: "termometr",
            text_en: "thermometr",
            description: "Kids here can only miss school if the thermometr reaches-35",
          },
          {
            id: 57,
            key: "adj",
            text_uz: "toliqtiruvchi",
            text_en: "tiring",
            description: "This train journey is tiring",
          },
          {
            id: 58,
            key: "n",
            text_uz: "rels",
            text_en: "track",
            description:
              "Powerful magnets lift the train off the tracks and push them forward",
          },
          {
            id: 59,
            key: "n",
            text_uz: "yo'l tirbandligi",
            text_en: "traffic jam",
            description: "There are often bad traffic jams on the motorways",
          },
          {
            id: 60,
            key: "adj",
            text_uz: "xavotirlangan",
            text_en: "worried",
            description: "I'm really worried about the exam tomorrow",
          },
          {
            id: 61,
            key: "adj",
            text_uz: "havotirli,tashvishli",
            text_en: "worrying",
            description: "The increase in prices is very worrying",
          },
        ],
        unit8: [
          {
            id: 1,
            key: "v",
            text_uz: "erishmoq",
            text_en: "achieve",
            description:
              "In the last few years,Finland and Shanghai have achieved the highest grades in the tests",
          },
          {
            id: 2,
            key: "adj",
            text_uz: "darsdan tashqari",
            text_en: "after-school",
            description: "What after-school activities do you do?",
          },
          {
            id: 3,
            key: "n",
            text_uz: "san'at",
            text_en: "art",
            description: "Did you do art at the school",
          },
          {
            id: 4,
            key: "n",
            text_uz: "muhit",
            text_en: "atmosphere",
            description: "The atmosphere is relaxed",
          },
          {
            id: 5,
            key: "n",
            text_uz: "gullash",
            text_en: "blossom",
            description:
              "I really like the world blossom, because I think it sounds as gentle as the thing it represents",
          },
          {
            id: 6,
            key: "n",
            text_uz: "muloqot ko'nikmalari",
            text_en: "communication skills",
            description: "I have very good communication skills",
          },
          {
            id: 7,
            key: "n",
            text_uz: "aloqa",
            text_en: "connection",
            description: "It's a really bad connection. Could you repeat that, please?",
          },
          {
            id: 8,
            key: "n",
            text_uz: "kurs",
            text_en: "course",
            description: "Is she going to do a course in psychology at university",
          },
          {
            id: 9,
            key: "adv",
            text_uz: "ijodkorona",
            text_en: "creatively",
            description: "Will  computers ever be able to think creatively, like human?",
          },
          {
            id: 10,
            key: "n",
            text_uz: "qaror",
            text_en: "decision",
            description: "Are you good at making decisions",
          },
          {
            id: 11,
            key: "n",
            text_uz: "daraja",
            text_en: "degree",
            description: "She's got a degree in history from York university",
          },
          {
            id: 12,
            key: "n",
            text_uz: "diplom",
            text_en: "diploma",
            description: "I have a diploma in foof safety",
          },
          {
            id: 13,
            key: "n",
            text_uz: "iqtisodiyot",
            text_en: "economics",
            description: "We studied economics last year",
          },
          {
            id: 14,
            key: "n",
            text_uz: "ta'lim",
            text_en: "education",
            description: "I think private schools offer the best education",
          },
          {
            id: 15,
            key: "n",
            text_uz: "hissiyot",
            text_en: "emotion",
            description:
              "Scientists might even be able to learn more about where our thoughts and emotions             come from",
          },
          {
            id: 16,
            key: "n",
            text_uz: "kirish imtihoni",
            text_en: "entrance exam",
            description:
              "In Shanghai, the university entrance exam is called the goo koo",
          },
          {
            id: 17,
            key: "v",
            text_uz: "tushuntirmoq",
            text_en: "explain",
            description: "I don't think he's very good at explaining things clearly",
          },
          {
            id: 18,
            key: "n",
            text_uz: "joylar",
            text_en: "fields",
            description: "Please complete all required fields below",
          },
          {
            id: 19,
            key: "adj",
            text_uz: "yuqori malakali",
            text_en: "fully-qualified",
            description:
              "We're offering proper training with fully-qualified instructors",
          },
          {
            id: 20,
            key: "n",
            text_uz: "baho",
            text_en: "grade",
            description: "My grades in literature and languages weren't great",
          },
          {
            id: 21,
            key: "n",
            text_uz: "tarix",
            text_en: "history",
            description: "My favorite subject was history",
          },
          {
            id: 22,
            key: "n",
            text_uz: "tasavvur",
            text_en: "imagination",
            descripton: "She uses her imagination to come up with some great ideas",
          },
          {
            id: 23,
            key: "n",
            text_uz: "dazmollash",
            text_en: "ironing",
            description: "Who usually does the ironing?",
          },
          {
            id: 24,
            key: "n",
            text_uz: "axborot texnologiyalari",
            text_en: "IT",
            description: "I'm pleased I did IT at school",
          },
          {
            id: 25,
            key: "n",
            text_uz: "tillar",
            text_en: "languages",
            description: "I was really good at languages at school",
          },
          {
            id: 26,
            key: "n",
            text_uz: "o'rganish qobiliyatlari",
            text_en: "learning skills",
            description: "His learning skills are very good",
          },
          {
            id: 27,
            key: "n",
            text_uz: "adabiyot",
            text_en: "literature",
            description: "Did you study literature at school?",
          },
          {
            id: 28,
            key: "n",
            text_uz: "xaritani tushunish",
            text_en: "map reading",
            description: "I'll drive, but are you any good at map reading",
          },
          {
            id: 29,
            key: "n",
            text_uz: "magistrlik drajasi",
            text_en: "master's degree",
            description: "He's got a Master's degree in economics",
          },
          {
            id: 30,
            key: "n",
            text_uz: "matematika",
            text_en: "maths",
            description: "when I was at school I didn't enjoy maths at all",
          },
          {
            id: 31,
            key: "n",
            text_uz: "xato",
            text_en: "mistake",
            description: "Have you ever made a big mistake",
          },
          {
            id: 32,
            key: "n",
            text_uz: "afsona",
            text_en: "myth",
            description: "This is one of the most common myths about the brain",
          },
          {
            id: 33,
            key: "n",
            text_uz: "yaqin qarindosh",
            text_en: "next of kin",
            description: "Who's your next of kin?",
          },
          {
            id: 34,
            key: "n",
            text_uz: "tana a'zosi",
            text_en: "organ",
            description: "The brain is an amazing organ",
          },
          {
            id: 35,
            key: "v",
            text_uz: "tashkil etmoq",
            text_en: "organize",
            description: "She loves organizing events",
          },
          {
            id: 36,
            key: "n",
            text_uz: "jismoniy tarbiya",
            text_en: "PE",
            description: "I really enjoyed PE at school",
          },
          {
            id: 37,
            key: "n",
            text_uz: "fotonusxa",
            text_en: "photocopy",
            description: "I'll just make a photocopy of the certificate for you",
          },
          {
            id: 38,
            key: "n",
            text_uz: "amaliy ko'nikmalar",
            text_en: "practical skills",
            description:
              "Her practical skills are excellent, so I think she is the right person for the job",
          },
          {
            id: 39,
            key: "n",
            text_uz: "xususiy maktab",
            text_en: "private school",
            description: "Did you go to a private school?",
          },
          {
            id: 40,
            key: "adv",
            text_uz: "balki",
            text_en: "probably",
            description: "I probably won't go out tonight",
          },
          {
            id: 41,
            key: "n",
            text_uz: "rag'batlantirish,lavozim ko'trilishi",
            text_en: "promotion",
            description: "Please send me details of offers and promotions",
          },
          {
            id: 42,
            key: "n",
            text_uz: "psixologiya",
            text_en: "psychology",
            description: "My brother's doing an MSc in psychology",
          },
          {
            id: 43,
            key: "n",
            text_uz: "malaka",
            text_en: "qualification",
            description: "What qualifications do you have?",
          },
          {
            id: 44,
            key: "v",
            text_uz: "eslamoq",
            text_en: "remember",
            description: "Are you good at remembiring people's names?",
          },
          {
            id: 45,
            key: "n",
            text_uz: "ilm-fan",
            text_en: "science",
            description: "I think science was the least useful subject for me at school",
          },
          {
            id: 46,
            key: "n",
            text_uz: "qidiruv tizimi",
            text_en: "search engine",
            description: "did you use a search engine to find about us?",
          },
          {
            id: 47,
            key: "n",
            text_uz: "signal",
            text_en: "signal",
            description: "I keep losing the signal so we might get cut off",
          },
          {
            id: 48,
            key: "v",
            text_uz: "hal qilmoq",
            text_en: "solve",
            description: "He's great at solving computer problems",
          },
          {
            id: 49,
            key: "n",
            text_uz: "imlo",
            text_en: "spelling",
            description: "He's not very good at spelling",
          },
          {
            id: 50,
            key: "n",
            text_uz: "davlat maktabi",
            text_en: "state school",
            description: "I think state schools are just as good as private schools",
          },
          {
            id: 51,
            key: "adj",
            text_uz: "qattiqqo'l",
            text_en: "strict",
            description: "Was your school strict?",
          },
          {
            id: 52,
            key: "n",
            text_uz: "o'rganish",
            text_en: "study",
            description:
              "An international study called PISA tests 500,00 students from over 60 countiries in      maths,science and reading",
          },
          {
            id: 53,
            key: "n",
            text_uz: "muvaffaqiyat",
            text_en: "success",
            description:
              "Do you think a university degree in necessary for success in life?",
          },
          {
            id: 54,
            key: "n",
            text_uz: "tizim",
            text_en: "system",
            description:
              "What is it about their education system that produces these great results?",
          },
          {
            id: 55,
            key: "phr",
            text_uz: "g'amxo'rlik qilmoq",
            text_en: "take care of",
            description: "she really enjoys taking care of people",
          },
          {
            id: 56,
            key: "phr",
            text_uz: "hazil aytib berish",
            text_en: "tell jokes",
            description: "Are you good at telling jokes",
          },
          {
            id: 57,
            key: "adj",
            text_uz: "biror narsada no'noq bo'lmoq,yomon",
            text_en: "terrible",
            description: "I'm terrible at remembering people's name",
          },
          {
            id: 58,
            key: "v",
            text_uz: "shug'ullanmoq",
            text_en: "train",
            description: "I trained as a chef",
          },
          {
            id: 59,
            key: "v",
            text_uz: "tushunmoq",
            text_en: "understand",
            description: "She's very good at understanding how things work",
          },
        ],
        unit9: [
          {
            id: 1,
            key: "adj",
            text_uz: "faol",
            text_en: "active",
            description: "She has a very active lifestyle.",
          },
          {
            id: 2,
            key: "adv",
            text_uz: "allaqachon",
            text_en: "already",
            description: "I do quite a bit of exercise already, so I`m pretty fit.",
          },
          {
            id: 3,
            key: "n",
            text_uz: "bahs, munozara",
            text_en: "argument",
            description:
              "Sometimes, people shake hands when they make friends again after an argument",
          },
          {
            id: 4,
            key: "n",
            text_uz: "vazifa",
            text_en: "assignment",
            description: "Please can I have some more money time to do my assignments?",
          },
          {
            id: 5,
            key: "v",
            text_uz: "ishonmoq",
            text_en: "believe in",
            description: "I don`t believe in the health benefits of taking exercise.",
          },
          {
            id: 6,
            key: "v",
            text_uz: "... ga tegishli bo`lmoq",
            text_en: "belong to",
            description: "You must always look after things that belong to other people.",
          },
          {
            id: 7,
            key: "v",
            text_uz: "urishtirmoq",
            text_en: "bump",
            description: "They bump fists as a greeting.",
          },
          {
            id: 8,
            key: "n",
            text_uz: "saraton kasalligi",
            text_en: "cancer",
            description:
              "Diseases, such as cancer, exist today because of our modern diet and lifestyle",
          },
          {
            id: 9,
            key: "n",
            text_uz: "marosim",
            text_en: "ceremony",
            description: "The graduation ceremony starts at 9 a.m.",
          },
          {
            id: 10,
            key: "n",
            text_uz: "yanoq",
            text_en: "cheek",
            description: "They kiss two or three times, starting with the right cheek.",
          },
          {
            id: 11,
            key: "n",
            text_uz: "ko`krak, ko`krak qafasi",
            text_en: "chest",
            description: "They put both their hands together at chest level.",
          },
          {
            id: 12,
            key: "n",
            text_uz: "iyak, dahan",
            text_en: "chin",
            description: "He always touches his chin if he is worried about something.",
          },
          {
            id: 13,
            key: "v",
            text_uz: "qarsak chalmoq",
            text_en: "clap",
            description: "They clap their hands three times before saying hello.",
          },
          {
            id: 14,
            key: "v",
            text_uz: "tabriklamoq",
            text_en: "congratulate",
            description: "We use a handshake when we congratulate people.",
          },
          {
            id: 15,
            key: "v",
            text_uz: "... dan iborat bo`lmoq",
            text_en: "consist of",
            description: "My diet consist of only the healthiest food.",
          },
          {
            id: 16,
            key: "v",
            text_uz: "velosiped haydash",
            text_en: "cycling",
            description: "Cycling is a good form of exercise.",
          },
          {
            id: 17,
            key: "v",
            text_uz: "... ga bog`liq bo`lmoq",
            text_en: "depend on",
            description:
              "Your success in life does not depend on other people, but on you alone.",
          },
          {
            id: 18,
            key: "adj",
            text_uz: "ruhiy tushkun holatda",
            text_en: "depressed",
            description: "Lack of sunshine can make you depressed.",
          },
          {
            id: 19,
            key: "n",
            text_uz: "qandli diabet",
            text_en: "diabetes",
            description: "Diabetes is one of today`s common disesases.",
          },
          {
            id: 20,
            key: "v",
            text_uz: "ovqatlanish",
            text_en: "diet",
            description: "Her diet isn`t very good.",
          },
          {
            id: 21,
            key: "n",
            text_uz: "kasallik, xastalik",
            text_en: "disesase",
            description:
              "Many of today`s diseases exist because of our modern lifestyle.",
          },
          {
            id: 22,
            key: "v",
            text_uz: "... haqida orzu qilmoq",
            text_en: "dream of",
            description: "Do you ever dream of visiting New York?",
          },
          {
            id: 23,
            key: "adj",
            text_uz: "oson",
            text_en: "easy",
            description: "Some people find it easy to keep fit.",
          },
          {
            id: 24,
            key: "n",
            text_uz: "tirsak",
            text_en: "elbow",
            description: "He sits with his elbows on the table.",
          },
          {
            id: 25,
            key: "n",
            text_uz: "tajriba",
            text_en: "experiment",
            description: "Tell us how the experiment was carried out.",
          },
          {
            id: 26,
            key: "n",
            text_uz: "musht",
            text_en: "fist",
            description: "In some countries, you bump fists when you greet someone.",
          },
          {
            id: 27,
            key: "n",
            text_uz: "yaxshi jismoniy holat",
            text_en: "fitness",
            description: "I`m trying to improve my fitness by cycling to work.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "peshona",
            text_en: "forehead",
            description: "They press their foreheads together while closing their eyes.",
          },
          {
            id: 29,
            key: "adj",
            text_uz: "yengil",
            text_en: "gentle",
            description: "Do plenty of gentle exercise, like watching",
          },
          {
            id: 30,
            key: "n, pl",
            text_uz: "mikrob, bakteriya",
            text_en: "germs",
            description:
              "People worry they mihght catch germs if they shake somebody`s hand.",
          },
          {
            id: 31,
            key: "n",
            text_uz: "bitiruv",
            text_en: "graduation",
            description: "Will you be at my gradauation ceremony?",
          },
          {
            id: 32,
            key: "v",
            text_uz: "salomlashmoq",
            text_en: "greet",
            description: "What do you do when you greet a friend?",
          },
          {
            id: 33,
            key: "n",
            text_uz: "salomlashish",
            text_en: "greeting",
            description: "How much do you know about International greetings?",
          },
          {
            id: 34,
            key: "n",
            text_uz: "qo`l berib ko`rishish",
            text_en: "handshake",
            description: "He welcomed me with a smile and a handshake.",
          },
          {
            id: 35,
            key: "v",
            text_uz: "sodir bo`lmoq",
            text_en: "happen",
            description: "If something good happens to me, it`s because I deserve it.",
          },
          {
            id: 36,
            key: "n",
            text_uz: "sog`liq",
            text_en: "health",
            description: "It`s important to look after your health and keep it.",
          },
          {
            id: 37,
            key: "v",
            text_uz: "quchoqlamoq",
            text_en: "hug",
            description: "They hug each other when they greet good friends.",
          },
          {
            id: 38,
            key: "n",
            text_uz: "taassurot",
            text_en: "impression",
            description: "If you get it wrong, you might give a bad impression.",
          },
          {
            id: 39,
            key: "adj",
            text_uz: "norasmiy",
            text_en: "informal",
            description: "You usually do this greeting in an informal situation.",
          },
          {
            id: 40,
            key: "n",
            text_uz: "sog`liqqa zarar ovqatlar",
            text_en: "junk food",
            description: "Definitely don`t eat any junk food, like crisps.",
          },
          {
            id: 41,
            key: "v",
            text_uz: "o`pmoq",
            text_en: "kiss",
            description: "They kiss three times.",
          },
          {
            id: 42,
            key: "n",
            text_uz: "lab",
            text_en: "lip",
            description: "She`s gotvery thin lips.",
          },
          {
            id: 43,
            key: "adj",
            text_uz: "tibbiy",
            text_en: "medical",
            description: "Here`s a copy of my medical certificate.",
          },
          {
            id: 44,
            key: "n",
            text_uz: "ruhiy sog`liq",
            text_en: "mental health",
            description:
              "I think that regular physical exerciser can help to improve your mental health",
          },
          {
            id: 45,
            key: "adj",
            text_uz: "tabiiy",
            text_en: "natural",
            description: "Eta only natural food like meat, vegetables and fruit.",
          },
          {
            id: 46,
            key: "v",
            text_uz: "bosh silkitmoq",
            text_en: "nod",
            description: "They nod their heads.",
          },
          {
            id: 47,
            key: "n",
            text_uz: "og`riq qoldiruvchi dori vositasi",
            text_en: "painkiller",
            description:
              "We`ll give him some strong painkillers before he goes for the X-ray.",
          },
          {
            id: 48,
            key: "n",
            text_uz: "tinchlik",
            text_en: "peace",
            description: "A common theory is that it started as a sign of peace.",
          },
          {
            id: 49,
            key: "n",
            text_uz: "falsafa",
            text_en: "philosophy",
            description: "That`s part off our philosophy.",
          },
          {
            id: 50,
            key: "v",
            text_uz: "bosmoq",
            text_en: "press",
            description: "They press their noses together.",
          },
          {
            id: 51,
            key: "v",
            text_uz: "buyurtma qilmoq",
            text_en: "reserve",
            description: "You`ll definitely need to reserve s place before you come.",
          },
          {
            id: 52,
            key: "v",
            text_uz: "hurmat qilmoq",
            text_en: "respect",
            description: "I trust and respect you.",
          },
          {
            id: 53,
            key: "adj",
            text_uz: "ahmoqona",
            text_en: "ridiculous",
            description:
              "How ridiculous! People will think you are unfriendly if you refuse a handshake.",
          },
          {
            id: 54,
            key: "adj",
            text_uz: "qo`pol",
            text_en: "rude",
            description:
              "In China or Turkey, for example, if ypur handshake is too tight and strong, you will seem rude.",
          },
          {
            id: 55,
            key: "phr",
            text_uz: "qo`l berib ko`rishmoq",
            text_en: "shake hands",
            description: "They shake hands for a very long time.",
          },
          {
            id: 56,
            key: "n",
            text_uz: "yelka",
            text_en: "shoulder",
            description: "He touched me on the shoulder to get my attention.",
          },
          {
            id: 57,
            key: "n",
            text_uz: "yeng",
            text_en: "sleeve",
            description:
              "This proved that there were no weapons h{iding in their sleeve.",
          },
          {
            id: 58,
            key: "v",
            text_uz: "kulmoq, jlmaymoq",
            text_en: "smile",
            description: "I always smile at someone when I first meet them.",
          },
          {
            id: 59,
            key: "v",
            text_uz: "chiqarmoq",
            text_en: "stick",
            description: "They stick their tongues out at each other.",
          },
          {
            id: 60,
            key: "v",
            text_uz: "... da muvaffaqiyat qozonmoq",
            text_en: "succeed in",
            description: "You succeed in doing anything if you try hard enough.",
          },
          {
            id: 61,
            key: "n",
            text_uz: "bosh barmoq",
            text_en: "thumb",
            description: "Press the button with your thumb.",
          },
          {
            id: 62,
            key: "n",
            text_uz: "til",
            text_en: "tongue",
            description: "In some countries, they stick out their tongies as a gretting.",
          },
          {
            id: 63,
            key: "v",
            text_uz: "tegmoq",
            text_en: "touch",
            description: "They greta without touching the body.",
          },
          {
            id: 64,
            key: "n",
            text_uz: "trend, urf-odat",
            text_en: "trend",
            description: "The Paleo movement is a recent trend in health and fitness.",
          },
          {
            id: 65,
            key: "n",
            text_uz: "virus",
            text_en: "virus",
            description: "Instead they died from things like viruses or old age.",
          },
          {
            id: 66,
            key: "n",
            text_uz: "qurol",
            text_en: "weapon",
            description:
              "They would put their right hand forward towards another man and opened it to show they were not holding a knife or other weapon.",
          },
          {
            id: 67,
            key: "n",
            text_uz: "og`ir atletika",
            text_en: "weight-lifting",
            description: "Only do intense like weighting-lifting occasionally.",
          },
          {
            id: 68,
            key: "v",
            text_uz: "... da/ga ishlamoq ",
            text_en: "work for",
            description: "Jack work for an oil company.",
          },
        ],
        unit10: [
          {
            id: 1,
            key: "n",
            text_uz: "spirtli ichimlik",
            text_en: "alcoholic drink",
            description: "Some dark green vegetables can taste bitter",
          },
          {
            id: 2,
            key: "n",
            text_uz: "olma sharbati",
            text_en: "apple juice",
            description: "I drink apple juice for breakfast",
          },
          {
            id: 3,
            key: "v",
            text_uz: "duxovkada pishirmoq",
            text_en: "bake",
            description: "They`re baked in the oven",
          },
          {
            id: 4,
            key: "n",
            text_uz: "... gacha iste`mol qilish tavsiya qilinishi",
            text_en: "best before",
            description: "A 'best before' label tells you about quality, not safety.",
          },
          {
            id: 5,
            key: "adj",
            text_uz: "... achchiq",
            text_en: "bitter",
            description: "I don`t like it. It`s got a very bitter taste.",
          },
          {
            id: 6,
            key: "adj",
            text_uz: "qaynatilgan",
            text_en: "boiled",
            description: "I don`t like boiled vegetables.",
          },
          {
            id: 7,
            key: "n",
            text_uz: "butilka",
            text_en: "bottle",
            description: "Let`s get a bottle of sparkling waater as well.",
          },
          {
            id: 8,
            key: "n",
            text_uz: "quti",
            text_en: "box",
            description: "We bought them a box of chocolates.",
          },
          {
            id: 9,
            key: "n",
            text_uz: "temir idish (ichimliklar uchun)",
            text_en: "can",
            description: "Can I have a can of lemonade, please?",
          },
          {
            id: 10,
            key: "n",
            text_uz: "qalin qog`oz",
            text_en: "cardboard",
            description: "This contaoner is made from cardboard.",
          },
          {
            id: 11,
            key: "n",
            text_uz: "karton quti",
            text_en: "carton",
            description: "There`s a cartoon of apple juice in the fr{idge.",
          },
          {
            id: 12,
            key: "v",
            text_uz: "to`lov olmoq, to`lov talab qilmoq",
            text_en: "charge",
            description: "Supermarkets should charge customers for shopping bags.",
          },
          {
            id: 13,
            key: "n",
            text_uz: "shokolad",
            text_en: "chocolate",
            description: "He gave some chocolates for my birthday.",
          },
          {
            id: 14,
            key: "n",
            text_uz: "iste`molchi",
            text_en: "consumer",
            description: "It`s not the consumers who are responsible for waste.",
          },
          {
            id: 15,
            key: "n",
            text_uz: "qayla (hindcha ovqat)",
            text_en: "curry",
            description: "Most curry dishes are hot and spicy.",
          },
          {
            id: 16,
            key: "n",
            text_uz: "shirinlik",
            text_en: "dessert",
            description: "Would you like some cake for desssert?",
          },
          {
            id: 17,
            key: "adj",
            text_uz: "turli xil",
            text_en: "different",
            description: "There are may different sorts of spring roll.",
          },
          {
            id: 18,
            key: "n",
            text_uz: "ovqat",
            text_en: "dish",
            description: "I usually serve this dish with vegetables.",
          },
          {
            id: 19,
            key: "n",
            text_uz: "ovqat qoldiqlari uchun paket",
            text_en: "doggy bag",
            description:
              "Ask the waiter for a 'dfoggy bag' to take home food you can`t eat.",
          },
          {
            id: 20,
            key: "n",
            text_uz: "raqam qomat",
            text_en: "figure",
            description:
              "Please write the number in words and figures. It`s a figure of a man.",
          },
          {
            id: 21,
            key: "n",
            text_uz: "ta`m",
            text_en: "flavour",
            description: "You dip them into this sauce to give them extra falavour.",
          },
          {
            id: 22,
            key: "adj",
            text_uz: "muzlatilgan",
            text_en: "frozen",
            description: "I need a packet of frozen peas for the meal tonight.",
          },
          {
            id: 23,
            key: "v",
            text_uz: "qovurmoq",
            text_en: "fry",
            description: "Sometimes the spring rools are fried.",
          },
          {
            id: 24,
            key: "adj",
            text_uz: "kulgili",
            text_en: "funny",
            description:
              "Do you know any funny jokes? A funny thing happened to me on the way to work.",
          },
          {
            id: 25,
            key: "n",
            text_uz: "giyoh, sog`liqqa foydali o`tlar",
            text_en: "herb",
            description: "There are lots of herbs in this stew.",
          },
          {
            id: 26,
            key: "n",
            text_uz: "asal",
            text_en: "honey",
            description: "The tagine has some honey in it so it tastes quite sweet.",
          },
          {
            id: 27,
            key: "n",
            text_uz: "banka",
            text_en: "jar",
            description:
              "Could you buy a jar of olives when you`re at the supermarket, please?",
          },
          {
            id: 28,
            key: "phr",
            text_uz: "turli xil",
            text_en: "kind of",
            description: "It`s a kind of stew.",
          },
          {
            id: 29,
            key: "n",
            text_uz: "barra qoi`zichoq go`shti",
            text_en: "lamb",
            description: "This tagine is made with pieces of lamb.",
          },
          {
            id: 30,
            key: "v",
            text_uz: "qoldirmoq",
            text_en: "leave",
            description: "I`ve left some cake for you.",
          },
          {
            id: 31,
            key: "adj",
            text_uz: "chap",
            text_en: "left",
            description: "We took a left turn instead of right.",
          },
          {
            id: 32,
            key: "n",
            text_uz: "dog`, baho, belgi",
            text_en: "mark",
            description:
              "There`s mark on my trousers. / What mark did you get in the test?",
          },
          {
            id: 33,
            key: "n",
            text_uz: "zaytun",
            text_en: "olives",
            description: "Would you likse some olives to have with your drink?",
          },
          {
            id: 34,
            key: "n",
            text_uz: "pachka, paket, qadoq",
            text_en: "packet",
            description: "I think there`s a packet of frozen peas in the freezer.",
          },
          {
            id: 35,
            key: "adj",
            text_uz: "oddiy",
            text_en: "plain",
            description: "I prefer plain food. Nothing spicy.",
          },
          {
            id: 36,
            key: "v",
            text_uz: "saqlamoq",
            text_en: "preserve",
            description: "His invention preserved food beautifully.",
          },
          {
            id: 37,
            key: "adj",
            text_uz: "chiroyli",
            text_en: "pretty",
            description: "She`s a very pretty woman.",
          },
          {
            id: 38,
            key: "adj",
            text_uz: "ancha",
            text_en: "pretty",
            description: "It`s pretty expensive.",
          },
          {
            id: 39,
            key: "n",
            text_uz: "malina",
            text_en: "raspberry",
            description: "Would you like some raspberries for dessert?",
          },

          {
            id: 40,
            key: "adj",
            text_uz: "xom, pishirilmagan",
            text_en: "raw",
            description: "They`re filled with raw vegetables.",
          },
          {
            id: 41,
            key: "n",
            text_uz: "sous, qayla",
            text_en: "sauce",
            description:
              "You dip the spring rolls into this sauce to give them extra flavour.",
          },
          {
            id: 42,
            key: "adj",
            text_uz: "o`tkir ta`mli",
            text_en: "savoury",
            description: "Do younprefer sweet ot savoury food?",
          },
          {
            id: 43,
            key: "v",
            text_uz: "tortmoq (taomni)",
            text_en: "serve",
            description: "This dish is often served with rice.",
          },
          {
            id: 44,
            key: "pron",
            text_uz: "bir nechta",
            text_en: "several",
            description:
              "There are several diffreent vegetables you can eat with this dish.",
          },
          {
            id: 45,
            key: "adj",
            text_uz: "hayratga soluvchi",
            text_en: "shocking",
            description:
              "It`s a pretty shocking figure. So what are the facts behind it?",
          },
          {
            id: 46,
            key: "n",
            text_uz: "yengil taom",
            text_en: "snack",
            description: "I have a small snack at 11 a.m.",
          },
          {
            id: 47,
            key: "adj",
            text_uz: "nordon",
            text_en: "sour",
            description: "The sauce has lime juice in it to make it sour.",
          },
          {
            id: 48,
            key: "n",
            text_uz: "gazli suv",
            text_en: "sparkling water",
            description: "Please can I have some sparkling water?",
          },
          {
            id: 49,
            key: "n",
            text_uz: "ziravorlar",
            text_en: "spice",
            description: "This dish is made with lots of different spices.",
          },
          {
            id: 50,
            key: "adj",
            text_uz: "achchiq",
            text_en: "spicy",
            description: "There is some chill in the sauce to make it spicy.",
          },
          {
            id: 51,
            key: "n",
            text_uz: "ismaloq",
            text_en: "spinach",
            description: "Spinach ahs a bitter taste.",
          },

          {
            id: 52,
            key: "n",
            text_uz: "tushenka, dimlama",
            text_en: "stew",
            description: "I`m making a lamb stew tonight. Would you like some?",
          },
          {
            id: 53,
            key: "n",
            text_uz: "qulupnay",
            text_en: "strawberry",
            description: "You put strawberry jam on them.",
          },
          {
            id: 54,
            key: "n",
            text_uz: "tajin (afrikancha ovqat)",
            text_en: "tagine",
            description: "Tagine is a kind of stew.",
          },
          {
            id: 55,
            key: "n",
            text_uz: "maza, ta`m",
            text_en: "taste",
            description: "This has a nice, bitter taste.",
          },
          {
            id: 56,
            key: "n",
            text_uz: "ta`m sezuvchi retseptorlar",
            text_en: "taste buds",
            description:
              "People taste food differently; it dpends on the number of taste buds on your tongue.",
          },

          {
            id: 57,
            key: "n",
            text_uz: "tuzlish",
            text_en: "texture",
            description: "I love alll the different textures in this dish.",
          },
          {
            id: 58,
            key: "adj",
            text_uz: "quyuq",
            text_en: "thick",
            description: "This a quite thick sauce, but it tastes lovely.",
          },
          {
            id: 59,
            key: "n",
            text_uz: "konserva banka",
            text_en: "tin",
            description: "I`m going to use a tin of tomatoes.",
          },
          {
            id: 60,
            key: "n",
            text_uz: "tamaki",
            text_en: "tobacco",
            description: "Tobacco has a strong taste.",
          },

          {
            id: 61,
            key: "n",
            text_uz: "pomidor",
            text_en: "tomato",
            description: "We need some tomatoes for the salad.",
          },
          {
            id: 62,
            key: "n",
            text_uz: "tish pastasi",
            text_en: "toothpaste",
            description: "I need to buy a tube of tooothpaste",
          },
          {
            id: 63,
            key: "n",
            text_uz: "transport",
            text_en: "transportation",
            description:
              "The waste happens on farms during production, or transportation.",
          },
          {
            id: 64,
            key: "n",
            text_uz: "tyubik (siqma idishcha)",
            text_en: "tube",
            description: "D{id you pack a tube of toothpaste?",
          },
          {
            id: 65,
            key: "n",
            text_uz: "...gacha yaroqli",
            text_en: "use by",
            description: "Make sure you check the 'use by' date on the label.",
          },
          {
            id: 66,
            key: "adj",
            text_uz: "isrofgar, tejamaydigan",
            text_en: "wasteful",
            description: "In the past, people were not as wasteful as they are today.",
          },
        ],
        unit11: [
          {
            id: 1,
            key: "adv",
            text_uz: "xorij",
            text_en: "abroad",
            description: "Many people are looking for jobs abroad",
          },
          {
            id: 2,
            key: "n",
            text_uz: "maqola",
            text_en: "article",
            description:
              "It was also the first time that newspapers contained pictures as well as articles",
          },
          {
            id: 3,
            key: "n",
            text_uz: "havola qilinadigan fayl",
            text_en: "attachment",
            description:
              "No email communication is 100% secure. You should only open attachments if you trust the sender",
          },
          {
            id: 4,
            key: "n",
            text_uz: "foyda",
            text_en: "benefit",
            description: "Everybody would benefit from a bit extra intelligence",
          },
          {
            id: 5,
            key: "n",
            text_uz: "bir dasta",
            text_en: "bunch",
            description: "She gave me a bunch of flowers",
          },
          {
            id: 6,
            key: "v",
            text_uz: "davom etmoq",
            text_en: "carry on",
            description:
              "History and human problems change, but time and nature carry on",
          },
          {
            id: 7,
            key: "n",
            text_uz: "qit'a",
            text_en: "continent",
            description: "News reached different continents within minutes",
          },
          {
            id: 8,
            key: "n",
            text_uz: "marjon qoya",
            text_en: "coral reef",
            description: "We need to keep tourists away from the damaged coral reefs",
          },
          {
            id: 9,
            key: "n",
            text_uz: "avariya",
            text_en: "crash",
            description: "People who saw the crash possed comments and photos on Twitter",
          },
          {
            id: 10,
            key: "n",
            text_uz: "davo",
            text_en: "cure",
            description: "Is there a possible cure for AIDS?",
          },

          {
            id: 11,
            key: "n",
            text_uz: "saylov",
            text_en: "election",
            description: "I want to watch the news report about the European elections",
          },
          {
            id: 12,
            key: "v",
            text_uz: "otmoq",
            text_en: "erupt",
            description:
              "When a valcano erupted on the Pacific island of Krakatoa in 1883 it killed 36,000 people",
          },

          {
            id: 13,
            key: "adj",
            text_uz: "qimmat",
            text_en: "expensive",
            description:
              "Ordinary people didn't use to buy newspapers because they were expensive.",
          },
          {
            id: 14,
            key: "adj",
            text_uz: "haddan tashqari",
            text_en: "extreme",
            description: "There has been an increase in extreme weather conditions.",
          },
          {
            id: 15,
            key: "adj",
            text_uz: "moliyaviy",
            text_en: "financial",
            description: "What do you think about the financial crisis?",
          },
          {
            id: 16,
            key: "phr v",
            text_uz: "bilib olmoq",
            text_en: "find out",
            description: "You need to find out the answer yourself.",
          },
          {
            id: 17,
            key: "n",
            text_uz: "to'da",
            text_en: "flock",
            description:
              "A plane landed in the Hudson River after a flock of birds flew into its engine.",
          },
          {
            id: 18,
            key: "n",
            text_uz: "suv toshqini",
            text_en: "flood",
            description: "The road is closed because of a flood.",
          },
          {
            id: 19,
            key: "n",
            text_uz: "o'rmon yong'ini",
            text_en: "forest fire",
            description: "There is a large forest fire near Sydney, Australia.",
          },
          {
            id: 20,
            key: "phr v",
            text_uz: "voz kechmoq",
            text_en: "give up",
            description: "I want to give up smoking.",
          },
          {
            id: 21,
            key: "adj",
            text_uz: "dunyoviy",
            text_en: "global",
            description: "The global economy has become unstable.",
          },
          {
            id: 22,
            key: "n",
            text_uz: "global isish",
            text_en: "global warming",
            description: "Is global warming really happening?",
          },
          {
            id: 23,
            key: "phr v",
            text_uz: "ulg'aymoq",
            text_en: "grow up",
            description:
              "He wants children to grow up to have a positive relationship with nature.",
          },
          {
            id: 24,
            key: "adj",
            text_uz: "uyda tayyorlangan",
            text_en: "home-made",
            description: "This is lovely home-made jam.",
          },
          {
            id: 25,
            key: "n",
            text_uz: "ochlik",
            text_en: "hunger",
            description: "They do a lot to try and fight world hunger and poverty.",
          },
          {
            id: 26,
            key: "n",
            text_uz: "to'fon",
            text_en: "hurricane",
            description: "Did you hear about the hurricane off the Mexican coast?",
          },
          {
            id: 27,
            key: "adj",
            text_uz: "aqlli",
            text_en: "intelligent",
            description:
              "My idea to change the world is to spend more money on developing drugs that can make us more intelligent.",
          },
          {
            id: 28,
            key: "n",
            text_uz: "ixtiro",
            text_en: "invention",
            description:
              "This changed in the 1850s with the invention of powerful printing presses.",
          },
          {
            id: 29,
            key: "n",
            text_uz: "muammo",
            text_en: "issue",
            description: "I want to talk to you about global issues.",
          },
          {
            id: 30,
            key: "adj",
            text_uz: "inson sababchi bo'lgan",
            text_en: "man-made",
            description: "It's a region that has suffered many man-made problems.",
          },
          {
            id: 31,
            key: "n",
            text_uz: "muhim bosqich",
            text_en: "milestone",
            description: "There have been several media milestones.",
          },
          {
            id: 32,
            key: "n",
            text_uz: "tabiiy ofat",
            text_en: "natural disaster",
            description: "It was one of the worst natural disasters in history.",
          },
          {
            id: 33,
            key: "adj",
            text_uz: "kuchli",
            text_en: "powerful",
            description:
              "The powerful printing presses could print 10,000 papers per hour.",
          },
          {
            id: 34,
            key: "phr v",
            text_uz: "pastga qo'ymoq",
            text_en: "put down",
            description: "He carefully put down the statues.",
          },
          {
            id: 35,
            key: "phr v",
            text_uz: "yig'moq",
            text_en: "put on",
            description: "I think she's put on weight.",
          },
          {
            id: 36,
            key: "v",
            text_uz: "yetib bormoq",
            text_en: "reach",
            description:
              "The news of Abraham Lincoln's death took nearly two weeks to reach Europe in 1865.",
          },
          {
            id: 37,
            key: "v",
            text_uz: "xabar bermoq, yangiliklarni yetkazmoq",
            text_en: "report",
            description: "Now anybody can report news.",
          },
          {
            id: 38,
            key: "n",
            text_uz: "o'g'rilik",
            text_en: "robbery",
            description: "They've arrested two men in connection with the robbery.",
          },
          {
            id: 39,
            key: "n",
            text_uz: "haykaltarosh",
            text_en: "sculptor",
            description: "I've been a sculptor for a long time.",
          },
          {
            id: 40,
            key: "adj",
            text_uz: "xavfsiz",
            text_en: "secure",
            description:
              "Be careful when you check emails in an internet cafe as public Wi-Fi is not always secure.",
          },
          {
            id: 41,
            key: "phr v",
            text_uz: "asos solmoq",
            text_en: "set up",
            description: "They want to set up a business this year.",
          },
          {
            id: 42,
            key: "v",
            text_uz: "tarqalmoq",
            text_en: "spread",
            description: "The news spread around the world in seconds.",
          },
          {
            id: 43,
            key: "v",
            text_uz: "o'g'irlamoq",
            text_en: "steal",
            description:
              "Don't leave your work files or laptop in your car because someone might steal them.",
          },
          {
            id: 44,
            key: "n",
            text_uz: "ish tashlash",
            text_en: "strike",
            description:
              "Because of the transport strike, there are no trains running today.",
          },
          {
            id: 45,
            key: "n",
            text_uz: "telegraf",
            text_en: "telegraph",
            description:
              "Before the telegraph was invented, it used to take weeks for news to travel around the world.",
          },
          {
            id: 46,
            key: "adj",
            text_uz: "eng so'nggi",
            text_en: "up to date",
            description: "The news wasn't always up to date.",
          },
          {
            id: 47,
            key: "adv",
            text_uz: "haftalik",
            text_en: "weekly",
            description: "News reels were changed weekly, not daily.",
          },
          {
            id: 48,
            key: "n",
            text_uz: "sim",
            text_en: "wire",
            description:
              "News could travel around the world in minutes, using undersea electrical telegraph wires.",
          },
        ],
        unit12: [
          {
            id: 1,
            key: "n",
            text_uz: "manzil",
            text_en: "address",
            description: "What is your home address?",
          },
          {
            id: 2,
            key: "n",
            text_uz: "alifbo",
            text_en: "alphabet",
            description: "The English alphabet has twenty-six letters",
          },
          {
            id: 3,
            key: "n",
            text_uz: "shahar",
            text_en: "city",
            description: "What city are you from?",
          },
          {
            id: 4,
            key: "adj",
            text_uz: "yaxshi",
            text_en: "fine",
            description: "I'm fine thanks",
          },
          {
            id: 5,
            key: "v",
            text_uz: "bo'ginlash",
            text_en: "spell",
            description: "How do you spell your name?",
          },
        ],
      },
      intermediate: {
        unit1: [
          {
            id: 1,
            key: "n",
            text_uz: "qobiliyat, mahorat",
            text_en: "ability",
            description: "the courses available are for different levels of ability",
          },
          {
            id: 2,
            key: "adj",
            text_uz: "qodir",
            text_en: "able",
            description: "The internet is changing our culture so that we are less able to concentrate or make deep connections in our brain",
          },
          {
            id: 3,
            key: "n",
            text_uz: "muvaffaqiyat, yutuq",
            text_en: "achievement",
            description: "Although it was hard work, it was an amazing achievement",
          },
          {
            id: 4,
            key: "n",
            text_uz: "sarguzasht",
            text_en: "adventure",
            description: "His adventure has taken him across Europe",
          },
          {
            id: 5,
            key: "n",
            text_uz: "savdo, kelishuv",
            text_en: "bargain",
            description: "What have you bought recently that was a bargain?",
          },
          {
            id: 6,
            key: "v",
            text_uz: "o`zini tutish",
            text_en: "behave",
            description: "The internet is changing the way our brains behave",
          },
          {
            id: 7,
            key: "n",
            text_uz: "xayriya",
            text_en: "charity",
            description: "His aim to raise money for a children`s charity",
          },
          {
            id: 8,
            key: "n",
            text_uz: "tanlov",
            text_en: "choice",
            description: "We`re trying to get people to think about the effect their buying choices have on the rest of the world",
          },
          {
            id: 9,
            key: "phr",
            text_uz: "yuzma-yuz kelmoq",
            text_en: "come face-to-face with",
            description: "He has already come face-to-face with 123 internet friends",
          },
          {
            id: 10,
            key: "n",
            text_uz: "aloqa",
            text_en: "communication",
            description: "The internet, and especially Skype, has improved communication with friends who live abroad",
          },
          {
            id: 11,
            key: "v",
            text_uz: "ulanmoq",
            text_en: "connect",
            description: "I think this caple connects to the back of the computer",
          },
          {
            id: 12,
            key: "n",
            text_uz: "iste`molchi",
            text_en: "consumer",
            description: "High-street shops have a wide choice of products for the consumer",
          },
          {
            id: 13,
            key: "adj",
            text_uz: "ishonch hosil qilgan",
            text_en: "convinced",
            description: "I`m convinced my life has improved since I started my new job",
          },
          {
            id: 14,
            key: "adv",
            text_uz: "hozirda",
            text_en: "currently",
            description: "Rob Jones is currently meeting every single friend on his Facebook page",
          },
          {
            id: 15,
            key: "n",
            text_uz: "kelishuv",
            text_en: "deal",
            description: "Have you ever bought something you didn`t need because it was a good deal?",
          },
          {
            id: 16,
            key: "adv",
            text_uz: "chuqur",
            text_en: "deeply",
            description: "We never take any time to think about things deeply",
          },
          {
            id: 17,
            key: "n",
            text_uz: "ta`rif, izoh",
            text_en: "definition",
            description: "What is your definition of a true friend?",
          },
          {
            id: 18,
            key: "v",
            text_uz: "rivojlantirish",
            text_en: "develop",
            description: "Our friendship has developed over time",
          },
          {
            id: 19,
            key: "n",
            text_uz: "raqamli asr",
            text_en: "digital age",
            description: "The digital age is making us lose our ability to do one thing at a time",
          },
          {
            id: 20,
            key: "n",
            text_uz: "ifoda, ibora",
            text_en: "expression",
            description: "The expression Black Friday has been used more than two billion times on Twitter recently",
          },
          {
            id: 21,
            key: "n",
            text_uz: "do`stlik",
            text_en: "friendship",
            description: "Her frienship means a lot to me",
          },
          {
            id: 22,
            key: "phr v",
            text_uz: "arazlashmoq",
            text_en: "fall out (with someone)",
            description: "I rarely fall out with my friends",
          },
          {
            id: 23,
            key: "v",
            text_uz: "boshqarish",
            text_en: "govern",
            description: "Who is the region governed by?",
          },
          {
            id: 24,
            key: "phr v",
            text_uz: "yaxshi munosabatda bo`lish",
            text_en: "get on (well with someone)",
            description: "I get on really well with Jill",
          },
          {
            id: 25,
            key: "n",
            text_uz: "hukumat",
            text_en: "government",
            description: "The government has announced the latest tax proposals",
          },
          {
            id: 26,
            key: "adj",
            text_uz: "aybsiz, toza vijdon bilan",
            text_en: "guilt-free",
            description: "How do you feel about the fact that guilt-free brands are often more expensive?",
          },
          {
            id: 27,
            key: "adj",
            text_uz: "yarim narx",
            text_en: "half-price",
            description: "I bought these in the sale. The were half-price!",
          },
          {
            id: 28,
            key: "adj",
            text_uz: "zararli",
            text_en: "harmful",
            description: "It has a harmful effect on the environment",
          },
          {
            id: 29,
            key: "phr",
            text_uz: "umumiy jihatlari juda ko`p",
            text_en: "have a lot in common",
            description: "I guess I don`t have a lot in common with them",
          },
          {
            id: 30,
            key: "phr v",
            text_uz: "yordamlashish",
            text_en: "help (someone) out",
            description: "A really good friend is someone you can ring at midnight and ask them to help you out",
          },
          {
            id: 31,
            key: "n",
            text_uz: "takomillashtirish",
            text_en: "improvement",
            description: "There have been some amazing improvements in the way we can get information",
          },
          {
            id: 32,
            key: "phr",
            text_uz: "aloqada (birov bilan)",
            text_en: "in touch (with someone)",
            description: "How do you keep in touch with family or friends who live far away?",
          },
          {
            id: 33,
            key: "n",
            text_uz: "jarohat",
            text_en: "injury",
            description: "There have been five injuries in the last few years on Black Friday",
          },
          {
            id: 34,
            key: "n",
            text_uz: "buyum",
            text_en: "item",
            description: "All of these items are half-price",
          },
          {
            id: 35,
            key: "n",
            text_uz: "mulohaza-hukmi",
            text_en: "judgement",
            description: "His book shows us that we need to use our judgement before we let computers take over",
          },
          {
            id: 36,
            key: "adv",
            text_uz: "so'nggi paytlarda",
            text_en: "lately",
            description: "How many of your Facebook friends have you seen lately?",
          },
          {
            id: 37,
            key: "n",
            text_uz: "bo`sh vaqt",
            text_en: "leisure time",
            description: "The idea of buying things as a way of spending your leisure time is crazy",
          },
          {
            id: 38,
            key: "n",
            text_uz: "axborot vositalari",
            text_en: "media",
            description: "When we use new media, our brain works and develops in a different way to how it did before the internet",
          },
          {
            id: 39,
            key: "phr v",
            text_uz: "uchrashmoq",
            text_en: "meet up",
            description: "Are often meet up with groups of friends in the evening",
          },
          {
            id: 40,
            key: "n",
            text_uz: "a`zolik",
            text_en: "membership",
            description: "The annual membership is too expensive for me",
          },
          {
            id: 41,
            key: "n",
            text_uz: "harakat",
            text_en: "movement",
            description: "Now there are Buy Dothing Day movements in over 65 countries",
          },
          {
            id: 42,
            key: "adj",
            text_uz: "vaqti-vaqti bilan",
            text_en: "occasional",
            description: "We spend the occasional message to each other",
          },
          {
            id: 43,
            key: "phr",
            text_uz: "kreditga",
            text_en: "on credit",
            description: "There`s a danger of spending more than you intended buying things on credit",
          },
          {
            id: 44,
            key: "n",
            text_uz: "imkoniyat",
            text_en: "opportunity",
            description: "This is a great opportunity",
          },
          {
            id: 45,
            key: "v",
            text_uz: "ishontirish",
            text_en: "persuade",
            description: "He persuades them to give to his charety",
          },
          {
            id: 46,
            key: "v",
            text_uz: "isbotlamoq",
            text_en: "prove",
            description: "This proves the internet is a powerful tool",
          },
          {
            id: 47,
            key: "n",
            text_uz: "jarayon",
            text_en: "process",
            description: "He hopes to have met all 700 Facebook friends wih in three years, travelling thousands of meals in the process",
          },
          {
            id: 48,
            key: "n",
            text_uz: "xarid",
            text_en: "purchase",
            description: "While you may get a good discount on your purchases, you should be careful",
          },
          {
            id: 49,
            key: "n",
            text_uz: "navbat",
            text_en: "queue",
            description: "Some people have queued overnight",
          },
          {
            id: 50,
            key: "n pl",
            text_uz: "manbalar",
            text_en: "resources",
            description: "People should bee encouraged not to consume more than their fair share of the world`s resources",
          },
          {
            id: 51,
            key: "v",
            text_uz: "qayta birlashmoq",
            text_en: "reunite",
            description: "I`m reuniting with friends",
          },
          {
            id: 52,
            key: "n",
            text_uz: "ovoragarchilik",
            text_en: "run-up",
            description: "The shops have amazing special offers in the run-up to Christmas",
          },
          {
            id: 53,
            key: "adj",
            text_uz: "havfsiz",
            text_en: "secure",
            description: "The important thing is to feel secure in your job",
          },
          {
            id: 54,
            key: "n",
            text_uz: "havfsizlik",
            text_en: "security",
            description: "I am always extremely careful about my personal security online",
          },
          {
            id: 55,
            key: "n",
            text_uz: "smartfon",
            text_en: "smartphone",
            description: "The development of smartphones has made a huge different to the way we all access information",
          },
          {
            id: 56,
            key: "v",
            text_uz: "muloqot qilmoq",
            text_en: "socialize",
            description: "Students in the USA spend 51% of their time socializing",
          },
          {
            id: 57,
            key: "n",
            text_uz: "maxsus taklif",
            text_en: "special offer",
            description: "Do you look for special offers such as buy one get one on free in the supermarket",
          },
          {
            id: 58,
            key: "v",
            text_uz: "tashimoq",
            text_en: "transport",
            description: "I`m not sure transporting goods by air is a good ide",
          },
          {
            id: 59,
            key: "v",
            text_uz: "ommaviylashmoq",
            text_en: "trend",
            description: "What`s trending in social media?",
          },
          {
            id: 60,
            key: "v",
            text_uz: "ishonmoq",
            text_en: "trust",
            description: "I can trust my closest friend with all my secrets",
          },
        ],
        unit2: [
          {

            id: 1,
            key: "v",
            text_uz: "e`lon qilmoq",
            text_en: "announce",
            description: "Police announced yesterday that calls to the emergency 999 number had risen sharply in recent months",
          },
          {
            id: 2,
            key: "v",
            text_uz: "paydo bo`lmoq",
            text_en: "appear",
            description: "A huge hippo suddenly appeared",
          },
          {
            id: 3,
            key: "n",
            text_uz: "urinish",
            text_en: "attempt",
            description: "The whole story had been made up by the boy`s parents, in an attempt to get a reality TV deal",
          },
          {
            id: 4,
            key: "phr",
            text_uz: "tiqilib qolmoq",
            text_en: "be stuck",
            description: "I realized I was stuck inside something",
          },
          {
            id: 5,
            key: "v",
            text_uz: "ishonmoq",
            text_en: "believe",
            description: "I believe, though, that I met him one more time",
          },
          {
            id: 6,
            key: "n",
            text_uz: "nafas",
            text_en: "breath",
            description: "I remember wondering which of us could hold his breath the longest",
          },
          {
            id: 7,
            key: "n",
            text_uz: "arqon yo`li vagoni, funikulyor",
            text_en: "cable car",
            description: "He decided not to take the cable car down with his friends, but to walk down instead",
          },
          {
            id: 8,
            key: "v",
            text_uz: "zaryadlamoq, quvvatlantirmoq",
            text_en: "charge",
            description: "A hoax story claimed that dialing 999 would charge your phone battery",
          },
          {
            id: 9,
            key: "v",
            text_uz: "tarqalmoq",
            text_en: "circulate",
            description: "Recently, a picture has been circulating on the internet of a bright blue watermelon",
          },
          {
            id: 10,
            key: "v",
            text_uz: "tasdiqlamoq, talab qilmoq",
            text_en: "claim",
            description: "The hoax story claims that calling 999 will charge your phone battery",
          },
          {
            id: 11,
            key: "n",
            text_uz: "tasodif",
            text_en: "coincidence",
            description: "Coincidences are often meaningful and `meant to happen`",
          },
          {
            id: 12,
            key: "n",
            text_uz: "xulosa",
            text_en: "conclusion",
            description: "The conclusion was that the judges were deciding not on what they could hear, but what they could see",
          },
          {
            id: 13,
            key: "adv",
            text_uz: "ketma-ket",
            text_en: "consecutively",
            description: "Expect: a man who makes three correct guesses consecutively",
          },
          {
            id: 14,
            key: "v",
            text_uz: "yaratmoq",
            text_en: "create",
            description: "It is easy to create a hoax now that everyone can change photos and videos digitally",
          },
          {
            id: 15,
            key: "adv",
            text_uz: "qiziqarlisi shundaki",
            text_en: "curiously",
            description: "Orchestras, curiously, started hiring women left, right and centre",
          },
          {
            id: 16,
            key: "v",
            text_uz: "g`oyib bo`lish",
            text_en: "disappear",
            description: "The hippo had quietly disappeared",
          },
          {
            id: 17,
            key: "n",
            text_uz: "qochish, qutulish",
            text_en: "escape",
            description: "That reminds me of another story I heard about a man who had a lucky escape",
          },
          {
            id: 18,
            key: "n",
            text_uz: "dalil, isbot",
            text_en: "evidence",
            description: "Scientists were keen to find some evidence that would prove the link",
          },
          {
            id: 19,
            key: "v",
            text_uz: "kutmoq, umid qilmoq",
            text_en: "expect",
            description: "Did you expect that to happen?",
          },
          {
            id: 20,
            key: "n",
            text_uz: "soxta",
            text_en: "fake",
            description: "In 1953 a team of researchers discovered that it was, in fact, a fake",
          },
          {
            id: 21,
            key: "v",
            text_uz: "suzmoq, uchmoq",
            text_en: "float",
            description: "On October 15, 2009, the media reported that a six-year-old boy was inside a large silver balloon floating high in the sky",
          },
          {
            id: 22,
            key: "adv",
            text_uz: "baxtiga, xayriyat",
            text_en: "fortunately",
            description: "Fortunately, we got to the airport on time",
          },
          {
            id: 23,
            key: "v",
            text_uz: "xalos qilmoq",
            text_en: "free",
            description: "I managed to free one hand and felt around - my hand touched a hippo`s nose",
          },
          {
            id: 24,
            key: "v",
            text_uz: "yollash",
            text_en: "hire",
            description: "Orchestras started hiring many more women",
          },
          {
            id: 25,
            key: "n",
            text_uz: "yolg`on",
            text_en: "hoax",
            description: "It turns out the story was another internet hoax",
          },
          {
            id: 26,
            key: "v",
            text_uz: "xabar berish",
            text_en: "inform",
            description: "The police were informed",
          },
          {
            id: 27,
            key: "adv",
            text_uz: "qiziqarlisi shu-ki",
            text_en: "interestingly",
            description: "Interestingly, I know a lot of people who want to work on television",
          },
          {
            id: 28,
            key: "v",
            text_uz: "suhbat olmoq",
            text_en: "interview",
            description: "The boy spoke to someone while reporters were interviewing the family on TV",
          },
          {
            id: 29,
            key: "v",
            text_uz: "kashf etmoq",
            text_en: "invent",
            description: "A journalist actually invented the story",
          },
          {
            id: 30,
            key: "n",
            text_uz: "jag`",
            text_en: "jaw",
            description: "It had an ape-like jaw",
          },
          {
            id: 31,
            key: "phr",
            text_uz: "jimlikni saqlash",
            text_en: "keep quiet",
            description: "He was supposed to keep quiet about it",
          },
          {
            id: 32,
            key: "adj",
            text_uz: "qiziqqan",
            text_en: "keen",
            description: "Scientists were keen to find some evidence that would prove the link between early man and apes",
          },
          {
            id: 33,
            key: "phr",
            text_uz: "urilish",
            text_en: "knock into",
            description: "Something knocked into the boat",
          },
          {
            id: 34,
            key: "adv",
            text_uz: "jonli",
            text_en: "live",
            description: "By the time the balloon finally landed about 80 km away, anhour or so later, the story was live on television",
          },
          {
            id: 35,
            key: "phr",
            text_uz: "aloqani yo`qotish",
            text_en: "lose contact",
            description: "Barry had lost contact with his family while he was workin gabroad",
          },
          {
            id: 36,
            key: "adv",
            text_uz: "baxtiga, yaxshiyam",
            text_en: "luckily",
            description: "Luckily, she wasn`t actually hurt",
          },
          {
            id: 37,
            key: "adj",
            text_uz: "tibbiy",
            text_en: "medical",
            description: "By chance, a medical team was nearby, and they helped me to reach a hospital",
          },
          {
            id: 38,
            key: "v",
            text_uz: "yodga olmoq, eslatib o`tmoq",
            text_en: "mention",
            description: "The boy accidently mentioned that they`d done it to be on TV",
          },
          {
            id: 39,
            key: "n",
            text_uz: "orkestr",
            text_en: "orchestra",
            description: "A group of thee `judges` from the orchestra would sit in aroom",
          },
          {
            id: 40,
            key: "adj",
            text_uz: "odatiy",
            text_en: "ordinary",
            description: "Intel started out as just an ordinary day at work, restingly, I know a lot of people who want to work on television",
          },
          {
            id: 41,
            key: "adv",
            text_uz: "shaxsan",
            text_en: "personally",
            description: "Personally, I prefer tea",
          },
          {
            id: 42,
            key: "v",
            text_uz: "anglamoq",
            text_en: "realize",
            description: "Did you realize what was going to happen?",
          },
          {
            id: 43,
            key: "v",
            text_uz: "tanimoq",
            text_en: "recognize",
            description: "Did you recognize it?",
          },
          {
            id: 44,
            key: "adv",
            text_uz: "ajoyib",
            text_en: "remarkably",
            description: "Remarkably, the company made 600 million dollars from the new chunky sauce",
          },
          {
            id: 45,
            key: "v",
            text_uz: "eslamoq",
            text_en: "remember",
            description: "I remembered it so clearly",
          },
          {
            id: 46,
            key: "v",
            text_uz: "eslatmoq",
            text_en: "remind",
            description: "What did it remind you of?",
          },
          {
            id: 47,
            key: "v",
            text_uz: "hisobot bermoq",
            text_en: "report",
            description: "The media reported that a six-year-old boy was inside a large silver balloon floating high in the sky",
          },
          {
            id: 48,
            key: "adj",
            text_uz: "javobgar",
            text_en: "responsible",
            description: "Meanwile, Dawson, who most people consider responsible for making the fake, had died",
          },
          {
            id: 49,
            key: "adv",
            text_uz: "afsuski, achinarlisi",
            text_en: "sadly",
            description: "Sadly, none of the students passed the final exam",
          },
          {
            id: 50,
            key: "v",
            text_uz: "qichqirmoq",
            text_en: "scream",
            description: "I screamed loudly",
          },
          {
            id: 51,
            key: "adv",
            text_uz: "keskin",
            text_en: "sharply",
            description: "Police announced yesterday that calls to the emergency 999 number and had risen sharply in recent months",
          },
          {
            id: 52,
            key: "n",
            text_uz: "ekran",
            text_en: "screen",
            description: "Orchestras started putting up screens in the rooms where the auditions took place",
          },
          {
            id: 53,
            key: "n",
            text_uz: "bosh suyagi",
            text_en: "scull",
            description: "He dug up a human skull",
          },
          {
            id: 54,
            key: "adj",
            text_uz: "nordon",
            text_en: "sour",
            description: "The moon melon will change the taste of anything you eat afterwards, making sweet thingd taste sour, and so on",
          },
          {
            id: 55,
            key: "n",
            text_uz: "oqim",
            text_en: "stream",
            description: "He fell in a stream and broke his leg",
          },
          {
            id: 56,
            key: "n",
            text_uz: "yuza",
            text_en: "surface",
            description: "I remember looking up at the surface of the water",
          },
          {
            id: 57,
            key: "adv",
            text_uz: "ajablanarli",
            text_en: "surprisingly",
            description: "Surprisingly, the results which Moskowitz obtained were completely confusing",
          },
          {
            id: 58,
            key: "v",
            text_uz: "tirik qolmoq",
            text_en: "survive",
            description: "He survived by drinking water mixed with the barbecue sauce",
          },
          {
            id: 59,
            key: "n",
            text_uz: "tizim",
            text_en: "system",
            description: "Under the system, most of the musicians who were chosen were men",
          },
          {
            id: 60,
            key: "v",
            text_uz: "gapirib bermoq",
            text_en: "tell",
            description: "They told the public to ignore the hoax",
          },
          {
            id: 61,
            key: "v",
            text_uz: "kuzatmoq",
            text_en: "track",
            description: "The police were informed and helicopters were sent up to track the balloon",
          },
          {
            id: 62,
            key: "phr v",
            text_uz: "o`girilmoq",
            text_en: "turn around",
            description: "I turned round to push it away, when suddenly everything went dark",
          },
          {
            id: 63,
            key: "adv",
            text_uz: "suv ostida",
            text_en: "underwater",
            description: "I realized I was underwater",
          },
          {
            id: 64,
            key: "adv",
            text_uz: "afsuski",
            text_en: "unfortunately",
            description: "I realized I was stuck inside something",
          },
          {
            id: 65,
            key: "v",
            text_uz: "isrof qilmoq",
            text_en: "waste",
            description: "By the time the hoax was discovered, scientists had wasted nearly forty years believing a lie",
          },
          {
            id: 66,
            key: "n",
            text_uz: "tarvuz",
            text_en: "watermelon",
            description: "Each watermelon is supposed to cost about $200",
          },
          {
            id: 67,
            key: "adj",
            text_uz: "zaif, kuchsiz",
            text_en: "weak",
            description: "Most people like weak coffee",
          },
          {
            id: 68,
            key: "v",
            text_uz: "pichirlamoq",
            text_en: "whisper",
            description: "He whispered something to me",
          },
          {
            id: 69,
            key: "v",
            text_uz: "qiziqmoq",
            text_en: "wonder",
            description: "I wonder if we`ll go there again",
          },

        ],
        unit3: [
          {

            id: 1,
            key: "v",
            text_uz: "qoyil qolmoq",
            text_en: "admire",
            description: "Pick up some valuable lessons by observing someone whose patience you admire",
          },
          {
            id: 2,
            key: "n",
            text_uz: "diqqat",
            text_en: "attention",
            description: "If you succeed in turning your attention away from the chocolate for a while, you may forget about it altogether",
          },
          {
            id: 3,
            key: "v",
            text_uz: "urmoq",
            text_en: "beat",
            description: "You sweat, your mouth goes dry, your heart starts beating fast",
          },
          {
            id: 4,
            key: "n",
            text_uz: "oqartiruvchi vosita",
            text_en: "bleach",
            description: "Fill the bottle with water and add ten millilitres of bleanch",
          },
          {
            id: 5,
            key: "n",
            text_uz: "qon tomirlari",
            text_en: "blood vessel",
            description: "There are signs of damage to the blood vessels around the heart",
          },
          {
            id: 6,
            key: "adj",
            text_uz: "kumpyuterlashtirilgan",
            text_en: "computerized",
            description: "Technology, such as computerized household appliances, are an essential part of everyday life",
          },
          {
            id: 7,
            key: "n",
            text_uz: "ishonch",
            text_en: "confidence",
            description: "You need a lot of confidence to succeed as a chef",
          },
          {
            id: 8,
            key: "n",
            text_uz: "musobaqa",
            text_en: "contest",
            description: "They take part in a contest",
          },
          {
            id: 9,
            key: "v",
            text_uz: "chaqmoq, sindirmoq",
            text_en: "crack",
            description: "Crack the egg into the bowl",
          },
          {
            id: 10,
            key: "n",
            text_uz: "ziyon, shikast",
            text_en: "damage",
            description: "There a sign of damage",
          },
          {
            id: 11,
            key: "n",
            text_uz: "so`nggi muddat",
            text_en: "deadline",
            description: "It`s also a very high-pressure job, so he must work to tight",
          },
          {
            id: 12,
            key: "phr v",
            text_uz: "to`qnash kelmoq",
            text_en: "deal with",
            description: "The successful children deal with the problem by looking away or covering their eyes",
          },
          {
            id: 13,
            key: "n",
            text_uz: "qaror",
            text_en: "decision",
            description: "An important member of the team is someone who can make decisions",
          },
          {
            id: 14,
            key: "n",
            text_uz: "qurilma",
            text_en: "device",
            description: "Al these devices are constantly developing",
          },
          {
            id: 15,
            key: "adj",
            text_uz: "dilkash",
            text_en: "easy-going",
            description: "Do you prefer a very strict or a very easy-going teacher?",
          },
          {
            id: 16,
            key: "adj",
            text_uz: "ingliz tilida so`zlovchi",
            text_en: "English-speaking",
            description: "Can you name five English speaking countries?",
          },
          {
            id: 17,
            key: "n",
            text_uz: "tajriba",
            text_en: "experiment",
            description: "One group who took part in the experiment were told nothing",
          },
          {
            id: 18,
            key: "n",
            text_uz: "mutaxassis",
            text_en: "expert",
            description: "They send someone with no experience in a particular job to live and train with an expert for four weeks",
          },
          {
            id: 19,
            key: "v",
            text_uz: "yiqilmoq, uddalay olmaslik",
            text_en: "fail",
            description: "How many of them failed the test?",
          },
          {
            id: 20,
            key: "adj",
            text_uz: "besh yulduzli",
            text_en: "five-star",
            description: "Have you ever stayed in a five-star hotel",
          },
          {
            id: 21,
            key: "v",
            text_uz: "o`girmoq",
            text_en: "flip",
            description: "When the first side is cooked, you flip it over",
          },
          {
            id: 22,
            key: "adj",
            text_uz: "to`liq stavka",
            text_en: "full-time",
            description: "He is a full time international business speaker",
          },
          {
            id: 23,
            key: "phr",
            text_uz: "taslim bo`moq",
            text_en: "give in",
            description: "Most of the children gave in before the time was up",
          },
          {
            id: 24,
            key: "adj",
            text_uz: "chiroli ko`rinishli",
            text_en: "good-looking",
            description: "i think it`s very good-looking",
          },
          {
            id: 25,
            key: "n",
            text_uz: "xobbi",
            text_en: "hobby",
            description: "A new hobby gives us something to talk about with our friends and family",
          },
          {
            id: 26,
            key: "n",
            text_uz: "maslahatchi",
            text_en: "instructor",
            description: "The instructor shouted, `Faster! Faster!`",
          },
          {
            id: 27,
            key: "n",
            text_uz: "idrok",
            text_en: "intelligence",
            description: "He`s good at using his intelligence to solve problems",
          },
          {
            id: 28,
            key: "n",
            text_uz: "sardor",
            text_en: "leader",
            description: "Audrey is a good leader",
          },
          {
            id: 29,
            key: "adj",
            text_uz: "chapaqay",
            text_en: "left-handed",
            description: "Did you know that Karen is left-handed?",
          },
          {
            id: 30,
            key: "phr",
            text_uz: "urinib ko`rmoq",
            text_en: "make an effort",
            description: "If they didn`t think about the marshmallow, they didn`t have to make an efford not to eat it",
          },
          {
            id: 31,
            key: "v",
            text_uz: "boshqarmoq",
            text_en: "manage",
            description: "She manages the team really well",
          },
          {
            id: 32,
            key: "n",
            text_uz: "zefir",
            text_en: "marshmallow",
            description: "If you can be patient and wait until I come back and not eat the marshmallow, you can have two marshmallows as a reward",
          },
          {
            id: 33,
            key: "v",
            text_uz: "o`lchamoq",
            text_en: "measure",
            description: "You need to use special metal-cutters, and you need to measure carefully",
          },
          {
            id: 34,
            key: "v",
            text_uz: "turli topshiriqlarni bajarmoq",
            text_en: "multitask",
            description: "He`s great at multitasking",
          },
          {
            id: 35,
            key: "v",
            text_uz: "kuzatmoq",
            text_en: "observe",
            description: "Pick up some valuable lessons by observing someone whose patience you admire",
          },
          {
            id: 36,
            key: "phr",
            text_uz: "shoshqaloqlik bilan",
            text_en: "on impulse",
            description: "Never buy things on impulse",
          },
          {
            id: 37,
            key: "v",
            text_uz: "kuydirib yubormoq",
            text_en: "overcook",
            description: "The vegetables were overcooked",
          },
          {
            id: 38,
            key: "adj",
            text_uz: "juda qimmat",
            text_en: "overpriced",
            description: "When was the last time you thought something was overpriced?",
          },
          {
            id: 39,
            key: "n",
            text_uz: "jamoa",
            text_en: "panel",
            description: "A panel of judges decides who wins",
          },
          {
            id: 40,
            key: "n",
            text_uz: "ishtirokchi",
            text_en: "participant",
            description: "The judges decide which participant is `the real thing`",
          },
          {
            id: 41,
            key: "n",
            text_uz: "ehtiroz",
            text_en: "passion",
            description: "He has passion for food",
          },
          {
            id: 42,
            key: "adj",
            text_uz: "sabrli",
            text_en: "patient",
            description: "Most of the children found it difficult to be patient",
          },
          {
            id: 43,
            key: "adj",
            text_uz: "yoqimli",
            text_en: "pleasant",
            description: "He didn`t need to do much apart from arrive at work on time and be responably pleasant to people",
          },
          {
            id: 44,
            key: "adj",
            text_uz: "xushmuomila",
            text_en: "polite",
            description: "He also had to be polite to the customers",
          },
          {
            id: 45,
            key: "adj",
            text_uz: "aniq",
            text_en: "precise",
            description: "As a chef, it`s important to work to very precise times",
          },
          {
            id: 46,
            key: "n",
            text_uz: "usta, mahoratli",
            text_en: "professional",
            description: "They take part in a contest against professionals",
          },
          {
            id: 47,
            key: "v",
            text_uz: "qarshilik qilmoq",
            text_en: "resist",
            description: "If the children managed to resist temptation, the researcher promised them a reward",
          },
          {
            id: 48,
            key: "v",
            text_uz: "hurmat qilmoq",
            text_en: "respect",
            description: "Ed was shocked to realize that he couldn`t say please andthank you all the time if he wanted the team to respect him",
          },
          {
            id: 49,
            key: "n",
            text_uz: "javobgarlik",
            text_en: "responsibility",
            description: "You must take responsibility for your actions",
          },
          {
            id: 50,
            key: "n",
            text_uz: "natija",
            text_en: "result",
            description: "The results were not good",
          },
          {
            id: 51,
            key: "n",
            text_uz: "taqdirlamoq",
            text_en: "reward",
            description: "The researches promised them a reward of two marshmallows",
          },
          {
            id: 52,
            key: "phr",
            text_uz: "da`vat/chaqiriqni qabul qilmoq",
            text_en: "rise to the challenge",
            description: "Those children who could rise to the challenge were generally much more successful than the others",
          },
          {
            id: 53,
            key: "v",
            text_uz: "surtmoq, ishqalamoq",
            text_en: "rub",
            description: "Next, rub the bottle with sandpaper",
          },
          {
            id: 54,
            key: "n",
            text_uz: "qum-qog`oz",
            text_en: "sandpaper",
            description: "Rub the bottle with sandpaper",
          },
          {
            id: 55,
            key: "n",
            text_uz: "jadval",
            text_en: "schedule",
            description: "She`s the best one in the them at managing schedules",
          },
          {
            id: 56,
            key: "phr",
            text_uz: "ilmiy isbotlangan",
            text_en: "scientifically proven",
            description: "The results have been scientifically proven",
          },
          {
            id: 57,
            key: "adj",
            text_uz: "ishlatilgan, ikkinchi qo`l",
            text_en: "second-hand",
            description: "Have you ever bought a second-hand car?",
          },
          {
            id: 58,
            key: "phr",
            text_uz: "maqsad qo`ymoq",
            text_en: "set goals",
            description: "He`s very good at setting goals ",
          },
          {
            id: 59,
            key: "adj",
            text_uz: "o`zini yo`qotib qo`ygan",
            text_en: "shocked",
            description: "Ed was shocked to realize that he couldn`t say please and thank you all the time if he wanted the team to respect him",
          },
          {
            id: 60,
            key: "adj",
            text_uz: "kalta yengli",
            text_en: "short-sleeved",
            description: "I`m going to wear a short-sleeved shirt to work today",
          },
          {
            id: 61,
            key: "v",
            text_uz: "ajratmoq",
            text_en: "spare",
            description: "can you spare the time to go for a run this afternoon?",
          },
          {
            id: 62,
            key: "n",
            text_uz: "bosim",
            text_en: "stress",
            description: "The Social Test is a way of measuring stress",
          },
          {
            id: 63,
            key: "adj",
            text_uz: "og`ir",
            text_en: "stressful",
            description: "One of the most stressful things you can ever do is speak in front of a large group of people",
          },
          {
            id: 64,
            key: "v",
            text_uz: "terlamoq",
            text_en: "sweat",
            description: "When I gave a speech or a talk, i sweat, my mouth goes dry, and my heart start beating fast",
          },
          {
            id: 65,
            key: "n",
            text_uz: "alomat, belgi",
            text_en: "symptom",
            description: "One of the test groups experienced symptoms of stress",
          },
          {
            id: 66,
            key: "phr",
            text_uz: "qatnashmoq",
            text_en: "take part in (something)",
            description: "They then have to take part in a contest against professionals",
          },
          {
            id: 67,
            key: "phr",
            text_uz: "javobgar bo`lmoq",
            text_en: "take responsibility",
            description: "However, he didn`t have to take much responsibility as his boss dealt with the money",
          },
          {
            id: 68,
            key: "n",
            text_uz: "suhbat",
            text_en: "talk",
            description: "Have you ever given a talk or speech to a large group of people",
          },
          {
            id: 69,
            key: "n",
            text_uz: "usul",
            text_en: "technique",
            description: "Did he explain what his technique was?",
          },
          {
            id: 70,
            key: "n",
            text_uz: "vasvasa, ehtiroz",
            text_en: "temptation",
            description: "The children are trying to resist the temptation to eat the marshmallow",
          },
          {
            id: 71,
            key: "phr",
            text_uz: "kelajakni o`ylamoq",
            text_en: "think ahead",
            description: "Think ahead. Plan for the future and you will succeed in achieving your goals",
          },
          {
            id: 72,
            key: "phr",
            text_uz: "paydo bo`lmoq",
            text_en: "turn up",
            description: "When he was working in the burger van, Ed had to be reliable and turn up for work on time",
          },
          {
            id: 73,
            key: "n",
            text_uz: "furgon",
            text_en: "van",
            description: "Jack works in a fast-food van in all weathers",
          },
          {
            id: 74,
            key: "phr",
            text_uz: "qattiq ishlamoq",
            text_en: "work hard",
            description: "She`s good at working hard on a project",
          },
          {
            id: 75,
            key: "phr",
            text_uz: "bosim ostida yaxshi ishlaydi",
            text_en: "work well under pressure",
            description: "Does she work well under pressure",
          }
        ],
        unit4: [
          {

            id: 1,
            key: "phr",
            text_uz: "hamma joyda",
            text_en: "all over the place",
            description: "i can`t find my glasses; I`ve looked all over the place",
          },
          {
            id: 2,
            key: "adj",
            text_uz: "sun`iy",
            text_en: "artificial",
            description: "The company will develop artificial island to provide houses for the Maldives` poorer citizens",
          },
          {
            id: 3,
            key: "adj",
            text_uz: "ishtiyoqli",
            text_en: "aspiring",
            description: "Are you an aspiring travel writer?",
          },
          {
            id: 4,
            key: "n",
            text_uz: "kanal",
            text_en: "canal",
            description: "The Thai capital, Bangkok, has many canals",
          },
          {
            id: 5,
            key: "adj",
            text_uz: "umumiy",
            text_en: "communal",
            description: "Every block of flats has a communal garden",
          },
          {
            id: 6,
            key: "n",
            text_uz: "kimyoviy modda",
            text_en: "chemical",
            description: "It seems that the trees give off chemcials which help to keep you healthy",
          },
          {
            id: 7,
            key: "n",
            text_uz: "tik qoya",
            text_en: "cliff",
            description: "You could also sit underneath the waterfalls coming down the cliffs into the river below",
          },
          {
            id: 8,
            key: "n",
            text_uz: "kabinka",
            text_en: "cubicle",
            description: "The shampoo is in the shower cubicle",
          },
          {
            id: 9,
            key: "n",
            text_uz: "madaniyat",
            text_en: "culture",
            description: "There are already cultures where a life on water is nothing new",
          },
          {
            id: 10,
            key: "n",
            text_uz: "zarar, ziyon",
            text_en: "damage",
            description: "There a sign of damage",
          },
          {
            id: 11,
            key: "phr",
            text_uz: "bemalol his qilish",
            text_en: "feel at home",
            description: "I feel at home in my new job already",
          },
          {
            id: 12,
            key: "n",
            text_uz: "kema xizmati",
            text_en: "ferry service",
            description: "There is a dealy 30-minute ferry servise",
          },
          {
            id: 13,
            key: "phr",
            text_uz: "xalos bo`lmoq",
            text_en: "get rid of (something)",
            description: "We need to get rid of some of our books - we have too many",
          },
          {
            id: 14,
            key: "n",
            text_uz: "qurilma",
            text_en: "device",
            description: "Al these devices are constantly developing",
          },
          {
            id: 15,
            key: "phr v",
            text_uz: "ajratmoq",
            text_en: "give off",
            description: "It seems that the trees give off chamicals which help to keep healthy",
          },
          {
            id: 16,
            key: "n",
            text_uz: "globallashuv",
            text_en: "globalization",
            description: "The project is all about globalization",
          },
          {
            id: 17,
            key: "n",
            text_uz: "ko`kat",
            text_en: "greenery",
            description: "There was planty of greenery, but also the most amazing rocks",
          },
          {
            id: 18,
            key: "adj",
            text_uz: "tarixiy",
            text_en: "historic",
            description: "It`s a mixture of historic buildings and natural beauty",
          },
          {
            id: 19,
            key: "n",
            text_uz: "to`plovchi, jamlovchi ",
            text_en: "hoarder",
            description: "I`m a hoarder - I`m just not able to throw things away",
          },
          {
            id: 20,
            key: "n",
            text_uz: "aholi",
            text_en: "inhabitant",
            description: "By 2030 eighteen cities will have more than twenty million inhabitants",
          },
          {
            id: 21,
            key: "adv",
            text_uz: "quruqlik ichkarisiga",
            text_en: "inland",
            description: "As cities become bigger, those who can`t move inland are starting to consider moving out, onto the sea itself",
          },
          {
            id: 22,
            key: "phr",
            text_uz: "juda yaxshi bilmoq",
            text_en: "know (someone/something) like the back of your hand",
            description: "Relax, I know this part of town like the back of my hand",
          },
          {
            id: 23,
            key: "n",
            text_uz: "manzara, ko`rinish",
            text_en: "landscape",
            description: "I don`t think I`ve ever seen such a beautiful and unusual landscape",
          },
          {
            id: 24,
            key: "n",
            text_uz: "xashamad, dabdala",
            text_en: "luxury",
            description: "This project isn`t about luxury living",
          },
          {
            id: 25,
            key: "n",
            text_uz: "qit`a",
            text_en: "mainland",
            description: "There are daily ferries to the mainland",
          },
          {
            id: 26,
            key: "phr",
            text_uz: "joy bo`shatish",
            text_en: "make room",
            description: "I`m sure we can make room for one more person",
          },
          {
            id: 27,
            key: "phr",
            text_uz: "o`z uyidagidek his qilish",
            text_en: "make yourself at home",
            description: "Come in and make yourself at home",
          },
          {
            id: 28,
            key: "phr",
            text_uz: "yiroqda",
            text_en: "miles from anywhere",
            description: "Well, actually we live miles from anywhere",
          },
          {
            id: 29,
            key: "n",
            text_uz: "qorishma",
            text_en: "mixture",
            description: "This part of town is a really interesting mixture of buildings",
          },
          {
            id: 30,
            key: "phr",
            text_uz: "batartib",
            text_en: "nead and tidy",
            description: "I like to keep my living space nead and tidy",
          },
          {
            id: 31,
            key: "n",
            text_uz: "ummon",
            text_en: "ocean",
            description: "Why do you think so many people want to go and live in the middle of the ocean?",
          },
          {
            id: 32,
            key: "phr",
            text_uz: "tirband",
            text_en: "packed in like sardines",
            description: "It`s awful, we`re packed in like sardines on the Tube",
          },
          {
            id: 33,
            key: "n",
            text_uz: "cho`qqi",
            text_en: "peak",
            description: "I could see the mountain peaks and the deep green walleys",
          },
          {
            id: 34,
            key: "adj",
            text_uz: "doimi",
            text_en: "permanent",
            description: "He`s choosing a permanent home",
          },
          {
            id: 35,
            key: "n",
            text_uz: "suv havzasi",
            text_en: "pool",
            description: "In between the rocks were lost of clear pools for swimming, with bluish water",
          },
          {
            id: 36,
            key: "n",
            text_uz: "qamish",
            text_en: "reed",
            description: "Island made from reeds float in the middle of Peru`s Lake Titicaca",
          },
          {
            id: 37,
            key: "n",
            text_uz: "xarsang, qoya",
            text_en: "rock",
            description: "The landscape had the most amazing rocks",
          },
          {
            id: 38,
            key: "phr v",
            text_uz: "tugamoq",
            text_en: "run out of (something)",
            description: "I agree. We we`ve run out of space here!",
          },
          {
            id: 39,
            key: "n",
            text_uz: "manzara",
            text_en: "scenery",
            description: "As I came out of the trees, I could see the beautiful scenery",
          },
          {
            id: 40,
            key: "n",
            text_uz: "fasl",
            text_en: "season",
            description: "Autumn is perhaps the most beautiful season",
          },
          {
            id: 41,
            key: "phr v",
            text_uz: "jo`namoq",
            text_en: "set off",
            description: "It was the end of September, and quite a cold, grey day, as I set off",
          },
          {
            id: 42,
            key: "phr v",
            text_uz: "o`rnashmoq",
            text_en: "settle down",
            description: "I didn`t want to settle down until I was 35",
          },
          {
            id: 43,
            key: "n",
            text_uz: "quyosh quvvati",
            text_en: "solar power",
            description: "They use solar power to make electricity",
          },
          {
            id: 44,
            key: "adj",
            text_uz: "tik",
            text_en: "steep",
            description: "The path was pretty steep",
          },
          {
            id: 45,
            key: "n",
            text_uz: "shahar chekkasi",
            text_en: "suburb",
            description: "Do you live in the suburbs?",
          },
          {
            id: 46,
            key: "n",
            text_uz: "quyosh botishi",
            text_en: "sunset",
            description: "I think the most incredible thing was the sunset",
          },
          {
            id: 47,
            key: "n",
            text_uz: "quyosh nuri",
            text_en: "sunshine",
            description: "The park was full of people enjoying the sunshine",
          },
          {
            id: 48,
            key: "n",
            text_uz: "yo`l, trassa",
            text_en: "trail",
            description: "As I climbed, I could hear the sound of the river by the side of the trail",
          },
          {
            id: 49,
            key: "n",
            text_uz: "vodiy",
            text_en: "valley",
            description: "I could see the most amazing deep green walleys",
          },
          {
            id: 50,
            key: "n",
            text_uz: "to`lqin",
            text_en: "wave",
            description: "I love walking on the sandy beaches and looking at the waves",

          }

        ],
        unit5: [
          {
            id: 1,
            key: "adv",
            text_uz: "mutlaqo",
            text_en: "absolutely",
            description: "I absolutely love it here",
          },
          {
            id: 2,
            key: "adj",
            text_uz: "mavjut, bor",
            text_en: "accessible",
            description: "It's absolutely essential we are accessible all the time",
          },
          {
            id: 3,
            key: "n",
            text_uz: "jangari film",
            text_en: "action film",
            description: "I prefer action films",
          },
          {
            id: 4,
            key: "n",
            text_uz: "jangari film qahramoni",
            text_en: "action hero",
            description: "Who plays the action hero in the film?",
          },
          {
            id: 5,
            key: "adj",
            text_uz: "qaram, tobe",
            text_en: "addicted",
            description: "I hadn't really realized that you could become addected to your screen",
          },
          {
            id: 6,
            key: "adj",
            text_uz: "ajoyib",
            text_en: "amusing",
            description: "Maliyo aims to produce something clever,amusing and definitely African",
          },
          {
            id: 7,
            key: "adj",
            text_uz: "animatsion",
            text_en: "animated",
            description: "Rio 2096 is an animated film",
          },
          {
            id: 8,
            key: "n",
            text_uz: "ilova",
            text_en: "app",
            description: "More and more people are looking for entertaining apps and games",
          },
          {
            id: 9,
            key: "n",
            text_uz: "joziba",
            text_en: "appeal",
            description: "In fact, the games do seem to have a world-wide appeal",
          },
          {
            id: 10,
            key: "adj",
            text_uz: "ajabtovur",
            text_en: "astonishing",
            description: "Last year, Nigerians bought an astonishing 21,5 million mobile phones",
          },
          {
            id: 11,
            key: "n",
            text_uz: "muhit",
            text_en: "atmosphere",
            description: "Thomas Newman's soundtrack creates an exciting atmosphere throughout the film ",
          },
          {
            id: 12,
            key: "adj",
            text_uz: "haqiqiy, chin",
            text_en: "authentic",
            description: "Agus's family would love to eat at an authentic Indonesian restaurant",
          },
          {
            id: 13,
            key: "n",
            text_uz: "bank ishchisi",
            text_en: "banker",
            description: "Tim Robbins plays Andy Dufresne, who is a banker ",
          },
          {
            id: 14,
            key: "phr v",
            text_uz: "asoslangan",
            text_en: "base on",
            description: "The film is based on a novel by Stephen King",
          },
          {
            id: 15,
            key: "adj",
            text_uz: "yorqin",
            text_en: "brilliant",
            description: "Although the film is a little slow, the end is absolutely brilliant",
          },
          {
            id: 16,
            key: "n",
            text_uz: "ijodiy jamoa",
            text_en: "cast",
            description: "There are several very good actors in the cast",
          },
          {
            id: 17,
            key: "n",
            text_uz: "kinodagi qahramon",
            text_en: "character",
            description: "He plays the part of the main character in the film",
          },
          {
            id: 18,
            key: "v",
            text_uz: "gap sotmoq",
            text_en: "chat",
            description: "Meanwhile, my daughter spends her days chatting online",
          },
          {
            id: 19,
            key: "n",
            text_uz: "klassik",
            text_en: "classic",
            description: "It has become a modern classic",
          },
          {
            id: 20,
            key: "n",
            text_uz: "klip",
            text_en: "clip",
            description: "Viewers use second screens to watch clips",
          },
          {
            id: 21,
            key: "v",
            text_uz: "yeldak uchmoq, yugurmoq",
            text_en: "dash",
            description: "He makes a living by dashing through the streets of Lagos",
          },
          {
            id: 22,
            key: "adj",
            text_uz: "aziz",
            text_en: "dear",
            description: "The teacher asked them to write an essay about their dearest dreams and wishes",
          },
          {
            id: 23,
            key: "prep",
            text_uz: "...ga qaramasdan",
            text_en: "despite",
            description: "Despite failing at the box office, the film has become popular",
          },
          {
            id: 24,
            key: "adj",
            text_uz: "qiyin",
            text_en: "difficult",
            description: "The exam was extremely difficult",
          },
          {
            id: 25,
            key: "adj",
            text_uz: "hafsalasi bir bo'lgan",
            text_en: "disappointing",
            description: "I thought the game was rather disappointing",
          },
          {
            id: 26,
            key: "adj",
            text_uz: "yoqimsiz",
            text_en: "disturbing",
            description: "It is a disturbing future where poor people can't afford to buy water ",
          },
          {
            id: 27,
            key: "n",
            text_uz: "hujjatli film",
            text_en: "documentary",
            description: "I watched an interesting documentary on TV this week",
          },
          {
            id: 28,
            key: "adj",
            text_uz: "qo'rqinchili, dahshatli",
            text_en: "dreadful",
            description: "The traffic is dreadful",
          },
          {
            id: 29,
            key: "adj",
            text_uz: "ko'ngilochar",
            text_en: "entertaining",
            description: "It was the most entertaining game I'va ever played",
          },
          {
            id: 30,
            key: "adv",
            text_uz: "asosan",
            text_en: "essentially",
            description: "The film is surprisingly sad in places, but essentially, it is a positive story",
          },
          {
            id: 31,
            key: "n",
            text_uz: "ko'rgazma",
            text_en: "exhibition",
            description: "Over the past month, I've been to the theatre three times, as well as a number of art exibition",
          },
          {
            id: 32,
            key: "adv",
            text_uz: "adashib",
            text_en: "falsely",
            description: " In the film, he plays a banker who is falsely sent to prison for killing his wife ",
          },
          {
            id: 33,
            key: "n",
            text_uz: "muhlis",
            text_en: "fan",
            description: "Most of its fans log in from Brazil, India and the US",
          },
          {
            id: 34,
            key: "v",
            text_uz: "xayol surmoq",
            text_en: "fantasize",
            description: "Mei fantasizes about becoming an actress",
          },
          {
            id: 35,
            key: "n",
            text_uz: "janr",
            text_en: "genre",
            description: "What genre of film do you prefer?",
          },
          {
            id: 36,
            key: "phr v",
            text_uz: "ajralmoq",
            text_en: "grow apart",
            description: "In the film, the two main characters meet at university and become friends; however, they grow apart for the next few years",
          },
          {
            id: 37,
            key: "adj",
            text_uz: "ruchno'y",
            text_en: "hand-held",
            description: "A second screen can be a tablet, a smartphone, a laptop or a hand-held gaming unit used whilst watching TV",
          },
          {
            id: 38,
            key: "adj",
            text_uz: "zararsiz",
            text_en: "harmless",
            description: "It's absolutely terrible to think that something that looks as harmless as a video game can have such an effect on your life",
          },
          {
            id: 39,
            key: "n",
            text_uz: "umid",
            text_en: "hope",
            description: "The film is about frienship and hope",
          },
          {
            id: 40,
            key: "adv",
            text_uz: "ajabtovur, aql bovar qilmaydigan darajada",
            text_en: "incredibly",
            description: "It's incredibly expensive",
          },
          {
            id: 41,
            key: "adj",
            text_uz: "g'azablantiradigan",
            text_en: "infuriating",
            description: "It's absolutely infuriating",
          },
          {
            id: 42,
            key: "v",
            text_uz: "hamkorlikda ishlash",
            text_en: "interact",
            description: "The more ways we have to interact with people the better",
          },
          {
            id: 43,
            key: "n",
            text_uz: "g'azab",
            text_en: "irritation",
            description: "The only things that that get hurt are mosquitos, a constant irritation in Lagos",
          },
          {
            id: 44,
            key: "phr v",
            text_uz: "tizimga kirish",
            text_en: "log in",
            description: "Most of its fans log in from Brazil, India and the US",
          },
          {
            id: 45,
            key: "adv",
            text_uz: "mo'jizaviy",
            text_en: "magically",
            description: "In the film, he magically turns into a bird",
          },
          {
            id: 46,
            key: "n",
            text_uz: "o'rta sinf",
            text_en: "middle class",
            description: "A growing middle class that is looking for entertainment has resulted in Nigerian movies and music sweeping across the continent",
          },
          {
            id: 47,
            key: "adj",
            text_uz: "harbiy",
            text_en: "military",
            description: "The film shows the couple living through military dictorship in 1970",
          },
          {
            id: 48,
            key: "adj",
            text_uz: "zamonaviy",
            text_en: "modern-day",
            description: "The second screen is part of modern-day life, especially for young people",
          },
          {
            id: 49,
            key: "adj",
            text_uz: "hayratlanarli",
            text_en: "moving",
            description: "Freeman's performance is very moving",
          },
          {
            id: 50,
            key: "v",
            text_uz: "talon-taroj qilish",
            text_en: "mug",
            description: "It can be quite a violent place. I haven't been mugged yet, but my friend has",
          },
          {
            id: 51,
            key: "n",
            text_uz: "roman",
            text_en: "novel",
            description: "I've read the novel, but I haven't seen the film",
          },
          {
            id: 52,
            key: "phr",
            text_uz: "nihoyat",
            text_en: "on balance",
            description: "Although living in New York definitely has some bad points, on balance I don't think I want to live anywhere else",
          },
          {
            id: 53,
            key: "adj",
            text_uz: "asl",
            text_en: "original",
            description: "He's a character in an original new video game",
          },
          {
            id: 54,
            key: "n",
            text_uz: "tomosha, ijro",
            text_en: "performance",
            description: "His performance in the film is the best",
          },
          {
            id: 55,
            key: "n",
            text_uz: "sujet",
            text_en: "plot",
            description: "The plot is quite difficult to follow",
          },
          {
            id: 56,
            key: "v",
            text_uz: "postni joylamoq",
            text_en: "post",
            description: "We are inviting fans to post reviews this month",
          },
          {
            id: 57,
            key: "n",
            text_uz: "yo'ldagi o'nqir-cho'nqirlar",
            text_en: "pothole",
            description: "He dashes through the streets of Lagos on his bike, avoiding cars, trucks and potholes",
          },
          {
            id: 58,
            key: "adj",
            text_uz: "ayon",
            text_en: "predictable",
            description: "The game was good, although it was quite predictable ",
          },
          {
            id: 59,
            key: "n",
            text_uz: "mahbus",
            text_en: "prisoner",
            description: "He soon makes friends with another prisoner",
          },
          {
            id: 60,
            key: "v",
            text_uz: "tavsiya qilmoq",
            text_en: "recommend",
            description: "I highly recommend it to everyone",
          },
          {
            id: 61,
            key: "v",
            text_uz: "chiqarmoq",
            text_en: "release",
            description: "Despite failing at the box office when it was originally released, it has now become a modern classic",
          },
          {
            id: 62,
            key: "n",
            text_uz: "qayta ishlangan, yangi talqinda",
            text_en: "remake",
            description: "It's a remake of an old film",
          },
          {
            id: 63,
            key: "phr v",
            text_uz: "natijada",
            text_en: "result in",
            description: "It has resulted in Nigerisn movies and music sweeping across the continent",
          },
          {
            id: 64,
            key: "n",
            text_uz: "romantik komediya",
            text_en: "romcom",
            description: "This film is a rom com",
          },
          {
            id: 65,
            key: "n",
            text_uz: "salsa",
            text_en: "salsa",
            description: "I've also just started salsa dance classes",
          },
          {
            id: 66,
            key: "n",
            text_uz: "sahna",
            text_en: "scene",
            description: "Some of the scenes were filmed in Denmark",
          },
          {
            id: 67,
            key: "phr v",
            text_uz: "yo'lga chiqish",
            text_en: "set out",
            description: "He desidet to set out on a journey to find a missing photographic negative",
          },
          {
            id: 68,
            key: "v",
            text_uz: "namoyish qilish",
            text_en: "showcase",
            description: "It is designed to showcase African culture to the world through games",
          },
          {
            id: 69,
            key: "adj",
            text_uz: "ahmoqona",
            text_en: "silly",
            description: "I thought it was really silly",
          },
          {
            id: 70,
            key: "n",
            text_uz: "osmono'par bino",
            text_en: "skyscraper",
            description: "The film starts in the future, where a man and a woman stand at the top of a skyscreper in the middle of the night",
          },
          {
            id: 71,
            key: "n",
            text_uz: "qullik",
            text_en: "slavery",
            description: "We then see the couple living through slavery in 1825",
          },
          {
            id: 72,
            key: "n",
            text_uz: "saundtrek",
            text_en: "soundtrack",
            description: "Thomas Newman's soundtrack creates an exciting atmosphere throughout the film",
          },
          {
            id: 73,
            key: "n pl",
            text_uz: "maxsus effektlar",
            text_en: "special effects",
            description: "There are some amazing special effects",
          },
          {
            id: 74,
            key: "adj",
            text_uz: "hayratlanarli",
            text_en: "stunning",
            description: "Stepping on the Flying Grass is both visually stunning and truly moving",
          },
          {
            id: 75,
            key: "v",
            text_uz: "tarqalmoq",
            text_en: "sweep",
            description: "It has resulted in Nigerian movies and music sweeping across the continent",
          },
          {
            id: 76,
            key: "n",
            text_uz: "moyil",
            text_en: "tend",
            description: "I tend to check emails and message while I watch",
          },
          {
            id: 77,
            key: "adj",
            text_uz: "dahshatli",
            text_en: "terrific",
            description: "The Shawshank Redemtion is terrific entertainment",
          },
          {
            id: 78,
            key: "adj",
            text_uz: "qo'rqinchili",
            text_en: "terrifying",
            description: "It was a terrifying experience",
          },
          {
            id: 79,
            key: "n",
            text_uz: "detektiv film, triller",
            text_en: "thriller",
            description: "Do you like thrillers?",
          },
          {
            id: 80,
            key: "n",
            text_uz: "mavzu",
            text_en: "topic",
            description: "We asked Paul to choose a topic that he found really interesting and relevant to people his age",
          },
          {
            id: 81,
            key: "adj",
            text_uz: "qiziqarsiz",
            text_en: "unexciting",
            description: "It's a pretty unexciting game, relly",
          },
          {
            id: 82,
            key: "adj",
            text_uz: "vahshiy",
            text_en: "violent",
            description: "It can also be quite a violent place",
          },
          {
            id: 83,
            key: "v",
            text_uz: "ovoz bermoq, dublyaj",
            text_en: "voice",
            description: "The main characters are voiced by Brazilian actors",
          },
          {
            id: 84,
            key: "v",
            text_uz: "ovoz berish, saylovda",
            text_en: "vote",
            description: "We want you to vote for your favourite film of all time ",
          },
          {
            id: 85,
            key: "adj",
            text_uz: "dunyo bo'ylab",
            text_en: "world-wide",
            description: "In fact, the games do seem to have a world-wide appeal",
          }

        ],
        unit6: [
          {
            id: 1,
            key: "n",
            text_uz: "baxtsiz hodisa",
            text_en: "accident",
            description: "90% of these accidents are caused by human error",
          },
          {
            id: 2,
            key: "adv",
            text_uz: "sun'iy ravishda",
            text_en: "artificially",
            description: "I read a report on ways in which scientists around the world have been trying to artificially control or change the weather",
          },
          {
            id: 3,
            key: "phr",
            text_uz: "tezlikda",
            text_en: "at speed",
            description: "Driverless cars will be able to drive at speed much closer to each other",
          },
          {
            id: 4,
            key: "adv",
            text_uz: "avtomatik ravishda",
            text_en: "automatically",
            description: "Many cars can already break automatically",
          },
          {
            id: 5,
            key: "adv",
            text_uz: "asosan",
            text_en: "basically",
            description: "Basically, due to problems with staff illness in her team, she's behind with her work  ",
          },
          {
            id: 6,
            key: "v",
            text_uz: "toxtatmoq",
            text_en: "brake",
            description: "Many caes can already brake automatically when they need to slow down",
          },
          {
            id: 7,
            key: "adj",
            text_uz: "quvnoq",
            text_en: "cheerful",
            description: "I find it difficult to be cheerful when the weather is bad",
          },
          {
            id: 8,
            key: "n",
            text_uz: "iqlim o'zgarishi",
            text_en: "climate change",
            description: "Many scientists now agree that climate change has been causing higher temperatures",
          },
          {
            id: 9,
            key: "n",
            text_uz: "bulutli ekish",
            text_en: "cloud seeding",
            description: "These scientistshave been exploring various techniques, including cloud seeding, over the past few years",
          },
          {
            id: 10,
            key: "v",
            text_uz: "ishga qatnamoq",
            text_en: "commute",
            description: "I hate commuting to work, it's so stressful",
          },
          {
            id: 11,
            key: "v",
            text_uz: "tasdiqlamoq",
            text_en: "confirm",
            description: "I'll check my diary and will confirm later",
          },
          {
            id: 12,
            key: "n",
            text_uz: "shartnoma",
            text_en: "contract",
            description: "We've won a new contract with the same company",
          },
          {
            id: 13,
            key: "n",
            text_uz: "muxbir",
            text_en: "correspondent",
            description: "With us in the studeo today we have Neil Clough, our science correspondet",
          },
          {
            id: 14,
            key: "n",
            text_uz: "ekipaj",
            text_en: "crew",
            description: "Rolls-Royce says robo-ships, which won't need any crew, will soon be sailing our seas",
          },
          {
            id: 15,
            key: "n",
            text_uz: "ekin",
            text_en: "crop",
            description: "Crops have died from water shortages",
          },
          {
            id: 16,
            key: "n",
            text_uz: "kamayish",
            text_en: "decrease",
            description: "They hope this means a decrease in rainfall",
          },
          {
            id: 17,
            key: "n",
            text_uz: "nogironlik",
            text_en: "disability",
            description: "My own disability, which I have had since birth, means that I will never be able to drive a 'real' car",
          },
          {
            id: 18,
            key: "adj",
            text_uz: "haydovchisiz",
            text_en: "driverless",
            description: "Driverless cars are already on the roads in California ",
          },
          {
            id: 19,
            key: "n",
            text_uz: "avtomobil haydash testi",
            text_en: "driving test",
            description: "Hw did you feel before your driving test?",
          },
          {
            id: 20,
            key: "n",
            text_uz: "dron",
            text_en: "drone",
            description: "Amazon promises robot drones which will deliver our packages",
          },
          {
            id: 21,
            key: "n",
            text_uz: "qurg'oqchilik",
            text_en: "drought",
            description: "Many scientists now agree that climate change has been causing floods and droughts",
          },
          {
            id: 22,
            key: "adj",
            text_uz: "chang bosgan",
            text_en: "dusty",
            description: "This room is very dusty",
          },
          {
            id: 23,
            key: "v",
            text_uz: "tadqiq qilish",
            text_en: "explore",
            description: "Scientists have been exploring another method",
          },
          {
            id: 24,
            key: "adj",
            text_uz: "ekstremal,keskin",
            text_en: "extreme",
            description: "In recent years, there has been a noticeable increase in extreme weather events",
          },
          {
            id: 25,
            key: "n",
            text_uz: "yong'in",
            text_en: "fire",
            description: "Have you heard about the terrible fires in Australia",
          },
          {
            id: 26,
            key: "n",
            text_uz: "issiqlik to'lqini",
            text_en: "heatwave",
            description: "There's going tobe heatwave next week",
          },
          {
            id: 27,
            key: "adj",
            text_uz: "noiloj, nochor",
            text_en: "helpless",
            description: "I feel absolutely helpless",
          },
          {
            id: 28,
            key: "adj",
            text_uz: "hayoliy",
            text_en: "imaginative",
            description: "Altough the problem is very serious, local people have begun to find new and imaginative solutions",
          },
          {
            id: 29,
            key: "phr",
            text_uz: "javobgar",
            text_en: "in charge",
            description: "Your car is now in charge: driveless cars are already here",
          },
          {
            id: 30,
            key: "phr",
            text_uz: "nazorat ostida",
            text_en: "in control",
            description: "You know, as soon as I get behind the steering wheel, I feel great. I'm in control",
          }, {
            id: 31,
            key: "n",
            text_uz: "ko'payish",
            text_en: "increase",
            description: "There has been an increase in tropical storms",
          },
          {
            id: 32,
            key: "v",
            text_uz: "jarohatlanmoq",
            text_en: "injure",
            description: "More than 50 million people die or are injured in road crashes every year",
          },
          {
            id: 33,
            key: "n",
            text_uz: "tezkor xabar almashish",
            text_en: "instant messaging",
            description: "Do you think instant messaging has made it easier to organize your social life?",
          },
          {
            id: 34,
            key: "v",
            text_uz: "uzmoq, bo'lib qo'ymoq",
            text_en: "interrupt",
            description: "Don't you ever get annoyed when people interrupt a meeting with a personal call",
          },
          {
            id: 35,
            key: "n",
            text_uz: "chorraha",
            text_en: "junction",
            description: "Driverless cars come with fast broadband and can communicate with traffic lights as they approach junctions ",
          },
          {
            id: 36,
            key: "n",
            text_uz: "yer ko'chishi",
            text_en: "landslide",
            description: "The road is blocked because of a landslide",
          },
          {
            id: 37,
            key: "n",
            text_uz: "yo'lak",
            text_en: "lane",
            description: "The car is driving in the correct lane on the motorway",
          },
          {
            id: 38,
            key: "adj",
            text_uz: "meteorologik",
            text_en: "meteorological",
            description: "He works in the meteorological department",
          },
          {
            id: 39,
            key: "n",
            text_uz: "avtomobil yo'li",
            text_en: "motorway",
            description: "What's it like being in a driverless car on a motorway?",
          },
          {
            id: 40,
            key: "adj",
            text_uz: "musiqiy",
            text_en: "musical",
            description: "She's a very musical person",
          },
          {
            id: 41,
            key: "adv",
            text_uz: "shu kunlarda",
            text_en: "nowadays",
            description: "I think most people organize their social life by mobile nowadays",
          },
          {
            id: 42,
            key: "v",
            text_uz: "quvib yetmoq",
            text_en: "overtake",
            description: "They are able to overtake other cars safely",
          },
          {
            id: 43,
            key: "v",
            text_uz: "parkovka qilmoq",
            text_en: "park",
            description: "Many cars can already park themselves by the side of the road",
          },
          {
            id: 44,
            key: "n",
            text_uz: "mulk",
            text_en: "possession",
            description: "Most of our possessions are replaceable",
          },
          {
            id: 45,
            key: "adj",
            text_uz: "amaliy",
            text_en: "practical",
            description: "I'm not a very practical person",
          },
          {
            id: 46,
            key: "v",
            text_uz: "oldini olish",
            text_en: "prevent",
            description: "They have been working on techniques to create or privent rain",
          },
          {
            id: 47,
            key: "v",
            text_uz: "himoya qilish",
            text_en: "protect",
            description: "We should try to prevent further global warming by reducing pollution, protecting trees and so on",
          },
          {
            id: 48,
            key: "n",
            text_uz: "puls",
            text_en: "pulse",
            description: "Their experiments have shown that pulses of light from a laser can be used to make clouds",
          },
          {
            id: 49,
            key: "n",
            text_uz: "kuchli yomg'ir",
            text_en: "rainfall",
            description: "In some areas, there has been a decrease in rainfall",
          },
          {
            id: 50,
            key: "adj",
            text_uz: "almashtiriladigan",
            text_en: "replaceable",
            description: "This is the one possession I have that is not replaceable",
          },
          {
            id: 51,
            key: "adj",
            text_uz: "mavsumiy",
            text_en: "seasonal",
            description: "The seasonal rains have been arriving later and later over the last ten years",
          },
          {
            id: 52,
            key: "n",
            text_uz: "yetishmovchilik",
            text_en: "shortage",
            description: "There are water shortages across the country because of the heat wave",
          },
          {
            id: 53,
            key: "n",
            text_uz: "mahorat",
            text_en: "skill",
            description: "Some think that only people whose skills are better than the machines' abilities will have work",
          },
          {
            id: 54,
            key: "phr v",
            text_uz: "sirpanib ketish",
            text_en: "slip out",
            description: "Driverless cars can warn the driver if they are slipping out of the correct lane ",
          },
          {
            id: 55,
            key: "adj",
            text_uz: "kirishimli",
            text_en: "sociable",
            description: "The most sociable person I know is my sister",
          },
          {
            id: 56,
            key: "adj",
            text_uz: "ijtimoiy",
            text_en: "social",
            description: "He's a very social person ",
          },
          {
            id: 57,
            key: "n",
            text_uz: "tezlik chegarasi",
            text_en: "speed limit",
            description: "Googles driverless car sticks to the speed limit",
          },
          {
            id: 58,
            key: "n",
            text_uz: "rul",
            text_en: "steering wheel",
            description: "The driver presses a button on the steering wheel-the caris now driving itself",
          },
          {
            id: 59,
            key: "adj",
            text_uz: "an'anaviy",
            text_en: "traditional",
            description: "At weddings, it's traditional for the bride and groom to have the first dance",
          },
          {
            id: 60,
            key: "n",
            text_uz: "tirbandlik",
            text_en: "traffic jam",
            description: "Being stuck in traffic jams could become a thing of the past",
          },
          {
            id: 61,
            key: "adj",
            text_uz: "tropik",
            text_en: "tropical",
            description: "Did you hear about the tropical storms in the Philippines?",
          },
          {
            id: 62,
            key: "adj",
            text_uz: "ishga layoqatsiz",
            text_en: "unemployable",
            description: "Those who don't have high-level skills risk being unemployable",
          },
          {
            id: 63,
            key: "n, pl",
            text_uz: "ish haqi",
            text_en: "wages",
            description: "They will have to work for very long wages",
          },
          {
            id: 64,
            key: "adj",
            text_uz: "yuviladigan",
            text_en: "washable",
            description: "Is this material washable?",
          },
          {
            id: 65,
            key: "n",
            text_uz: "ob-havo sharoitlari",
            text_en: "weather pattern",
            description: "If this changes in weather patterns have been happening as a result of global warming, then we should try to prevent further warming",
          }
        ],
        unit7: [
          {
            "id": 1,
            "key": "n",
            "text_uz": "turar joy",
            "text_en": "accommodation",
            "description": "The job also came with rent - free accommodation in a beautiful apartment."
          },
          {
            "id": 2,
            "key": "adj",
            "text_uz": "intiluvchan",
            "text_en": "ambitious",
            "description": "She was hardworking and ambitious."
          },
          {
            "id": 3,
            "key": "n",
            "text_uz": "reklama",
            "text_en": "advertisement",
            "description": "I am writing regarding your advertisement for team leaders posted on the Jobs & Training website this month."
          },
          {
            "id": 4,
            "key": "n",
            "text_uz": "niyyat, istak, ishtiyoq",
            "text_en": "ambition",
            "description": "I'd like to know if you have any further ambitions."
          },
          {
            "id": 5,
            "key": "n",
            "text_uz": "antropolog",
            "text_en": "anthropologist",
            "description": "In her early twenties, she worked as a secretary to the anthropologist Louis Leakey."
          },
          {
            "id": 6,
            "key": "n",
            "text_uz": "ariza beruvchi",
            "text_en": "applicant",
            "description": "Applicants should have at least a school leaver's certificate plus a strong interest in travel."
          },
          {
            "id": 7,
            "key": "v",
            "text_uz": "ariza berish",
            "text_en": "apply",
            "description": "Send applications to Carmen Ramos at studytrips @travelabroad.com or apply online."
          },
          {
            "id": 8,
            "key": "n",
            "text_uz": "jihat",
            "text_en": "aspect",
            "description": "Did you like that aspect of the job?"
          },
          {
            "id": 9,
            "key": "n",
            "text_uz": "boshqaruvchi yordamchisi",
            "text_en": "assistant manager",
            "description": "I am working as an assistant manager."
          },
          {
            "id": 10,
            "key": "v",
            "text_uz": "qatnashmoq",
            "text_en": "attend",
            "description": "I would be happy to attend an interview"
          },
          {
            "id": 11,
            "key": "n",
            "text_uz": "munosabat",
            "text_en": "attitude",
            "description": "I want to be remembered as someone who helped to change attitudes towards animals."
          },
          {
            "id": 12,
            "key": "n",
            "text_uz": "mukofot",
            "text_en": "award",
            "description": "He has received various awards for his achievements."
          },
          {
            "id": 13,
            "key": "n",
            "text_uz": "xulq - atvor",
            "text_en": "behaviour",
            "description": "Jane soon became a researcher herself, studying the behaviour of wild apes and chimpanzees."
          },
          {
            "id": 14,
            "key": "v",
            "text_uz": "ayblamoq",
            "text_en": "blame",
            "description": "You mustn't blame him."
          },
          {
            "id": 15,
            "key": "n",
            "text_uz": "blogger",
            "text_en": "blogger",
            "description": "Blon Social bloggers wanted for online lifestyle magazine."
          },
          {
            "id": 16,
            "key": "n",
            "text_uz": "bo'lim",
            "text_en": "branch",
            "description": "We are looking for people to lead teams in our new branches across the country."
          },
          {
            "id": 17,
            "key": "adj",
            "text_uz": "yorqin",
            "text_en": "bright",
            "description": "For many years, people have moved to Europe in search of a brighter future."
          },
          {
            "id": 18,
            "key": "adj",
            "text_uz": "chempion",
            "text_en": "champion",
            "description": "Rebecca Adlington is a champion swimmer."
          },
          {
            "id": 19,
            "key": "adj",
            "text_uz": "o'ynoqi",
            "text_en": "bubbly",
            "description": "I want to be remembered as someone who enjoyed life, was bubbly and worked hard."
          },
          {
            "id": 20,
            "key": "v",
            "text_uz": "yuqoriga chiqmoq",
            "text_en": "climb",
            "description": "Imagine you send out a group of scouts to a new land to find mountains to climb."
          },
          {
            "id": 21,
            "key": "v",
            "text_uz": "diqqatni jamlamoq",
            "text_en": "concentrate",
            "description": "They believe that a school system that concentrates on marks and grades will reduce the ability of the kids to produce new ideas."
          },
          {
            "id": 22,
            "key": "adj",
            "text_uz": "ijodiy",
            "text_en": "creative",
            "description": "The experts were worried that young people in France were not creative and innovative enough for the modern world."
          },
          {
            "id": 23,
            "key": "v",
            "text_uz": "tanqid qilmoq",
            "text_en": "criticize",
            "description": "He says that if you criticize people for having good ideas, they will give up."
          },
          {
            "id": 24,
            "key": "n",
            "text_uz": "mijozlarga xizmat",
            "text_en": "customer care",
            "description": "Customer care is very important in this company."
          },
          {
            "id": 25,
            "key": "n",
            "text_uz": "qaror qabul qiluvchi",
            "text_en": "decision maker",
            "description": "Her sister's illness made her more determined to succeed."
          },
          {
            "id": 26,
            "key": "adj",
            "text_uz": "qat'iy",
            "text_en": "determined",
            "description": "We want decision makers who are good with people."
          },
          {
            "id": 27,
            "key": "n",
            "text_uz": "direktor",
            "text_en": "director",
            "description": "After two years, became a director."
          },
          {
            "id": 28,
            "key": "n",
            "text_uz": "kelishmovchilik",
            "text_en": "disagreement",
            "description": "When was the last time you had a disagreement at work ?"
          },
          {
            "id": 29,
            "key": "n",
            "text_uz": "ninachi",
            "text_en": "dragonfly",
            "description": "Have you ever seen a dragonfly ?"
          },
          {
            "id": 30,
            "key": "adj",
            "text_uz": "erta, barvaqt o'yin-kulgi",
            "text_en": "early",
            "description": "What is your earliest memory?"
          },
          {
            "id": 32,
            "key": "n",
            "text_uz": "o'yin-kulgu",
            "text_en": "entertainment",
            "description": "We are looking for writers with something to say about social media, fashion, food and entertainment."
          },
          {
            "id": 33,
            "key": "n",
            "text_uz": "kirish",
            "text_en": "entrance",
            "description": "We reward success in exams, for example, with entrance to university."
          },
          {
            "id": 34,
            "key": "adj",
            "text_uz": "atrof-muhitga oid",
            "text_en": "environmental",
            "description": "She set up a global environmental programme."
          },
          {
            "id": 35,
            "key": "n",
            "text_uz": "ijrochi",
            "text_en": "executive",
            "description": "He left his job in London to teach English to business executives in Buenos Aires."
          },
          {
            id: 36,
            key: "adj",
            text_uz: "kengayuvchi",
            text_en: "expanding",
            description: "We are looking for new and experienced leaders to manage our expanding group of coffee shops."
          },
          {
            id: 37,
            key: "n",
            text_uz: "muvaffaqiyatsizlik",
            text_en: "failure",
            description: "There are reasons why we should value failure as well."
          },
          {
            id: 38,
            key: "n",
            text_uz: "shuhrat",
            text_en: "fame",
            description: "She uses her fame to raise money for an encephalitis charity."
          },
          {
            id: 39,
            key: "adj",
            text_uz: "mashhur",
            text_en: "famous",
            description: "She became famous after winning two gold medals. "
          },
          {
            id: 40,
            key: "n",
            text_uz: "bayram",
            text_en: "festival",
            description: "Are you going to the music festival this weekend? "
          },
          {
            id: 41,
            key: "v",
            text_uz: "to'da",
            text_en: "flock",
            description: "Young Europeans flock to Argentina for job opportunities. "
          },
          {
            id: 42,
            key: "phr",
            text_uz: "cho'qqiga chiqmoq",
            text_en: "get to the top",
            description: "Most people who work here want to get to the top."
          },
          {
            id: 43,
            key: "n",
            text_uz: "yuqori yutuqlarga erishgan inson",
            text_en: "high achiever",
            description: "What does it take to be a high achiever in business?"
          },
          {
            id: 44,
            key: "adj",
            text_uz: "insonparvar",
            text_en: "humanitarian",
            description: "She works for a humanitarian youth education programme. "
          },
          {
            id: 45,
            key: "adj",
            text_uz: "innovativ, yangiliklarga, intiluvchi",
            text_en: "innovative",
            description: "The experts were worried that young people in France were not creative or innovative enough for the modern world. "
          },
          {
            id: 46,
            key: "n",
            text_uz: "ishdan qoniqish",
            text_en: "job satisfaction",
            description: "Job satisfaction is really important. It's good to feel happy and content about what you do."
          },
          {
            id: 47,
            key: "n",
            text_uz: "hayot davomiyligi",
            text_en: "lifetime",
            description: "It's the experience of a lifetime."
          },
          {
            id: 48,
            key: "n",
            text_uz: "hayot tarzi",
            text_en: "lifestyle",
            description: "The city welcomes a growing number of young professionals who have come here looking for jobs and a more relaxed lifestyle."
          },
          {
            id: 49,
            key: "phr",
            text_uz: "taraqqiyotga erishish",
            text_en: "make progress",
            description: "So making a mistake can mean you also make progress!"
          },
          {
            id: 50,
            key: "phr",
            text_uz: "keraksiz qilmoq",
            text_en: "make redundant",
            description: "The company is making people redundant."
          },
          {
            id: 51,
            key: "n",
            text_uz: "boshqaruv",
            text_en: "management",
            description: "Do you want to get into management?"
          },
          {
            id: 52,
            key: "n",
            text_uz: "turtki berish",
            text_en: "motivate",
            description: "What motivates you and what doesn't?"
          },
          {
            id: 53,
            key: "n",
            text_uz: "tarmoq",
            text_en: "networking",
            description: "I am very active in the world of business networking."
          },
          {
            id: 54,
            key: "n",
            text_uz: "bo'ysunish",
            text_en: "obey",
            description: "We follow the procedures, obey the rules."
          },
          {
            id: 55,
            key: "n",
            text_uz: "kasb, hunar",
            text_en: "occupation",
            description: "Two years ago, Hanson decided to change his occupation. "
          },
          {
            id: 56,
            key: "n",
            text_uz: "onlayn jamiyat",
            text_en: "online community",
            description: "If you have great ideas and experiences to share with our magazine's online community, apply now."
          },
          {
            id: 57,
            key: "n",
            text_uz: "tunab qolish bilan",
            text_en: "overnight",
            description: "Included in the trip are overnight visits to places of local interest."
          },
          {
            id: 58,
            key: "n",
            text_uz: "naqsh, model",
            text_en: "pattern",
            description: "In recent years, however, the pattern seems to be changing. "
          },
          {
            id: 59,
            key: "n",
            text_uz: "nuqtayi nazar ",
            text_en: "point of view",
            description: "Another point of view is provided by Dr Astro Teller who works for Google."
          },
          {
            id: 60,
            key: "n",
            text_uz: "pozitsiya, lavozim",
            text_en: "position",
            description: "I've been promoted to a higher position."
          },
          {
            id: 61,
            key: "n",
            text_uz: "protsedura, tartib, muolaja ",
            text_en: "procedure",
            description: "Make sure you follow the procedures."
          },
          {
            id: 62,
            key: "n",
            text_uz: "prodyuser",
            text_en: "producer",
            description: "There are many directors and producers here younger than I am who are very successful."
          },
          {
            id: 63,
            key: "n",
            text_uz: "istiqbollar",
            text_en: "prospects",
            description: "My career prospects have definitely been improved by coming to Manila."
          },
          {
            id: 64,
            key: "n",
            text_uz: "sifat",
            text_en: "quality",
            description: "This company has a good reputation for quality."
          },
          {
            id: 65,
            key: "v",
            text_uz: "tark etish",
            text_en: "quit",
            description: "She quit her job."
          },
          {
            id: 66,
            key: "adj",
            text_uz: "xotirjam",
            text_en: "relaxed",
            description: "She changed her job because she wanted a more relaxed lifestyle."
          },
          {
            id: 67,
            key: "n",
            text_uz: "ko'chirish idorasi",
            text_en: "relocation office",
            description: "I work in an international relocation office, helping companies set up abroad."
          },
          {
            id: 68,
            key: "adj",
            text_uz: "ijara to'lovidan holi",
            text_en: "rent-free",
            description: "The job came with rent-free accommodation in a beautiful apartment."
          },
          {
            id: 69,
            key: "n",
            text_uz: "obro', nufuz",
            text_en: "reputation",
            description: "Your company has a very good reputation."
          },
          {
            id: 70,
            key: "n",
            text_uz: "tadqiqotchi",
            text_en: "researcher",
            description: "She soon became a researcher herself."
          },
          {
            id: 81,
            key: "v",
            text_uz: "qayta o'rganish",
            text_en: "retrain",
            description: "I have been able to retrain as a landscape designer."
          },
          {
            id: 82,
            key: "n",
            text_uz: "qoida",
            text_en: "rule",
            description: "We have to obey the rules."
          },
          {
            id: 83,
            key: "n",
            text_uz: "maktabni tugatganligi to'g'risida shahodatnoma",
            text_en: "school leaver's certificate",
            description: "Applicants should have at least a school leaver's certificate."
          },
          {
            id: 84,
            key: "n",
            text_uz: "kasallik ta'til uchun to'lov",
            text_en: "sick holiday pay",
            description: "I get sick pay and holiday pay and plenty of time off. "
          },
          {
            id: 85,
            key: "adj",
            text_uz: "tajribali",
            text_en: "skilled",
            description: "The work available is mainly skilled work."
          },
          {
            id: 86,
            key: "n",
            text_uz: "mutaxassis",
            text_en: "specialist",
            description: "Some French education specialists recently put on a festival in Paris to encourage children to make mistakes!"
          },
          {
            id: 87,
            key: "n",
            text_uz: "turmush darajasi",
            text_en: "standard of living",
            description: "They are searching for a higher standard of living."
          },
          {
            id: 88,
            key: "n",
            text_uz: "qolish",
            text_en: "stay",
            description: "Short stays with local families are included in the trip."
          },
          {
            id: 89,
            key: "adj",
            text_uz: "mos",
            text_en: "suited",
            description: "I believe I would be ideally suited to a management position in your company."
          },
          {
            id: 90,
            key: "v",
            text_uz: "nazorat qilish",
            text_en: "supervise",
            description: "Have you ever had a job where you had to supervise other employees?"
          },
          {
            id: 91,
            key: "phr",
            text_uz: "tavakkal qilmoq",
            text_en: "take risks",
            description: "People who like to take risks think creatively."
          },
          {
            id: 92,
            key: "adj",
            text_uz: "iste'dodli",
            text_en: "talented",
            description: "A talented musician, he began to learn piano aged five."
          },
          {
            id: 93,
            key: "adj",
            text_uz: "vaqtinchalik",
            text_en: "temporary",
            description: "Have you ever had a temporary job?"
          },
          {
            id: 94,
            key: "n",
            text_uz: "guruh sardori",
            text_en: "team leader",
            description: "Last month, I was working in a project team, and I didn't agree with the team leader about the time we needed to complete the project."
          },
          {
            id: 95,
            key: "adj",
            text_uz: "mulohazali",
            text_en: "thoughtful",
            description: "She is the most thoughtful person that I've ever known."
          },
          {
            id: 96,
            key: "phr",
            text_uz: "moziyga sayohat",
            text_en: "travel back in time",
            description: "My super power would be to travel back in time."
          },
          {
            id: 97,
            key: "adj",
            text_uz: "qimmatbaho",
            text_en: "treasured",
            description: "What is your most treasured possession?"
          },
          {
            id: 98,
            key: "adj",
            text_uz: "aql bovar qilmaydigan",
            text_en: "unbelievable",
            description: "His company is famous for its unbelievable failures."
          },
          {
            id: 99,
            key: "v",
            text_uz: "birlashtirmoq",
            text_en: "unite",
            description: "He co-founded an orchestra in order to unite Israeli and Arab musicians."
          },
          {
            id: 100,
            key: "adj",
            text_uz: "tajribasiz",
            text_en: "unskilled",
            description: "There's plenty of work, both unskilled and skilled."
          },
          {
            id: 101,
            key: "adj",
            text_uz: "zamonaviy",
            text_en: "up to date",
            description: "My business knowledge and IT skills are up to date."
          },
          {
            id: 102,
            key: "v",
            text_uz: "qadirlamoq",
            text_en: "value",
            description: "You should value your position in the company."
          },
          {
            id: 103,
            key: "n",
            text_uz: "viza",
            text_en: "visa",
            description: "It wasn't too difficult to get a visa."
          },
          {
            id: 104,
            key: "adj",
            text_uz: "yaxshi ma’lum, tanilgan",
            text_en: "well known",
            description: "He is also well known for his work with young people."
          },
          {
            id: 105,
            key: "n",
            text_uz: "hayrat",
            text_en: "wonder",
            description: "The activities in the week-long event showed the participants the wonder and pleasure of getting things wrong."
          },
          {
            id: 106,
            key: "n",
            text_uz: "ish tajribasi",
            text_en: "work experience",
            description: "With my work experience and skills, I believe I would be ideally suited to a management position in your company."
          },
          {
            id: 107,
            key: "n",
            text_uz: "ish sharoitlari",
            text_en: "working conditions",
            description: "The working conditions are much better at the moment than in Lisbon, where I'm from."
          },
          {
            id: 108,
            key: "n",
            text_uz: "ish vaqti",
            text_en: "working hours",
            description: "What are your usual working hours?"
          },
        ],
        unit8: [
          {
            "id": 1,
            "key": "adj",
            "text_uz": "faol",
            "text_en": "active",
            "description": "If people are active in work and free time, they'll probably be healthier."
          },
          {
            "id": 2,
            "key": "v",
            "text_uz": "moslashmoq",
            "text_en": "adapt",
            "description": "Some people have no problems adapting to different cultures."
          },
          {
            "id": 3,
            "key": "adj",
            "text_uz": "qo'rqqan",
            "text_en": "afraid",
            "description": "It's about learning to make the right choices, even if we are afraid."
          },
          {
            "id": 4,
            "key": "v",
            "text_uz": "qadrlamoq",
            "text_en": "appreciate",
            "description": "In the end, I came to appreciate Iceland's differences."
          },
          {
            "id": 5,
            "key": "adj",
            "text_uz": "mos, muvofiq",
            "text_en": "appropriate",
            "description": "Make sure you are wearing the appropriate clothes for the meeting."
          },
          {
            "id": 6,
            "key": "n",
            "text_uz": "tomoshabinlar",
            "text_en": "audience",
            "description": "She made appropriate eye-contact with the audience."
          },
          {
            "id": 7,
            "key": "adj",
            "text_uz": "muvozanatli",
            "text_en": "balanced",
            "description": "Danish people tend to eat a balanced diet and get plenty of physical exercise."
          },
          {
            "id": 8,
            "key": "phr",
            "text_uz": "qodir bo'lmoq",
            "text_en": "be capable of",
            "description": "Researchers believe we are all capable of becoming heroes."
          },
          {
            "id": 9,
            "key": "adj",
            "text_uz": "jasur",
            "text_en": "brave",
            "description": "Do you think Clark was crazy or unusually brave?"
          },
          {
            "id": 10,
            "key": "phrv",
            "text_uz": "tarbiyalamoq",
            "text_en": "bring up",
            "description": "I must say they've definitely got some things right when it comes to bringing up children."
          },
          {
            "id": 11,
            "key": "n",
            "text_uz": "bezori",
            "text_en": "bully",
            "description": "If I were stronger, I would stop that bully!"
          },
          {
            "id": 12,
            "key": "adj",
            "text_uz": "yonayotgan",
            "text_en": "burning",
            "description": "A firefighter risks his/her life every day to save people from burning buildings."
          },
          {
            "id": 13,
            "key": "adj",
            "text_uz": "odatiy, erkin",
            "text_en": "casual",
            "description": "I had to replace my very casual clothes with some smarter ones."
          },
          {
            "id": 14,
            "key": "n",
            "text_uz": "bolalarni parvarish qilish",
            "text_en": "childcare",
            "description": "Denmark is a very family-friendly country, with free or very cheap childcare provided by the government."
          },
          {
            "id": 15,
            "key": "n",
            "text_uz": "yashash narxi",
            "text_en": "cost of living",
            "description": "The cost of living was another thing I quickly noticed."
          },
          {
            "id": 16,
            "key": "adj",
            "text_uz": "shinam",
            "text_en": "cosy",
            "description": "The winter may be cold and dark, but there is a special term 'hygge', to describe a kind of cosy meeting with friends and family."
          },
          {
            "id": 17,
            "key": "n",
            "text_uz": "hunar",
            "text_en": "craft",
            "description": "I suppose it's one of their traditional crafts."
          },
          {
            "id": 18,
            "key": "adj",
            "text_uz": "madaniy",
            "text_en": "cultural",
            "description": "Danes spend a lot of their leisure time socializing and enjoying cultural activities."
          },
          {
            "id": 19,
            "key": "n",
            "text_uz": "hayrat",
            "text_en": "culture shock",
            "description": "Since I moved to Iceland ten years ago, I've been through several different stages of culture shock."
          },
          {
            "id": 20,
            "key": "n",
            "text_uz": "kamchilik",
            "text_en": "disadvantage",
            "description": "List all of the advantages and disadvantages on a piece of paper."
          },
          {
            "id": 21,
            "key": "n",
            "text_uz": "falokat",
            "text_en": "disaster",
            "description": "Having been lucky enough to survive a disaster yourself makes you three times more likely to be a hero and a volunteer."
          },
          {
            "id": 22,
            "key": "n",
            "text_uz": "kiyinish qoidalari",
            "text_en": "dress code",
            "description": "Make sure you find out what the dress code is for the party."
          },
          {
            "id": 23,
            "key": "n",
            "text_uz": "iqtisodiyot",
            "text_en": "economy",
            "description": "What they do have is a strong economy."
          },
          {
            "id": 24,
            "key": "adj",
            "text_uz": "o'qimishli",
            "text_en": "educated",
            "description": "The more educated you are, the more likely you are to be a hero."
          },
          {
            "id": 25,
            "key": "adj",
            "text_uz": "xijolat bo'lgan",
            "text_en": "embarrassed",
            "description": "Women can be a bit embarrassed about their heroic actions."
          },
          {
            "id": 26,
            "key": "v",
            "text_uz": "portlash",
            "text_en": "explode",
            "description": "He rushed over to help, even though the plane was on fire and might explode any minute."
          },
          {
            "id": 27,
            "key": "adj",
            "text_uz": "nihoyatda",
            "text_en": "extremely",
            "description": "I was extremely embarrassed about it."
          },
          {
            "id": 28,
            "key": "n",
            "text_uz": "ko'z bilan aloqa qilish",
            "text_en": "eye contact",
            "description": "I made eye-contact with them immediately."
          },
          {
            "id": 29,
            "key": "n",
            "text_uz": "omil",
            "text_en": "factor",
            "description": "The third and last factor that affects our decision-making is the amount of information we have."
          },
          {
            "id": 30,
            "key": "n",
            "text_uz": "qo'rquv",
            "text_en": "fear",
            "description": "He's someone who is ready to do things that are dangerous without showing any fear."
          },
          {
            "id": 31,
            "key": "n",
            "text_uz": "o't o'chiruvchi",
            "text_en": "firefighter",
            "description": "If I were braver, I would be a firefighter."
          },
          {
            "id": 32,
            "key": "adj",
            "text_uz": "rasmiy",
            "text_en": "formal",
            "description": "In the UK, we rarely wear formal clothes when we aren't at work."
          },
          {
            "id": 33,
            "key": "n",
            "text_uz": "jins",
            "text_en": "gender",
            "description": "There's a difference with the genders when it comes to making decisions."
          },
          {
            "id": 34,
            "key": "adj",
            "text_uz": "saxiy",
            "text_en": "generous",
            "description": "Kind, generous people are more likely to be heroes."
          },
          {
            "id": 35,
            "key": "n",
            "text_uz": "daho",
            "text_en": "genius",
            "description": "Even a scientific genius like Charles Darwin is said to have used this method."
          },
          {
            "id": 36,
            "key": "phr",
            "text_uz": "hech qanday muammo yo'q",
            "text_en": "have no problems",
            "description": "Some people have no problems adapting to different cultures."
          },
          {
            "id": 37,
            "key": "n",
            "text_uz": "qahramon",
            "text_en": "hero",
            "description": "The more educated you are, the more likely you are to be a hero."
          },
          {
            "id": 38,
            "key": "adj",
            "text_uz": "mardlarcha, qahramonlarcha",
            "text_en": "heroic",
            "description": "One in five people has done something heroic."
          },
          {
            "id": 39,
            "key": "adv",
            "text_uz": "qahramonona, qahramonlarcha",
            "text_en": "heroically",
            "description": "Researchers at Berkeley University have spent the last five years studying what exactly makes people act heroically."
          },
          {
            "id": 40,
            "key": "n",
            "text_uz": "qahramonlik",
            "text_en": "heroism",
            "description": "Men reported heroism more than women."
          },
          {
            "id": 41,
            "key": "adj",
            "text_uz": "darhol, yaqin",
            "text_en": "immediate",
            "description": "Some Icelanders wear suits to meet their immediate family on important days of the year."
          },
          {
            "id": 42,
            "key": "n",
            "text_uz": "to'qish",
            "text_en": "knitting",
            "description": "They teach knitting in schools."
          },
          {
            "id": 43,
            "key": "n",
            "text_uz": "lotereya",
            "text_en": "lottery",
            "description": "If we won the lottery, we would give some money to charity."
          },
          {
            "id": 44,
            "key": "n",
            "text_uz": "usul",
            "text_en": "method",
            "description": "One common method is to make two lists on a piece of paper."
          },
          {
            "id": 45,
            "key": "v",
            "text_uz": "o'zini yomon tutmoq",
            "text_en": "misbehave",
            "description": "Parents can be very embarrassed if their children misbehave in public."
          },
          {
            "id": 46,
            "key": "v",
            "text_uz": "noto'g'ri baholash",
            "text_en": "misjudge",
            "description": "Once I completely misjudged the dress code when I was invited to a family meal."
          },
          {
            "id": 47,
            "key": "v",
            "text_uz": "noto'g'ri tushunish",
            "text_en": "misunderstand",
            "description": "If you move to a very different culture, people may easily misunderstand your behaviour."
          },
          {
            "id": 48,
            "key": "n",
            "text_uz": "qo'shni",
            "text_en": "neighbour",
            "description": "Danes use their extra leisure time to do voluntary work, helping their neighbours."
          },
          {
            "id": 49,
            "key": "v",
            "text_uz": "ortiqcha sarf qilish",
            "text_en": "overspend",
            "description": "I must be careful I don't overspend this month."
          },
          {
            "id": 50,
            "key": "n",
            "text_uz": "jismoniy faoliyat",
            "text_en": "physical activity",
            "description": "You'll be healthier if you have plenty of physical activity."
          },
          {
            "id": 51,
            "key": "n",
            "text_uz": "kambag'allik ",
            "text_en": "poverty",
            "description": "Denmark doesn't have much poverty."
          },
          {
            "id": 52,
            "key": "n",
            "text_uz": "bolalar aravachasi",
            "text_en": "pram",
            "description": "Look outside any café and you're likely to see lots of babies sleeping outside in prams."
          },
          {
            "id": 53,
            "key": "n",
            "text_uz": "jamoat transporti tizimi",
            "text_en": "public transport system",
            "description": "If there was a cheap and reliable public transport system, people would use their cars less."
          },
          {
            "id": 54,
            "key": "adv",
            "text_uz": "kamdan-kam hollarda ",
            "text_en": "rarely",
            "description": "Where I come from, we rarely do that."
          },
          {
            "id": 55,
            "key": "v",
            "text_uz": "qayta paydo bo'lmoq",
            "text_en": "reappear",
            "description": "The stars stop coming out at night and don't reappear until August."
          },
          {
            "id": 56,
            "key": "adj",
            "text_uz": "oqilona, asosli",
            "text_en": "reasonable",
            "description": "People tend to have more job satisfaction if they work reasonable hours."
          },
          {
            "id": 57,
            "key": "v",
            "text_uz": "qayta bezash",
            "text_en": "redecorate",
            "description": "When we moved into the new apartment, we completely redecorated it."
          },
          {
            "id": 58,
            "key": "adj",
            "text_uz": "qayta tiklanuvchi",
            "text_en": "renewable",
            "description": "Renewable energy comes from sources that will always exist."
          },
          {
            "id": 59,
            "key": "v",
            "text_uz": "qayta rejalashtirish",
            "text_en": "reschedule",
            "description": "The flight has to be rescheduled due to the bad weather."
          },
          {
            "id": 60,
            "key": "v",
            "text_uz": "qutqarmoq",
            "text_en": "rescue",
            "description": "He rushed over there immediately and started to rescue people."
          },
          {
            "id": 61,
            "key": "v",
            "text_uz": "tavakkal qilmoq",
            "text_en": "risk",
            "description": "If you saw a crash, would you risk your life to help?"
          },
          {
            "id": 62,
            "key": "adj",
            "text_uz": "tavakkal, xavfli",
            "text_en": "risky",
            "description": "I wouldn't do a job if it was risky or dangerous."
          },
          {
            "id": 63,
            "key": "adj",
            "text_uz": "xudbin",
            "text_en": "selfish",
            "description": "They have created an online course to train people to become less selfish and more heroic."
          },
          {
            "id": 64,
            "key": "adj",
            "text_uz": "oqil",
            "text_en": "sensible",
            "description": "She's a very sensible person."
          },
          {
            "id": 65,
            "key": "n",
            "text_uz": "jamiyat",
            "text_en": "society",
            "description": "Denmark is also a very equal society."
          },
          {
            "id": 66,
            "key": "adv",
            "text_uz": "ta'sirli",
            "text_en": "spectacularly",
            "description": "I must say, it did look spectacularly beautiful."
          },
          {
            "id": 67,
            "key": "phrv",
            "text_uz": "tunni uxlamasdan o'tkazmoq",
            "text_en": "stay up",
            "description": "It was really exciting to stay up with my friends, having meals outside in the middle of the night."
          },
          {
            "id": 68,
            "key": "v",
            "text_uz": "aziyat chekmoq",
            "text_en": "suffer",
            "description": "Some people who move to another country suffer from culture shock."
          },
          {
            "id": 69,
            "key": "n",
            "text_uz": "super yulduz",
            "text_en": "superstar",
            "description": "Sometimes a superstar makes a smaller country more famous."
          },
          {
            "id": 70,
            "key": "v",
            "text_uz": "chala pishirmoq",
            "text_en": "undercook",
            "description": "I sent the steak back because it was undercooked - in fact, it was almost raw."
          },
          {
            "id": 71,
            "key": "v",
            "text_uz": "oddiy kiyingan",
            "text_en": "underdressed",
            "description": "I felt extremely undressed!"
          },
          {
            "id": 72,
            "key": "v",
            "text_uz": "ko'ngilli bo'lib chiqish",
            "text_en": "volunteer",
            "description": "One third of the heroes in the study had also volunteered up to 59 hours a week."
          },
          {
            "id": 73,
            "key": "n",
            "text_uz": "ko'ngilli",
            "text_en": "volunteer",
            "description": "Having been lucky enough to survive a disaster yourself makes you three times more likely to be a hero and a volunteer."
          }
        ],
        unit9: [
          {
            "id": 1,
            "key": "adj",
            "text_uz": "mavhum",
            "text_en": "abstract",
            "description": "The abstract painting is very modern."
          },
          {
            "id": 2,
            "key": "n",
            "text_uz": "orqa fon",
            "text_en": "background",
            "description": "The background of the picture is really detailed."
          },
          {
            "id": 3,
            "key": "n",
            "text_uz": "chiroy, go'zallik",
            "text_en": "beauty",
            "description": "Although the campaign is selling beauty, I think the advert is better than adverts that make women feel bad about themselves."
          },
          {
            "id": 4,
            "key": "n",
            "text_uz": "qushlarni kuzatish",
            "text_en": "bird-watching",
            "description": "Jon took up bird-watching in his teens."
          },
          {
            "id": 5,
            "key": "n",
            "text_uz": "tomchi, kichik shar",
            "text_en": "blob",
            "description": "We try to find meaning and patterns in chance lines, blobs and colours."
          },
          {
            "id": 6,
            "key": "adj",
            "text_uz": "mallasoch",
            "text_en": "blond(e)",
            "description": "She's got short blonde hair."
          },
          {
            "id": 7,
            "key": "adj",
            "text_uz": "soqoli silliq olingan",
            "text_en": "clean-shaven",
            "description": "He's clean-shaven."
          },
          {
            "id": 8,
            "key": "adj",
            "text_uz": "yopiq, sovuq (inson yuzini tasvirlashda)",
            "text_en": "closed off",
            "description": "One woman described her face as 'a lot more closed off, and fatter, sadder too'."
          },
          {
            "id": 9,
            "key": "phrv",
            "text_uz": "kelmoq",
            "text_en": "come across",
            "description": "I came across a website called 'Houses that look like faces'. Scientists have come up with various ideas to explain it."
          },
          {
            "id": 10,
            "key": "adj",
            "text_uz": "jingalak",
            "text_en": "curly",
            "description": "She's got short curly hair."
          },
          {
            "id": 11,
            "key": "n",
            "text_uz": "parda",
            "text_en": "curtain",
            "description": "He was hidden behind a curtain."
          },
          {
            "id": 12,
            "key": "n",
            "text_uz": "egri, egilgan",
            "text_en": "curve",
            "description": "Look at the curves of the lines in the painting."
          },
          {
            "id": 13,
            "key": "n",
            "text_uz": "ma'lumotlar bazasi",
            "text_en": "database",
            "description": "A German design studio is making a database of such faces."
          },
          {
            "id": 14,
            "key": "n",
            "text_uz": "tavsif",
            "text_en": "description",
            "description": "The sketches were done from the women's descriptions of themselves."
          },
          {
            "id": 15,
            "key": "adj",
            "text_uz": "batafsil",
            "text_en": "detailed",
            "description": "I love the painting because it's so detailed."
          },
          {
            "id": 16,
            "key": "v",
            "text_uz": "bag'ishlamoq",
            "text_en": "devote",
            "description": "There are websites devoted to all kinds of objects."
          },
          {
            "id": 17,
            "key": "n",
            "text_uz": "qo'sh baqbaqa",
            "text_en": "double chin",
            "description": "He's got a bit of a double chin."
          },
          {
            "id": 18,
            "key": "v",
            "text_uz": "bo'yamoq",
            "text_en": "dye",
            "description": "Her hair might be dyed."
          },
          {
            "id": 19,
            "key": "n",
            "text_uz": "hissiyot",
            "text_en": "emotion",
            "description": "The houses seemed to express emotions as well."
          },
          {
            "id": 20,
            "key": "v",
            "text_uz": "ifodalamoq",
            "text_en": "express",
            "description": "Not only did the houses look like faces, but they seemed to express emotions as well."
          },
          {
            "id": 21,
            "key": "n",
            "text_uz": "qosh",
            "text_en": "eyebrow",
            "description": "He's got quite thick eyebrows."
          },
          {
            "id": 22,
            "key": "n",
            "text_uz": "kiprik",
            "text_en": "eyelash",
            "description": "She's got long eyelashes."
          },
          {
            "id": 23,
            "key": "n",
            "text_uz": "old ko'rinish",
            "text_en": "foreground",
            "description": "The woman is in the foreground of the picture."
          },
          {
            "id": 24,
            "key": "phr",
            "text_uz": "kal bo'lish",
            "text_en": "go bald",
            "description": "He's going bald."
          },
          {
            "id": 25,
            "key": "adj",
            "text_uz": "kulrang",
            "text_en": "grey",
            "description": "He's got grey hair."
          },
          {
            "id": 26,
            "key": "adj",
            "text_uz": "tarixiy",
            "text_en": "historical",
            "description": "It must be either an old painting or a painting of a historical scene."
          },
          {
            "id": 27,
            "key": "adj",
            "text_uz": "ochig'i, rosti",
            "text_en": "honestly",
            "description": "They were asked to describe their own faces, honestly, to a complete stranger."
          },
          {
            "id": 28,
            "key": "v",
            "text_uz": "ov qilmoq",
            "text_en": "hunt",
            "description": "I think they might be going out to hunt."
          },
          {
            "id": 29,
            "key": "adj",
            "text_uz": "g'azablangan",
            "text_en": "irritated",
            "description": "Some looked a bit irritated."
          },
          {
            "id": 30,
            "key": "phr",
            "text_uz": "intizorlik bilan kutmoq",
            "text_en": "look forward to",
            "description": "I'm looking forward to the party."
          },
          {
            "id": 58,
            "key": "phr",
            "text_uz": "(kitobda) qidirmoq",
            "text_en": "look up",
            "description": "We looked up the word in the dictionary."
          },
          {
            "id": 31,
            "key": "phrv",
            "text_uz": "tanimoq, ilg'ab olmoq",
            "text_en": "make out",
            "description": "We can't help making out faces where there aren't any."
          },
          {
            "id": 32,
            "key": "adj",
            "text_uz": "mo'ylov",
            "text_en": "moustache",
            "description": "He's got a bit of a moustache."
          },
          {
            "id": 33,
            "key": "adj",
            "text_uz": "sirli",
            "text_en": "mysterious",
            "description": "It's really mysterious."
          },
          {
            "id": 34,
            "key": "adj",
            "text_uz": "ortiqcha vaznli, semiz",
            "text_en": "overweight",
            "description": "It can't be a modern painting; it looks too old-fashioned. He's possibly a bit overweight."
          },
          {
            "id": 35,
            "key": "n",
            "text_uz": "g'ayrioddiy hodisa",
            "text_en": "phenomenon",
            "description": "I did some research and found out that this phenomenon is called pareidolia."
          },
          {
            "id": 36,
            "key": "n",
            "text_uz": "surat",
            "text_en": "portrait",
            "description": "It can't be a portrait of a mandrill."
          },
          {
            "id": 37,
            "key": "n",
            "text_uz": "surat proyektor",
            "text_en": "projector",
            "description": "We had to put off the meeting because the projector broke down."
          },
          {
            "id": 38,
            "key": "phrv",
            "text_uz": "osmoq, qo'ymoq",
            "text_en": "put up",
            "description": "Images have been put up on a wall."
          },
          {
            "id": 39,
            "key": "v",
            "text_uz": "aks etmoq",
            "text_en": "reflect",
            "description": "I think it must be a mirror. It's reflecting the sea."
          },
          {
            "id": 40,
            "key": "n",
            "text_uz": "aks",
            "text_en": "reflection",
            "description": "It must be a mirror; I can see the reflection of her face."
          },
          {
            "id": 41,
            "key": "v",
            "text_uz": "tuyilmoq",
            "text_en": "seem",
            "description": "It seems to be moving."
          },
          {
            "id": 42,
            "key": "adv",
            "text_uz": "aftidan, chamasi",
            "text_en": "seemingly",
            "description": "She was seemingly calm when she took her driving test."
          },
          {
            "id": 43,
            "key": "adj",
            "text_uz": "o'z o'zini ta'riflagan",
            "text_en": "self-described",
            "description": "Looking at her self-described portrait, one woman described her face as 'a lot more closed off and fatter, sadder, too'."
          },
          {
            "id": 44,
            "key": "adj",
            "text_uz": "yelka uzunligida",
            "text_en": "shoulder-length",
            "description": "His hair is shoulder-length and dark brown."
          },
          {
            "id": 45,
            "key": "phr",
            "text_uz": "yonma-yon",
            "text_en": "side by side",
            "description": "He put the two sketches side by side."
          },
          {
            "id": 46,
            "key": "v",
            "text_uz": "konki uchmoq",
            "text_en": "skate",
            "description": "The river must be frozen over, because they're skating on it."
          },
          {
            "id": 47,
            "key": "n",
            "text_uz": "chizg'i, andoza",
            "text_en": "sketch",
            "description": "They had sketches done of themselves."
          },
          {
            "id": 48,
            "key": "adj",
            "text_uz": "nozik",
            "text_en": "slim",
            "description": "I think she's quite slim."
          },
          {
            "id": 49,
            "key": "adj",
            "text_uz": "tikanli, qirrali",
            "text_en": "spiky",
            "description": "He's got spiky hair."
          },
          {
            "id": 50,
            "key": "n",
            "text_uz": "notanish",
            "text_en": "stranger",
            "description": "They were later asked to go into a room and describe their own faces, honestly, to a complete stranger."
          },
          {
            "id": 51,
            "key": "n",
            "text_uz": "biroz sogolli (soqol olingandan keyin biroz o'sgani)",
            "text_en": "stubble",
            "description": "He's got stubble."
          },
          {
            "id": 52,
            "key": "v",
            "text_uz": "mos kelmoq",
            "text_en": "suit",
            "description": "We need to dress to suit where we work."
          },
          {
            "id": 53,
            "key": "n",
            "text_uz": "jo'mrak",
            "text_en": "tap",
            "description": "Taps, teapots, tape recorders - it seems as if we can't help making out faces where there aren't any."
          },
          {
            "id": 54,
            "key": "n",
            "text_uz": "magnitofon",
            "text_en": "tape recorder",
            "description": "As well as taps and teapots, there are even tape recorders that resemble faces."
          },
          {
            "id": 55,
            "key": "n",
            "text_uz": "choynak",
            "text_en": "teapot",
            "description": "This teapot resembles a face."
          },
          {
            "id": 56,
            "key": "v",
            "text_uz": "kiymoq",
            "text_en": "wear",
            "description": "Rules about what we wear have changed so much in the last few years."
          },
          {
            "id": 57,
            "key": "adj",
            "text_uz": "baquvvat",
            "text_en": "well-built",
            "description": "He's quite well-built."
          }
        ],
        unit10: [
          {
            "id": 1,
            "key": "n",
            "text_uz": "serob, ko'p",
            "text_en": "abundance",
            "description": "In the past, most visitors explored the city's abundance of historic buildings."
          },
          {
            "id": 2,
            "key": "adv",
            "text_uz": "akademik jihatdan",
            "text_en": "academically",
            "description": "There are plenty of children who don't do well academically, who are brilliant at sports."
          },
          {
            "id": 3,
            "key": "n",
            "text_uz": "atlet, sportchi",
            "text_en": "athlete",
            "description": "Is the noise of their supporters always a positive thing for players or athletes? Not necessarily."
          },
          {
            "id": 4,
            "key": "n",
            "text_uz": "diqqatga sazovor joy",
            "text_en": "attraction",
            "description": "It is one of the most important attractions in the city."
          },
          {
            "id": 5,
            "key": "v",
            "text_uz": "qo'llab quvvatlamoq",
            "text_en": "back",
            "description": "They are going to back the project and become an investor."
          },
          {
            "id": 6,
            "key": "n",
            "text_uz": "bank qarzi",
            "text_en": "bank loan",
            "description": "We had to take out a bank loan to pay for it."
          },
          {
            "id": 7,
            "key": "n",
            "text_uz": "butik mehmonxona",
            "text_en": "boutique hotel",
            "description": "The old buildings were turned into boutique hotels."
          },
          {
            "id": 8,
            "key": "phr",
            "text_uz": "record o'rnatmoq",
            "text_en": "break a record",
            "description": "It is also hoped that the new plans will help Britain to break more records in future Olympic Games."
          },
          {
            "id": 9,
            "key": "n",
            "text_uz": "qo'llab quvvatlash guruhi",
            "text_en": "cheerleading",
            "description": "Cheerleading is very popular in American schools."
          },
          {
            "id": 10,
            "key": "v",
            "text_uz": "bellashmoq",
            "text_en": "compete",
            "description": "Winning teams will compete in 60 county finals before going on to a national final."
          },
          {
            "id": 11,
            "key": "adj",
            "text_uz": "raqobatbardosh",
            "text_en": "competitive",
            "description": "Schools have been avoiding competitive sports."
          },
          {
            "id": 12,
            "key": "n",
            "text_uz": "guruh bo'lib biror biznesga sarmoya kiritmoq",
            "text_en": "crowd-funding",
            "description": "Together with Yancey Strickler and Charles Adler, he started up Kickstarter, a crowd-funding website."
          },
          {
            "id": 13,
            "key": "n",
            "text_uz": "raqs",
            "text_en": "dancing",
            "description": "As well as yoga and trampolining, dancing is one of the activities offered at our school."
          },
          {
            "id": 14,
            "key": "n",
            "text_uz": "10 yillik",
            "text_en": "decade",
            "description": "In the past decades, development has dramatically changed many parts of the city."
          },
          {
            "id": 15,
            "key": "n",
            "text_uz": "manzil, belgilangan joy",
            "text_en": "destination",
            "description": "In 2014 the city was voted the world's top destination in Trip Advisor's Travellers Choice Awards."
          },
          {
            "id": 16,
            "key": "n",
            "text_uz": "tuman",
            "text_en": "district",
            "description": "It is starting to resemble Manhattan in some districts where modern skyscrapers are rapidly being built."
          },
          {
            "id": 17,
            "key": "adv",
            "text_uz": "keskin",
            "text_en": "dramatically",
            "description": "Development has dramatically changed many parts of the city."
          },
          {
            "id": 18,
            "key": "v",
            "text_uz": "ustuvorlik qilish",
            "text_en": "dominate",
            "description": "The skyline is dominated by skyscrapers."
          },
          {
            "id": 19,
            "key": "n",
            "text_uz": "quloqni to'suvchi tiqin",
            "text_en": "earplug",
            "description": "There are two holes which are located near your ears so you can put in ear-plugs."
          },
          {
            "id": 20,
            "key": "n",
            "text_uz": "tadbirkor",
            "text_en": "entrepreneur",
            "description": "For entrepreneurs who find themselves short of cash, it's a great way to get funding."
          },
          {
            "id": 21,
            "key": "n",
            "text_uz": "tadbir, xodisa",
            "text_en": "event",
            "description": "Why do we go to big events such as music festivals?"
          },
          {
            "id": 22,
            "key": "adj",
            "text_uz": "zamonaviy",
            "text_en": "fashionable",
            "description": "Istanbul is becoming just as well known for its modern galleries, designer shops and fashionable restaurants."
          },
          {
            "id": 23,
            "key": "n",
            "text_uz": "soha",
            "text_en": "field",
            "description": "We've had lots of emails from people in all different kinds of fields saying that they have found it useful."
          },
          {
            "id": 24,
            "key": "n",
            "text_uz": "raqam, son, shakl",
            "text_en": "figure",
            "description": "Recent figures show that more and more children are overweight."
          },
          {
            "id": 25,
            "key": "n",
            "text_uz": "kafolat",
            "text_en": "guarantee",
            "description": "They won't give any guarantee that the new business will make a profit."
          },
          {
            "id": 26,
            "key": "phr",
            "text_uz": "tushunchaga ega bo'lmoq",
            "text_en": "have a clue (about) ",
            "description": "I haven't got a clue about racing."
          },
          {
            "id": 27,
            "key": "phr",
            "text_uz": "tuyulmoq",
            "text_en": "have a feeling",
            "description": "I have a feeling this holiday will be a mistake."
          },
          {
            "id": 28,
            "key": "phr",
            "text_uz": "sinab ko'rmoq, urinib ko'rmoq",
            "text_en": "have a go",
            "description": "It's a bit difficult at first, but just have a go."
          },
          {
            "id": 29,
            "key": "n",
            "text_uz": "mahalliy stadion",
            "text_en": "home stadium",
            "description": "Sporting teams always prefer to play in their home stadium."
          },
          {
            "id": 30,
            "key": "n",
            "text_uz": "mahalliy jamoa",
            "text_en": "home team",
            "description": "The home team really does have an advantage."
          },
          {
            "id": 31,
            "key": "n",
            "text_uz": "sarmoya",
            "text_en": "investment",
            "description": "There's always the possibility that their investment will increase in value."
          },
          {
            "id": 32,
            "key": "n",
            "text_uz": "sarmoyador",
            "text_en": "investor",
            "description": "Anyone who wants to back their projects can become an investor."
          },
          {
            "id": 33,
            "key": "adj",
            "text_uz": "hashamatli, muhtasham",
            "text_en": "magnificent",
            "description": "Istanbul was traditionally famous for its magnificent ancient sights."
          },
          {
            "id": 34,
            "key": "v",
            "text_uz": "ishlab chiqarmoq",
            "text_en": "manufacture",
            "description": "More are currently being manufactured."
          },
          {
            "id": 35,
            "key": "adj",
            "text_uz": "ko'rishga arzigulik",
            "text_en": "must-see",
            "description": "Compared to 20 years ago, the city's list of must-see attractions has also changed."
          },
          {
            "id": 36,
            "key": "n",
            "text_uz": "tungi klub",
            "text_en": "nightclub",
            "description": "There are lots of nightclubs in the city."
          },
          {
            "id": 37,
            "key": "adj",
            "text_uz": "noraqobatbardosh",
            "text_en": "non-competitive",
            "description": "Yoga, dancing and cheerleading are all examples of non-competitive sports."
          },
          {
            "id": 38,
            "key": "adj",
            "text_uz": "ochiq havodagi",
            "text_en": "open-air",
            "description": "It is the biggest open-air shopping centre in the UK."
          },
          {
            "id": 39,
            "key": "adj",
            "text_uz": "to'ldirilgan",
            "text_en": "padded",
            "description": "The 'Ostrich Pillow' is a kind of padded hat."
          },
          {
            "id": 40,
            "key": "v",
            "text_uz": "pul kiritmoq",
            "text_en": "pledge",
            "description": "People have pledged $195,094."
          },
          {
            "id": 41,
            "key": "n",
            "text_uz": "mashhurlik, shuhrat",
            "text_en": "popularity",
            "description": "It is growing in popularity in countries like the United States, Switzerland and Canada."
          },
          {
            "id": 42,
            "key": "v",
            "text_uz": "taqdim qilmoq",
            "text_en": "present",
            "description": "First of all, you need to present your idea to the bank."
          },
          {
            "id": 43,
            "key": "adj",
            "text_uz": "foyda",
            "text_en": "profit",
            "description": "How much profit did they make on the business?"
          },
          {
            "id": 44,
            "key": "v",
            "text_uz": "boshga kiyish",
            "text_en": "pull (over)",
            "description": "It's a padded hat that people can pull over their heads to take а nар."
          },
          {
            "id": 45,
            "key": "v",
            "text_uz": "to'plamoq, yig'moq",
            "text_en": "raise",
            "description": "He couldn't raise the money he needed."
          },
          {
            "id": 46,
            "key": "n",
            "text_uz": "hakam",
            "text_en": "referee",
            "description": "The biggest impact of the crowd is not on the players, but on the referees."
          },
          {
            "id": 47,
            "key": "v",
            "text_uz": "yangilash",
            "text_en": "renovate",
            "description": "The rundown buildings in many areas were renovated."
          },
          {
            "id": 48,
            "key": "v",
            "text_uz": "o'xshamoq",
            "text_en": "resemble",
            "description": "There are websites devoted to all kinds of objects that resemble faces.."
          },
          {
            "id": 49,
            "key": "n",
            "text_uz": "g'alayon, isyon",
            "text_en": "riot",
            "description": "TThe audience got out of control and the concert turned into a riot."
          },
          {
            "id": 50,
            "key": "n",
            "text_uz": "regbi",
            "text_en": "rugby",
            "description": "Schools will play against each other in an Olympic-style event, with sports such as football, athletics, rugby, swimming, tennis and cycling."
          },
          {
            "id": 51,
            "key": "adj",
            "text_uz": "eski, haroba",
            "text_en": "run-down",
            "description": "The run-down buildings in many areas were renovated and turned into boutique hotels and trendy cafés."
          },
          {
            "id": 52,
            "key": "n",
            "text_uz": "hamiyat, g'urur",
            "text_en": "self-esteem",
            "description": "We have to realize that taking part in competitive sport is not bad for people's self-esteem."
          },
          {
            "id": 53,
            "key": "n",
            "text_uz": "xizmat",
            "text_en": "service",
            "description": "Please give me some details about the product or service you are offering."
          },
          {
            "id": 54,
            "key": "phr",
            "text_uz": "nagd pul yetishmovchiligi",
            "text_en": "short of cash",
            "description": "For entrepreneurs who find themselves short of cash, it's a great way to get funding."
          },
          {
            "id": 55,
            "key": "phrv",
            "text_uz": "boshlamoq, o'rnatmoq",
            "text_en": "set up",
            "description": "Anyone who wants to set up a business can present their idea on the website."
          },
          {
            "id": 56,
            "key": "n",
            "text_uz": "osmon chizig'i",
            "text_en": "skyline",
            "description": "The skyline was dominated by historic buildings and monuments."
          },
          {
            "id": 57,
            "key": "adj",
            "text_uz": "murakkab, hashamdor",
            "text_en": "sophisticated",
            "description": "The neighbourhood is now home to sophisticated nightclubs."
          },
          {
            "id": 58,
            "key": "adj",
            "text_uz": "eng songgi, o'ta zamonaviy",
            "text_en": "state of the art",
            "description": "The warehouse is now a state-of-the-art gallery."
          },
          {
            "id": 59,
            "key": "phr",
            "text_uz": "qaror qabul qilmoq",
            "text_en": "take a decision",
            "description": "It's very important to take the right decision."
          },
          {
            "id": 60,
            "key": "phr",
            "text_uz": "tavakkal qilmoq",
            "text_en": "take a risk",
            "description": "Don't take a risk - it's not worth it."
          },
          {
            "id": 61,
            "key": "phr",
            "text_uz": "e'tiborga olmaslik",
            "text_en": "take no notice of (someone/something)",
            "description": "Take no notice of him - he's being silly."
          },
          {
            "id": 62,
            "key": "phr",
            "text_uz": "gapiga ishonmoq",
            "text_en": "take (someone's) word for it",
            "description": "I'll take your word for it, since I don't know much about it!"
          },
          {
            "id": 63,
            "key": "phr",
            "text_uz": "biror nimani jiddiy qabul qilmoq",
            "text_en": "take (something/someone) seriously",
            "description": "I just can't take Paul seriously."
          },
          {
            "id": 64,
            "key": "phr",
            "text_uz": "vaziyatdan foydalanmoq",
            "text_en": "take advantage of",
            "description": "We've decided to take advantage of the warm weather."
          },
          {
            "id": 65,
            "key": "phr",
            "text_uz": "g'amxo'rlik qilmoq",
            "text_en": "take care of",
            "description": "She's the nurse who takes care of my grandmother."
          },
          {
            "id": 66,
            "key": "phrv",
            "text_uz": "chiqarib olmoq",
            "text_en": "take out",
            "description": "You will need to take out a bank loan to pay for it."
          },
          {
            "id": 67,
            "key": "phr",
            "text_uz": "galma-gal",
            "text_en": "take turns",
            "description": "Sometimes we'll buy street food, and the rest of the time we're planning to take turns to cook in the evenings."
          },
          {
            "id": 68,
            "key": "adj",
            "text_uz": "hayajonli",
            "text_en": "thrilling",
            "description": "It is a thrilling mixture of soccer, volleyball and gymnastics."
          },
          {
            "id": 69,
            "key": "n",
            "text_uz": "musobaqa",
            "text_en": "tournament",
            "description": "The government has announced that highly competitive sports days and tournaments are to be re-introduced at schools."
          },
          {
            "id": 70,
            "key": "n",
            "text_uz": "batutda sakrash",
            "text_en": "trampolining",
            "description": "Our school avoids competitive sports and has introduced activities such as dancing and trampolining."
          },
          {
            "id": 71,
            "key": "adj",
            "text_uz": "urfda, zamonaviy",
            "text_en": "trendy",
            "description": "Some of the buildings are now trendy cafés."
          },
          {
            "id": 72,
            "key": "phr",
            "text_uz": "eshitilmagan",
            "text_en": "unheard of",
            "description": "Almost unheard of in Europe, sepak takraw is an extremely popular sport throughout East Asia."
          },
          {
            "id": 73,
            "key": "adj",
            "text_uz": "haqiqatdan yiroq",
            "text_en": "unrealistic",
            "description": "It's just unrealistic for children to be told that everyone can win."
          },
          {
            "id": 74,
            "key": "adj",
            "text_uz": "jonli, zavqli",
            "text_en": "vibrant",
            "description": "Istanbul is now one of Europe's most popular and vibrant cities."
          }
        ],
        unit11: [
          {
            id: 1,
            key: "v",
            text_uz: "hibsga olmoq",
            text_en: "arrest",
            description: "The police are close to arresting him."
          },
          {
            id: 2,
            key: "n",
            text_uz: "bandit/ bosqinchi",
            text_en: "bandit",
            description: "They call him the 'barefoot bandit'."
          },
          {
            id: 3,
            key: "adj",
            text_uz: "yalangoyoq",
            text_en: "barefoot",
            description: "He's known as the 'barefoot bandit', as he often carries out his robberies with no shoes on."
          },
          {
            id: 4,
            key: "v",
            text_uz: "blog yozmoq",
            text_en: "blog",
            description: "It led to people blogging or tweeting about the issue."
          },
          {
            id: 5,
            key: "n",
            text_uz: "o'g'ri qulf-buzar",
            text_en: "burglar",
            description: "A burglar was caught on Friday night, after getting stuck in a bathroom window."
          },
          {
            id: 6,
            key: "n",
            text_uz: "o'g'rilik, qulf buzarlik",
            text_en: "burglary",
            description: "His burglaries have terrified local residents."
          },
          {
            id: 7,
            key: "n",
            text_uz: "nomzod",
            text_en: "candidate",
            description: "They should've given him the job anyway if he was the best candidate."
          },
          {
            id: 8,
            key: "v",
            text_uz: "qo'lga olish/ qo'lga tushirish",
            text_en: "capture",
            description: "The police have been trying to capture 19-year-old Cotton Harris-Moore for nearly two years."
          },
          {
            id: 9,
            key: "adj",
            text_uz: "beparvo/ e'tiborsiz",
            text_en: "careless",
            description: "I thought it was very careless and unpleasant of him."
          },
          {
            id: 10,
            key: "v",
            text_uz: "almashtirmoq/ o'zgartirmoq",
            text_en: "change",
            description: "The school buildings have changed very little since I was at school."
          },
          {
            id: 11,
            key: "n",
            text_uz: "oqibat",
            text_en: "consequence",
            description: "The idea of unintended consequences is an important one in politics and economics."
          },
          {
            id: 12,
            key: "v",
            text_uz: "halokatli qo'nish",
            text_en: "crash-land",
            description: "That didn't stop him from crash-landing in the sea."
          },
          {
            id: 13,
            key: "n",
            text_uz: "jinoyatchi",
            text_en: "criminal",
            description: "There are examples of criminals who actually did some good."
          },
          {
            id: 14,
            key: "n",
            text_uz: "kiberhujum",
            text_en: "cyberbullying",
            description: "This can therefore result in a careless or unpleasant tweet, or at worst, cyberbullying."
          },
          {
            id: 15,
            key: "n",
            text_uz: "kechikmoq, keying surmoq",
            text_en: "delay",
            description: "I apologize for the delay in replying."
          },
          {
            id: 16,
            key: "v",
            text_uz: "qochmoq",
            text_en: "escape",
            description: "He escaped from prison."
          },
          {
            id: 17,
            key: "n",
            text_uz: "kengaytirish, yoyish",
            text_en: "extension",
            description: "It would have been better to ask for an extension earlier."
          },
          {
            id: 18,
            key: "n",
            text_uz: "jarima",
            text_en: "fine",
            description: "The doctor made the patients pay a fine if they missed an appointment."
          },
          {
            id: 19,
            key: "adv",
            text_uz: "noqonuniy",
            text_en: "illegally",
            description: "They entered the building illegally."
          },
          {
            id: 20,
            key: "n",
            text_uz: "noqulaylik",
            text_en: "inconvenience",
            description: "I apologize for the inconvenience."
          },
          {
            id: 21,
            key: "n",
            text_uz: "muammo, masala",
            text_en: "issue",
            description: "I have had some problems completing work in the last month due to family issues."
          },
          {
            id: 22,
            key: "v",
            text_uz: "haqorat qilmoq, tahqirlamoq",
            text_en: "insult",
            description: "They are more likely to insult each other when the communication is not face-to-face."
          },
          {
            id: 23,
            key: "n",
            text_uz: "o'zaro ta'sir",
            text_en: "interaction",
            description: "More than half of the 2,000 people surveyed said that they felt social media had replaced face-to-face interaction."
          },
          {
            id: 24,
            key: "n",
            text_uz: "chiroq",
            text_en: "light",
            description: "Please can you turn on the light. It's very dark in here."
          },
          {
            id: 25,
            key: "n",
            text_uz: "match",
            text_en: "match",
            description: "Are you going to watch the match this evening?"
          },
          {
            id: 26,
            key: "adj",
            text_uz: "jirkanch, yomon, yoqimsiz",
            text_en: "nasty",
            description: "More than a quarter (26%) admitted they have said something nasty on a social media website."
          },
          {
            id: 27,
            key: "n",
            text_uz: "jinoyatchi ",
            text_en: "outlaw",
            description: "The outlaw became an internet sensation."
          },
          {
            id: 28,
            key: "adj",
            text_uz: "jo'shqin, ehtirosli",
            text_en: "passionate",
            description: "They felt passionate about it."
          },
          {
            id: 29,
            key: "n",
            text_uz: "ruxsat, ijozat",
            text_en: "permission",
            description: "The DVDs were taken without permission."
          },
          {
            id: 30,
            key: "n",
            text_uz: "qamoqxona",
            text_en: "prison",
            description: "He is in prison."
          },
          {
            id: 31,
            key: "n",
            text_uz: "jazo",
            text_en: "punishment",
            description: "The court will decide on his punishment later today."
          },
          {
            id: 32,
            key: "v",
            text_uz: "afsuslanmoq",
            text_en: "regret",
            description: "More than a quarter of all users of Twitter and other social networking sites send messages they later regret."
          },
          {
            id: 33,
            key: "adv",
            text_uz: "xabarlarga ko'ra",
            text_en: "reportedly",
            description: "He had reportedly taught himself to fly, using information he found on the internet."
          },
          {
            id: 34,
            key: "v",
            text_uz: "o'g'irlamoq, talamoq",
            text_en: "rob",
            description: "They were planning to rob the bank."
          },
          {
            id: 35,
            key: "n",
            text_uz: "o'g'ri",
            text_en: "robber",
            description: "The robber is known to the police."
          },
          {
            id: 36,
            key: "phr",
            text_uz: "biror nimani yuziga aytmoq",
            text_en: "say to face",
            description: "Online, people are more likely to say something rude or nasty that they would never say to someone's face."
          },
          {
            id: 37,
            key: "n",
            text_uz: "olamshumul voqea",
            text_en: "sensation",
            description: "He became an internet sensation, with a Facebook fan page collecting thousands of 'likes'."
          },
          {
            id: 38,
            key: "v",
            text_uz: "mahkum qilmoq",
            text_en: "sentence",
            description: "He was sentenced to seven years in prison."
          },
          {
            id: 39,
            key: "adj",
            text_uz: "ortiqcha, zaxira, bo'sh",
            text_en: "spare",
            description: "I thought it would be good to offer her my spare ticket. "
          },
          {
            id: 40,
            key: "phr",
            text_uz: "o'z fikrini ayta olish",
            text_en: "speak up",
            description: "Nearly two in five people said they used social media to speak up about something."
          },
          {
            id: 41,
            key: "n",
            text_uz: "maydon, skver",
            text_en: "square",
            description: "Let's meet in the town square this afternoon."
          },
          {
            id: 42,
            key: "adj",
            text_uz: "o'g'irlangan",
            text_en: "stolen",
            description: "He escaped by flying a stolen plane all the way from Indiana to the Bahamas."
          },
          {
            id: 43,
            key: "phr",
            text_uz: "biror nimani qilishni to'xtatmoq",
            text_en: "stop from",
            description: "That didn't stop him from crash-landing in the sea."
          },
          {
            id: 44,
            key: "n",
            text_uz: "topshirish",
            text_en: "submission",
            description: "Please accept my apologies for the late submission of this term's work."
          },
          {
            id: 45,
            key: "v",
            text_uz: "gumon qilmoq",
            text_en: "suspect",
            description: "He is suspected of more than 100 thefts in the United States and Canada."
          },
          {
            id: 46,
            key: "n",
            text_uz: "o'g'irlik",
            text_en: "theft",
            description: "There have been a lot of thefts recently."
          },
          {
            id: 47,
            key: "n",
            text_uz: "o'g'ri",
            text_en: "thief",
            description: "The thief was caught by the police earlier this morning."
          },
          {
            id: 48,
            key: "adj",
            text_uz: "urf bo'lmagan",
            text_en: "unfashionable",
            description: "The problem is that wearing crash helmets is very 'uncool' or unfashionable."
          },
          {
            id: 49,
            key: "adj",
            text_uz: "kutilmagan, ko'zda tutilmagan",
            text_en: "unintended",
            description: "The idea of unintended consequences is an important one in politics and economics."
          },
          {
            id: 50,
            key: "adj",
            text_uz: "noprofessional",
            text_en: "unprofessional",
            description: "Now my boss thinks I'm really unprofessional."
          },
          {
            id: 51,
            key: "v",
            text_uz: "yuklamoq",
            text_en: "upload",
            description: "I was uploading a different video and accidentally clicked on this video, too."
          },
          {
            id: 52,
            key: "v",
            text_uz: "hafa qilmoq",
            text_en: "upset",
            description: "I didn't mean to upset you."
          },
          {
            id: 53,
            key: "n",
            text_uz: "jabrlanuvchi, qurbon",
            text_en: "victim",
            description: "None of his victims were actually injured."
          },
          {
            id: 54,
            key: "n",
            text_uz: "zo'ravonlik",
            text_en: "violence",
            description: "The thieves used unnecessary violence."
          },
        ],
        unit12: [
          {
            id: 1,
            key: "n",
            text_uz: "reklama, e'lon",
            text_en: "advert",
            description: "I think the most effective adverts are those that make people laugh."
          },
          {
            id: 2,
            key: "v",
            text_uz: "qiyoslamoq, bog'lamoq",
            text_en: "associate",
            description: "One tip for remembering a person's name is to look at their face and associate it with the name."
          },
          {
            id: 3,
            key: "n",
            text_uz: "e'lonlar taxtasi",
            text_en: "billboard",
            description: "Have you seen the new advertising billboards near the cinema?"
          },
          {
            id: 4,
            key: "n",
            text_uz: "mahsulot nomi",
            text_en: "brand",
            description: "She always buys the well-known brands."
          },
          {
            id: 5,
            key: "phr",
            text_uz: "ortidan ergashtirmoq",
            text_en: "bring round to",
            description: "You won't be successful in business if you can't bring people round to your way of thinking."
          },
          {
            id: 6,
            key: "n",
            text_uz: "kamchilik",
            text_en: "drawback",
            description: "Another drawback is the cost of production."
          },
          {
            id: 7,
            key: "adj",
            text_uz: "samarali",
            text_en: "effective",
            description: "What are the most effective adverts?"
          },
          {
            id: 8,
            key: "adj",
            text_uz: "uysiz",
            text_en: "homeless",
            description: "I saw an amazing ad to raise our awareness of the problems homeless people have."
          },
          {
            id: 9,
            key: "n",
            text_uz: "ko'rinish",
            text_en: "image",
            description: "I think this gives the companies a negative image."
          },
          {
            id: 10,
            key: "v",
            text_uz: "ta'sir o'tkazmoq",
            text_en: "influence",
            description: "Funny adverts can be a good way to influence people. Each product is recognized by its own logo."
          },

          {
            id: 11,
            key: "n",
            text_uz: "mahsulot belgisi",
            text_en: "logo",
            description: "Each product is recognized by its own logo."
          },
          {
            id: 12,
            key: "phr",
            text_uz: "xabardor qilmoq",
            text_en: "make aware of",
            description: "Adverts can make people aware of social issues."
          },
          {
            id: 13,
            key: "adj",
            text_uz: "asosiy",
            text_en: "major",
            description: "What do you think are the major advantages?"
          },
          {
            id: 14,
            key: "adj",
            text_uz: "esda qolarli",
            text_en: "memorable",
            description: "It's important to make sure our adverts are memorable."
          },
          {
            id: 15,
            key: "n",
            text_uz: "erkaklar kiyim do'koni",
            text_en: "menswear store",
            description: "I was in town recently in a menswear store."
          },
          {
            id: 16,
            key: "n",
            text_uz: "kuya kapalagi",
            text_en: "moth",
            description: "He saw a huge cloud of moths coming towards them. "
          },
          {
            id: 17,
            key: "n",
            text_uz: "muzokarachi",
            text_en: "negotiator",
            description: "With this book, you will become an amazing negotiator."
          },
          {
            id: 18,
            key: "n",
            text_uz: "yangiliklar kun tartibi",
            text_en: "news agenda",
            description: "France 24 online provides an alternative to the English- language dominated news agenda."
          },
          {
            id: 19,
            key: "n",
            text_uz: "e'tiroz, norozilik",
            text_en: "objection",
            description: "This book will help you to overcome objections."
          },
          {
            id: 20,
            key: "n",
            text_uz: "maqsad",
            text_en: "objective",
            description: "The main objectives of 'fast fashion' are to bring high-fashion clothes into the shops quickly and cheaply."
          },
          {
            id: 21,
            key: "v",
            text_uz: "ustun kelmoq, yengmoq",
            text_en: "overcome",
            description: "What do you think is the best way to overcome someone's objections to an idea?"
          },
          {
            id: 22,
            key: "phr",
            text_uz: "qonun qabul qilish",
            text_en: "pass a law",
            description: "The instructor told them that a new law had been passed."
          },
          {
            id: 23,
            key: "n",
            text_uz: "nuqtai nazar",
            text_en: "perspective",
            description: "The 226 Alliance Françaises and France 24 online provide news from a different perspective."
          },
          {
            id: 24,
            key: "n",
            text_uz: "ishontirish",
            text_en: "persuasion",
            description: "Philip is a full-time speaker on the psychology of persuasion. "
          },
          {
            id: 25,
            key: "adj",
            text_uz: "ishonarli, asosli",
            text_en: "persuasive",
            description: "It's a very persuasive advert."
          },
          {
            id: 26,
            key: "n",
            text_uz: "nazar, fikr, qarash",
            text_en: "point of view",
            description: "It's important that you understand the other person's point of view."
          },
          {
            id: 27,
            key: "n",
            text_uz: "afisha, e'lon",
            text_en: "poster",
            description: "Please can you put this poster up to advertise the concert?"
          },
          {
            id: 28,
            key: "n",
            text_uz: "psixologiya",
            text_en: "psychology",
            description: "Philip Hesketh is a full-time international business speaker on the psychology of persuasion."
          },
          {
            id: 29,
            key: "phr",
            text_uz: "suyanmoq, tayanmoq",
            text_en: "rely on",
            description: "They don't rely on radio stations to tell them what music they should listen to any more."
          },
          {
            id: 30,
            key: "n",
            text_uz: "shior, chaqiriq",
            text_en: "slogan",
            description: "What slogans can you remember?"
          },
          {
            id: 31,
            key: "n",
            text_uz: "nozik jihat, nozik qudrat",
            text_en: "soft power",
            description: "The Olympic Games can increase a country's soft power."
          },
          {
            id: 32,
            key: "adj",
            text_uz: "zamonaviy, ommaviy, uslubga mos",
            text_en: "stylish",
            description: "This particular model was never stylish! It's just awful."
          },
          {
            id: 33,
            key: "phrv",
            text_uz: "o'chirmoq (chiroq)",
            text_en: "switch off",
            description: "Maybe every moth in Australia was heading for their light because all the others had been switched off!"
          },
          {
            id: 34,
            key: "adj",
            text_uz: "xafa",
            text_en: "upset",
            description: "I was really upset when I saw this advert."
          },
          {
            id: 35,
            key: "phrv",
            text_uz: "o'z tomoniga og'dirmoq",
            text_en: "win over",
            description: "This book will help you find the perfect way to win people over."
          },
        ],
      },
      upperIntermediate: {
        unit1: [
          {
            id: 1,
            key: "v",
            text_uz: "moslashtirmoq",
            text_en: "adapt (to)",
            description: "The locals adapted the whistling language to Spanish."
          },
          {
            id: 2,
            key: "n",
            text_uz: "uzoq muddat, ancha vaqt",
            text_en: "ages",
            description: "It seems like ages since we were in touch."
          },
          {
            id: 3,
            key: "n",
            text_uz: "ilova, havola",
            text_en: "app",
            description: "I've downloaded a Spanish vocabulary app for extra practice."
          },
          {
            id: 4,
            key: "v",
            text_uz: "qadrlamoq, minnatdor bo'lmoq",
            text_en: "appreciate",
            description: "There is so much to appreciate when you receive a handwritten letter."
          },
          {
            id: 5,
            key: "v",
            text_uz: "hibsga olmoq",
            text_en: "arrest",
            description: "In the Phillipines, what can you be arrested for?"
          },
          {
            id: 6,
            key: "n",
            text_uz: "urinish",
            text_en: "attempt",
            description: "Several internet campaigns have sprung up in an attempt to save the art of letter-writing."
          },
          {
            id: 7,
            key: "adj",
            text_uz: "noqulay",
            text_en: "awkward",
            description: "Stand too close and you might make someone feel awkward."
          },
          {
            id: 8,
            key: "v",
            text_uz: "ta'qiqlamoq",
            text_en: "ban (from)",
            description: "Henry Ford banned his employees from whistling."
          },
          {
            id: 9,
            key: "phr",
            text_uz: "sabr qilmoq, chidamoq",
            text_en: "bear with",
            description: "Just bear with me a moment."
          },
          {
            id: 10,
            key: "n",
            text_uz: "qush sayrashi",
            text_en: "birdsong",
            description: "Lots of birdsong can be heard at dawn."
          },

          {
            id: 11,
            key: "n",
            text_uz: "blogger",
            text_en: "blogger",
            description: "Shaun Usher is a blogger who posts letters on his website."
          },
          {
            id: 12,
            key: "phr",
            text_uz: "yetib olmoq",
            text_en: "catch up",
            description: "It would be great if we could catch up properly soon."
          },
          {
            id: 13,
            key: "v",
            text_uz: "sabab bo'lmoq",
            text_en: "cause",
            description: "Getting these things wrong can cause offence."
          },
          {
            id: 14,
            key: "v",
            text_uz: "ilova qilish",
            text_en: "cc (somebody) into",
            description: "Can you cc somebody into a handwritten letter?"
          },
          {
            id: 15,
            key: "adj",
            text_uz: "maxfiy",
            text_en: "confidential",
            description: "If an email is confidential, you shouldn't share it with anyone."
          },
          {
            id: 16,
            key: "v",
            text_uz: "chalkashtirmoq, adashtirmoq",
            text_en: "confuse",
            description: "It's easy to confuse Silbo with birdsong."
          },
          {
            id: 17,
            key: "v",
            text_uz: "-dan iborat bo'lmoq, tarkib topmoq",
            text_en: "consist (of)",
            description: "Silbo consists of four vowels and four consonants."
          },
          {
            id: 18,
            key: "v",
            text_uz: "hissa qo'shmoq",
            text_en: "contribute (to)",
            description: "The development of mobile phones contributed to the decline of Silbo."
          },
          {
            id: 19,
            key: "phr",
            text_uz: "nusxa ko'chirmoq",
            text_en: "copy (somebody) in",
            description: "I copied you in on my email to him."
          },
          {
            id: 20,
            key: "n",
            text_uz: "yozishma",
            text_en: "correspondence",
            description: "What correspondence will we leave behind for future generations?"
          },
          {
            id: 21,
            key: "n",
            text_uz: "qamrov",
            text_en: "coverage",
            description: "In much of the island, you cannot depend on telephone coverage."
          },
          {
            id: 22,
            key: " phr",
            text_uz: "ustidan chizmoq",
            text_en: "cross out",
            description: "If you make a mistake, just cross it out."
          },
          {
            id: 23,
            key: "v",
            text_uz: "chashka shakliga keltirish",
            text_en: "cup",
            description: "One hand is cupped next to the mouth to control the whistle's direction."
          },
          {
            id: 24,
            key: "v",
            text_uz: "burmoq (barmoqni)",
            text_en: "curl",
            description: "The 'come here' sign is made by curling your finger towards you."
          },
          {
            id: 25,
            key: "v",
            text_uz: "o'chirib tashlamoq",
            text_en: "delete",
            description: "Texts and emails are quickly deleted, while letters stay around for longer."
          },
          {
            id: 26,
            key: " pr",
            text_uz: "yo'qolib bormoq",
            text_en: "die out",
            description: "If letters died out completely, that would be the greatest loss to our culture."
          },
          {
            id: 27,
            key: "n",
            text_uz: "raqamli axborot vositalari",
            text_en: "digital media",
            description: "With digital media, we write more than ever before."
          },
          {
            id: 28,
            key: "v",
            text_uz: "rad qilmoq, ma'qullamaslik",
            text_en: "disapprove (of)",
            description: "Spectators whistle when they disapprove of a referee's decision."
          },
          {
            id: 29,
            key: "phr",
            text_uz: "suhbatda ustunlik qilmoq",
            text_en: "dominate the conversation ",
            description: "I don't like the way she always dominates the conversation."
          },
          {
            id: 30,
            key: "n",
            text_uz: "kulgich",
            text_en: "emoticon",
            description: "We often use emoticons instead of expressing our feelings."
          },
          {
            id: 31,
            key: "adj",
            text_uz: "ko'ngil ochar",
            text_en: "entertaining",
            description: "We had an entertaining evening with our friends this weekend."
          },
          {
            id: 32,
            key: "v",
            text_uz: "o'rnatmoq, yo'lga qo'ymoq",
            text_en: "establish",
            description: "In conversations, we often try to establish shared interests."
          },
          {
            id: 33,
            key: "phr",
            text_uz: "yangilik almashish",
            text_en: "exchange news",
            description: "We can exchange news by email, text or letter."
          },
          {
            id: 34,
            key: "adj",
            text_uz: "g'ayrioddiy, notabily",
            text_en: "extraordinary",
            description: "Silbo is an extraordinary language which is whistled rather than spoken."
          },
          {
            id: 35,
            key: "n",
            text_uz: "imo-ishora",
            text_en: "gesture",
            description: "I'd like to talk about gestures - the signs we make with our hands."
          },
          {
            id: 36,
            key: "n",
            text_uz: "husnixat",
            text_en: "handwriting",
            description: "I've always had terrible handwriting."
          },
          {
            id: 37,
            key: "adj",
            text_uz: "qo'lda yozilgan",
            text_en: "handwritten",
            description: "The handwritten letter is in serious decline."
          },
          {
            id: 38,
            key: "phr",
            text_uz: "tushunmovchilik bo'lishi",
            text_en: "have a misunderstanding",
            description: "People from different cultures can have a misunderstanding if they don't know each other's rules of communication."
          },
          {
            id: 39,
            key: "phr",
            text_uz: "xafalashib qolmoqn",
            text_en: "have a row",
            description: "I don't want to have a row about the weather."
          },
          {
            id: 40,
            key: "v",
            text_uz: "(haqida) eshitmoq",
            text_en: "hear (of)",
            description: "Have you heard of Silbo Gomero?"
          },
          {
            id: 41,
            key: " phr",
            text_uz: "kim bilandir chiqishib ketmoq",
            text_en: "hit it off (with someone)",
            description: "Can you tell me about a person you hit it off with as soon as you met them?"
          },
          {
            id: 42,
            key: " n",
            text_uz: "taassurot",
            text_en: "impression",
            description: "When is it very important to make a good impression?"
          },
          {
            id: 43,
            key: "n",
            text_uz: "xujjatlar uchun idish (quti)",
            text_en: "in tray ",
            description: "Please put the letter in my in tray."
          },
          {
            id: 44,
            key: " n",
            text_uz: "kiruvchi xatlar",
            text_en: "inbox",
            description: "My inbox is too full - I need to delete some emails."
          },
          {
            id: 45,
            key: " adj",
            text_uz: "tezkor, bir onda sodir bo'ladigan",
            text_en: "instant",
            description: "Texts and emails allow for instant communication but are quickly deleted."
          },
          {
            id: 46,
            key: " v",
            text_uz: "xalaqit bermoq, bo'lib qo'ymoq",
            text_en: "interrupt",
            description: "For communication to be successful, we need to know if it's OK to interrupt a person."
          },
          {
            id: 47,
            key: " n",
            text_uz: "orolda istiqomat qiluvchi",
            text_en: "islander",
            description: "The islanders of La Gomera have been communicating with whistles for centuries."
          },
          {
            id: 48,
            key: " n",
            text_uz: "shahar telefoni",
            text_en: "landline",
            description: "Could you call me back on my landline?"
          },
          {
            id: 49,
            key: " v",
            text_uz: "sabab bo'lmoq,...ga olib kelmoq",
            text_en: "lead (to)",
            description: "Getting these things wrong can lead to misunderstandings. "
          },
          {
            id: 50,
            key: " n",
            text_uz: "tarmoq",
            text_en: "line",
            description: "Hold on, the line is breaking up."
          },
          {
            id: 51,
            key: "phr",
            text_uz: "qiziqish bilan tinglamoq",
            text_en: "listen enthusiastically",
            description: "It would be good if you tried to listen more enthusiastically in conversations."
          },
          {
            id: 52,
            key: "adj",
            text_uz: "omadli",
            text_en: "lucky",
            description: "If you're lucky, you'll hear the islanders whistle on La Gomera."
          },
          {
            id: 53,
            key: "phr",
            text_uz: "yaxshi taassurot qoldirmoq",
            text_en: "make a good impression",
            description: "You want to make a good impression in an interview."
          },
          {
            id: 54,
            key: "phr",
            text_uz: "kichik suhbat olib bormoq",
            text_en: "make small talk",
            description: "Could you tell me how easy you find it to make small talk?"
          },
          {
            id: 55,
            key: "n",
            text_uz: "tushunmovchilik",
            text_en: "misunderstanding",
            description: "Getting these things wrong can lead to misunderstandings."
          },
          {
            id: 56,
            key: "v",
            text_uz: "xafa qilmoq, ranjitmoq, haqorat qilmoq",
            text_en: "offend (someone)",
            description: "The weather is seen as a topic which is unlikely to offend anybody."
          },
          {
            id: 57,
            key: "phr",
            text_uz: "baxtdan sarxush bo'lmoq",
            text_en: "over the moon",
            description: "My sister and her husband are over the moon because they are having twins!"
          },
          {
            id: 58,
            key: "adj",
            text_uz: "dehqonlarga oid",
            text_en: "peasant",
            description: "Some locals think that Silbo is a peasant language that should be left to die out."
          },
          {
            id: 59,
            key: "n",
            text_uz: "pochta markasi",
            text_en: "postage stamp",
            description: "Do you know the cost of a postage stamp?"
          },
          {
            id: 60,
            key: "n",
            text_uz: "tinish belgilari",
            text_en: "punctuation",
            description: "Punctuation is important in written communication."
          },
          {
            id: 61,
            key: "phr",
            text_uz: "kimnidir xotirjam qilmoq",
            text_en: "put (someone) at ease",
            description: "My friend Marc is very good at putting people at ease in new situations."
          },
          {
            id: 62,
            key: "phr",
            text_uz: "noqulay ahvolga solmoq",
            text_en: "put your foot in it",
            description: "Can you remember a conversation when you put your foot in it?"
          },
          {
            id: 63,
            key: "n",
            text_uz: "jarlik, chuqurlik, dara",
            text_en: "ravine",
            description: "La Gomera's steep hills and deep ravines make it difficult to cross."
          },
          {
            id: 64,
            key: "v",
            text_uz: "sabab bo'lmoq",
            text_en: "result (in)",
            description: "In Russia it is believed that whistling indoors can result in bad luck."
          },
          {
            id: 65,
            key: "n",
            text_uz: "o'quv qurollari",
            text_en: "stationery",
            description: "Newspapers have reported a rise in stationery sales."
          },
          {
            id: 66,
            key: "adj",
            text_uz: "tik",
            text_en: "steep",
            description: "La Gomera has numerous steep hills."
          },
          {
            id: 67,
            key: "phrv",
            text_uz: "egallamoq (vaqtni)",
            text_en: "take up",
            description: "I won't take up any more of your time."
          },
          {
            id: 68,
            key: "phr",
            text_uz: "ko'ngilochar hikoya aytib bermoq",
            text_en: "tell an entertaining story",
            description: "Can you tell me an entertaining story?"
          },
          {
            id: 69,
            key: "n",
            text_uz: "ukulele, gavayi gitarasi",
            text_en: "ukulele",
            description: "Is the ukulele as popular in Spain as it is here?"
          },
          {
            id: 70,
            key: "n",
            text_uz: "vulqon",
            text_en: "volcano",
            description: "La Gomera is a tiny Spanish island, just the tip of a volcano... "
          },
          {
            id: 71,
            key: "v",
            text_uz: "hushtak chalmoq",
            text_en: "whistle",
            description: "We whistle when we want to get someone's attention."
          },
          {
            id: 72,
            key: "pron",
            text_uz: "qaysiki (insonlarga nisbatan)",
            text_en: "whom",
            description: "About 1.8 billion people in the world speak English, 359 million of whom speak it as a native language."
          },
        ],
        unit2: [
          {
            id: 1,
            key: "v",
            text_uz: "sherik bo'lmoq, kuzatib bormoq",
            text_en: "accompany",
            description: "There was no question that Mary Kingsley could accompany her father on his travels."
          },
          {
            id: 2,
            key: "adj",
            text_uz: "sarguzashtni sevuvchi",
            text_en: "adventurous",
            description: "You need to be more adventurous. Step out of your comfort zone."
          },
          {
            id: 3,
            key: "adj",
            text_uz: "tashvishli",
            text_en: "anxious",
            description: "Henry Brown must have felt anxious before he got into his box."
          },
          {
            id: 4,
            key: "v",
            text_uz: "o'ziga tortmoq, ko'ngliga yoqmoq",
            text_en: "appeal",
            description: "The cold weather doesn't appeal to me."
          },
          {
            id: 5,
            key: "n",
            text_uz: "yordam",
            text_en: "assistance",
            description: "With the assistance of two friends, Henry made arrangements for them to receive the package."
          },
          {
            id: 6,
            key: "n",
            text_uz: "yuk",
            text_en: "baggage",
            description: "Put the baggage in the trunk."
          },
          {
            id: 7,
            key: "adj",
            text_uz: "achchiq",
            text_en: "bitter",
            description: "Henry Brown felt bitter after his owner allowed his family to be taken from him."
          },
          {
            id: 8,
            key: "phr",
            text_uz: "samolyotga chiqmoq",
            text_en: "board the plane",
            description: "Passengers were asked to stay seated whilst passengers from Miami boarded the plane."
          },
          {
            id: 9,
            key: "n",
            text_uz: "mashina yukxonasi",
            text_en: "boot",
            description: "Put the luggage in the boot."
          },
          {
            id: 10,
            key: "n",
            text_uz: "o'simlikshunos",
            text_en: "botanist",
            description: "North's painting provided botanists in Europe with the first images of some very unusual plants."
          },
          {
            id: 11,
            key: "n",
            text_uz: "avtofurgon",
            text_en: "campervan",
            description: "We went camping in our campervan in the south of France."
          },
          {
            id: 12,
            key: "n",
            text_uz: "baydarka(qayiq turi)",
            text_en: "canoe",
            description: "Mary Kingsley was paddling up rivers in a canoe."
          },
          {
            id: 13,
            key: "n",
            text_uz: "g'ildirakli ko'chma uy",
            text_en: "caravan",
            description: "For our last holiday, we rented a caravan and drove to the west coast."
          },
          {
            id: 14,
            key: "n",
            text_uz: "duradgor",
            text_en: "carpenter",
            description: "Henry Brown asked a friend, who was a carpenter, to build him a box."
          },
          {
            id: 15,
            key: "n",
            text_uz: "farroshlar",
            text_en: "cleaning staff",
            description: "Cleaning staff would enter the plane in order to prepare the seats for the new passengers."
          },
          {
            id: 16,
            key: "n",
            text_uz: "hamroh, sherik",
            text_en: "companion",
            description: "If you need a travelling companion, let me know."
          },
          {
            id: 17,
            key: "n",
            text_uz: "musobaqa",
            text_en: "competition",
            description: "The newspaper held a competition in which readers had to guess how long it would take Bly to circle the globe."
          },
          {
            id: 18,
            key: "n",
            text_uz: "jasorat",
            text_en: "courage",
            description: "Because of the extraordinary courage he had shown, his story became famous."
          },
          {
            id: 19,
            key: "n",
            text_uz: "timsoh",
            text_en: "crocodile",
            description: "Mary Kingsley once had an encounter with a crocodile."
          },
          {
            id: 20,
            key: "adj",
            text_uz: "hayratlangan",
            text_en: "delighted",
            description: "Henry Brown was delighted when he reached Philadelphia safely in his box."
          },
          {
            id: 21,
            key: "n",
            text_uz: "manzil",
            text_en: "destination",
            description: "Why had Henry Brown chosen Pennsylvania as his destination?"
          },
          {
            id: 22,
            key: "n",
            text_uz: "qat'iyat",
            text_en: "determination",
            description: "Henry Brown had shown great determination on his way to freedom."
          },
          {
            id: 23,
            key: "adj",
            text_uz: "qat'iyatli",
            text_en: "determined",
            description: "This terrible loss made Brown determined to escape slavery."
          },
          {
            id: 24,
            key: "adj",
            text_uz: "yo'lini yo'qotgan",
            text_en: "disorientated",
            description: "When Henry Brown first climbed out of his box, he felt disorientated."
          },
          {
            id: 25,
            key: "n",
            text_uz: "muharrir",
            text_en: "editor",
            description: "Bly suggested to her editor that his newspaper should pay for her trip."
          },
          {
            id: 26,
            key: "n",
            text_uz: "to'qnashuv",
            text_en: "encounter",
            description: "Mary Kingsley had encounters with all kinds of animals on her travels."
          },
          {
            id: 27,
            key: "v",
            text_uz: "boyitmoq, yaxshilamoq",
            text_en: "enrich",
            description: "Learning holidays can enrich your life long after the trip is over."
          },
          {
            id: 28,
            key: "v",
            text_uz: "ta'minlamoq, kafolatlamoq",
            text_en: "ensure",
            description: "Please investigate the matter to ensure that this does not happen to other passengers."
          },
          {
            id: 29,
            key: "n",
            text_uz: "tadqiqotchi",
            text_en: "explorer",
            description: "Mary Kingsley was the first explorer to show proper respect to the African people."
          },
          {
            id: 30,
            key: "n",
            text_uz: "avtomagistral, katta yo'l",
            text_en: "expressway",
            description: "An expressway in North American English is called a motorway in British English."
          },

          {
            id: 31,
            key: "n",
            text_uz: "lochin",
            text_en: "falcon",
            description: "The falcons are well trained, so it's super safe."
          },
          {
            id: 32,
            key: "n",
            text_uz: "jasorat",
            text_en: "feat",
            description: "In honour of this creative but dangerous feat, he became known as Henry 'Box' Brown."
          },
          {
            id: 33,
            key: "adj",
            text_uz: "g'azablangan",
            text_en: "furious",
            description: "Henry Brown must have been furious when his wife and children were sold."
          },
          {
            id: 34,
            key: "n",
            text_uz: "gladiator (qadimiy rim qul jangchilari)",
            text_en: "gladiator",
            description: "You've got a chance to train and experience what it was like to fight as a gladiator."
          },
          {
            id: 35,
            key: "n",
            text_uz: "gorilla (katta maymun turi)",
            text_en: "gorilla",
            description: "Kingsley was one of the first Europeans to see a gorilla with her own eyes."
          },
          {
            id: 36,
            key: "n",
            text_uz: "yashash joyi, muhit",
            text_en: "habitat",
            description: "I'd like to see the penguins in their natural habitat."
          },
          {
            id: 37,
            key: "adj",
            text_uz: "quvnoq, kulguli ",
            text_en: "hilarious",
            description: "That's hilarious!"
          },
          {
            id: 38,
            key: "n",
            text_uz: "ta'til",
            text_en: "holiday",
            description: "A place I'd really like to go on holiday this year is Istanbul."
          },
          {
            id: 39,
            key: "n",
            text_uz: "uy yumushlar",
            text_en: "household chore",
            description: "Mary Kingsley much prefered paddling up rivers to household chores."
          },
          {
            id: 40,
            key: "v",
            text_uz: "e'tibor bermaslik",
            text_en: "ignore",
            description: "Her father's medical friends had warned her about tropical diseases, but she ignored them."
          },
          {
            id: 41,
            key: "adj",
            text_uz: "noqulay",
            text_en: "inconvenient",
            description: "They lost my luggage. Just for a day, but still very inconvenient."
          },
          {
            id: 42,
            key: "v",
            text_uz: "o'rganib chiqmoqchin",
            text_en: "investigate",
            description: "I have asked the airline to investigate the incident."
          },
          {
            id: 43,
            key: "n",
            text_uz: "meros",
            text_en: "legacy",
            description: "Collecting two species of fish which were unknown before was not Mary Kingsley's only legacy."
          },
          {
            id: 44,
            key: "n",
            text_uz: "qoplon",
            text_en: "leopard",
            description: "Kingsley rescued a leopard that had got caught in a trap."
          },
          {
            id: 45,
            key: "n",
            text_uz: "yuk mashinasi",
            text_en: "lorry",
            description: "There had been an accident on the motorway ahead of us - a lorry had turned over."
          },
          {
            id: 46,
            key: "n",
            text_uz: "yuk",
            text_en: "luggage",
            description: "They lost my luggage."
          },
          {
            id: 47,
            key: "adj",
            text_uz: "ulkan",
            text_en: "massive",
            description: "There was a massive queue at security control."
          },
          {
            id: 48,
            key: "adj",
            text_uz: "qayg'uli",
            text_en: "miserable",
            description: "Henry Brown felt miserable while he was travelling in the box. "
          },
          {
            id: 49,
            key: "n",
            text_uz: "vazifa, topshiriq",
            text_en: "mission",
            description: "She had two missions to complete while she was touring the continent."
          },
          {
            id: 50,
            key: "n",
            text_uz: "loy",
            text_en: "muddy",
            description: "Her boots were muddy because she went for a walk in the woods after it had rained."
          },
          {
            id: 51,
            key: "n",
            text_uz: "bir tomonlama chipta",
            text_en: "one-way ticket",
            description: "Would you like a one-way or a round-trip bus ticket?"
          },
          {
            id: 52,
            key: "phr",
            text_uz: "mavsumdan tashqari",
            text_en: "out of season",
            description: "It gets touristy in the summer, so it's probably best to go out of season."
          },
          {
            id: 53,
            key: "n",
            text_uz: "jo'natma",
            text_en: "package",
            description: "People in Pennsylvania were waiting anxiously for the arrival of the package from Virginia."
          },
          {
            id: 54,
            key: "n",
            text_uz: "eshkak, belkurak,",
            text_en: "paddle",
            description: "The crocodile tried to climb into her canoe, so she hit it on the head with a paddle."
          },
          {
            id: 55,
            key: "n",
            text_uz: "yo'lak",
            text_en: "pavement",
            description: "There was a lot of rubbish on the pavement."
          },
          {
            id: 56,
            key: "adj",
            text_uz: "tosh qotgan (qo'rquvdan)",
            text_en: "petrified",
            description: "I bet you were petrified!"
          },
          {
            id: 57,
            key: "n",
            text_uz: "benzin",
            text_en: "petrol",
            description: "There was a long queue at the petrol station."
          },
          {
            id: 58,
            key: "adj",
            text_uz: "jismoniy",
            text_en: "physical",
            description: "Henry Brown didn't suffer physical abuse."
          },
          {
            id: 59,
            key: "n",
            text_uz: "ananas bargi",
            text_en: "pineapple leaf",
            description: "The local people taught her how to fish with pineapple leaves. "
          },
          {
            id: 60,
            key: "adj",
            text_uz: "boshi qotgan",
            text_en: "puzzled",
            description: "The luggage handlers would have been puzzled if they had heard a noise coming from the box."
          },

          {
            id: 61,
            key: "n",
            text_uz: "navbat",
            text_en: "queue",
            description: "There was a very long queue for the toilets."
          },
          {
            id: 62,
            key: "n",
            text_uz: "rekord",
            text_en: "record",
            description: "Kira Salak set a Wisconsin state record in cross-country running."
          },
          {
            id: 63,
            key: "adj",
            text_uz: "yengil, xotirjam",
            text_en: "relieved",
            description: "He was relieved because he had found his passport."
          },
          {
            id: 64,
            key: "adj",
            text_uz: "olis, yiroq",
            text_en: "remote",
            description: "If you go somewhere remote, it is far away from places where other people live."
          },
          {
            id: 65,
            key: "n",
            text_uz: "sudralib yuruvchilar",
            text_en: "reptilen",
            description: "Mary Kingsley set off alone along the river in search of fish and reptiles."
          },
          {
            id: 66,
            key: "phr",
            text_uz: "tovon puli talab qilmoq",
            text_en: "request compensation",
            description: "I am requesting compensation for the MP3 player."
          },
          {
            id: 67,
            key: "n",
            text_uz: "mas'uliyat",
            text_en: "responsibility",
            description: "I feel that the airline should take responsibility for this incident."
          },
          {
            id: 68,
            key: "n",
            text_uz: "borish-kelish chiptasi",
            text_en: "return ticket",
            description: "Would you like a single or a return ticket?"
          },
          {
            id: 69,
            key: "n",
            text_uz: "riksha (transport turi)",
            text_en: "rickshaw",
            description: "Bly travelled by ship, horse, rickshaw and other vehicles."
          },
          {
            id: 70,
            key: "phr",
            text_uz: "qiyinchilikarga chidash",
            text_en: "rough it ",
            description: "I'm not very good at roughing it. I like life's little luxuries!"
          },
          {
            id: 71,
            key: "adj",
            text_uz: "ikki yoqlama safar",
            text_en: "round-trip",
            description: "Are you buying a round-trip ticket to Los Angeles or are you staying there?"
          },
          {
            id: 72,
            key: "n",
            text_uz: "chiqit",
            text_en: "rubbish",
            description: "There was a lot of rubbish on the pavement."
          },
          {
            id: 73,
            key: "n",
            text_uz: "maktab o'yingohi",
            text_en: "school playground",
            description: "You know what I'd done? I had parked in a school playground! "
          },
          {
            id: 74,
            key: "phr v",
            text_uz: "jo'nab ketmoq, yo'lga chiqmoq",
            text_en: "set off",
            description: "She set off alone on her journey."
          },
          {
            id: 75,
            key: "n",
            text_uz: "yo'lak",
            text_en: "sidewalk",
            description: "Lots of streets in the US don't have sidewalks."
          },
          {
            id: 76,
            key: "n",
            text_uz: "bir tomonga chipta",
            text_en: "single ticket",
            description: "I would like a single ticket into town, please."
          },
          {
            id: 77,
            key: "n",
            text_uz: "qullik",
            text_en: "slavery",
            description: "Henry Brown escaped from slavery by shipping himself as freight to Pennsylvania."
          },
          {
            id: 78,
            key: "phr",
            text_uz: "sho'ng'ish, berilib ketish",
            text_en: "soak up",
            description: "It would be great just to wander around the old streets and soak up the atmosphere."
          },
          {
            id: 79,
            key: "n",
            text_uz: "esdalik",
            text_en: "souvenir",
            description: "Wouldn't you like to come home from holiday with something more useful than lots of souvenirs?"
          },
          {
            id: 80,
            key: "adj",
            text_uz: "uchli, qirrali",
            text_en: "spiky",
            description: "Mary Kingsley once fell into a hole and landed on a spiky branch."
          },
          {
            id: 81,
            key: "phr",
            text_uz: "qulaylik zonasidan chiqib ketmoq",
            text_en: "step out of your comfort zone",
            description: "Do you ever step out of your comfort zone?"
          },
          {
            id: 82,
            key: "adj",
            text_uz: "maftunkor",
            text_en: "stunning",
            description: "The views from Machu Picchu are absolutely stunning."
          },
          {
            id: 83,
            key: "n",
            text_uz: "botqoq",
            text_en: "swamp",
            description: "Marianne North crossed muddy swamps to find the plants she wanted."
          },
          {
            id: 84,
            key: "v",
            text_uz: "yengil urib qo'yish",
            text_en: "tap",
            description: "One of the men tapped on the box and asked: 'Is all right inside?'"
          },
          {
            id: 85,
            key: "adj",
            text_uz: "asabi tarang",
            text_en: "tense",
            description: "The men receiving Henry Brown's box were very tense."
          },
          {
            id: 86,
            key: "adj",
            text_uz: "qo'rqqan",
            text_en: "terrified",
            description: "The people waiting for Henry Brown were terrified that he would not arrive safely."
          },
          {
            id: 87,
            key: "n",
            text_uz: "hojatxona",
            text_en: "toilet",
            description: "Can you tell me where the toilets are?"
          },
          {
            id: 88,
            key: "n",
            text_uz: "to'fon",
            text_en: "tornado",
            description: "Mary Kingsley had to deal with extreme heat and tornadoes."
          },
          {
            id: 89,
            key: "adj",
            text_uz: "sayyohlar bilan gavjum",
            text_en: "touristy",
            description: "I imagine it gets quite touristy in the summer."
          },
          {
            id: 90,
            key: "n",
            text_uz: "yo'l harakati tirbandligi",
            text_en: "traffic jam",
            description: "After about half an hour, we got stuck in a traffic jam."
          },
          {
            id: 91,
            key: "n",
            text_uz: "sayohat tirkamasi",
            text_en: "travel trailer",
            description: "We love going on holiday with our travel trailer."
          },
          {
            id: 92,
            key: "n",
            text_uz: "piyoda sayohat",
            text_en: "trek",
            description: "Kira Salak went on a solo jungle trek through Papua New Guinea."
          },
          {
            id: 93,
            key: "n",
            text_uz: "urf",
            text_en: "trend",
            description: "Learning vacations are the hottest new trend in travel."
          },
          {
            id: 94,
            key: "n",
            text_uz: "yuk mashinasi",
            text_en: "truck",
            description: "Trucks can transport lots of goods at the same time."
          },
          {
            id: 95,
            key: "n",
            text_uz: "metro",
            text_en: "underground",
            description: "I like the free papers you can get at Underground stations."
          },
          {
            id: 96,
            key: "adj",
            text_uz: "xafa bo'lgan",
            text_en: "upset",
            description: "I was upset that my MP3 player was stolen."
          },
          {
            id: 97,
            key: "n",
            text_uz: "ta'til",
            text_en: "vacation",
            description: "There are many interesting learning vacations that you can go on."
          },
          {
            id: 98,
            key: "v",
            text_uz: "sarson-sargardon",
            text_en: "wander",
            description: "It would be great just to wander around the old streets."
          },
          {
            id: 99,
            key: "phr",
            text_uz: "hurmat va ehtirom ila",
            text_en: "yours faithfully",
            description: "I look forward to your reply. Yours faithfully, Kevin Peters."
          },
        ],
        unit3: [
          {
            id: 1,
            key: "",
            text_uz: "",
            text_en: "",
            description: ""
          },
        ],
        unit4: [],
        unit5: [],
        unit6: [],
        unit7: [],
        unit8: [],
        unit9: [],
        unit10: [],
        unit11: [],
        unit12: [],
      },
    };
  },
});
